(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1668"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1668"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bpcaj", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $3lnkk = parcelRequire("3lnkk");

var $lPOtB = parcelRequire("lPOtB");

var $dXdNl = parcelRequire("dXdNl");

var $l3RwB = parcelRequire("l3RwB");

var $40EBy = parcelRequire("40EBy");

var $cfh0a = parcelRequire("cfh0a");

var $h045Z = parcelRequire("h045Z");

var $lO9y8 = parcelRequire("lO9y8");
/* eslint-disable no-proto */ function makeReactive(obj) {
    var proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get: function() {
            return proto;
        },
        set: function(value) {
            proto.__proto__ = value;
        }
    });
}
var Dom7 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $l3RwB._)(Dom7, Array1);
    function Dom7(items) {
        (0, $dXdNl._)(this, Dom7);
        var _this;
        if (typeof items === 'number') _this = (0, $lPOtB._)(this, Dom7, [
            items
        ]);
        else {
            _this = (0, $lPOtB._)(this, Dom7, (0, $cfh0a._)(items || []));
            makeReactive(_this);
        }
        return (0, $3lnkk._)(_this);
    }
    return Dom7;
}((0, $h045Z._)(Array));
function arrayFlat() {
    var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var res = [];
    arr.forEach(function(el) {
        var _res;
        if (Array.isArray(el)) (_res = res).push.apply(_res, (0, $cfh0a._)(arrayFlat(el)));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    var uniqueArray = [];
    for(var i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, function(match, group) {
        return group.toUpperCase();
    });
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    var a = [];
    var res = context.querySelectorAll(selector);
    for(var i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    var window = (0, $lO9y8.getWindow)();
    var document = (0, $lO9y8.getDocument)();
    var arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            var toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            var tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(var i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        var _el_classList;
        (_el_classList = el.classList).add.apply(_el_classList, (0, $cfh0a._)(classNames));
    });
    return this;
}
function removeClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        var _el_classList;
        (_el_classList = el.classList).remove.apply(_el_classList, (0, $cfh0a._)(classNames));
    });
    return this;
}
function toggleClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        classNames.forEach(function(className) {
            el.classList.toggle(className);
        });
    });
}
function hasClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    return arrayFilter(this, function(el) {
        return classNames.filter(function(className) {
            return el.classList.contains(className);
        }).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(var i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(var attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(var i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(var i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(var propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        var dataKey = el.getAttribute("data-".concat(key));
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(var i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    var el = this[0];
    if (!el) return undefined;
    var dataset = {}; // eslint-disable-line
    if (el.dataset) for(var dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(var i = 0; i < el.attributes.length; i += 1){
        var attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(var key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        var el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            var values = [];
            for(var i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(var i1 = 0; i1 < this.length; i1 += 1){
        var el1 = this[i1];
        if (Array.isArray(value) && el1.multiple && el1.nodeName.toLowerCase() === 'select') for(var j = 0; j < el1.options.length; j += 1)el1.options[j].selected = value.indexOf(el1.options[j].value) >= 0;
        else el1.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? "".concat(duration, "ms") : duration;
    return this;
}
function on() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $40EBy._)(args, 4), eventType = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === 'function') {
        var ref;
        ref = (0, $40EBy._)(args, 3), eventType = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        var target = e.target;
        if (!target) return;
        var eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            var parents = $(target).parents(); // eslint-disable-line
            for(var k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            var event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            var event1 = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event1]) el.dom7LiveListeners[event1] = [];
            el.dom7LiveListeners[event1].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event1, handleLiveEvent, capture);
        }
    }
    return this;
}
function off() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $40EBy._)(args, 4), eventType = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === 'function') {
        var ref;
        ref = (0, $40EBy._)(args, 3), eventType = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(' ');
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            var handlers = void 0;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(var k = handlers.length - 1; k >= 0; k -= 1){
                var handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var dom = this;
    var _args = (0, $40EBy._)(args, 4), eventName = _args[0], targetSelector = _args[1], listener = _args[2], capture = _args[3];
    if (typeof args[1] === 'function') {
        var ref;
        ref = (0, $40EBy._)(args, 3), eventName = ref[0], listener = ref[1], capture = ref[2], ref;
        targetSelector = undefined;
    }
    function onceHandler() {
        for(var _len = arguments.length, eventArgs = new Array(_len), _key = 0; _key < _len; _key++){
            eventArgs[_key] = arguments[_key];
        }
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var window = (0, $lO9y8.getWindow)();
    var events = args[0].split(' ');
    var eventData = args[1];
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            if (window.CustomEvent) {
                var evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter(function(data, dataIndex) {
                    return dataIndex > 0;
                });
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    var window = (0, $lO9y8.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    var window = (0, $lO9y8.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        var window = (0, $lO9y8.getWindow)();
        var document = (0, $lO9y8.getDocument)();
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = document.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === window ? window.scrollY : el.scrollTop;
        var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(var i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    var window = (0, $lO9y8.getWindow)();
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    var window = (0, $lO9y8.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    var window = (0, $lO9y8.getWindow)();
    var i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(var prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach(function(el, index) {
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    var result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(var i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(var i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    var window = (0, $lO9y8.getWindow)();
    var document = (0, $lO9y8.getDocument)();
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    var child = this[0];
    var i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    var length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        var returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append() {
    for(var _len = arguments.length, els = new Array(_len), _key = 0; _key < _len; _key++){
        els[_key] = arguments[_key];
    }
    var newChild;
    var document = (0, $lO9y8.getDocument)();
    for(var k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(var i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(var j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    var document = (0, $lO9y8.getDocument)();
    var i;
    var j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    var before = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(var j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    var after = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(var j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        var el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    var foundElements = [];
    for(var i = 0; i < this.length; i += 1){
        var found = this[i].querySelectorAll(selector);
        for(var j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    var children = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var childNodes = this[i].children;
        for(var j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add() {
    for(var _len = arguments.length, els = new Array(_len), _key = 0; _key < _len; _key++){
        els[_key] = arguments[_key];
    }
    var dom = this;
    var i;
    var j;
    for(i = 0; i < els.length; i += 1){
        var toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.nodeType === 1) {
            for(var j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var window = (0, $lO9y8.getWindow)();
    var _args = (0, $40EBy._)(args, 5), left = _args[0], top = _args[1], duration = _args[2], easing = _args[3], callback = _args[4];
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        var ref;
        ref = (0, $40EBy._)(args, 5), left = ref[0], top = ref[1], duration = ref[2], callback = ref[3], easing = ref[4], ref;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        var el = this;
        var currentTop;
        var currentLeft;
        var maxTop;
        var maxLeft;
        var newTop;
        var newLeft;
        var scrollTop; // eslint-disable-line
        var scrollLeft; // eslint-disable-line
        var animateTop = top > 0 || top === 0;
        var animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        var startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render() {
            var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date().getTime();
            if (startTime === null) startTime = time;
            var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            var done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $40EBy._)(args, 4), top = _args[0], duration = _args[1], easing = _args[2], callback = _args[3];
    var ref;
    if (args.length === 3 && typeof easing === 'function') ref = (0, $40EBy._)(args, 4), top = ref[0], duration = ref[1], callback = ref[2], easing = ref[3], ref;
    var dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $40EBy._)(args, 4), left = _args[0], duration = _args[1], easing = _args[2], callback = _args[3];
    var ref;
    if (args.length === 3 && typeof easing === 'function') ref = (0, $40EBy._)(args, 4), left = ref[0], duration = ref[1], callback = ref[2], easing = ref[3], ref;
    var dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    var window = (0, $lO9y8.getWindow)();
    var els = this;
    var a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress: function(easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop: function() {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done: function(complete) {
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                var que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate: function(props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            var elements = []; // Define & Cache Initials & Units
            a.elements.each(function(el, index) {
                var initialFullValue;
                var initialValue;
                var unit;
                var finalValue;
                var finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach(function(prop) {
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            var startTime = null;
            var time;
            var elementsDone = 0;
            var propsDone = 0;
            var done;
            var began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                var progress;
                var easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach(function(element) {
                    var el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach(function(prop) {
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        var _el_prop = el[prop], initialValue = _el_prop.initialValue, finalValue = _el_prop.finalValue, unit = _el_prop.unit;
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        var currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    var animateInstance;
    for(var i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    var els = this;
    for(var i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
var noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (typeof args[0] === 'undefined') {
            for(var i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on.apply(this, [
            name
        ].concat((0, $cfh0a._)(args)));
    }
    return eventHandler;
}
var click = shortcut('click');
var blur = shortcut('blur');
var focus = shortcut('focus');
var focusin = shortcut('focusin');
var focusout = shortcut('focusout');
var keyup = shortcut('keyup');
var keydown = shortcut('keydown');
var keypress = shortcut('keypress');
var submit = shortcut('submit');
var change = shortcut('change');
var mousedown = shortcut('mousedown');
var mousemove = shortcut('mousemove');
var mouseup = shortcut('mouseup');
var mouseenter = shortcut('mouseenter');
var mouseleave = shortcut('mouseleave');
var mouseout = shortcut('mouseout');
var mouseover = shortcut('mouseover');
var touchstart = shortcut('touchstart');
var touchend = shortcut('touchend');
var touchmove = shortcut('touchmove');
var resize = shortcut('resize');
var scroll = shortcut('scroll');
var $84db774920f4be0e$export$2e2bcd8739ae039 = $;

});
parcelRegister("3lnkk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $26f56d7b34f72a2d$export$71511d61b312f219; });
function $26f56d7b34f72a2d$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("lPOtB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fe5583f2e29ca6f4$export$71511d61b312f219; });

var $bgEXz = parcelRequire("bgEXz");

var $fERRE = parcelRequire("fERRE");

var $ghe6v = parcelRequire("ghe6v");
function $fe5583f2e29ca6f4$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $bgEXz._)(derived);
    return (0, $ghe6v._)(_this, (0, $fERRE._)() ? Reflect.construct(derived, args || [], (0, $bgEXz._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("bgEXz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8340f613b7b30663$export$71511d61b312f219; });
function $8340f613b7b30663$export$71511d61b312f219(o) {
    $8340f613b7b30663$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8340f613b7b30663$export$71511d61b312f219(o);
}

});

parcelRegister("fERRE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6645fc2ba50f183$export$71511d61b312f219; });
function $b6645fc2ba50f183$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($b6645fc2ba50f183$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("ghe6v", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd992c99b233548f$export$71511d61b312f219; });

var $3lnkk = parcelRequire("3lnkk");

var $j2WbH = parcelRequire("j2WbH");
function $bd992c99b233548f$export$71511d61b312f219(self, call) {
    if (call && ((0, $j2WbH._)(call) === "object" || typeof call === "function")) return call;
    return (0, $3lnkk._)(self);
}

});
parcelRegister("j2WbH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dddb5712ecd4207b$export$71511d61b312f219; });
function $dddb5712ecd4207b$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("dXdNl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a28b7c7285f71c8a$export$71511d61b312f219; });
function $a28b7c7285f71c8a$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("l3RwB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f55365b8c3b63a5e$export$71511d61b312f219; });

var $avbQ8 = parcelRequire("avbQ8");
function $f55365b8c3b63a5e$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $avbQ8._)(subClass, superClass);
}

});
parcelRegister("avbQ8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7a55fbc417274c80$export$71511d61b312f219; });
function $7a55fbc417274c80$export$71511d61b312f219(o, p) {
    $7a55fbc417274c80$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7a55fbc417274c80$export$71511d61b312f219(o, p);
}

});


parcelRegister("40EBy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2eb6a8c2efe4d1d3$export$71511d61b312f219; });

var $1WcVU = parcelRequire("1WcVU");

var $1S4Jc = parcelRequire("1S4Jc");

var $jqOdP = parcelRequire("jqOdP");

var $lAURb = parcelRequire("lAURb");
function $2eb6a8c2efe4d1d3$export$71511d61b312f219(arr, i) {
    return (0, $1WcVU._)(arr) || (0, $1S4Jc._)(arr, i) || (0, $lAURb._)(arr, i) || (0, $jqOdP._)();
}

});
parcelRegister("1WcVU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $16953d725958e36c$export$71511d61b312f219; });
function $16953d725958e36c$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("1S4Jc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15ce807e88c74d11$export$71511d61b312f219; });
function $15ce807e88c74d11$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("jqOdP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e257671a377ccc5f$export$71511d61b312f219; });
function $e257671a377ccc5f$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("lAURb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fb89105dfd661251$export$71511d61b312f219; });

var $2hkqz = parcelRequire("2hkqz");
function $fb89105dfd661251$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2hkqz._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2hkqz._)(o, minLen);
}

});
parcelRegister("2hkqz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1a8d03ca4aff1456$export$71511d61b312f219; });
function $1a8d03ca4aff1456$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("cfh0a", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ea412f19da8a8a2$export$71511d61b312f219; });

var $fBBrg = parcelRequire("fBBrg");

var $eyqj9 = parcelRequire("eyqj9");

var $5aZWD = parcelRequire("5aZWD");

var $lAURb = parcelRequire("lAURb");
function $8ea412f19da8a8a2$export$71511d61b312f219(arr) {
    return (0, $fBBrg._)(arr) || (0, $eyqj9._)(arr) || (0, $lAURb._)(arr) || (0, $5aZWD._)();
}

});
parcelRegister("fBBrg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5c75a414da7f998$export$71511d61b312f219; });

var $2hkqz = parcelRequire("2hkqz");
function $b5c75a414da7f998$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $2hkqz._)(arr);
}

});

parcelRegister("eyqj9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a988a5e0c8989e33$export$71511d61b312f219; });
function $a988a5e0c8989e33$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("5aZWD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3c4defe0731b43f6$export$71511d61b312f219; });
function $3c4defe0731b43f6$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("h045Z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c6059d0badf91f2b$export$71511d61b312f219; });

var $9L7YN = parcelRequire("9L7YN");

var $bgEXz = parcelRequire("bgEXz");

var $j8oJ9 = parcelRequire("j8oJ9");

var $avbQ8 = parcelRequire("avbQ8");
function $c6059d0badf91f2b$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $c6059d0badf91f2b$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $j8oJ9._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $9L7YN._)(Class, arguments, (0, $bgEXz._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $avbQ8._)(Wrapper, Class);
    };
    return $c6059d0badf91f2b$export$71511d61b312f219(Class);
}

});
parcelRegister("9L7YN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $71aeb16aab56d5ef$export$71511d61b312f219; });

var $fERRE = parcelRequire("fERRE");

var $avbQ8 = parcelRequire("avbQ8");
function $71aeb16aab56d5ef$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $fERRE._)()) $71aeb16aab56d5ef$export$71511d61b312f219 = Reflect.construct;
    else $71aeb16aab56d5ef$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $avbQ8._)(instance, Class.prototype);
        return instance;
    };
    return $71aeb16aab56d5ef$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("j8oJ9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dee1f1f85c069cd1$export$71511d61b312f219; });
function $dee1f1f85c069cd1$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("lO9y8", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $fe05acd7e22b68c9$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $fe05acd7e22b68c9$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ 
var $j2WbH = parcelRequire("j2WbH");
function $fe05acd7e22b68c9$var$isObject(obj) {
    return obj !== null && (typeof obj === "undefined" ? "undefined" : (0, $j2WbH._)(obj)) === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $fe05acd7e22b68c9$export$8b58be045bf06082() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, src = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($fe05acd7e22b68c9$var$isObject(src[key]) && $fe05acd7e22b68c9$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $fe05acd7e22b68c9$export$8b58be045bf06082(target[key], src[key]);
    });
}
var $fe05acd7e22b68c9$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ''
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $fe05acd7e22b68c9$export$f65ca476c09acec0() {
    var doc = typeof document !== 'undefined' ? document : {};
    $fe05acd7e22b68c9$export$8b58be045bf06082(doc, $fe05acd7e22b68c9$export$3fdcb9b4d81368d8);
    return doc;
}
var $fe05acd7e22b68c9$export$8582633f185c62bb = {
    document: $fe05acd7e22b68c9$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return '';
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $fe05acd7e22b68c9$export$38b2d434cce3ea22() {
    var win = typeof window !== 'undefined' ? window : {};
    $fe05acd7e22b68c9$export$8b58be045bf06082(win, $fe05acd7e22b68c9$export$8582633f185c62bb);
    return win;
}

});











var $9fbfdf2573d3d86b$exports = {};
/*! gumshoejs v5.1.2 | (c) 2019 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/gumshoe */ !function(e, t) {
    "function" == typeof define && define.amd ? define([], function() {
        return t(e);
    }) : $9fbfdf2573d3d86b$exports = t(e);
}("undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof window ? window : $9fbfdf2573d3d86b$exports, function(e) {
    "use strict";
    var t = {
        navClass: "active",
        contentClass: "active",
        nested: !1,
        nestedClass: "active",
        offset: 0,
        reflow: !1,
        events: !0
    }, n = function n(e, t, _n) {
        if (_n.settings.events) {
            var o = new CustomEvent(e, {
                bubbles: !0,
                cancelable: !0,
                detail: _n
            });
            t.dispatchEvent(o);
        }
    }, o = function o(e) {
        var t = 0;
        if (e.offsetParent) for(; e;)t += e.offsetTop, e = e.offsetParent;
        return t >= 0 ? t : 0;
    }, s = function s(e) {
        e && e.sort(function(e, t) {
            return o(e.content) < o(t.content) ? -1 : 1;
        });
    }, c = function c(t, n, o) {
        var s = t.getBoundingClientRect(), c = function(e) {
            return "function" == typeof e.offset ? parseFloat(e.offset()) : parseFloat(e.offset);
        }(n);
        return o ? parseInt(s.bottom, 10) < (e.innerHeight || document.documentElement.clientHeight) : parseInt(s.top, 10) <= c;
    }, i = function i() {
        return e.innerHeight + e.pageYOffset >= Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    }, r = function r(e, t) {
        var n = e[e.length - 1];
        if (function(e, t) {
            return !(!i() || !c(e.content, t, !0));
        }(n, t)) return n;
        for(var o = e.length - 1; o >= 0; o--)if (c(e[o].content, t)) return e[o];
    }, a = function a1(e, t) {
        if (t.nested && e.parentNode) {
            var n = e.parentNode.closest("li");
            n && (n.classList.remove(t.nestedClass), a(n, t));
        }
    }, l = function l(e, t) {
        if (e) {
            var o = e.nav.closest("li");
            o && (o.classList.remove(t.navClass), e.content.classList.remove(t.contentClass), a(o, t), n("gumshoeDeactivate", o, {
                link: e.nav,
                content: e.content,
                settings: t
            }));
        }
    }, u = function u1(e, t) {
        if (t.nested) {
            var n = e.parentNode.closest("li");
            n && (n.classList.add(t.nestedClass), u(n, t));
        }
    };
    return function(o, c) {
        var i, a, f, d, v, m = {};
        m.setup = function() {
            i = document.querySelectorAll(o), a = [], Array.prototype.forEach.call(i, function(e) {
                var t = document.getElementById(decodeURIComponent(e.hash.substr(1)));
                t && a.push({
                    nav: e,
                    content: t
                });
            }), s(a);
        }, m.detect = function() {
            var _$e = r(a, v);
            _$e ? f && _$e.content === f.content || (l(f, v), function(e, t) {
                if (e) {
                    var o = e.nav.closest("li");
                    o && (o.classList.add(t.navClass), e.content.classList.add(t.contentClass), u(o, t), n("gumshoeActivate", o, {
                        link: e.nav,
                        content: e.content,
                        settings: t
                    }));
                }
            }(_$e, v), f = _$e) : f && (l(f, v), f = null);
        };
        var p = function p(t) {
            d && e.cancelAnimationFrame(d), d = e.requestAnimationFrame(m.detect);
        }, h = function h(t) {
            d && e.cancelAnimationFrame(d), d = e.requestAnimationFrame(function() {
                s(a), m.detect();
            });
        };
        m.destroy = function() {
            f && l(f, v), e.removeEventListener("scroll", p, !1), v.reflow && e.removeEventListener("resize", h, !1), a = null, i = null, f = null, d = null, v = null;
        };
        return v = function() {
            var _$e = {};
            return Array.prototype.forEach.call(arguments, function(t) {
                for(var n in t){
                    if (!t.hasOwnProperty(n)) return;
                    _$e[n] = t[n];
                }
            }), _$e;
        }(t, c || {}), m.setup(), m.detect(), e.addEventListener("scroll", p, !1), v.reflow && e.addEventListener("resize", h, !1), m;
    };
});


/**
 * Swiper 7.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 24, 2021
 */ /* eslint no-param-reassign: "off" */ 
var $dXdNl = parcelRequire("dXdNl");
function $4015c67c6c377176$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4015c67c6c377176$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4015c67c6c377176$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4015c67c6c377176$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



var $40EBy = parcelRequire("40EBy");

var $cfh0a = parcelRequire("cfh0a");

var $lO9y8 = parcelRequire("lO9y8");

var $bpcaj = parcelRequire("bpcaj");
var $6947194dc33a33f2$var$Methods = {
    addClass: (0, $bpcaj.addClass),
    removeClass: (0, $bpcaj.removeClass),
    hasClass: (0, $bpcaj.hasClass),
    toggleClass: (0, $bpcaj.toggleClass),
    attr: (0, $bpcaj.attr),
    removeAttr: (0, $bpcaj.removeAttr),
    transform: (0, $bpcaj.transform),
    transition: (0, $bpcaj.transition),
    on: (0, $bpcaj.on),
    off: (0, $bpcaj.off),
    trigger: (0, $bpcaj.trigger),
    transitionEnd: (0, $bpcaj.transitionEnd),
    outerWidth: (0, $bpcaj.outerWidth),
    outerHeight: (0, $bpcaj.outerHeight),
    styles: (0, $bpcaj.styles),
    offset: (0, $bpcaj.offset),
    css: (0, $bpcaj.css),
    each: (0, $bpcaj.each),
    html: (0, $bpcaj.html),
    text: (0, $bpcaj.text),
    is: (0, $bpcaj.is),
    index: (0, $bpcaj.index),
    eq: (0, $bpcaj.eq),
    append: (0, $bpcaj.append),
    prepend: (0, $bpcaj.prepend),
    next: (0, $bpcaj.next),
    nextAll: (0, $bpcaj.nextAll),
    prev: (0, $bpcaj.prev),
    prevAll: (0, $bpcaj.prevAll),
    parent: (0, $bpcaj.parent),
    parents: (0, $bpcaj.parents),
    closest: (0, $bpcaj.closest),
    find: (0, $bpcaj.find),
    children: (0, $bpcaj.children),
    filter: (0, $bpcaj.filter),
    remove: (0, $bpcaj.remove)
};
Object.keys($6947194dc33a33f2$var$Methods).forEach(function(methodName) {
    Object.defineProperty((0, $bpcaj.$).fn, methodName, {
        value: $6947194dc33a33f2$var$Methods[methodName],
        writable: true
    });
});
var $6947194dc33a33f2$export$2e2bcd8739ae039 = (0, $bpcaj.$);


function $37e80ca29cd951d6$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $j2WbH = parcelRequire("j2WbH");

var $lO9y8 = parcelRequire("lO9y8");
function $7fdc5d9b728c141a$export$8694e5c03a4df8e6(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $7fdc5d9b728c141a$export$bdd553fddd433dcb(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return setTimeout(callback, delay);
}
function $7fdc5d9b728c141a$export$461939dd4422153() {
    return Date.now();
}
function $7fdc5d9b728c141a$export$3735103072e4a80(el) {
    var window1 = (0, $lO9y8.getWindow)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $7fdc5d9b728c141a$export$5ec402b7fcf74398(el) {
    var axis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'x';
    var window1 = (0, $lO9y8.getWindow)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $7fdc5d9b728c141a$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map(function(a) {
            return a.replace(',', '.');
        }).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $7fdc5d9b728c141a$export$a6cdc56e425d0d0a(o) {
    return (typeof o === "undefined" ? "undefined" : (0, $j2WbH._)(o)) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $7fdc5d9b728c141a$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $7fdc5d9b728c141a$export$8b58be045bf06082() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var to = Object(args[0]);
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(var i = 1; i < args.length; i += 1){
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$7fdc5d9b728c141a$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($7fdc5d9b728c141a$export$a6cdc56e425d0d0a(to[nextKey]) && $7fdc5d9b728c141a$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $7fdc5d9b728c141a$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$7fdc5d9b728c141a$export$a6cdc56e425d0d0a(to[nextKey]) && $7fdc5d9b728c141a$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $7fdc5d9b728c141a$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $7fdc5d9b728c141a$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $7fdc5d9b728c141a$export$a5dd2b4b1a116d6d(param) {
    var swiper = param.swiper, targetPosition = param.targetPosition, side = param.side;
    var window1 = (0, $lO9y8.getWindow)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? 'next' : 'prev';
    var isOutOfBound = function(current, target) {
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, $37e80ca29cd951d6$export$71511d61b312f219)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo((0, $37e80ca29cd951d6$export$71511d61b312f219)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $lO9y8 = parcelRequire("lO9y8");
var $d3c4054151d5f564$var$support;
function $d3c4054151d5f564$var$calcSupport() {
    var window = (0, $lO9y8.getWindow)();
    var document = (0, $lO9y8.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get: function() {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $d3c4054151d5f564$export$d61c7b85ff180578() {
    if (!$d3c4054151d5f564$var$support) $d3c4054151d5f564$var$support = $d3c4054151d5f564$var$calcSupport();
    return $d3c4054151d5f564$var$support;
}



var $lO9y8 = parcelRequire("lO9y8");

var $06af74ad1fc711e2$var$deviceCached;
function $06af74ad1fc711e2$var$calcDevice() {
    var userAgent = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).userAgent;
    var support = (0, $d3c4054151d5f564$export$d61c7b85ff180578)();
    var window = (0, $lO9y8.getWindow)();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === 'Win32';
    var macos = platform === 'MacIntel'; // iPadOs 13 fix
    var iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $06af74ad1fc711e2$export$30c823bc834d6ab4() {
    var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!$06af74ad1fc711e2$var$deviceCached) $06af74ad1fc711e2$var$deviceCached = $06af74ad1fc711e2$var$calcDevice(overrides);
    return $06af74ad1fc711e2$var$deviceCached;
}



var $lO9y8 = parcelRequire("lO9y8");
var $2ed494b0741a6d15$var$browser;
function $2ed494b0741a6d15$var$calcBrowser() {
    var window = (0, $lO9y8.getWindow)();
    function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $2ed494b0741a6d15$export$89e15fc796a4a429() {
    if (!$2ed494b0741a6d15$var$browser) $2ed494b0741a6d15$var$browser = $2ed494b0741a6d15$var$calcBrowser();
    return $2ed494b0741a6d15$var$browser;
}



var $lO9y8 = parcelRequire("lO9y8");
function $87b2c9e74d47a5ff$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, on = param.on, emit = param.emit;
    var window = (0, $lO9y8.getWindow)();
    var observer = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            var width = swiper.width, height = swiper.height;
            var newWidth = width;
            var newHeight = height;
            entries.forEach(function(param) {
                var contentBoxSize = param.contentBoxSize, contentRect = param.contentRect, target = param.target;
                if (target && target !== swiper.el) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) resizeHandler();
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', function() {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', function() {
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}



var $lO9y8 = parcelRequire("lO9y8");
function $794b015812f470a6$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var observers = [];
    var window = (0, $lO9y8.getWindow)();
    var attach = function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = swiper.$el.parents();
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}


/* eslint-disable no-underscore-dangle */ 
var $cfh0a = parcelRequire("cfh0a");
var $b77b8ebeb17ae01d$export$2e2bcd8739ae039 = {
    on: function(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function(event) {
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var self = this;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, $cfh0a._)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $d046b167e33fe7a7$export$2e2bcd8739ae039() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}




function $6cfd5cce8f0d2f10$export$2e2bcd8739ae039() {
    var swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(".".concat(swiper.params.slideClass));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $7fdc5d9b728c141a$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $7fdc5d9b728c141a$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = "";
            var slideStyles = getComputedStyle(slide[0]);
            var currentTransform = slide[0].style.transform;
            var currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, 'width');
                var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                var boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    var _slide_ = slide[0], clientWidth = _slide_.clientWidth, offsetWidth = _slide_.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = "".concat(slideSize, "px");
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: "".concat(swiper.virtualSize + params.spaceBetween, "px")
    });
    if (params.setWrapperSize) $wrapperEl.css((0, $37e80ca29cd951d6$export$71511d61b312f219)({}, getDirectionLabel('width'), "".concat(swiper.virtualSize + params.spaceBetween, "px")));
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css((0, $37e80ca29cd951d6$export$71511d61b312f219)({}, key, "".concat(spaceBetween, "px")));
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize1 -= params.spaceBetween;
        if (allSlidesSize1 < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $7fdc5d9b728c141a$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', "".concat(-snapGrid[0], "px"));
        (0, $7fdc5d9b728c141a$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
}


function $b569af7140611888$export$2e2bcd8739ae039(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides.filter(function(el) {
            return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
        })[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) swiper.visibleSlides.each(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', "".concat(newHeight, "px"));
}


function $198bebf50801bef3$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $2e6bdd4e94ec2b04$export$2e2bcd8739ae039() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $54a738e1ff3191c1$export$2e2bcd8739ae039(translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
        var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $91c15806b2605a65$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex, realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass("".concat(params.slideActiveClass, " ").concat(params.slideNextClass, " ").concat(params.slidePrevClass, " ").concat(params.slideDuplicateActiveClass, " ").concat(params.slideDuplicateNextClass, " ").concat(params.slideDuplicatePrevClass));
    var activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(activeIndex, '"]'));
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(realIndex, '"]')).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    var nextSlide = activeSlide.nextAll(".".concat(params.slideClass)).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    var prevSlide = activeSlide.prevAll(".".concat(params.slideClass)).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(nextSlide.attr('data-swiper-slide-index'), '"]')).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(nextSlide.attr('data-swiper-slide-index'), '"]')).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(".".concat(params.slideClass, ":not(.").concat(params.slideDuplicateClass, ')[data-swiper-slide-index="').concat(prevSlide.attr('data-swiper-slide-index'), '"]')).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, '[data-swiper-slide-index="').concat(prevSlide.attr('data-swiper-slide-index'), '"]')).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $109f04551d29dff1$export$2e2bcd8739ae039(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $c7572e356aebf868$export$2e2bcd8739ae039(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(e).closest(".".concat(params.slideClass))[0];
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $78b556847d826a2d$export$2e2bcd8739ae039 = {
    updateSize: (0, $d046b167e33fe7a7$export$2e2bcd8739ae039),
    updateSlides: (0, $6cfd5cce8f0d2f10$export$2e2bcd8739ae039),
    updateAutoHeight: (0, $b569af7140611888$export$2e2bcd8739ae039),
    updateSlidesOffset: (0, $198bebf50801bef3$export$2e2bcd8739ae039),
    updateSlidesProgress: (0, $2e6bdd4e94ec2b04$export$2e2bcd8739ae039),
    updateProgress: (0, $54a738e1ff3191c1$export$2e2bcd8739ae039),
    updateSlidesClasses: (0, $91c15806b2605a65$export$2e2bcd8739ae039),
    updateActiveIndex: (0, $109f04551d29dff1$export$2e2bcd8739ae039),
    updateClickedSlide: (0, $c7572e356aebf868$export$2e2bcd8739ae039)
};



function $a1760a4c734cee9d$export$2e2bcd8739ae039() {
    var axis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? 'x' : 'y';
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $7fdc5d9b728c141a$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $f0dc417f85e706eb$export$2e2bcd8739ae039(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, $wrapperEl = swiper.$wrapperEl, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform("translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)"));
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $f8cdb12b98f4549c$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $fe767865ee1e3e07$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}




function $dc9075d14c2e7863$export$2e2bcd8739ae039() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, translateBounds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, internal = arguments.length > 4 ? arguments[4] : void 0;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $7fdc5d9b728c141a$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $37e80ca29cd951d6$export$71511d61b312f219)(_obj, isH ? 'left' : 'top', -newTranslate), (0, $37e80ca29cd951d6$export$71511d61b312f219)(_obj, "behavior", 'smooth'), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $53f6fca9d4a2cce1$export$2e2bcd8739ae039 = {
    getTranslate: (0, $a1760a4c734cee9d$export$2e2bcd8739ae039),
    setTranslate: (0, $f0dc417f85e706eb$export$2e2bcd8739ae039),
    minTranslate: (0, $f8cdb12b98f4549c$export$2e2bcd8739ae039),
    maxTranslate: (0, $fe767865ee1e3e07$export$2e2bcd8739ae039),
    translateTo: (0, $dc9075d14c2e7863$export$2e2bcd8739ae039)
};


function $84014e0801689183$export$2e2bcd8739ae039(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $3318263d0d8a84be$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, runCallbacks = param.runCallbacks, direction = param.direction, step = param.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit("slideResetTransition".concat(step));
            return;
        }
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === 'next') swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}


function $624f9d9b41483c66$export$2e2bcd8739ae039() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $3318263d0d8a84be$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}



function $f57101f8c7ffb03d$export$2e2bcd8739ae039() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $3318263d0d8a84be$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}


var $9c4e51314f7f0421$export$2e2bcd8739ae039 = {
    setTransition: (0, $84014e0801689183$export$2e2bcd8739ae039),
    transitionStart: (0, $624f9d9b41483c66$export$2e2bcd8739ae039),
    transitionEnd: (0, $f57101f8c7ffb03d$export$2e2bcd8739ae039)
};




var $j2WbH = parcelRequire("j2WbH");

function $211a02e7872846a7$export$2e2bcd8739ae039() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0, initial = arguments.length > 4 ? arguments[4] : void 0;
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [".concat(typeof index === "undefined" ? "undefined" : (0, $j2WbH._)(index), "] given."));
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ var indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ var isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(index, "] given."));
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    var translate = -snapGrid[snapIndex]; // Update progress
    swiper.updateProgress(translate); // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    var direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $7fdc5d9b728c141a$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $37e80ca29cd951d6$export$71511d61b312f219)(_obj, isH ? 'left' : 'top', t), (0, $37e80ca29cd951d6$export$71511d61b312f219)(_obj, "behavior", 'smooth'), _obj));
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $78e598e103788bb7$export$2e2bcd8739ae039() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $42ed7040d5bd3956$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var animating = swiper.animating, enabled = swiper.enabled, params = swiper.params;
    if (!enabled) return swiper;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $c2fbcf05f5eb44e3$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) return swiper.slideTo(swiper.slides.length - 1, speed, runCallbacks, internal);
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $d193fe04d6dd82c9$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $4d9533f0af82efdf$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0, threshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $ce216405e73ca2fc$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
                (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(".".concat(params.slideClass, '[data-swiper-slide-index="').concat(realIndex, '"]:not(.').concat(params.slideDuplicateClass, ")")).eq(0).index();
            (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $bd3baf8b62cd1678$export$2e2bcd8739ae039 = {
    slideTo: (0, $211a02e7872846a7$export$2e2bcd8739ae039),
    slideToLoop: (0, $78e598e103788bb7$export$2e2bcd8739ae039),
    slideNext: (0, $42ed7040d5bd3956$export$2e2bcd8739ae039),
    slidePrev: (0, $c2fbcf05f5eb44e3$export$2e2bcd8739ae039),
    slideReset: (0, $d193fe04d6dd82c9$export$2e2bcd8739ae039),
    slideToClosest: (0, $4d9533f0af82efdf$export$2e2bcd8739ae039),
    slideToClickedSlide: (0, $ce216405e73ca2fc$export$2e2bcd8739ae039)
};



var $lO9y8 = parcelRequire("lO9y8");

function $85480b8924f3d427$export$2e2bcd8739ae039() {
    var swiper = this;
    var document = (0, $lO9y8.getDocument)();
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
    var $selector = $wrapperEl.children().length > 0 ? (0, $6947194dc33a33f2$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass)).remove();
    var slides = $selector.children(".".concat(params.slideClass));
    if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankNode = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(document.createElement('div')).addClass("".concat(params.slideClass, " ").concat(params.slideBlankClass));
                $selector.append(blankNode);
            }
            slides = $selector.children(".".concat(params.slideClass));
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function(el, index) {
        var slide = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(var i1 = 0; i1 < appendSlides.length; i1 += 1)$selector.append((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(appendSlides[i1].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(var i2 = prependSlides.length - 1; i2 >= 0; i2 -= 1)$selector.prepend((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(prependSlides[i2].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $f0a674a56e64dc90$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.emit('beforeLoopFix');
    var activeIndex = swiper.activeIndex, slides = swiper.slides, loopedSlides = swiper.loopedSlides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, snapGrid = swiper.snapGrid, rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var slideChanged1 = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged1 && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $f7fa29ce2a0badb5$export$2e2bcd8739ae039() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, slides = swiper.slides;
    $wrapperEl.children(".".concat(params.slideClass, ".").concat(params.slideDuplicateClass, ",.").concat(params.slideClass, ".").concat(params.slideBlankClass)).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $ea1520e3a592f664$export$2e2bcd8739ae039 = {
    loopCreate: (0, $85480b8924f3d427$export$2e2bcd8739ae039),
    loopFix: (0, $f0a674a56e64dc90$export$2e2bcd8739ae039),
    loopDestroy: (0, $f7fa29ce2a0badb5$export$2e2bcd8739ae039)
};


function $977da6f31411616c$export$2e2bcd8739ae039(moving) {
    var swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $e7607682caa24407$export$2e2bcd8739ae039() {
    var swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


var $eb668380b0e822af$export$2e2bcd8739ae039 = {
    setGrabCursor: (0, $977da6f31411616c$export$2e2bcd8739ae039),
    unsetGrabCursor: (0, $e7607682caa24407$export$2e2bcd8739ae039)
};



var $lO9y8 = parcelRequire("lO9y8");

var $lO9y8 = parcelRequire("lO9y8");


function $645c54bd38df8304$var$closestElement(selector) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
    function __closestFrom(el) {
        if (!el || el === (0, $lO9y8.getDocument)() || el === (0, $lO9y8.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $645c54bd38df8304$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var document = (0, $lO9y8.getDocument)();
    var window = (0, $lO9y8.getWindow)();
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) $targetEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(event.path[0]);
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $645c54bd38df8304$var$closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $7fdc5d9b728c141a$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        var preventDefault = true;
        if ($targetEl.is(data.focusableElements)) preventDefault = false;
        if (document.activeElement && (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    swiper.emit('touchStart', e);
}



var $lO9y8 = parcelRequire("lO9y8");


function $d1de915ca2f8be63$export$2e2bcd8739ae039(event) {
    var document = (0, $lO9y8.getDocument)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $7fdc5d9b728c141a$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $363d855ccd3965e6$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    var touchEndTime = (0, $7fdc5d9b728c141a$export$461939dd4422153)();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $7fdc5d9b728c141a$export$461939dd4422153)();
    (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    } // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(stopIndex + increment1);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}


function $734ccf627544a405$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $2aca64af04e27ef4$export$2e2bcd8739ae039(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $cf3ee340a195548d$export$2e2bcd8739ae039() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


var $6eb83e0ea1670222$var$dummyEventAttached = false;
function $6eb83e0ea1670222$var$dummyEventListener() {}
var $6eb83e0ea1670222$var$events = function(swiper, method) {
    var document = (0, $lO9y8.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    var capture = !!params.nested;
    var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    var swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $734ccf627544a405$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]('observerUpdate', (0, $734ccf627544a405$export$2e2bcd8739ae039), true);
};
function $6eb83e0ea1670222$var$attachEvents() {
    var swiper = this;
    var document = (0, $lO9y8.getDocument)();
    var params = swiper.params, support = swiper.support;
    swiper.onTouchStart = (0, $645c54bd38df8304$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $d1de915ca2f8be63$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $363d855ccd3965e6$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $cf3ee340a195548d$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $2aca64af04e27ef4$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$6eb83e0ea1670222$var$dummyEventAttached) {
        document.addEventListener('touchstart', $6eb83e0ea1670222$var$dummyEventListener);
        $6eb83e0ea1670222$var$dummyEventAttached = true;
    }
    $6eb83e0ea1670222$var$events(swiper, 'on');
}
function $6eb83e0ea1670222$var$detachEvents() {
    var swiper = this;
    $6eb83e0ea1670222$var$events(swiper, 'off');
}
var $6eb83e0ea1670222$export$2e2bcd8739ae039 = {
    attachEvents: $6eb83e0ea1670222$var$attachEvents,
    detachEvents: $6eb83e0ea1670222$var$detachEvents
};



var $47c4ed7b2ce685af$var$isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $47c4ed7b2ce685af$export$2e2bcd8739ae039() {
    var swiper = this;
    var activeIndex = swiper.activeIndex, initialized = swiper.initialized, _swiper_loopedSlides = swiper.loopedSlides, loopedSlides = _swiper_loopedSlides === void 0 ? 0 : _swiper_loopedSlides, params = swiper.params, $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = $47c4ed7b2ce685af$var$isGridEnabled(swiper, params);
    var isMultiRow = $47c4ed7b2ce685af$var$isGridEnabled(swiper, breakpointParams);
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass("".concat(params.containerModifierClass, "grid ").concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $7fdc5d9b728c141a$export$8b58be045bf06082)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $lO9y8 = parcelRequire("lO9y8");
function $e50186831524047c$export$2e2bcd8739ae039(breakpoints) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'window', containerEl = arguments.length > 2 ? arguments[2] : void 0;
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    var breakpoint = false;
    var window = (0, $lO9y8.getWindow)();
    var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === 'window') {
            if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $27a83606bb48b4f0$export$2e2bcd8739ae039 = {
    setBreakpoint: (0, $47c4ed7b2ce685af$export$2e2bcd8739ae039),
    getBreakpoint: (0, $e50186831524047c$export$2e2bcd8739ae039)
};



var $cfh0a = parcelRequire("cfh0a");

var $j2WbH = parcelRequire("j2WbH");
function $640a7dcc90cbe62d$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if ((typeof item === "undefined" ? "undefined" : (0, $j2WbH._)(item)) === 'object') Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $640a7dcc90cbe62d$export$2e2bcd8739ae039() {
    var _classNames;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, $el = swiper.$el, device = swiper.device, support = swiper.support; // prettier-ignore
    var suffixes = $640a7dcc90cbe62d$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, $cfh0a._)(suffixes));
    $el.addClass((0, $cfh0a._)(classNames).join(' '));
    swiper.emitContainerClasses();
}


function $1d6f6893d1d71bd0$export$2e2bcd8739ae039() {
    var swiper = this;
    var $el = swiper.$el, classNames = swiper.classNames;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $202448b71adfeadd$export$2e2bcd8739ae039 = {
    addClasses: (0, $640a7dcc90cbe62d$export$2e2bcd8739ae039),
    removeClasses: (0, $1d6f6893d1d71bd0$export$2e2bcd8739ae039)
};



var $lO9y8 = parcelRequire("lO9y8");

function $76d637f4e9653442$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var window = (0, $lO9y8.getWindow)();
    var image;
    function onReady() {
        if (callback) callback();
    }
    var isPicture = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $a6f434829420cbeb$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(var i = 0; i < swiper.imagesToLoad.length; i += 1){
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $4c639ee666a0e058$export$2e2bcd8739ae039 = {
    loadImage: (0, $76d637f4e9653442$export$2e2bcd8739ae039),
    preloadImages: (0, $a6f434829420cbeb$export$2e2bcd8739ae039)
};


function $d32f0780685cd20f$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $d32f0780685cd20f$export$2e2bcd8739ae039 = {
    checkOverflow: $d32f0780685cd20f$var$checkOverflow
};


var $5e3e59a20c019694$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



var $j2WbH = parcelRequire("j2WbH");

function $4affd362fdafeba7$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams() {
        var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if ((typeof moduleParams === "undefined" ? "undefined" : (0, $j2WbH._)(moduleParams)) !== 'object' || moduleParams === null) {
            (0, $7fdc5d9b728c141a$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $7fdc5d9b728c141a$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if ((0, $j2WbH._)(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $7fdc5d9b728c141a$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


var $b7fc613ae4207215$var$prototypes = {
    eventsEmitter: (0, $b77b8ebeb17ae01d$export$2e2bcd8739ae039),
    update: (0, $78b556847d826a2d$export$2e2bcd8739ae039),
    translate: (0, $53f6fca9d4a2cce1$export$2e2bcd8739ae039),
    transition: (0, $9c4e51314f7f0421$export$2e2bcd8739ae039),
    slide: (0, $bd3baf8b62cd1678$export$2e2bcd8739ae039),
    loop: (0, $ea1520e3a592f664$export$2e2bcd8739ae039),
    grabCursor: (0, $eb668380b0e822af$export$2e2bcd8739ae039),
    events: (0, $6eb83e0ea1670222$export$2e2bcd8739ae039),
    breakpoints: (0, $27a83606bb48b4f0$export$2e2bcd8739ae039),
    checkOverflow: (0, $d32f0780685cd20f$export$2e2bcd8739ae039),
    classes: (0, $202448b71adfeadd$export$2e2bcd8739ae039),
    images: (0, $4c639ee666a0e058$export$2e2bcd8739ae039)
};
var $b7fc613ae4207215$var$extendedDefaults = {};
var $b7fc613ae4207215$var$Swiper = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _swiper_modules;
        (0, $dXdNl._)(this, Swiper);
        var el;
        var params;
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else ref = (0, $40EBy._)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, $7fdc5d9b728c141a$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(params.el).length > 1) {
            var swipers = [];
            (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(params.el).each(function(containerEl) {
                var newParams = (0, $7fdc5d9b728c141a$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        } // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $d3c4054151d5f564$export$d61c7b85ff180578)();
        swiper.device = (0, $06af74ad1fc711e2$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $2ed494b0741a6d15$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, $cfh0a._)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, $cfh0a._)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                swiper: swiper,
                extendParams: (0, $4affd362fdafeba7$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        var swiperParams = (0, $7fdc5d9b728c141a$export$8b58be045bf06082)({}, (0, $5e3e59a20c019694$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $7fdc5d9b728c141a$export$8b58be045bf06082)({}, swiperParams, $b7fc613ae4207215$var$extendedDefaults, params);
        swiper.originalParams = (0, $7fdc5d9b728c141a$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $7fdc5d9b728c141a$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $6947194dc33a33f2$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === 'horizontal';
            },
            isVertical: function() {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                var touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                var desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $7fdc5d9b728c141a$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        return swiper;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Swiper, [
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit('enable');
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit('disable');
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit('_containerClasses', cls.join(' '));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                return slideEl.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(' ');
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.each(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit('_slideClass', slideEl, classNames);
                });
                swiper.emit('_slideClasses', updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic() {
                var view = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'current', exact = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex].swiperSlideSize;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += slides[i].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === 'current') for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params; // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
                    setTranslate();
                    if (swiper.params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
                    else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit('update');
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection) {
                var needUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
                if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
                swiper.$el.removeClass("".concat(swiper.params.containerModifierClass).concat(currentDirection)).addClass("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.each(function(slideEl) {
                    if (newDirection === 'vertical') slideEl.style.width = '';
                    else slideEl.style.height = '';
                });
                swiper.emit('changeDirection');
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "mount",
            value: function mount(el) {
                var swiper = this;
                if (swiper.mounted) return true; // Find el
                var $el = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(el || swiper.params.el);
                el = $el[0];
                if (!el) return false;
                el.swiper = swiper;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || '').trim().split(' ').join('.'));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                        res.children = function(options) {
                            return $el.children(options);
                        };
                        return res;
                    }
                    return $el.children(getWrapperSelector());
                }; // Find Wrapper
                var $wrapperEl = getWrapper();
                if ($wrapperEl.length === 0 && swiper.params.createElements) {
                    var document = (0, $lO9y8.getDocument)();
                    var wrapper = document.createElement('div');
                    $wrapperEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(wrapper);
                    wrapper.className = swiper.params.wrapperClass;
                    $el.append(wrapper);
                    $el.children(".".concat(swiper.params.slideClass)).each(function(slideEl) {
                        $wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    $el: $el,
                    el: el,
                    $wrapperEl: $wrapperEl,
                    wrapperEl: $wrapperEl[0],
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
                    rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
                    wrongRTL: $wrapperEl.css('display') === '-webkit-box'
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit('beforeInit'); // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                 // Add Classes
                swiper.addClasses(); // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                 // Update size
                swiper.updateSize(); // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                 // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                if (swiper.params.preloadImages) swiper.preloadImages();
                 // Slide To Initial Slide
                if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                 // Attach events
                swiper.attachEvents(); // Init Flag
                swiper.initialized = true; // Emit
                swiper.emit('init');
                swiper.emit('afterInit');
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var deleteInstance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, cleanStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var params = swiper.params, $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
                swiper.emit('beforeDestroy'); // Init Flag
                swiper.initialized = false; // Detach events
                swiper.detachEvents(); // Destroy loop
                if (params.loop) swiper.loopDestroy();
                 // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    $el.removeAttr('style');
                    $wrapperEl.removeAttr('style');
                    if (slides && slides.length) slides.removeClass([
                        params.slideVisibleClass,
                        params.slideActiveClass,
                        params.slideNextClass,
                        params.slidePrevClass
                    ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
                }
                swiper.emit('destroy'); // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    swiper.$el[0].swiper = null;
                    (0, $7fdc5d9b728c141a$export$8694e5c03a4df8e6)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, $7fdc5d9b728c141a$export$8b58be045bf06082)($b7fc613ae4207215$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $b7fc613ae4207215$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return 0, $5e3e59a20c019694$export$2e2bcd8739ae039;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($b7fc613ae4207215$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($b7fc613ae4207215$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $b7fc613ae4207215$var$Swiper.prototype[protoMethod] = $b7fc613ae4207215$var$prototypes[prototypeGroup][protoMethod];
    });
});
$b7fc613ae4207215$var$Swiper.use([
    (0, $87b2c9e74d47a5ff$export$2e2bcd8739ae039),
    (0, $794b015812f470a6$export$2e2bcd8739ae039)
]);
var $b7fc613ae4207215$export$2e2bcd8739ae039 = $b7fc613ae4207215$var$Swiper;



var $j2WbH = parcelRequire("j2WbH");


function $1cdf76d12f6b4a03$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        var $slideEl = params.renderSlide ? (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<div class="'.concat(swiper.params.slideClass, '" data-swiper-slide-index="').concat(index, '">').concat(slide, "</div>"));
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, "".concat(offset, "px"));
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        if (force) swiper.$wrapperEl.find(".".concat(swiper.params.slideClass)).remove();
        else {
            for(var i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(i, '"]')).remove();
        }
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (i1 >= from && i1 <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i1);
            else {
                if (i1 > previousTo) appendIndexes.push(i1);
                if (i1 < previousFrom) prependIndexes.push(i1);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function(a, b) {
            return b - a;
        }).forEach(function(index) {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, "".concat(offset, "px"));
        onRendered();
    }
    function appendSlide(slides) {
        if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var $cachedEl = cache[cachedIndex];
                var cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', function() {
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on('init update resize', function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $7fdc5d9b728c141a$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-virtual-size', "".concat(swiper.virtualSize, "px"));
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $lO9y8 = parcelRequire("lO9y8");

function $2d0a787457998a56$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var document = (0, $lO9y8.getDocument)();
    var window = (0, $lO9y8.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(".".concat(swiper.params.slideClass)).length > 0 && swiper.$el.parents(".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var $el = swiper.$el;
            var swiperWidth = $el[0].clientWidth;
            var swiperHeight = $el[0].clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', function() {
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', function() {
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $lO9y8 = parcelRequire("lO9y8");


function $6aafbce85c956554$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var window = (0, $lO9y8.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    var timeout;
    var lastScrollTime = (0, $7fdc5d9b728c141a$export$461939dd4422153)();
    var lastEventBeforeSnap;
    var recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $7fdc5d9b728c141a$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $7fdc5d9b728c141a$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        var e = event1;
        var disableParentSwiper = true;
        if (!swiper.enabled) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $7fdc5d9b728c141a$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: (0, $7fdc5d9b728c141a$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', function() {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $lO9y8 = parcelRequire("lO9y8");
function $7ba68284cebcae4a$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    var document = (0, $lO9y8.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = swiper.$el.children(".".concat(checkProps[key]))[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $9969adb5ca25ad64$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        var $el;
        if (el) {
            $el = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        var params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
    }
    function init() {
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $7ba68284cebcae4a$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl = getEl(params.nextEl);
        var $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', function() {
        init();
        update();
    });
    on('toEdge fromEdge lock unlock', function() {
        update();
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', function(_s, e) {
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        var targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $6947194dc33a33f2$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $6947194dc33a33f2$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    Object.assign(swiper.navigation, {
        update: update,
        init: init,
        destroy: destroy
    });
}



function $b10f89386299ada0$export$2e2bcd8739ae039() {
    var classes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return ".".concat(classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.'));
}



function $03a2af08df22ddfa$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "".concat(pfx, "-bullet"),
            bulletActiveClass: "".concat(pfx, "-bullet-active"),
            modifierClass: "".concat(pfx, "-"),
            currentClass: "".concat(pfx, "-current"),
            totalClass: "".concat(pfx, "-total"),
            hiddenClass: "".concat(pfx, "-hidden"),
            progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
            clickableClass: "".concat(pfx, "-clickable"),
            lockClass: "".concat(pfx, "-lock"),
            horizontalClass: "".concat(pfx, "-horizontal"),
            verticalClass: "".concat(pfx, "-vertical")
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
        $bulletEl[position]().addClass("".concat(bulletActiveClass, "-").concat(position))[position]().addClass("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
    }
    function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el; // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', "".concat(bulletSize * (params.dynamicMainBullets + 4), "px"));
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map(function(suffix) {
                return "".concat(params.bulletActiveClass).concat(suffix);
            }).join(' '));
            if ($el.length > 1) bullets.each(function(bullet) {
                var $bullet = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(bullet);
                var bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass("".concat(params.bulletActiveClass, "-main"));
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                var $bullet = bullets.eq(current);
                var bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    var $firstDisplayedBullet = bullets.eq(firstIndex);
                    var $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(var i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass("".concat(params.bulletActiveClass, "-main"));
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(var i1 = params.dynamicMainBullets; i1 >= 0; i1 -= 1)bullets.eq(bullets.length - i1).addClass("".concat(params.bulletActiveClass, "-main"));
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass("".concat(params.bulletActiveClass, "-prev"));
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                var offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', "".concat(bulletsOffset, "px"));
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $b10f89386299ada0$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $b10f89386299ada0$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            var progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            var scale = (current + 1) / total;
            var scaleX = 1;
            var scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $b10f89386299ada0$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")")).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = '';
        if (params.type === 'bullets') {
            var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += "<".concat(params.bulletElement, ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $b10f89386299ada0$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + ' / ' + '<span class="'.concat(params.totalClass, '"></span>');
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $7ba68284cebcae4a$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter(function(el) {
                if ((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(params.modifierClass + swiper.params.direction);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass("".concat(params.modifierClass).concat(params.type, "-dynamic"));
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $b10f89386299ada0$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            var index = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(params.modifierClass + swiper.params.direction);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $b10f89386299ada0$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on('init', function() {
        init();
        render();
        update();
    });
    on('activeIndexChange', function() {
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', function() {
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', function() {
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', function() {
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var $el = swiper.pagination.$el;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', function() {
        update();
    });
    on('click', function(_s, e) {
        var targetEl = e.target;
        var $el = swiper.pagination.$el;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el.length > 0 && !(0, $6947194dc33a33f2$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    Object.assign(swiper.pagination, {
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $lO9y8 = parcelRequire("lO9y8");



function $8f86c57cef9bbf8b$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var document = (0, $lO9y8.getDocument)();
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos;
    var dragSize;
    var trackSize;
    var divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag'
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate, progress = swiper.progress;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform("translate3d(".concat(newPos, "px, 0, 0)"));
            $dragEl[0].style.width = "".concat(newSize, "px");
        } else {
            $dragEl.transform("translate3d(0px, ".concat(newPos, "px, 0)"));
            $dragEl[0].style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(function() {
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl, $el = scrollbar.$el;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = "".concat(dragSize, "px");
        else $dragEl[0].style.height = "".concat(dragSize, "px");
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el, $dragEl = scrollbar.$dragEl;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        var scrollbar = swiper.scrollbar, touchEventsTouch = swiper.touchEventsTouch, touchEventsDesktop = swiper.touchEventsDesktop, params = swiper.params, support = swiper.support;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        var eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events('off');
    }
    function init() {
        var scrollbar = swiper.scrollbar, $swiperEl = swiper.$el;
        swiper.params.scrollbar = (0, $7ba68284cebcae4a$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var $el = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        var $dragEl = $el.find(".".concat(swiper.params.scrollbar.dragClass));
        if ($dragEl.length === 0) {
            $dragEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<div class="'.concat(swiper.params.scrollbar.dragClass, '"></div>'));
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        disableDraggable();
    }
    on('init', function() {
        init();
        updateSize();
        setTranslate();
    });
    on('update resize observerUpdate lock unlock', function() {
        updateSize();
    });
    on('setTranslate', function() {
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        setTransition(duration);
    });
    on('enable disable', function() {
        var $el = swiper.scrollbar.$el;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', function() {
        destroy();
    });
    Object.assign(swiper.scrollbar, {
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $a0590464a191b6a3$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var $el = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr('data-swiper-parallax') || '0';
        var x = $el.attr('data-swiper-parallax-x');
        var y = $el.attr('data-swiper-parallax-y');
        var scale = $el.attr('data-swiper-parallax-scale');
        var opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(x * progress * rtlFactor, "px");
        if (y.indexOf('%') >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(y * progress, "px");
        if (typeof opacity !== 'undefined' && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px)"));
        else {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform("translate3d(".concat(x, ", ").concat(y, ", 0px) scale(").concat(currentScale, ")"));
        }
    };
    var setTranslate = function() {
        var $el = swiper.$el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(el) {
            setTransform(el, progress);
        });
        slides.each(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(el) {
                setTransform(el, slideProgress);
            });
        });
    };
    var setTransition = function() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : swiper.params.speed;
        var $el = swiper.$el;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function(parallaxEl) {
            var $parallaxEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(parallaxEl);
            var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', function() {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', function(_swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $lO9y8 = parcelRequire("lO9y8");


function $cd7ce9e3a015756f$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var window = (0, $lO9y8.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    var currentScale = 1;
    var isScaling = false;
    var gesturesEnabled;
    var fakeGestureTouched;
    var fakeGestureMoved;
    var gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                var slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    } // Events
    function onGestureStart(e) {
        var support = swiper.support;
        var params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(e.target).closest(".".concat(swiper.params.slideClass));
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.$imageEl.transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    }
    function onGestureEnd(e) {
        var device = swiper.device;
        var support = swiper.support;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        var device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        var zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $7fdc5d9b728c141a$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $7fdc5d9b728c141a$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    }
    function onTouchEnd() {
        var zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)"));
    }
    function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(e.target).closest(".".concat(swiper.params.slideClass));
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform("translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)"));
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(zoom.scale, ")"));
    }
    function zoomOut() {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(".".concat(swiper.params.slideActiveClass));
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(".".concat(params.containerClass)).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(".".concat(params.containerClass));
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass("".concat(params.zoomedSlideClass));
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        var support = swiper.support;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return ".".concat(swiper.params.slideClass);
    }
    function toggleGestures(method) {
        var passiveListener = getListeners().passiveListener;
        var slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var support = swiper.support;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        var slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        var support = swiper.support;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        var slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, ".".concat(swiper.params.zoom.containerClass), onTouchMove, activeListenerWithCapture);
    }
    on('init', function() {
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', function() {
        disable();
    });
    on('touchStart', function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', function(_s, e) {
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $lO9y8 = parcelRequire("lO9y8");

function $953ac4b8dabb97b8$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    var scrollHandlerAttached = false;
    var initialImageLoaded = false;
    function loadInSlide(index) {
        var loadInDuplicate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(index, '"]')) : swiper.slides.eq(index);
        var $images = $slideEl.find(".".concat(params.elementClass, ":not(.").concat(params.loadedClass, "):not(.").concat(params.loadingClass, ")"));
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each(function(imageEl) {
            var $imageEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            var background = $imageEl.attr('data-background');
            var src = $imageEl.attr('data-src');
            var srcset = $imageEl.attr('data-srcset');
            var sizes = $imageEl.attr('data-sizes');
            var $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function() {
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', 'url("'.concat(background, '")'));
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each(function(sourceEl) {
                        var $source = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(".".concat(params.preloaderClass)).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(slideOriginalIndex, '"]:not(.').concat(swiper.params.slideDuplicateClass, ")"));
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        var duplicatedSlide = swiper.$wrapperEl.children(".".concat(swiper.params.slideDuplicateClass, '[data-swiper-slide-index="').concat(slideOriginalIndex, '"]'));
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        var $wrapperEl = swiper.$wrapperEl, swiperParams = swiper.params, slides = swiper.slides, activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(".".concat(swiperParams.slideClass, '[data-swiper-slide-index="').concat(index, '"]')).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index');
            return (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(".".concat(swiperParams.slideVisibleClass)).each(function(slideEl) {
            var index = isVirtual ? (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index') : (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(var i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                var amount = params.loadPrevNextAmount;
                var spv = slidesPerView;
                var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(var i1 = activeIndex + slidesPerView; i1 < maxIndex; i1 += 1)if (slideExist(i1)) loadInSlide(i1);
                 // Prev Slides
                for(var i2 = minIndex; i2 < activeIndex; i2 += 1)if (slideExist(i2)) loadInSlide(i2);
            } else {
                var nextSlide = $wrapperEl.children(".".concat(swiperParams.slideNextClass));
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                var prevSlide = $wrapperEl.children(".".concat(swiperParams.slidePrevClass));
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        var window = (0, $lO9y8.getWindow)();
        if (!swiper || swiper.destroyed) return;
        var $scrollElement = swiper.params.lazy.scrollingElement ? (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(window);
        var isWindow = $scrollElement[0] === window;
        var scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        var scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        var swiperOffset = swiper.$el.offset();
        var rtl = swiper.rtlTranslate;
        var inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        var swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(var i = 0; i < swiperCoord.length; i += 1){
            var point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        var passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', function() {
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', function() {
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', function() {
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', function() {
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', function() {
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', function() {
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', function() {
        var _swiper_params = swiper.params, lazy = _swiper_params.lazy, cssMode = _swiper_params.cssMode, watchSlidesProgress = _swiper_params.watchSlidesProgress, touchReleaseOnEdges = _swiper_params.touchReleaseOnEdges, resistanceRatio = _swiper_params.resistanceRatio;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $23f429b221c49334$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(function() {
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', function() {
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', function() {
        removeSpline();
    });
    on('resize', function() {
        removeSpline();
    });
    on('observerUpdate', function() {
        removeSpline();
    });
    on('setTranslate', function(_s, translate, byController) {
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', function(_s, duration, byController) {
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $93d25f92c01c9d85$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group'
        }
    });
    var liveRegion = null;
    function notify(message) {
        var notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = swiper.params.a11y;
        var $targetEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $b10f89386299ada0$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, $nextEl = _swiper_navigation.$nextEl, $prevEl = _swiper_navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        var params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each(function(bulletEl) {
            var $bulletEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(".".concat(swiper.params.pagination.bulletActiveClass))) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    var initNavEl = function($el, wrapperId, message) {
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    function init() {
        var params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        var $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        var $wrapperEl = swiper.$wrapperEl;
        var wrapperId = $wrapperEl.attr('id') || "swiper-wrapper-".concat(getRandomNumber(16));
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        addElRole((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        var slidesLength = swiper.params.loop ? swiper.slides.filter(function(el) {
            return !el.classList.contains(swiper.params.slideDuplicateClass);
        }).length : swiper.slides.length;
        swiper.slides.each(function(slideEl, index) {
            var $slideEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(slideEl);
            var slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        }); // Navigation
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $b10f89386299ada0$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $b10f89386299ada0$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
    on('beforeInit', function() {
        liveRegion = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<span class="'.concat(swiper.params.a11y.notificationClass, '" aria-live="assertive" aria-atomic="true"></span>'));
    });
    on('afterInit', function() {
        if (!swiper.params.a11y.enabled) return;
        init();
        updateNavigation();
    });
    on('toEdge', function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('fromEdge', function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', function() {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', function() {
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $lO9y8 = parcelRequire("lO9y8");
function $31e24684cb70cde2$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides'
        }
    });
    var initialized = false;
    var paths = {};
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    var getPathValues = function(urlOverride) {
        var window = (0, $lO9y8.getWindow)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split('/').filter(function(part) {
            return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var window = (0, $lO9y8.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.slides.eq(index);
        var value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = "".concat(root, "/").concat(key, "/").concat(value);
        } else if (!location.pathname.includes(key)) value = "".concat(key, "/").concat(value);
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides.eq(i);
            var slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                var index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, swiper.paths.value, false);
    };
    var init = function() {
        var window = (0, $lO9y8.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    var destroy = function() {
        var window = (0, $lO9y8.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', function() {
        if (swiper.params.history.enabled) init();
    });
    on('destroy', function() {
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $lO9y8 = parcelRequire("lO9y8");

function $b27dce13aa05e165$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, on = param.on;
    var initialized = false;
    var document = (0, $lO9y8.getDocument)();
    var window = (0, $lO9y8.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    var onHashChange = function() {
        emit('hashChange');
        var newHash = document.location.hash.replace('#', '');
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.$wrapperEl.children(".".concat(swiper.params.slideClass, '[data-hash="').concat(newHash, '"]')).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#".concat(swiper.slides.eq(swiper.activeIndex).attr('data-hash')) || '');
            emit('hashSet');
        } else {
            var slide = swiper.slides.eq(swiper.activeIndex);
            var hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    var init = function() {
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace('#', '');
        if (hash) {
            var speed = 0;
            for(var i = 0, length = swiper.slides.length; i < length; i += 1){
                var slide = swiper.slides.eq(i);
                var slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    var index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(window).on('hashchange', onHashChange);
    };
    var destroy = function() {
        if (swiper.params.hashNavigation.watchState) (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(window).off('hashchange', onHashChange);
    };
    on('init', function() {
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', function() {
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHash();
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $lO9y8 = parcelRequire("lO9y8");

function $6a53d3bced22dc73$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $7fdc5d9b728c141a$export$bdd553fddd433dcb)(function() {
            var autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        var document = (0, $lO9y8.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else pause();
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', function() {
        if (swiper.params.autoplay.enabled) {
            start();
            var document = (0, $lO9y8.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', function(_s, speed, internal) {
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', function() {
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', function() {
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', function() {
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        var document = (0, $lO9y8.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $4a20353ab7c9b248$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $6947194dc33a33f2$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $6947194dc33a33f2$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            var currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            var prevIndex = swiper.slides.eq(currentIndex).prevAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            var nextIndex = swiper.slides.eq(currentIndex).nextAll('[data-swiper-slide-index="'.concat(slideToIndex, '"]')).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $7fdc5d9b728c141a$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll('[data-swiper-slide-index="'.concat(swiper.realIndex, '"]')).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        } // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children('[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).addClass(thumbActiveClass);
        else for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)thumbsSwiper.slides.eq(swiper.realIndex + i1).addClass(thumbActiveClass);
    }
    on('beforeInit', function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', function() {
        if (!swiper.thumbs.swiper) return;
        update();
    });
    on('setTransition', function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        if (swiperCreated && thumbsSwiper) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $e8908d322a7c80c2$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, once = param.once;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchMove() {
        var data = swiper.touchEventsData, touches = swiper.touches; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $7fdc5d9b728c141a$export$461939dd4422153)()
        });
    }
    function onTouchEnd(param) {
        var currentPos = param.currentPos;
        var params = swiper.params, $wrapperEl = swiper.$wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData; // Time diff
        var touchEndTime = (0, $7fdc5d9b728c141a$export$461939dd4422153)();
        var timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $7fdc5d9b728c141a$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeMode.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', function() {
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}




var $cfh0a = parcelRequire("cfh0a");
function $a7efc64c85ec7bf0$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var initSlides = function(slidesLength) {
        var slidesPerView = swiper.params.slidesPerView;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    var updateSlide = function(i, slide, slidesLength, getDirectionLabel) {
        var _swiper_params = swiper.params, slidesPerGroup = _swiper_params.slidesPerGroup, spaceBetween = _swiper_params.spaceBetween;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill; // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === 'row' && slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (slidesPerGroup * rows));
            var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && "".concat(spaceBetween, "px") : '');
    };
    var updateWrapperSize = function(slideSize, snapGrid, getDirectionLabel) {
        var _swiper_params = swiper.params, spaceBetween = _swiper_params.spaceBetween, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var rows = swiper.params.grid.rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css((0, $37e80ca29cd951d6$export$71511d61b312f219)({}, getDirectionLabel('width'), "".concat(swiper.virtualSize + spaceBetween, "px")));
        if (centeredSlides) {
            var _snapGrid;
            snapGrid.splice(0, snapGrid.length);
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, $cfh0a._)(newSlidesGrid));
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



var $j2WbH = parcelRequire("j2WbH");
function $6440a4f085b34fce$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params;
    if (params.loop) swiper.loopDestroy();
    if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}



var $j2WbH = parcelRequire("j2WbH");
function $c89d7729dcc8d9e4$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}



var $j2WbH = parcelRequire("j2WbH");
function $8b0276b3f92124db$export$2e2bcd8739ae039(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if ((typeof slides === "undefined" ? "undefined" : (0, $j2WbH._)(slides)) === 'object' && 'length' in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) $wrapperEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)$wrapperEl.append(slidesBuffer[i2]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}



var $j2WbH = parcelRequire("j2WbH");
function $5c4de70429299f03$export$2e2bcd8739ae039(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(".".concat(params.slideClass));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if ((typeof slidesIndexes === "undefined" ? "undefined" : (0, $j2WbH._)(slidesIndexes)) === 'object' && 'length' in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $6b908db3ae6150af$export$2e2bcd8739ae039() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $795d333d6000fc9e$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper;
    Object.assign(swiper, {
        appendSlide: (0, $6440a4f085b34fce$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $c89d7729dcc8d9e4$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $8b0276b3f92124db$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $5c4de70429299f03$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $6b908db3ae6150af$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $16957bcc944e3484$export$2e2bcd8739ae039(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective;
    on('beforeInit', function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));
        if (perspective && perspective()) swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
}


function $d1469bae66586c53$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}


function $ec8d9ca3a9fdd2fb$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, duration = param.duration, transformEl = param.transformEl, allSlides = param.allSlides;
    var slides = swiper.slides, activeIndex = swiper.activeIndex, $wrapperEl = swiper.$wrapperEl;
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(function() {
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(var i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $ab60ecd0206b84e4$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = swiper.params.fadeEffect;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = swiper.slides.eq(i);
            var offset = $slideEl[0].swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            var $targetEl = (0, $d1469bae66586c53$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform("translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)"));
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.fadeEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $ec8d9ca3a9fdd2fb$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $16957bcc944e3484$export$2e2bcd8739ae039)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




function $862d51a13977644a$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    var setTranslate = function() {
        var $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: "".concat(swiperWidth, "px")
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? 'left' : 'top', '"></div>'));
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<div class="swiper-slide-shadow-'.concat(isHorizontal ? 'right' : 'bottom', '"></div>'));
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            '-webkit-transform-origin': "50% 50% -".concat(swiperSize / 2, "px"),
            'transform-origin': "50% 50% -".concat(swiperSize / 2, "px")
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform("translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")"));
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                $cubeShadowEl.transform("scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)"));
            }
        }
        var zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)"));
    };
    var setTransition = function(duration) {
        var $el = swiper.$el, slides = swiper.slides;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $16957bcc944e3484$export$2e2bcd8739ae039)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
}



function $4d5132de133a69b3$export$2e2bcd8739ae039(params, $slideEl, side) {
    var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : '');
    var $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    var $shadowEl = $shadowContainer.children(".".concat(shadowClass));
    if (!$shadowEl.length) {
        $shadowEl = (0, $6947194dc33a33f2$export$2e2bcd8739ae039)('<div class="swiper-slide-shadow'.concat(side ? "-".concat(side) : '', '"></div>'));
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $f392c83abed42973$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = swiper.params.flipEffect;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            var offset = $slideEl[0].swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) {
                // Set shadows
                var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if (shadowBefore.length === 0) shadowBefore = (0, $4d5132de133a69b3$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
                if (shadowAfter.length === 0) shadowAfter = (0, $4d5132de133a69b3$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)");
            var $targetEl = (0, $d1469bae66586c53$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.flipEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $ec8d9ca3a9fdd2fb$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $16957bcc944e3484$export$2e2bcd8739ae039)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}





function $6a273a2ef5cd8702$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth; // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var $slideEl = slides.eq(i);
            var slideSize = slidesSizesGrid[i];
            var slideOffset = $slideEl[0].swiperSlideOffset;
            var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
            var $targetEl = (0, $d1469bae66586c53$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $4d5132de133a69b3$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $4d5132de133a69b3$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.coverflowEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $16957bcc944e3484$export$2e2bcd8739ae039)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
}






function $ce6e5774f9f2a4e5$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var getTranslateValue = function(value) {
        if (typeof value === 'string') return value;
        return "".concat(value, "px");
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var $slideEl = slides.eq(i);
            var slideProgress = $slideEl[0].progress;
            var progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            var offset = $slideEl[0].swiperSlideOffset;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach(function(value, index) {
                t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
            }); // set rotates
            r.forEach(function(value, index) {
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var translateString = t.join(', ');
            var rotateString = "rotateX(".concat(r[0], "deg) rotateY(").concat(r[1], "deg) rotateZ(").concat(r[2], "deg)");
            var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString); // Set shadows
            if (custom && data.shadow || !custom) {
                var $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $4d5132de133a69b3$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            var $targetEl = (0, $d1469bae66586c53$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        };
        var slides = swiper.slides, $wrapperEl = swiper.$wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.creativeEffect;
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform("translateX(calc(50% - ".concat(margin, "px))"));
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.creativeEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $ec8d9ca3a9fdd2fb$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $16957bcc944e3484$export$2e2bcd8739ae039)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return swiper.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}






function $927af4c01ac51974$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex;
        var params = swiper.params.cardsEffect;
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var $slideEl = slides.eq(i);
            var slideProgress = $slideEl[0].progress;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform("translateX(".concat(swiper.minTranslate(), "px)"));
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -2 * progress;
            var tXAdd = 8 - Math.abs(progress) * 0.75;
            var isSwipeToNext = (i === activeIndex || i === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            var isSwipeToPrev = (i === activeIndex || i === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = "".concat(-25 * subProgress * Math.abs(progress), "%");
            }
            if (progress < 0) // next
            tX = "calc(".concat(tX, "px + (").concat(tXAdd * Math.abs(progress), "%))");
            else if (progress > 0) // prev
            tX = "calc(".concat(tX, "px + (-").concat(tXAdd * Math.abs(progress), "%))");
            else tX = "".concat(tX, "px");
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
            var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(rotate, "deg)\n        scale(").concat(scaleString, ")\n      ");
            if (params.slideShadows) {
                // Set shadows
                var $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $4d5132de133a69b3$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var $targetEl = (0, $d1469bae66586c53$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    var setTransition = function(duration) {
        var transformEl = swiper.params.cardsEffect.transformEl;
        var $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $ec8d9ca3a9fdd2fb$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $16957bcc944e3484$export$2e2bcd8739ae039)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




/*!
  * PhotoSwipe Lightbox 5.4.4 - https://photoswipe.com
  * (c) 2024 Dmytro Semenov
  */ /** @typedef {import('../photoswipe.js').Point} Point */ /**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */ 
var $lPOtB = parcelRequire("lPOtB");

var $dXdNl = parcelRequire("dXdNl");


var $l3RwB = parcelRequire("l3RwB");

var $j2WbH = parcelRequire("j2WbH");
function $d5cf025f85a9e906$var$createElement(className, tagName, appendToEl) {
    var el = document.createElement(tagName);
    if (className) el.className = className;
    if (appendToEl) appendToEl.appendChild(el);
    return el;
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */ function $d5cf025f85a9e906$var$toTransformString(x, y, scale) {
    var propValue = "translate3d(".concat(x, "px,").concat(y || 0, "px,0)");
    if (scale !== undefined) propValue += " scale3d(".concat(scale, ",").concat(scale, ",1)");
    return propValue;
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */ function $d5cf025f85a9e906$var$setWidthHeight(el, w, h) {
    el.style.width = typeof w === 'number' ? "".concat(w, "px") : w;
    el.style.height = typeof h === 'number' ? "".concat(h, "px") : h;
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */ /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */ var $d5cf025f85a9e906$var$LOAD_STATE = {
    IDLE: 'idle',
    LOADING: 'loading',
    LOADED: 'loaded',
    ERROR: 'error'
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */ function $d5cf025f85a9e906$var$specialKeyUsed(e) {
    return 'button' in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */ function $d5cf025f85a9e906$var$getElementsFromOption(option, legacySelector) {
    var parent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    /** @type {HTMLElement[]} */ var elements = [];
    if (option instanceof Element) elements = [
        option
    ];
    else if (option instanceof NodeList || Array.isArray(option)) elements = Array.from(option);
    else {
        var selector = typeof option === 'string' ? option : legacySelector;
        if (selector) elements = Array.from(parent.querySelectorAll(selector));
    }
    return elements;
}
/**
 * Check if variable is PhotoSwipe class
 *
 * @param {any} fn
 * @returns {boolean}
 */ function $d5cf025f85a9e906$var$isPswpClass(fn) {
    return typeof fn === 'function' && fn.prototype && fn.prototype.goTo;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */ function $d5cf025f85a9e906$var$isSafari() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../slide/content.js').default} ContentDefault */ /** @typedef {import('../slide/slide.js').default} Slide */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */ /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */ /**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */ /** @typedef {{ x?: number; y?: number }} Point */ /**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */ /**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thumbnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
 *
 */ /**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */ /**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */ var $d5cf025f85a9e906$var$PhotoSwipeEvent = /*#__PURE__*/ function() {
    "use strict";
    function PhotoSwipeEvent(type, details) {
        (0, $dXdNl._)(this, PhotoSwipeEvent);
        this.type = type;
        this.defaultPrevented = false;
        if (details) Object.assign(this, details);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PhotoSwipeEvent, [
        {
            key: "preventDefault",
            value: function preventDefault() {
                this.defaultPrevented = true;
            }
        }
    ]);
    return PhotoSwipeEvent;
}();
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */ var $d5cf025f85a9e906$var$Eventable = /*#__PURE__*/ function() {
    "use strict";
    function Eventable() {
        (0, $dXdNl._)(this, Eventable);
        /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */ this._listeners = {};
        /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */ this._filters = {};
        /** @type {PhotoSwipe | undefined} */ this.pswp = undefined;
        /** @type {PhotoSwipeOptions | undefined} */ this.options = undefined;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Eventable, [
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */ key: "addFilter",
            value: function addFilter(name, fn) {
                var priority = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
                var _this$_filters$name, _this$_filters$name2, _this$pswp;
                if (!this._filters[name]) this._filters[name] = [];
                (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
                    fn: fn,
                    priority: priority
                });
                (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort(function(f1, f2) {
                    return f1.priority - f2.priority;
                });
                (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */ key: "removeFilter",
            value: function removeFilter(name, fn) {
                if (this._filters[name]) // @ts-expect-error
                this._filters[name] = this._filters[name].filter(function(filter) {
                    return filter.fn !== fn;
                });
                if (this.pswp) this.pswp.removeFilter(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */ key: "applyFilters",
            value: function applyFilters(name) {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this$_filters$name3;
                (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(function(filter) {
                    // @ts-expect-error
                    args[0] = filter.fn.apply(_this, args);
                });
                return args[0];
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "on",
            value: function on(name, fn) {
                var _this$_listeners$name, _this$pswp2;
                if (!this._listeners[name]) this._listeners[name] = [];
                (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
                // also bind events to PhotoSwipe Core,
                // if it's open.
                (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "off",
            value: function off(name, fn) {
                var _this$pswp3;
                if (this._listeners[name]) // @ts-expect-error
                this._listeners[name] = this._listeners[name].filter(function(listener) {
                    return fn !== listener;
                });
                (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */ key: "dispatch",
            value: function dispatch(name, details) {
                var _this = this;
                var _this$_listeners$name2;
                if (this.pswp) return this.pswp.dispatch(name, details);
                var event = /** @type {AugmentedEvent<T>} */ new $d5cf025f85a9e906$var$PhotoSwipeEvent(name, details);
                (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(function(listener) {
                    listener.call(_this, event);
                });
                return event;
            }
        }
    ]);
    return Eventable;
}();
var $d5cf025f85a9e906$var$Placeholder = /*#__PURE__*/ function() {
    "use strict";
    function Placeholder(imageSrc, container) {
        (0, $dXdNl._)(this, Placeholder);
        // Create placeholder
        // (stretched thumbnail or simple div behind the main image)
        /** @type {HTMLImageElement | HTMLDivElement | null} */ this.element = $d5cf025f85a9e906$var$createElement('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);
        if (imageSrc) {
            var imgEl = /** @type {HTMLImageElement} */ this.element;
            imgEl.decoding = 'async';
            imgEl.alt = '';
            imgEl.src = imageSrc;
            imgEl.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Placeholder, [
        {
            /**
   * @param {number} width
   * @param {number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.element.tagName === 'IMG') {
                    // Use transform scale() to modify img placeholder size
                    // (instead of changing width/height directly).
                    // This helps with performance, specifically in iOS15 Safari.
                    $d5cf025f85a9e906$var$setWidthHeight(this.element, 250, 'auto');
                    this.element.style.transformOrigin = '0 0';
                    this.element.style.transform = $d5cf025f85a9e906$var$toTransformString(0, 0, width / 250);
                } else $d5cf025f85a9e906$var$setWidthHeight(this.element, width, height);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this$element;
                if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) this.element.remove();
                this.element = null;
            }
        }
    ]);
    return Placeholder;
}();
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../util/util.js').LoadState} LoadState */ var $d5cf025f85a9e906$var$Content = /*#__PURE__*/ function() {
    "use strict";
    function Content(itemData, instance, index) {
        (0, $dXdNl._)(this, Content);
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        /** @type {HTMLImageElement | HTMLDivElement | undefined} */ this.element = undefined;
        /** @type {Placeholder | undefined} */ this.placeholder = undefined;
        /** @type {Slide | undefined} */ this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        /** @type {LoadState} */ this.state = $d5cf025f85a9e906$var$LOAD_STATE.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = 'image';
        else this.type = 'html';
        this.instance.dispatch('contentInit', {
            content: this
        });
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Content, [
        {
            key: "removePlaceholder",
            value: function removePlaceholder() {
                var _this = this;
                if (this.placeholder && !this.keepPlaceholder()) // With delay, as image might be loaded, but not rendered
                setTimeout(function() {
                    if (_this.placeholder) {
                        _this.placeholder.destroy();
                        _this.placeholder = undefined;
                    }
                }, 1000);
            }
        },
        {
            /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */ key: "load",
            value: function load(isLazy, reload) {
                if (this.slide && this.usePlaceholder()) {
                    if (!this.placeholder) {
                        var placeholderSrc = this.instance.applyFilters('placeholderSrc', // as rendering (even small stretched thumbnail) is an expensive operation
                        this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
                        this.placeholder = new $d5cf025f85a9e906$var$Placeholder(placeholderSrc, this.slide.container);
                    } else {
                        var placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created
                        if (placeholderEl && !placeholderEl.parentElement) this.slide.container.prepend(placeholderEl);
                    }
                }
                if (this.element && !reload) return;
                if (this.instance.dispatch('contentLoad', {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                if (this.isImageContent()) {
                    this.element = $d5cf025f85a9e906$var$createElement('pswp__img', 'img'); // Start loading only after width is defined, as sizes might depend on it.
                    // Due to Safari feature, we must define sizes before srcset.
                    if (this.displayedImageWidth) this.loadImage(isLazy);
                } else {
                    this.element = $d5cf025f85a9e906$var$createElement('pswp__content', 'div');
                    this.element.innerHTML = this.data.html || '';
                }
                if (reload && this.slide) this.slide.updateContentSize(true);
            }
        },
        {
            /**
   * Preload image
   *
   * @param {boolean} isLazy
   */ key: "loadImage",
            value: function loadImage(isLazy) {
                var _this = this;
                var _this$data$src, _this$data$alt;
                if (!this.isImageContent() || !this.element || this.instance.dispatch('contentLoadImage', {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                var imageElement = /** @type HTMLImageElement */ this.element;
                this.updateSrcsetSizes();
                if (this.data.srcset) imageElement.srcset = this.data.srcset;
                imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
                imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
                this.state = $d5cf025f85a9e906$var$LOAD_STATE.LOADING;
                if (imageElement.complete) this.onLoaded();
                else {
                    imageElement.onload = function() {
                        _this.onLoaded();
                    };
                    imageElement.onerror = function() {
                        _this.onError();
                    };
                }
            }
        },
        {
            /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */ key: "setSlide",
            value: function setSlide(slide) {
                this.slide = slide;
                this.hasSlide = true;
                this.instance = slide.pswp; // todo: do we need to unset slide?
            }
        },
        {
            /**
   * Content load success handler
   */ key: "onLoaded",
            value: function onLoaded() {
                this.state = $d5cf025f85a9e906$var$LOAD_STATE.LOADED;
                if (this.slide && this.element) {
                    this.instance.dispatch('loadComplete', {
                        slide: this.slide,
                        content: this
                    }); // if content is reloaded
                    if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
                        this.append();
                        this.slide.updateContentSize(true);
                    }
                    if (this.state === $d5cf025f85a9e906$var$LOAD_STATE.LOADED || this.state === $d5cf025f85a9e906$var$LOAD_STATE.ERROR) this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Content load error handler
   */ key: "onError",
            value: function onError() {
                this.state = $d5cf025f85a9e906$var$LOAD_STATE.ERROR;
                if (this.slide) {
                    this.displayError();
                    this.instance.dispatch('loadComplete', {
                        slide: this.slide,
                        isError: true,
                        content: this
                    });
                    this.instance.dispatch('loadError', {
                        slide: this.slide,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {Boolean} If the content is currently loading
   */ key: "isLoading",
            value: function isLoading() {
                return this.instance.applyFilters('isContentLoading', this.state === $d5cf025f85a9e906$var$LOAD_STATE.LOADING, this);
            }
        },
        {
            /**
   * @returns {Boolean} If the content is in error state
   */ key: "isError",
            value: function isError() {
                return this.state === $d5cf025f85a9e906$var$LOAD_STATE.ERROR;
            }
        },
        {
            /**
   * @returns {boolean} If the content is image
   */ key: "isImageContent",
            value: function isImageContent() {
                return this.type === 'image';
            }
        },
        {
            /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.placeholder) this.placeholder.setDisplayedSize(width, height);
                if (this.instance.dispatch('contentResize', {
                    content: this,
                    width: width,
                    height: height
                }).defaultPrevented) return;
                $d5cf025f85a9e906$var$setWidthHeight(this.element, width, height);
                if (this.isImageContent() && !this.isError()) {
                    var isInitialSizeUpdate = !this.displayedImageWidth && width;
                    this.displayedImageWidth = width;
                    this.displayedImageHeight = height;
                    if (isInitialSizeUpdate) this.loadImage(false);
                    else this.updateSrcsetSizes();
                    if (this.slide) this.instance.dispatch('imageSizeChange', {
                        slide: this.slide,
                        width: width,
                        height: height,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {boolean} If the content can be zoomed
   */ key: "isZoomable",
            value: function isZoomable() {
                return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== $d5cf025f85a9e906$var$LOAD_STATE.ERROR, this);
            }
        },
        {
            /**
   * Update image srcset sizes attribute based on width and height
   */ key: "updateSrcsetSizes",
            value: function updateSrcsetSizes() {
                // Handle srcset sizes attribute.
                //
                // Never lower quality, if it was increased previously.
                // Chrome does this automatically, Firefox and Safari do not,
                // so we store largest used size in dataset.
                if (!this.isImageContent() || !this.element || !this.data.srcset) return;
                var image = /** @type HTMLImageElement */ this.element;
                var sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
                if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
                    image.sizes = sizesWidth + 'px';
                    image.dataset.largestUsedSize = String(sizesWidth);
                }
            }
        },
        {
            /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */ key: "usePlaceholder",
            value: function usePlaceholder() {
                return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
            }
        },
        {
            /**
   * Preload content with lazy-loading param
   */ key: "lazyLoad",
            value: function lazyLoad() {
                if (this.instance.dispatch('contentLazyLoad', {
                    content: this
                }).defaultPrevented) return;
                this.load(true);
            }
        },
        {
            /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */ key: "keepPlaceholder",
            value: function keepPlaceholder() {
                return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
            }
        },
        {
            /**
   * Destroy the content
   */ key: "destroy",
            value: function destroy() {
                this.hasSlide = false;
                this.slide = undefined;
                if (this.instance.dispatch('contentDestroy', {
                    content: this
                }).defaultPrevented) return;
                this.remove();
                if (this.placeholder) {
                    this.placeholder.destroy();
                    this.placeholder = undefined;
                }
                if (this.isImageContent() && this.element) {
                    this.element.onload = null;
                    this.element.onerror = null;
                    this.element = undefined;
                }
            }
        },
        {
            /**
   * Display error message
   */ key: "displayError",
            value: function displayError() {
                if (this.slide) {
                    var _this$instance$option, _this$instance$option2;
                    var errorMsgEl = $d5cf025f85a9e906$var$createElement('pswp__error-msg', 'div');
                    errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : '';
                    errorMsgEl = /** @type {HTMLDivElement} */ this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
                    this.element = $d5cf025f85a9e906$var$createElement('pswp__content pswp__error-msg-container', 'div');
                    this.element.appendChild(errorMsgEl);
                    this.slide.container.innerText = '';
                    this.slide.container.appendChild(this.element);
                    this.slide.updateContentSize(true);
                    this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Append the content
   */ key: "append",
            value: function append() {
                var _this = this;
                if (this.isAttached || !this.element) return;
                this.isAttached = true;
                if (this.state === $d5cf025f85a9e906$var$LOAD_STATE.ERROR) {
                    this.displayError();
                    return;
                }
                if (this.instance.dispatch('contentAppend', {
                    content: this
                }).defaultPrevented) return;
                var supportsDecode = 'decode' in this.element;
                if (this.isImageContent()) {
                    // Use decode() on nearby slides
                    //
                    // Nearby slide images are in DOM and not hidden via display:none.
                    // However, they are placed offscreen (to the left and right side).
                    //
                    // Some browsers do not composite the image until it's actually visible,
                    // using decode() helps.
                    //
                    // You might ask "why dont you just decode() and then append all images",
                    // that's because I want to show image before it's fully loaded,
                    // as browser can render parts of image while it is loading.
                    // We do not do this in Safari due to partial loading bug.
                    if (supportsDecode && this.slide && (!this.slide.isActive || $d5cf025f85a9e906$var$isSafari())) {
                        this.isDecoding = true; // purposefully using finally instead of then,
                        // as if srcset sizes changes dynamically - it may cause decode error
                        /** @type {HTMLImageElement} */ this.element.decode().catch(function() {}).finally(function() {
                            _this.isDecoding = false;
                            _this.appendImage();
                        });
                    } else this.appendImage();
                } else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
            }
        },
        {
            /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */ key: "activate",
            value: function activate() {
                if (this.instance.dispatch('contentActivate', {
                    content: this
                }).defaultPrevented || !this.slide) return;
                if (this.isImageContent() && this.isDecoding && !$d5cf025f85a9e906$var$isSafari()) // add image to slide when it becomes active,
                // even if it's not finished decoding
                this.appendImage();
                else if (this.isError()) this.load(false, true); // try to reload
                if (this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'false');
            }
        },
        {
            /**
   * Deactivate the content
   */ key: "deactivate",
            value: function deactivate() {
                this.instance.dispatch('contentDeactivate', {
                    content: this
                });
                if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'true');
            }
        },
        {
            /**
   * Remove the content from DOM
   */ key: "remove",
            value: function remove() {
                this.isAttached = false;
                if (this.instance.dispatch('contentRemove', {
                    content: this
                }).defaultPrevented) return;
                if (this.element && this.element.parentNode) this.element.remove();
                if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
            }
        },
        {
            /**
   * Append the image content to slide container
   */ key: "appendImage",
            value: function appendImage() {
                if (!this.isAttached) return;
                if (this.instance.dispatch('contentAppendImage', {
                    content: this
                }).defaultPrevented) return;
                 // ensure that element exists and is not already appended
                if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
                if (this.state === $d5cf025f85a9e906$var$LOAD_STATE.LOADED || this.state === $d5cf025f85a9e906$var$LOAD_STATE.ERROR) this.removePlaceholder();
            }
        }
    ]);
    return Content;
}();
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */ function $d5cf025f85a9e906$var$getViewportSize(options, pswp) {
    if (options.getViewportSizeFn) {
        var newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) return newViewportSize;
    }
    return {
        x: document.documentElement.clientWidth,
        // TODO: height on mobile is very incosistent due to toolbar
        // find a way to improve this
        //
        // document.documentElement.clientHeight - doesn't seem to work well
        y: window.innerHeight
    };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */ function $d5cf025f85a9e906$var$parsePaddingOption(prop, options, viewportSize, itemData, index) {
    var paddingValue = 0;
    if (options.paddingFn) paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
    else if (options.padding) paddingValue = options.padding[prop];
    else {
        var legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error
        if (options[legacyPropName]) // @ts-expect-error
        paddingValue = options[legacyPropName];
    }
    return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */ function $d5cf025f85a9e906$var$getPanAreaSize(options, viewportSize, itemData, index) {
    return {
        x: viewportSize.x - $d5cf025f85a9e906$var$parsePaddingOption('left', options, viewportSize, itemData, index) - $d5cf025f85a9e906$var$parsePaddingOption('right', options, viewportSize, itemData, index),
        y: viewportSize.y - $d5cf025f85a9e906$var$parsePaddingOption('top', options, viewportSize, itemData, index) - $d5cf025f85a9e906$var$parsePaddingOption('bottom', options, viewportSize, itemData, index)
    };
}
var $d5cf025f85a9e906$var$MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */ /**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */ var $d5cf025f85a9e906$var$ZoomLevel = /*#__PURE__*/ function() {
    "use strict";
    function ZoomLevel(options, itemData, index, pswp) {
        (0, $dXdNl._)(this, ZoomLevel);
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        /** @type { Point | null } */ this.panAreaSize = null;
        /** @type { Point | null } */ this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(ZoomLevel, [
        {
            /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */ key: "update",
            value: function update(maxWidth, maxHeight, panAreaSize) {
                /** @type {Point} */ var elementSize = {
                    x: maxWidth,
                    y: maxHeight
                };
                this.elementSize = elementSize;
                this.panAreaSize = panAreaSize;
                var hRatio = panAreaSize.x / elementSize.x;
                var vRatio = panAreaSize.y / elementSize.y;
                this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
                this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
                // when it has 100% of viewport vertical space (height)
                this.vFill = Math.min(1, vRatio);
                this.initial = this._getInitial();
                this.secondary = this._getSecondary();
                this.max = Math.max(this.initial, this.secondary, this._getMax());
                this.min = Math.min(this.fit, this.initial, this.secondary);
                if (this.pswp) this.pswp.dispatch('zoomLevelsUpdate', {
                    zoomLevels: this,
                    slideData: this.itemData
                });
            }
        },
        {
            /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */ key: "_parseZoomLevelOption",
            value: function _parseZoomLevelOption(optionPrefix) {
                var optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ optionPrefix + 'ZoomLevel';
                var optionValue = this.options[optionName];
                if (!optionValue) return;
                if (typeof optionValue === 'function') return optionValue(this);
                if (optionValue === 'fill') return this.fill;
                if (optionValue === 'fit') return this.fit;
                return Number(optionValue);
            }
        },
        {
            /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */ key: "_getSecondary",
            value: function _getSecondary() {
                var currZoomLevel = this._parseZoomLevelOption('secondary');
                if (currZoomLevel) return currZoomLevel;
                 // 3x of "fit" state, but not larger than original
                currZoomLevel = Math.min(1, this.fit * 3);
                if (this.elementSize && currZoomLevel * this.elementSize.x > $d5cf025f85a9e906$var$MAX_IMAGE_WIDTH) currZoomLevel = $d5cf025f85a9e906$var$MAX_IMAGE_WIDTH / this.elementSize.x;
                return currZoomLevel;
            }
        },
        {
            /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */ key: "_getInitial",
            value: function _getInitial() {
                return this._parseZoomLevelOption('initial') || this.fit;
            }
        },
        {
            /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */ key: "_getMax",
            value: function _getMax() {
                // max zoom level is x4 from "fit state",
                // used for zoom gesture and ctrl/trackpad zoom
                return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
            }
        }
    ]);
    return ZoomLevel;
}();
/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */ function $d5cf025f85a9e906$var$lazyLoadData(itemData, instance, index) {
    var content = instance.createContentFromData(itemData, index);
    /** @type {ZoomLevel | undefined} */ var zoomLevel;
    var options = instance.options; // We need to know dimensions of the image to preload it,
    // as it might use srcset, and we need to define sizes
    if (options) {
        zoomLevel = new $d5cf025f85a9e906$var$ZoomLevel(options, itemData, -1);
        var viewportSize;
        if (instance.pswp) viewportSize = instance.pswp.viewportSize;
        else viewportSize = $d5cf025f85a9e906$var$getViewportSize(options, instance);
        var panAreaSize = $d5cf025f85a9e906$var$getPanAreaSize(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
    }
    content.lazyLoad();
    if (zoomLevel) content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
    return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */ function $d5cf025f85a9e906$var$lazyLoadSlide(index, instance) {
    var itemData = instance.getItemData(index);
    if (instance.dispatch('lazyLoadSlide', {
        index: index,
        itemData: itemData
    }).defaultPrevented) return;
    return $d5cf025f85a9e906$var$lazyLoadData(itemData, instance, index);
}
/** @typedef {import("../photoswipe.js").default} PhotoSwipe */ /** @typedef {import("../slide/slide.js").SlideData} SlideData */ /**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */ var $d5cf025f85a9e906$var$PhotoSwipeBase = /*#__PURE__*/ function(Eventable) {
    "use strict";
    (0, $l3RwB._)(PhotoSwipeBase, Eventable);
    function PhotoSwipeBase() {
        (0, $dXdNl._)(this, PhotoSwipeBase);
        return (0, $lPOtB._)(this, PhotoSwipeBase, arguments);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PhotoSwipeBase, [
        {
            /**
   * Get total number of slides
   *
   * @returns {number}
   */ key: "getNumItems",
            value: function getNumItems() {
                var _this$options;
                var numItems = 0;
                var dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
                if (dataSource && 'length' in dataSource) // may be an array or just object with length property
                numItems = dataSource.length;
                else if (dataSource && 'gallery' in dataSource) {
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    if (dataSource.items) numItems = dataSource.items.length;
                } // legacy event, before filters were introduced
                var event = this.dispatch('numItems', {
                    dataSource: dataSource,
                    numItems: numItems
                });
                return this.applyFilters('numItems', event.numItems, dataSource);
            }
        },
        {
            /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */ key: "createContentFromData",
            value: function createContentFromData(slideData, index) {
                return new $d5cf025f85a9e906$var$Content(slideData, this, index);
            }
        },
        {
            /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */ key: "getItemData",
            value: function getItemData(index) {
                var _this$options2;
                var dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
                /** @type {SlideData | HTMLElement} */ var dataSourceItem = {};
                if (Array.isArray(dataSource)) // Datasource is an array of elements
                dataSourceItem = dataSource[index];
                else if (dataSource && 'gallery' in dataSource) {
                    // dataSource has gallery property,
                    // thus it was created by Lightbox, based on
                    // gallery and children options
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    dataSourceItem = dataSource.items[index];
                }
                var itemData = dataSourceItem;
                if (itemData instanceof Element) itemData = this._domElementToItemData(itemData);
                 // Dispatching the itemData event,
                // it's a legacy verion before filters were introduced
                var event = this.dispatch('itemData', {
                    itemData: itemData || {},
                    index: index
                });
                return this.applyFilters('itemData', event.itemData, index);
            }
        },
        {
            /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */ key: "_getGalleryDOMElements",
            value: function _getGalleryDOMElements(galleryElement) {
                var _this$options3, _this$options4;
                if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) return $d5cf025f85a9e906$var$getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
                return [
                    galleryElement
                ];
            }
        },
        {
            /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */ key: "_domElementToItemData",
            value: function _domElementToItemData(element) {
                /** @type {SlideData} */ var itemData = {
                    element: element
                };
                var linkEl = /** @type {HTMLAnchorElement} */ element.tagName === 'A' ? element : element.querySelector('a');
                if (linkEl) {
                    // src comes from data-pswp-src attribute,
                    // if it's empty link href is used
                    itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
                    if (linkEl.dataset.pswpSrcset) itemData.srcset = linkEl.dataset.pswpSrcset;
                    itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
                    itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties
                    itemData.w = itemData.width;
                    itemData.h = itemData.height;
                    if (linkEl.dataset.pswpType) itemData.type = linkEl.dataset.pswpType;
                    var thumbnailEl = element.querySelector('img');
                    if (thumbnailEl) {
                        var _thumbnailEl$getAttri;
                        // msrc is URL to placeholder image that's displayed before large image is loaded
                        // by default it's displayed only for the first slide
                        itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
                        itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : '';
                    }
                    if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) itemData.thumbCropped = true;
                }
                return this.applyFilters('domItemData', itemData, element, linkEl);
            }
        },
        {
            /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */ key: "lazyLoadData",
            value: function lazyLoadData1(itemData, index) {
                return $d5cf025f85a9e906$var$lazyLoadData(itemData, this, index);
            }
        }
    ]);
    return PhotoSwipeBase;
}($d5cf025f85a9e906$var$Eventable);
/**
 * @template T
 * @typedef {import('../types.js').Type<T>} Type<T>
 */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/content.js').default} Content */ /** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */ /** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
 */ /**
 * PhotoSwipe Lightbox
 *
 * - If user has unsupported browser it falls back to default browser action (just opens URL)
 * - Binds click event to links that should open PhotoSwipe
 * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
 * - Initializes PhotoSwipe
 *
 *
 * Loader options use the same object as PhotoSwipe, and supports such options:
 *
 * gallery - Element | Element[] | NodeList | string selector for the gallery element
 * children - Element | Element[] | NodeList | string selector for the gallery children
 *
 */ var $d5cf025f85a9e906$export$2e2bcd8739ae039 = /*#__PURE__*/ function(PhotoSwipeBase) {
    "use strict";
    (0, $l3RwB._)(PhotoSwipeLightbox, PhotoSwipeBase);
    function PhotoSwipeLightbox(options) {
        (0, $dXdNl._)(this, PhotoSwipeLightbox);
        var _this;
        _this = (0, $lPOtB._)(this, PhotoSwipeLightbox);
        /** @type {PhotoSwipeOptions} */ _this.options = options || {};
        _this._uid = 0;
        _this.shouldOpen = false;
        /**
     * @private
     * @type {Content | undefined}
     */ _this._preloadedContent = undefined;
        _this.onThumbnailsClick = _this.onThumbnailsClick.bind(_this);
        return _this;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PhotoSwipeLightbox, [
        {
            /**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */ key: "init",
            value: function init() {
                var _this = this;
                // Bind click events to each gallery
                $d5cf025f85a9e906$var$getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(function(galleryElement) {
                    galleryElement.addEventListener('click', _this.onThumbnailsClick, false);
                });
            }
        },
        {
            /**
   * @param {MouseEvent} e
   */ key: "onThumbnailsClick",
            value: function onThumbnailsClick(e) {
                // Exit and allow default browser action if:
                if ($d5cf025f85a9e906$var$specialKeyUsed(e) // ... if clicked with a special key (ctrl/cmd...)
                 || window.pswp) // ... if PhotoSwipe is already open
                return;
                 // If both clientX and clientY are 0 or not defined,
                // the event is likely triggered by keyboard,
                // so we do not pass the initialPoint
                //
                // Note that some screen readers emulate the mouse position,
                // so it's not the ideal way to detect them.
                //
                /** @type {Point | null} */ var initialPoint = {
                    x: e.clientX,
                    y: e.clientY
                };
                if (!initialPoint.x && !initialPoint.y) initialPoint = null;
                var clickedIndex = this.getClickedIndex(e);
                clickedIndex = this.applyFilters('clickedIndex', clickedIndex, e, this);
                /** @type {DataSource} */ var dataSource = {
                    gallery: /** @type {HTMLElement} */ e.currentTarget
                };
                if (clickedIndex >= 0) {
                    e.preventDefault();
                    this.loadAndOpen(clickedIndex, dataSource, initialPoint);
                }
            }
        },
        {
            /**
   * Get index of gallery item that was clicked.
   *
   * @param {MouseEvent} e click event
   * @returns {number}
   */ key: "getClickedIndex",
            value: function getClickedIndex(e) {
                // legacy option
                if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, e);
                var clickedTarget = /** @type {HTMLElement} */ e.target;
                var childElements = $d5cf025f85a9e906$var$getElementsFromOption(this.options.children, this.options.childSelector, /** @type {HTMLElement} */ e.currentTarget);
                var clickedChildIndex = childElements.findIndex(function(child) {
                    return child === clickedTarget || child.contains(clickedTarget);
                });
                if (clickedChildIndex !== -1) return clickedChildIndex;
                else if (this.options.children || this.options.childSelector) // click wasn't on a child element
                return -1;
                 // There is only one item (which is the gallery)
                return 0;
            }
        },
        {
            /**
   * Load and open PhotoSwipe
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   * @param {Point | null} [initialPoint]
   * @returns {boolean}
   */ key: "loadAndOpen",
            value: function loadAndOpen(index, dataSource, initialPoint) {
                // Check if the gallery is already open
                if (window.pswp || !this.options) return false;
                 // Use the first gallery element if dataSource is not provided
                if (!dataSource && this.options.gallery && this.options.children) {
                    var galleryElements = $d5cf025f85a9e906$var$getElementsFromOption(this.options.gallery);
                    if (galleryElements[0]) dataSource = {
                        gallery: galleryElements[0]
                    };
                } // set initial index
                this.options.index = index; // define options for PhotoSwipe constructor
                this.options.initialPointerPos = initialPoint;
                this.shouldOpen = true;
                this.preload(index, dataSource);
                return true;
            }
        },
        {
            /**
   * Load the main module and the slide content by index
   *
   * @param {number} index
   * @param {DataSource} [dataSource]
   */ key: "preload",
            value: function preload(index, dataSource) {
                var _this = this;
                var options = this.options;
                if (dataSource) options.dataSource = dataSource;
                 // Add the main module
                /** @type {Promise<Type<PhotoSwipe>>[]} */ var promiseArray = [];
                var pswpModuleType = (0, $j2WbH._)(options.pswpModule);
                if ($d5cf025f85a9e906$var$isPswpClass(options.pswpModule)) promiseArray.push(Promise.resolve(/** @type {Type<PhotoSwipe>} */ options.pswpModule));
                else if (pswpModuleType === 'string') throw new Error('pswpModule as string is no longer supported');
                else if (pswpModuleType === 'function') promiseArray.push(/** @type {() => Promise<Type<PhotoSwipe>>} */ options.pswpModule());
                else throw new Error('pswpModule is not valid');
                 // Add custom-defined promise, if any
                if (typeof options.openPromise === 'function') // allow developers to perform some task before opening
                promiseArray.push(options.openPromise());
                if (options.preloadFirstSlide !== false && index >= 0) this._preloadedContent = $d5cf025f85a9e906$var$lazyLoadSlide(index, this);
                 // Wait till all promises resolve and open PhotoSwipe
                var uid = ++this._uid;
                Promise.all(promiseArray).then(function(iterableModules) {
                    if (_this.shouldOpen) {
                        var mainModule = iterableModules[0];
                        _this._openPhotoswipe(mainModule, uid);
                    }
                });
            }
        },
        {
            /**
   * @private
   * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
   * @param {number} uid
   */ key: "_openPhotoswipe",
            value: function _openPhotoswipe(module, uid) {
                var _this = this;
                // Cancel opening if UID doesn't match the current one
                // (if user clicked on another gallery item before current was loaded).
                //
                // Or if shouldOpen flag is set to false
                // (developer may modify it via public API)
                if (uid !== this._uid && this.shouldOpen) return;
                this.shouldOpen = false; // PhotoSwipe is already open
                if (window.pswp) return;
                /**
     * Pass data to PhotoSwipe and open init
     *
     * @type {PhotoSwipe}
     */ var pswp = (typeof module === "undefined" ? "undefined" : (0, $j2WbH._)(module)) === 'object' ? new module.default(this.options) // eslint-disable-line
                 : new module(this.options); // eslint-disable-line
                this.pswp = pswp;
                window.pswp = pswp; // map listeners from Lightbox to PhotoSwipe Core
                /** @type {(keyof PhotoSwipeEventsMap)[]} */ Object.keys(this._listeners).forEach(function(name) {
                    var _this$_listeners$name;
                    (_this$_listeners$name = _this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.forEach(function(fn) {
                        pswp.on(name, /** @type {EventCallback<typeof name>} */ fn);
                    });
                }); // same with filters
                /** @type {(keyof PhotoSwipeFiltersMap)[]} */ Object.keys(this._filters).forEach(function(name) {
                    var _this$_filters$name;
                    (_this$_filters$name = _this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.forEach(function(filter) {
                        pswp.addFilter(name, filter.fn, filter.priority);
                    });
                });
                if (this._preloadedContent) {
                    pswp.contentLoader.addToCache(this._preloadedContent);
                    this._preloadedContent = undefined;
                }
                pswp.on('destroy', function() {
                    // clean up public variables
                    _this.pswp = undefined;
                    delete window.pswp;
                });
                pswp.init();
            }
        },
        {
            /**
   * Unbinds all events, closes PhotoSwipe if it's open.
   */ key: "destroy",
            value: function destroy() {
                var _this = this;
                var _this$pswp;
                (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.destroy();
                this.shouldOpen = false;
                this._listeners = {};
                $d5cf025f85a9e906$var$getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(function(galleryElement) {
                    galleryElement.removeEventListener('click', _this.onThumbnailsClick, false);
                });
            }
        }
    ]);
    return PhotoSwipeLightbox;
}($d5cf025f85a9e906$var$PhotoSwipeBase);


/*!
  * PhotoSwipe 5.4.4 - https://photoswipe.com
  * (c) 2024 Dmytro Semenov
  */ /** @typedef {import('../photoswipe.js').Point} Point */ /**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */ 
var $lPOtB = parcelRequire("lPOtB");

var $dXdNl = parcelRequire("dXdNl");


var $l3RwB = parcelRequire("l3RwB");

function $a9846c98c872cb75$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $37e80ca29cd951d6$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}



var $cfh0a = parcelRequire("cfh0a");
function $f38b189616c72948$var$createElement(className, tagName, appendToEl) {
    var el = document.createElement(tagName);
    if (className) el.className = className;
    if (appendToEl) appendToEl.appendChild(el);
    return el;
}
/**
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */ function $f38b189616c72948$var$equalizePoints(p1, p2) {
    p1.x = p2.x;
    p1.y = p2.y;
    if (p2.id !== undefined) p1.id = p2.id;
    return p1;
}
/**
 * @param {Point} p
 */ function $f38b189616c72948$var$roundPoint(p) {
    p.x = Math.round(p.x);
    p.y = Math.round(p.y);
}
/**
 * Returns distance between two points.
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {number}
 */ function $f38b189616c72948$var$getDistanceBetween(p1, p2) {
    var x = Math.abs(p1.x - p2.x);
    var y = Math.abs(p1.y - p2.y);
    return Math.sqrt(x * x + y * y);
}
/**
 * Whether X and Y positions of points are equal
 *
 * @param {Point} p1
 * @param {Point} p2
 * @returns {boolean}
 */ function $f38b189616c72948$var$pointsEqual(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
/**
 * The float result between the min and max values.
 *
 * @param {number} val
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */ function $f38b189616c72948$var$clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */ function $f38b189616c72948$var$toTransformString(x, y, scale) {
    var propValue = "translate3d(".concat(x, "px,").concat(y || 0, "px,0)");
    if (scale !== undefined) propValue += " scale3d(".concat(scale, ",").concat(scale, ",1)");
    return propValue;
}
/**
 * Apply transform:translate(x, y) scale(scale) to element
 *
 * @param {HTMLElement} el
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 */ function $f38b189616c72948$var$setTransform(el, x, y, scale) {
    el.style.transform = $f38b189616c72948$var$toTransformString(x, y, scale);
}
var $f38b189616c72948$var$defaultCSSEasing = 'cubic-bezier(.4,0,.22,1)';
/**
 * Apply CSS transition to element
 *
 * @param {HTMLElement} el
 * @param {string} [prop] CSS property to animate
 * @param {number} [duration] in ms
 * @param {string} [ease] CSS easing function
 */ function $f38b189616c72948$var$setTransitionStyle(el, prop, duration, ease) {
    // inOut: 'cubic-bezier(.4, 0, .22, 1)', // for "toggle state" transitions
    // out: 'cubic-bezier(0, 0, .22, 1)', // for "show" transitions
    // in: 'cubic-bezier(.4, 0, 1, 1)'// for "hide" transitions
    el.style.transition = prop ? "".concat(prop, " ").concat(duration, "ms ").concat(ease || $f38b189616c72948$var$defaultCSSEasing) : 'none';
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */ function $f38b189616c72948$var$setWidthHeight(el, w, h) {
    el.style.width = typeof w === 'number' ? "".concat(w, "px") : w;
    el.style.height = typeof h === 'number' ? "".concat(h, "px") : h;
}
/**
 * @param {HTMLElement} el
 */ function $f38b189616c72948$var$removeTransitionStyle(el) {
    $f38b189616c72948$var$setTransitionStyle(el);
}
/**
 * @param {HTMLImageElement} img
 * @returns {Promise<HTMLImageElement | void>}
 */ function $f38b189616c72948$var$decodeImage(img) {
    if ('decode' in img) return img.decode().catch(function() {});
    if (img.complete) return Promise.resolve(img);
    return new Promise(function(resolve, reject) {
        img.onload = function() {
            return resolve(img);
        };
        img.onerror = reject;
    });
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */ /** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */ var $f38b189616c72948$var$LOAD_STATE = {
    IDLE: 'idle',
    LOADING: 'loading',
    LOADED: 'loaded',
    ERROR: 'error'
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */ function $f38b189616c72948$var$specialKeyUsed(e) {
    return 'button' in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */ function $f38b189616c72948$var$getElementsFromOption(option, legacySelector) {
    var parent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    /** @type {HTMLElement[]} */ var elements = [];
    if (option instanceof Element) elements = [
        option
    ];
    else if (option instanceof NodeList || Array.isArray(option)) elements = Array.from(option);
    else {
        var selector = typeof option === 'string' ? option : legacySelector;
        if (selector) elements = Array.from(parent.querySelectorAll(selector));
    }
    return elements;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */ function $f38b189616c72948$var$isSafari() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}
// Detect passive event listener support
var $f38b189616c72948$var$supportsPassive = false;
/* eslint-disable */ try {
    /* @ts-ignore */ window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
        get: function() {
            $f38b189616c72948$var$supportsPassive = true;
        }
    }));
} catch (e) {}
/* eslint-enable */ /**
 * @typedef {Object} PoolItem
 * @prop {HTMLElement | Window | Document | undefined | null} target
 * @prop {string} type
 * @prop {EventListenerOrEventListenerObject} listener
 * @prop {boolean} [passive]
 */ var $f38b189616c72948$var$DOMEvents = /*#__PURE__*/ function() {
    "use strict";
    function DOMEvents() {
        (0, $dXdNl._)(this, DOMEvents);
        /**
     * @type {PoolItem[]}
     * @private
     */ this._pool = [];
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(DOMEvents, [
        {
            /**
   * Adds event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type Can be multiple, separated by space.
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */ key: "add",
            value: function add(target, type, listener, passive) {
                this._toggleListener(target, type, listener, passive);
            }
        },
        {
            /**
   * Removes event listeners
   *
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   */ key: "remove",
            value: function remove(target, type, listener, passive) {
                this._toggleListener(target, type, listener, passive, true);
            }
        },
        {
            /**
   * Removes all bound events
   */ key: "removeAll",
            value: function removeAll() {
                var _this = this;
                this._pool.forEach(function(poolItem) {
                    _this._toggleListener(poolItem.target, poolItem.type, poolItem.listener, poolItem.passive, true, true);
                });
                this._pool = [];
            }
        },
        {
            /**
   * Adds or removes event
   *
   * @private
   * @param {PoolItem['target']} target
   * @param {PoolItem['type']} type
   * @param {PoolItem['listener']} listener
   * @param {PoolItem['passive']} [passive]
   * @param {boolean} [unbind] Whether the event should be added or removed
   * @param {boolean} [skipPool] Whether events pool should be skipped
   */ key: "_toggleListener",
            value: function _toggleListener(target, type, listener, passive, unbind, skipPool) {
                var _this = this;
                if (!target) return;
                var methodName = unbind ? 'removeEventListener' : 'addEventListener';
                var types = type.split(' ');
                types.forEach(function(eType) {
                    if (eType) {
                        // Events pool is used to easily unbind all events when PhotoSwipe is closed,
                        // so developer doesn't need to do this manually
                        if (!skipPool) {
                            if (unbind) // Remove from the events pool
                            _this._pool = _this._pool.filter(function(poolItem) {
                                return poolItem.type !== eType || poolItem.listener !== listener || poolItem.target !== target;
                            });
                            else // Add to the events pool
                            _this._pool.push({
                                target: target,
                                type: eType,
                                listener: listener,
                                passive: passive
                            });
                        } // most PhotoSwipe events call preventDefault,
                        // and we do not need browser to scroll the page
                        var eventOptions = $f38b189616c72948$var$supportsPassive ? {
                            passive: passive || false
                        } : false;
                        target[methodName](eType, listener, eventOptions);
                    }
                });
            }
        }
    ]);
    return DOMEvents;
}();
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */ function $f38b189616c72948$var$getViewportSize(options, pswp) {
    if (options.getViewportSizeFn) {
        var newViewportSize = options.getViewportSizeFn(options, pswp);
        if (newViewportSize) return newViewportSize;
    }
    return {
        x: document.documentElement.clientWidth,
        // TODO: height on mobile is very incosistent due to toolbar
        // find a way to improve this
        //
        // document.documentElement.clientHeight - doesn't seem to work well
        y: window.innerHeight
    };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */ function $f38b189616c72948$var$parsePaddingOption(prop, options, viewportSize, itemData, index) {
    var paddingValue = 0;
    if (options.paddingFn) paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
    else if (options.padding) paddingValue = options.padding[prop];
    else {
        var legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error
        if (options[legacyPropName]) // @ts-expect-error
        paddingValue = options[legacyPropName];
    }
    return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */ function $f38b189616c72948$var$getPanAreaSize(options, viewportSize, itemData, index) {
    return {
        x: viewportSize.x - $f38b189616c72948$var$parsePaddingOption('left', options, viewportSize, itemData, index) - $f38b189616c72948$var$parsePaddingOption('right', options, viewportSize, itemData, index),
        y: viewportSize.y - $f38b189616c72948$var$parsePaddingOption('top', options, viewportSize, itemData, index) - $f38b189616c72948$var$parsePaddingOption('bottom', options, viewportSize, itemData, index)
    };
}
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {Record<Axis, number>} Point */ /** @typedef {'x' | 'y'} Axis */ /**
 * Calculates minimum, maximum and initial (center) bounds of a slide
 */ var $f38b189616c72948$var$PanBounds = /*#__PURE__*/ function() {
    "use strict";
    function PanBounds(slide) {
        (0, $dXdNl._)(this, PanBounds);
        this.slide = slide;
        this.currZoomLevel = 1;
        this.center = /** @type {Point} */ {
            x: 0,
            y: 0
        };
        this.max = /** @type {Point} */ {
            x: 0,
            y: 0
        };
        this.min = /** @type {Point} */ {
            x: 0,
            y: 0
        };
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PanBounds, [
        {
            /**
   * _getItemBounds
   *
   * @param {number} currZoomLevel
   */ key: "update",
            value: function update(currZoomLevel) {
                this.currZoomLevel = currZoomLevel;
                if (!this.slide.width) this.reset();
                else {
                    this._updateAxis('x');
                    this._updateAxis('y');
                    this.slide.pswp.dispatch('calcBounds', {
                        slide: this.slide
                    });
                }
            }
        },
        {
            /**
   * _calculateItemBoundsForAxis
   *
   * @param {Axis} axis
   */ key: "_updateAxis",
            value: function _updateAxis(axis) {
                var pswp = this.slide.pswp;
                var elSize = this.slide[axis === 'x' ? 'width' : 'height'] * this.currZoomLevel;
                var paddingProp = axis === 'x' ? 'left' : 'top';
                var padding = $f38b189616c72948$var$parsePaddingOption(paddingProp, pswp.options, pswp.viewportSize, this.slide.data, this.slide.index);
                var panAreaSize = this.slide.panAreaSize[axis]; // Default position of element.
                // By default, it is center of viewport:
                this.center[axis] = Math.round((panAreaSize - elSize) / 2) + padding; // maximum pan position
                this.max[axis] = elSize > panAreaSize ? Math.round(panAreaSize - elSize) + padding : this.center[axis]; // minimum pan position
                this.min[axis] = elSize > panAreaSize ? padding : this.center[axis];
            } // _getZeroBounds
        },
        {
            key: "reset",
            value: function reset() {
                this.center.x = 0;
                this.center.y = 0;
                this.max.x = 0;
                this.max.y = 0;
                this.min.x = 0;
                this.min.y = 0;
            }
        },
        {
            /**
   * Correct pan position if it's beyond the bounds
   *
   * @param {Axis} axis x or y
   * @param {number} panOffset
   * @returns {number}
   */ key: "correctPan",
            value: function correctPan(axis, panOffset) {
                // checkPanBounds
                return $f38b189616c72948$var$clamp(panOffset, this.max[axis], this.min[axis]);
            }
        }
    ]);
    return PanBounds;
}();
var $f38b189616c72948$var$MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */ /**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */ var $f38b189616c72948$var$ZoomLevel = /*#__PURE__*/ function() {
    "use strict";
    function ZoomLevel(options, itemData, index, pswp) {
        (0, $dXdNl._)(this, ZoomLevel);
        this.pswp = pswp;
        this.options = options;
        this.itemData = itemData;
        this.index = index;
        /** @type { Point | null } */ this.panAreaSize = null;
        /** @type { Point | null } */ this.elementSize = null;
        this.fit = 1;
        this.fill = 1;
        this.vFill = 1;
        this.initial = 1;
        this.secondary = 1;
        this.max = 1;
        this.min = 1;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(ZoomLevel, [
        {
            /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */ key: "update",
            value: function update(maxWidth, maxHeight, panAreaSize) {
                /** @type {Point} */ var elementSize = {
                    x: maxWidth,
                    y: maxHeight
                };
                this.elementSize = elementSize;
                this.panAreaSize = panAreaSize;
                var hRatio = panAreaSize.x / elementSize.x;
                var vRatio = panAreaSize.y / elementSize.y;
                this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
                this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
                // when it has 100% of viewport vertical space (height)
                this.vFill = Math.min(1, vRatio);
                this.initial = this._getInitial();
                this.secondary = this._getSecondary();
                this.max = Math.max(this.initial, this.secondary, this._getMax());
                this.min = Math.min(this.fit, this.initial, this.secondary);
                if (this.pswp) this.pswp.dispatch('zoomLevelsUpdate', {
                    zoomLevels: this,
                    slideData: this.itemData
                });
            }
        },
        {
            /**
   * Parses user-defined zoom option.
   *
   * @private
   * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
   * @returns { number | undefined }
   */ key: "_parseZoomLevelOption",
            value: function _parseZoomLevelOption(optionPrefix) {
                var optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */ optionPrefix + 'ZoomLevel';
                var optionValue = this.options[optionName];
                if (!optionValue) return;
                if (typeof optionValue === 'function') return optionValue(this);
                if (optionValue === 'fill') return this.fill;
                if (optionValue === 'fit') return this.fit;
                return Number(optionValue);
            }
        },
        {
            /**
   * Get zoom level to which image will be zoomed after double-tap gesture,
   * or when user clicks on zoom icon,
   * or mouse-click on image itself.
   * If you return 1 image will be zoomed to its original size.
   *
   * @private
   * @return {number}
   */ key: "_getSecondary",
            value: function _getSecondary() {
                var currZoomLevel = this._parseZoomLevelOption('secondary');
                if (currZoomLevel) return currZoomLevel;
                 // 3x of "fit" state, but not larger than original
                currZoomLevel = Math.min(1, this.fit * 3);
                if (this.elementSize && currZoomLevel * this.elementSize.x > $f38b189616c72948$var$MAX_IMAGE_WIDTH) currZoomLevel = $f38b189616c72948$var$MAX_IMAGE_WIDTH / this.elementSize.x;
                return currZoomLevel;
            }
        },
        {
            /**
   * Get initial image zoom level.
   *
   * @private
   * @return {number}
   */ key: "_getInitial",
            value: function _getInitial() {
                return this._parseZoomLevelOption('initial') || this.fit;
            }
        },
        {
            /**
   * Maximum zoom level when user zooms
   * via zoom/pinch gesture,
   * via cmd/ctrl-wheel or via trackpad.
   *
   * @private
   * @return {number}
   */ key: "_getMax",
            value: function _getMax() {
                // max zoom level is x4 from "fit state",
                // used for zoom gesture and ctrl/trackpad zoom
                return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
            }
        }
    ]);
    return ZoomLevel;
}();
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 * Renders and allows to control a single slide
 */ var $f38b189616c72948$var$Slide = /*#__PURE__*/ function() {
    "use strict";
    function Slide(data, index, pswp) {
        (0, $dXdNl._)(this, Slide);
        this.data = data;
        this.index = index;
        this.pswp = pswp;
        this.isActive = index === pswp.currIndex;
        this.currentResolution = 0;
        /** @type {Point} */ this.panAreaSize = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.pan = {
            x: 0,
            y: 0
        };
        this.isFirstSlide = this.isActive && !pswp.opener.isOpen;
        this.zoomLevels = new $f38b189616c72948$var$ZoomLevel(pswp.options, data, index, pswp);
        this.pswp.dispatch('gettingData', {
            slide: this,
            data: this.data,
            index: index
        });
        this.content = this.pswp.contentLoader.getContentBySlide(this);
        this.container = $f38b189616c72948$var$createElement('pswp__zoom-wrap', 'div');
        /** @type {HTMLElement | null} */ this.holderElement = null;
        this.currZoomLevel = 1;
        /** @type {number} */ this.width = this.content.width;
        /** @type {number} */ this.height = this.content.height;
        this.heavyAppended = false;
        this.bounds = new $f38b189616c72948$var$PanBounds(this);
        this.prevDisplayedWidth = -1;
        this.prevDisplayedHeight = -1;
        this.pswp.dispatch('slideInit', {
            slide: this
        });
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Slide, [
        {
            /**
   * If this slide is active/current/visible
   *
   * @param {boolean} isActive
   */ key: "setIsActive",
            value: function setIsActive(isActive) {
                if (isActive && !this.isActive) // slide just became active
                this.activate();
                else if (!isActive && this.isActive) // slide just became non-active
                this.deactivate();
            }
        },
        {
            /**
   * Appends slide content to DOM
   *
   * @param {HTMLElement} holderElement
   */ key: "append",
            value: function append(holderElement) {
                this.holderElement = holderElement;
                this.container.style.transformOrigin = '0 0'; // Slide appended to DOM
                if (!this.data) return;
                this.calculateSize();
                this.load();
                this.updateContentSize();
                this.appendHeavy();
                this.holderElement.appendChild(this.container);
                this.zoomAndPanToInitial();
                this.pswp.dispatch('firstZoomPan', {
                    slide: this
                });
                this.applyCurrentZoomPan();
                this.pswp.dispatch('afterSetContent', {
                    slide: this
                });
                if (this.isActive) this.activate();
            }
        },
        {
            key: "load",
            value: function load() {
                this.content.load(false);
                this.pswp.dispatch('slideLoad', {
                    slide: this
                });
            }
        },
        {
            /**
   * Append "heavy" DOM elements
   *
   * This may depend on a type of slide,
   * but generally these are large images.
   */ key: "appendHeavy",
            value: function appendHeavy() {
                var pswp = this.pswp;
                var appendHeavyNearby = true; // todo
                // Avoid appending heavy elements during animations
                if (this.heavyAppended || !pswp.opener.isOpen || pswp.mainScroll.isShifted() || !this.isActive && !appendHeavyNearby) return;
                if (this.pswp.dispatch('appendHeavy', {
                    slide: this
                }).defaultPrevented) return;
                this.heavyAppended = true;
                this.content.append();
                this.pswp.dispatch('appendHeavyContent', {
                    slide: this
                });
            }
        },
        {
            /**
   * Triggered when this slide is active (selected).
   *
   * If it's part of opening/closing transition -
   * activate() will trigger after the transition is ended.
   */ key: "activate",
            value: function activate() {
                this.isActive = true;
                this.appendHeavy();
                this.content.activate();
                this.pswp.dispatch('slideActivate', {
                    slide: this
                });
            }
        },
        {
            /**
   * Triggered when this slide becomes inactive.
   *
   * Slide can become inactive only after it was active.
   */ key: "deactivate",
            value: function deactivate() {
                this.isActive = false;
                this.content.deactivate();
                if (this.currZoomLevel !== this.zoomLevels.initial) // allow filtering
                this.calculateSize();
                 // reset zoom level
                this.currentResolution = 0;
                this.zoomAndPanToInitial();
                this.applyCurrentZoomPan();
                this.updateContentSize();
                this.pswp.dispatch('slideDeactivate', {
                    slide: this
                });
            }
        },
        {
            /**
   * The slide should destroy itself, it will never be used again.
   * (unbind all events and destroy internal components)
   */ key: "destroy",
            value: function destroy() {
                this.content.hasSlide = false;
                this.content.remove();
                this.container.remove();
                this.pswp.dispatch('slideDestroy', {
                    slide: this
                });
            }
        },
        {
            key: "resize",
            value: function resize() {
                if (this.currZoomLevel === this.zoomLevels.initial || !this.isActive) {
                    // Keep initial zoom level if it was before the resize,
                    // as well as when this slide is not active
                    // Reset position and scale to original state
                    this.calculateSize();
                    this.currentResolution = 0;
                    this.zoomAndPanToInitial();
                    this.applyCurrentZoomPan();
                    this.updateContentSize();
                } else {
                    // readjust pan position if it's beyond the bounds
                    this.calculateSize();
                    this.bounds.update(this.currZoomLevel);
                    this.panTo(this.pan.x, this.pan.y);
                }
            }
        },
        {
            /**
   * Apply size to current slide content,
   * based on the current resolution and scale.
   *
   * @param {boolean} [force] if size should be updated even if dimensions weren't changed
   */ key: "updateContentSize",
            value: function updateContentSize(force) {
                // Use initial zoom level
                // if resolution is not defined (user didn't zoom yet)
                var scaleMultiplier = this.currentResolution || this.zoomLevels.initial;
                if (!scaleMultiplier) return;
                var width = Math.round(this.width * scaleMultiplier) || this.pswp.viewportSize.x;
                var height = Math.round(this.height * scaleMultiplier) || this.pswp.viewportSize.y;
                if (!this.sizeChanged(width, height) && !force) return;
                this.content.setDisplayedSize(width, height);
            }
        },
        {
            /**
   * @param {number} width
   * @param {number} height
   */ key: "sizeChanged",
            value: function sizeChanged(width, height) {
                if (width !== this.prevDisplayedWidth || height !== this.prevDisplayedHeight) {
                    this.prevDisplayedWidth = width;
                    this.prevDisplayedHeight = height;
                    return true;
                }
                return false;
            }
        },
        {
            /** @returns {HTMLImageElement | HTMLDivElement | null | undefined} */ key: "getPlaceholderElement",
            value: function getPlaceholderElement() {
                var _this$content$placeho;
                return (_this$content$placeho = this.content.placeholder) === null || _this$content$placeho === void 0 ? void 0 : _this$content$placeho.element;
            }
        },
        {
            /**
   * Zoom current slide image to...
   *
   * @param {number} destZoomLevel Destination zoom level.
   * @param {Point} [centerPoint]
   * Transform origin center point, or false if viewport center should be used.
   * @param {number | false} [transitionDuration] Transition duration, may be set to 0.
   * @param {boolean} [ignoreBounds] Minimum and maximum zoom levels will be ignored.
   */ key: "zoomTo",
            value: function zoomTo(destZoomLevel, centerPoint, transitionDuration, ignoreBounds) {
                var _this = this;
                var pswp = this.pswp;
                if (!this.isZoomable() || pswp.mainScroll.isShifted()) return;
                pswp.dispatch('beforeZoomTo', {
                    destZoomLevel: destZoomLevel,
                    centerPoint: centerPoint,
                    transitionDuration: transitionDuration
                }); // stop all pan and zoom transitions
                pswp.animations.stopAllPan(); // if (!centerPoint) {
                //   centerPoint = pswp.getViewportCenterPoint();
                // }
                var prevZoomLevel = this.currZoomLevel;
                if (!ignoreBounds) destZoomLevel = $f38b189616c72948$var$clamp(destZoomLevel, this.zoomLevels.min, this.zoomLevels.max);
                 // if (transitionDuration === undefined) {
                //   transitionDuration = this.pswp.options.zoomAnimationDuration;
                // }
                this.setZoomLevel(destZoomLevel);
                this.pan.x = this.calculateZoomToPanOffset('x', centerPoint, prevZoomLevel);
                this.pan.y = this.calculateZoomToPanOffset('y', centerPoint, prevZoomLevel);
                $f38b189616c72948$var$roundPoint(this.pan);
                var finishTransition = function() {
                    _this._setResolution(destZoomLevel);
                    _this.applyCurrentZoomPan();
                };
                if (!transitionDuration) finishTransition();
                else pswp.animations.startTransition({
                    isPan: true,
                    name: 'zoomTo',
                    target: this.container,
                    transform: this.getCurrentTransform(),
                    onComplete: finishTransition,
                    duration: transitionDuration,
                    easing: pswp.options.easing
                });
            }
        },
        {
            /**
   * @param {Point} [centerPoint]
   */ key: "toggleZoom",
            value: function toggleZoom(centerPoint) {
                this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, centerPoint, this.pswp.options.zoomAnimationDuration);
            }
        },
        {
            /**
   * Updates zoom level property and recalculates new pan bounds,
   * unlike zoomTo it does not apply transform (use applyCurrentZoomPan)
   *
   * @param {number} currZoomLevel
   */ key: "setZoomLevel",
            value: function setZoomLevel(currZoomLevel) {
                this.currZoomLevel = currZoomLevel;
                this.bounds.update(this.currZoomLevel);
            }
        },
        {
            /**
   * Get pan position after zoom at a given `point`.
   *
   * Always call setZoomLevel(newZoomLevel) beforehand to recalculate
   * pan bounds according to the new zoom level.
   *
   * @param {'x' | 'y'} axis
   * @param {Point} [point]
   * point based on which zoom is performed, usually refers to the current mouse position,
   * if false - viewport center will be used.
   * @param {number} [prevZoomLevel] Zoom level before new zoom was applied.
   * @returns {number}
   */ key: "calculateZoomToPanOffset",
            value: function calculateZoomToPanOffset(axis, point, prevZoomLevel) {
                var totalPanDistance = this.bounds.max[axis] - this.bounds.min[axis];
                if (totalPanDistance === 0) return this.bounds.center[axis];
                if (!point) point = this.pswp.getViewportCenterPoint();
                if (!prevZoomLevel) prevZoomLevel = this.zoomLevels.initial;
                var zoomFactor = this.currZoomLevel / prevZoomLevel;
                return this.bounds.correctPan(axis, (this.pan[axis] - point[axis]) * zoomFactor + point[axis]);
            }
        },
        {
            /**
   * Apply pan and keep it within bounds.
   *
   * @param {number} panX
   * @param {number} panY
   */ key: "panTo",
            value: function panTo(panX, panY) {
                this.pan.x = this.bounds.correctPan('x', panX);
                this.pan.y = this.bounds.correctPan('y', panY);
                this.applyCurrentZoomPan();
            }
        },
        {
            /**
   * If the slide in the current state can be panned by the user
   * @returns {boolean}
   */ key: "isPannable",
            value: function isPannable() {
                return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit;
            }
        },
        {
            /**
   * If the slide can be zoomed
   * @returns {boolean}
   */ key: "isZoomable",
            value: function isZoomable() {
                return Boolean(this.width) && this.content.isZoomable();
            }
        },
        {
            /**
   * Apply transform and scale based on
   * the current pan position (this.pan) and zoom level (this.currZoomLevel)
   */ key: "applyCurrentZoomPan",
            value: function applyCurrentZoomPan() {
                this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
                if (this === this.pswp.currSlide) this.pswp.dispatch('zoomPanUpdate', {
                    slide: this
                });
            }
        },
        {
            key: "zoomAndPanToInitial",
            value: function zoomAndPanToInitial() {
                this.currZoomLevel = this.zoomLevels.initial; // pan according to the zoom level
                this.bounds.update(this.currZoomLevel);
                $f38b189616c72948$var$equalizePoints(this.pan, this.bounds.center);
                this.pswp.dispatch('initialZoomPan', {
                    slide: this
                });
            }
        },
        {
            /**
   * Set translate and scale based on current resolution
   *
   * @param {number} x
   * @param {number} y
   * @param {number} zoom
   * @private
   */ key: "_applyZoomTransform",
            value: function _applyZoomTransform(x, y, zoom) {
                zoom /= this.currentResolution || this.zoomLevels.initial;
                $f38b189616c72948$var$setTransform(this.container, x, y, zoom);
            }
        },
        {
            key: "calculateSize",
            value: function calculateSize() {
                var pswp = this.pswp;
                $f38b189616c72948$var$equalizePoints(this.panAreaSize, $f38b189616c72948$var$getPanAreaSize(pswp.options, pswp.viewportSize, this.data, this.index));
                this.zoomLevels.update(this.width, this.height, this.panAreaSize);
                pswp.dispatch('calcSlideSize', {
                    slide: this
                });
            }
        },
        {
            /** @returns {string} */ key: "getCurrentTransform",
            value: function getCurrentTransform() {
                var scale = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
                return $f38b189616c72948$var$toTransformString(this.pan.x, this.pan.y, scale);
            }
        },
        {
            /**
   * Set resolution and re-render the image.
   *
   * For example, if the real image size is 2000x1500,
   * and resolution is 0.5 - it will be rendered as 1000x750.
   *
   * Image with zoom level 2 and resolution 0.5 is
   * the same as image with zoom level 1 and resolution 1.
   *
   * Used to optimize animations and make
   * sure that browser renders image in the highest quality.
   * Also used by responsive images to load the correct one.
   *
   * @param {number} newResolution
   */ key: "_setResolution",
            value: function _setResolution(newResolution) {
                if (newResolution === this.currentResolution) return;
                this.currentResolution = newResolution;
                this.updateContentSize();
                this.pswp.dispatch('resolutionChanged');
            }
        }
    ]);
    return Slide;
}();
/** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('./gestures.js').default} Gestures */ var $f38b189616c72948$var$PAN_END_FRICTION = 0.35;
var $f38b189616c72948$var$VERTICAL_DRAG_FRICTION = 0.6; // 1 corresponds to the third of viewport height
var $f38b189616c72948$var$MIN_RATIO_TO_CLOSE = 0.4; // Minimum speed required to navigate
// to next or previous slide
var $f38b189616c72948$var$MIN_NEXT_SLIDE_SPEED = 0.5;
/**
 * @param {number} initialVelocity
 * @param {number} decelerationRate
 * @returns {number}
 */ function $f38b189616c72948$var$project(initialVelocity, decelerationRate) {
    return initialVelocity * decelerationRate / (1 - decelerationRate);
}
/**
 * Handles single pointer dragging
 */ var $f38b189616c72948$var$DragHandler = /*#__PURE__*/ function() {
    "use strict";
    function DragHandler(gestures) {
        (0, $dXdNl._)(this, DragHandler);
        this.gestures = gestures;
        this.pswp = gestures.pswp;
        /** @type {Point} */ this.startPan = {
            x: 0,
            y: 0
        };
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(DragHandler, [
        {
            key: "start",
            value: function start() {
                if (this.pswp.currSlide) $f38b189616c72948$var$equalizePoints(this.startPan, this.pswp.currSlide.pan);
                this.pswp.animations.stopAll();
            }
        },
        {
            key: "change",
            value: function change() {
                var _this_gestures = this.gestures, p1 = _this_gestures.p1, prevP1 = _this_gestures.prevP1, dragAxis = _this_gestures.dragAxis;
                var currSlide = this.pswp.currSlide;
                if (dragAxis === 'y' && this.pswp.options.closeOnVerticalDrag && currSlide && currSlide.currZoomLevel <= currSlide.zoomLevels.fit && !this.gestures.isMultitouch) {
                    // Handle vertical drag to close
                    var panY = currSlide.pan.y + (p1.y - prevP1.y);
                    if (!this.pswp.dispatch('verticalDrag', {
                        panY: panY
                    }).defaultPrevented) {
                        this._setPanWithFriction('y', panY, $f38b189616c72948$var$VERTICAL_DRAG_FRICTION);
                        var bgOpacity = 1 - Math.abs(this._getVerticalDragRatio(currSlide.pan.y));
                        this.pswp.applyBgOpacity(bgOpacity);
                        currSlide.applyCurrentZoomPan();
                    }
                } else {
                    var mainScrollChanged = this._panOrMoveMainScroll('x');
                    if (!mainScrollChanged) {
                        this._panOrMoveMainScroll('y');
                        if (currSlide) {
                            $f38b189616c72948$var$roundPoint(currSlide.pan);
                            currSlide.applyCurrentZoomPan();
                        }
                    }
                }
            }
        },
        {
            key: "end",
            value: function end() {
                var velocity = this.gestures.velocity;
                var _this_pswp = this.pswp, mainScroll = _this_pswp.mainScroll, currSlide = _this_pswp.currSlide;
                var indexDiff = 0;
                this.pswp.animations.stopAll(); // Handle main scroll if it's shifted
                if (mainScroll.isShifted()) {
                    // Position of the main scroll relative to the viewport
                    var mainScrollShiftDiff = mainScroll.x - mainScroll.getCurrSlideX(); // Ratio between 0 and 1:
                    // 0 - slide is not visible at all,
                    // 0.5 - half of the slide is visible
                    // 1 - slide is fully visible
                    var currentSlideVisibilityRatio = mainScrollShiftDiff / this.pswp.viewportSize.x; // Go next slide.
                    //
                    // - if velocity and its direction is matched,
                    //   and we see at least tiny part of the next slide
                    //
                    // - or if we see less than 50% of the current slide
                    //   and velocity is close to 0
                    //
                    if (velocity.x < -$f38b189616c72948$var$MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio < 0 || velocity.x < 0.1 && currentSlideVisibilityRatio < -0.5) {
                        // Go to next slide
                        indexDiff = 1;
                        velocity.x = Math.min(velocity.x, 0);
                    } else if (velocity.x > $f38b189616c72948$var$MIN_NEXT_SLIDE_SPEED && currentSlideVisibilityRatio > 0 || velocity.x > -0.1 && currentSlideVisibilityRatio > 0.5) {
                        // Go to prev slide
                        indexDiff = -1;
                        velocity.x = Math.max(velocity.x, 0);
                    }
                    mainScroll.moveIndexBy(indexDiff, true, velocity.x);
                } // Restore zoom level
                if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.max || this.gestures.isMultitouch) this.gestures.zoomLevels.correctZoomPan(true);
                else {
                    // we run two animations instead of one,
                    // as each axis has own pan boundaries and thus different spring function
                    // (correctZoomPan does not have this functionality,
                    //  it animates all properties with single timing function)
                    this._finishPanGestureForAxis('x');
                    this._finishPanGestureForAxis('y');
                }
            }
        },
        {
            /**
   * @private
   * @param {'x' | 'y'} axis
   */ key: "_finishPanGestureForAxis",
            value: function _finishPanGestureForAxis(axis) {
                var _this = this;
                var velocity = this.gestures.velocity;
                var currSlide = this.pswp.currSlide;
                if (!currSlide) return;
                var pan = currSlide.pan, bounds = currSlide.bounds;
                var panPos = pan[axis];
                var restoreBgOpacity = this.pswp.bgOpacity < 1 && axis === 'y'; // 0.995 means - scroll view loses 0.5% of its velocity per millisecond
                // Increasing this number will reduce travel distance
                var decelerationRate = 0.995; // 0.99
                // Pan position if there is no bounds
                var projectedPosition = panPos + $f38b189616c72948$var$project(velocity[axis], decelerationRate);
                if (restoreBgOpacity) {
                    var vDragRatio = this._getVerticalDragRatio(panPos);
                    var projectedVDragRatio = this._getVerticalDragRatio(projectedPosition); // If we are above and moving upwards,
                    // or if we are below and moving downwards
                    if (vDragRatio < 0 && projectedVDragRatio < -$f38b189616c72948$var$MIN_RATIO_TO_CLOSE || vDragRatio > 0 && projectedVDragRatio > $f38b189616c72948$var$MIN_RATIO_TO_CLOSE) {
                        this.pswp.close();
                        return;
                    }
                } // Pan position with corrected bounds
                var correctedPanPosition = bounds.correctPan(axis, projectedPosition); // Exit if pan position should not be changed
                // or if speed it too low
                if (panPos === correctedPanPosition) return;
                 // Overshoot if the final position is out of pan bounds
                var dampingRatio = correctedPanPosition === projectedPosition ? 1 : 0.82;
                var initialBgOpacity = this.pswp.bgOpacity;
                var totalPanDist = correctedPanPosition - panPos;
                this.pswp.animations.startSpring({
                    name: 'panGesture' + axis,
                    isPan: true,
                    start: panPos,
                    end: correctedPanPosition,
                    velocity: velocity[axis],
                    dampingRatio: dampingRatio,
                    onUpdate: function(pos) {
                        // Animate opacity of background relative to Y pan position of an image
                        if (restoreBgOpacity && _this.pswp.bgOpacity < 1) {
                            // 0 - start of animation, 1 - end of animation
                            var animationProgressRatio = 1 - (correctedPanPosition - pos) / totalPanDist; // We clamp opacity to keep it between 0 and 1.
                            // As progress ratio can be larger than 1 due to overshoot,
                            // and we do not want to bounce opacity.
                            _this.pswp.applyBgOpacity($f38b189616c72948$var$clamp(initialBgOpacity + (1 - initialBgOpacity) * animationProgressRatio, 0, 1));
                        }
                        pan[axis] = Math.floor(pos);
                        currSlide.applyCurrentZoomPan();
                    }
                });
            }
        },
        {
            /**
   * Update position of the main scroll,
   * or/and update pan position of the current slide.
   *
   * Should return true if it changes (or can change) main scroll.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @returns {boolean}
   */ key: "_panOrMoveMainScroll",
            value: function _panOrMoveMainScroll(axis) {
                var _this_gestures = this.gestures, p1 = _this_gestures.p1, dragAxis = _this_gestures.dragAxis, prevP1 = _this_gestures.prevP1, isMultitouch = _this_gestures.isMultitouch;
                var _this_pswp = this.pswp, currSlide = _this_pswp.currSlide, mainScroll = _this_pswp.mainScroll;
                var delta = p1[axis] - prevP1[axis];
                var newMainScrollX = mainScroll.x + delta;
                if (!delta || !currSlide) return false;
                 // Always move main scroll if image can not be panned
                if (axis === 'x' && !currSlide.isPannable() && !isMultitouch) {
                    mainScroll.moveTo(newMainScrollX, true);
                    return true; // changed main scroll
                }
                var bounds = currSlide.bounds;
                var newPan = currSlide.pan[axis] + delta;
                if (this.pswp.options.allowPanToNext && dragAxis === 'x' && axis === 'x' && !isMultitouch) {
                    var currSlideMainScrollX = mainScroll.getCurrSlideX(); // Position of the main scroll relative to the viewport
                    var mainScrollShiftDiff = mainScroll.x - currSlideMainScrollX;
                    var isLeftToRight = delta > 0;
                    var isRightToLeft = !isLeftToRight;
                    if (newPan > bounds.min[axis] && isLeftToRight) {
                        // Panning from left to right, beyond the left edge
                        // Wether the image was at minimum pan position (or less)
                        // when this drag gesture started.
                        // Minimum pan position refers to the left edge of the image.
                        var wasAtMinPanPosition = bounds.min[axis] <= this.startPan[axis];
                        if (wasAtMinPanPosition) {
                            mainScroll.moveTo(newMainScrollX, true);
                            return true;
                        } else this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
                    } else if (newPan < bounds.max[axis] && isRightToLeft) {
                        // Paning from right to left, beyond the right edge
                        // Maximum pan position refers to the right edge of the image.
                        var wasAtMaxPanPosition = this.startPan[axis] <= bounds.max[axis];
                        if (wasAtMaxPanPosition) {
                            mainScroll.moveTo(newMainScrollX, true);
                            return true;
                        } else this._setPanWithFriction(axis, newPan); //currSlide.pan[axis] = newPan;
                    } else // If main scroll is shifted
                    if (mainScrollShiftDiff !== 0) {
                        // If main scroll is shifted right
                        if (mainScrollShiftDiff > 0) {
                            mainScroll.moveTo(Math.max(newMainScrollX, currSlideMainScrollX), true);
                            return true;
                        } else if (mainScrollShiftDiff < 0) {
                            // Main scroll is shifted left (Position is less than 0 comparing to the viewport 0)
                            mainScroll.moveTo(Math.min(newMainScrollX, currSlideMainScrollX), true);
                            return true;
                        }
                    } else // We are within pan bounds, so just pan
                    this._setPanWithFriction(axis, newPan);
                } else {
                    if (axis === 'y') // Do not pan vertically if main scroll is shifted o
                    {
                        if (!mainScroll.isShifted() && bounds.min.y !== bounds.max.y) this._setPanWithFriction(axis, newPan);
                    } else this._setPanWithFriction(axis, newPan);
                }
                return false;
            } // If we move above - the ratio is negative
        },
        {
            // If we move below the ratio is positive
            /**
   * Relation between pan Y position and third of viewport height.
   *
   * When we are at initial position (center bounds) - the ratio is 0,
   * if position is shifted upwards - the ratio is negative,
   * if position is shifted downwards - the ratio is positive.
   *
   * @private
   * @param {number} panY The current pan Y position.
   * @returns {number}
   */ key: "_getVerticalDragRatio",
            value: function _getVerticalDragRatio(panY) {
                var _this$pswp$currSlide$, _this$pswp$currSlide;
                return (panY - ((_this$pswp$currSlide$ = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.bounds.center.y) !== null && _this$pswp$currSlide$ !== void 0 ? _this$pswp$currSlide$ : 0)) / (this.pswp.viewportSize.y / 3);
            }
        },
        {
            /**
   * Set pan position of the current slide.
   * Apply friction if the position is beyond the pan bounds,
   * or if custom friction is defined.
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} potentialPan
   * @param {number} [customFriction] (0.1 - 1)
   */ key: "_setPanWithFriction",
            value: function _setPanWithFriction(axis, potentialPan, customFriction) {
                var currSlide = this.pswp.currSlide;
                if (!currSlide) return;
                var pan = currSlide.pan, bounds = currSlide.bounds;
                var correctedPan = bounds.correctPan(axis, potentialPan); // If we are out of pan bounds
                if (correctedPan !== potentialPan || customFriction) {
                    var delta = Math.round(potentialPan - pan[axis]);
                    pan[axis] += delta * (customFriction || $f38b189616c72948$var$PAN_END_FRICTION);
                } else pan[axis] = potentialPan;
            }
        }
    ]);
    return DragHandler;
}();
/** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {import('./gestures.js').default} Gestures */ var $f38b189616c72948$var$UPPER_ZOOM_FRICTION = 0.05;
var $f38b189616c72948$var$LOWER_ZOOM_FRICTION = 0.15;
/**
 * Get center point between two points
 *
 * @param {Point} p
 * @param {Point} p1
 * @param {Point} p2
 * @returns {Point}
 */ function $f38b189616c72948$var$getZoomPointsCenter(p, p1, p2) {
    p.x = (p1.x + p2.x) / 2;
    p.y = (p1.y + p2.y) / 2;
    return p;
}
var $f38b189616c72948$var$ZoomHandler = /*#__PURE__*/ function() {
    "use strict";
    function ZoomHandler(gestures) {
        (0, $dXdNl._)(this, ZoomHandler);
        this.gestures = gestures;
        /**
     * @private
     * @type {Point}
     */ this._startPan = {
            x: 0,
            y: 0
        };
        /**
     * @private
     * @type {Point}
     */ this._startZoomPoint = {
            x: 0,
            y: 0
        };
        /**
     * @private
     * @type {Point}
     */ this._zoomPoint = {
            x: 0,
            y: 0
        };
        /** @private */ this._wasOverFitZoomLevel = false;
        /** @private */ this._startZoomLevel = 1;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(ZoomHandler, [
        {
            key: "start",
            value: function start() {
                var currSlide = this.gestures.pswp.currSlide;
                if (currSlide) {
                    this._startZoomLevel = currSlide.currZoomLevel;
                    $f38b189616c72948$var$equalizePoints(this._startPan, currSlide.pan);
                }
                this.gestures.pswp.animations.stopAllPan();
                this._wasOverFitZoomLevel = false;
            }
        },
        {
            key: "change",
            value: function change() {
                var _this_gestures = this.gestures, p1 = _this_gestures.p1, startP1 = _this_gestures.startP1, p2 = _this_gestures.p2, startP2 = _this_gestures.startP2, pswp = _this_gestures.pswp;
                var currSlide = pswp.currSlide;
                if (!currSlide) return;
                var minZoomLevel = currSlide.zoomLevels.min;
                var maxZoomLevel = currSlide.zoomLevels.max;
                if (!currSlide.isZoomable() || pswp.mainScroll.isShifted()) return;
                $f38b189616c72948$var$getZoomPointsCenter(this._startZoomPoint, startP1, startP2);
                $f38b189616c72948$var$getZoomPointsCenter(this._zoomPoint, p1, p2);
                var currZoomLevel = 1 / $f38b189616c72948$var$getDistanceBetween(startP1, startP2) * $f38b189616c72948$var$getDistanceBetween(p1, p2) * this._startZoomLevel; // slightly over the zoom.fit
                if (currZoomLevel > currSlide.zoomLevels.initial + currSlide.zoomLevels.initial / 15) this._wasOverFitZoomLevel = true;
                if (currZoomLevel < minZoomLevel) {
                    if (pswp.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= currSlide.zoomLevels.initial) {
                        // fade out background if zooming out
                        var bgOpacity = 1 - (minZoomLevel - currZoomLevel) / (minZoomLevel / 1.2);
                        if (!pswp.dispatch('pinchClose', {
                            bgOpacity: bgOpacity
                        }).defaultPrevented) pswp.applyBgOpacity(bgOpacity);
                    } else // Apply the friction if zoom level is below the min
                    currZoomLevel = minZoomLevel - (minZoomLevel - currZoomLevel) * $f38b189616c72948$var$LOWER_ZOOM_FRICTION;
                } else if (currZoomLevel > maxZoomLevel) // Apply the friction if zoom level is above the max
                currZoomLevel = maxZoomLevel + (currZoomLevel - maxZoomLevel) * $f38b189616c72948$var$UPPER_ZOOM_FRICTION;
                currSlide.pan.x = this._calculatePanForZoomLevel('x', currZoomLevel);
                currSlide.pan.y = this._calculatePanForZoomLevel('y', currZoomLevel);
                currSlide.setZoomLevel(currZoomLevel);
                currSlide.applyCurrentZoomPan();
            }
        },
        {
            key: "end",
            value: function end() {
                var pswp = this.gestures.pswp;
                var currSlide = pswp.currSlide;
                if ((!currSlide || currSlide.currZoomLevel < currSlide.zoomLevels.initial) && !this._wasOverFitZoomLevel && pswp.options.pinchToClose) pswp.close();
                else this.correctZoomPan();
            }
        },
        {
            /**
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} currZoomLevel
   * @returns {number}
   */ key: "_calculatePanForZoomLevel",
            value: function _calculatePanForZoomLevel(axis, currZoomLevel) {
                var zoomFactor = currZoomLevel / this._startZoomLevel;
                return this._zoomPoint[axis] - (this._startZoomPoint[axis] - this._startPan[axis]) * zoomFactor;
            }
        },
        {
            /**
   * Correct currZoomLevel and pan if they are
   * beyond minimum or maximum values.
   * With animation.
   *
   * @param {boolean} [ignoreGesture]
   * Wether gesture coordinates should be ignored when calculating destination pan position.
   */ key: "correctZoomPan",
            value: function correctZoomPan(ignoreGesture) {
                var pswp = this.gestures.pswp;
                var currSlide = pswp.currSlide;
                if (!(currSlide !== null && currSlide !== void 0 && currSlide.isZoomable())) return;
                if (this._zoomPoint.x === 0) ignoreGesture = true;
                var prevZoomLevel = currSlide.currZoomLevel;
                /** @type {number} */ var destinationZoomLevel;
                var currZoomLevelNeedsChange = true;
                if (prevZoomLevel < currSlide.zoomLevels.initial) destinationZoomLevel = currSlide.zoomLevels.initial; // zoom to min
                else if (prevZoomLevel > currSlide.zoomLevels.max) destinationZoomLevel = currSlide.zoomLevels.max; // zoom to max
                else {
                    currZoomLevelNeedsChange = false;
                    destinationZoomLevel = prevZoomLevel;
                }
                var initialBgOpacity = pswp.bgOpacity;
                var restoreBgOpacity = pswp.bgOpacity < 1;
                var initialPan = $f38b189616c72948$var$equalizePoints({
                    x: 0,
                    y: 0
                }, currSlide.pan);
                var destinationPan = $f38b189616c72948$var$equalizePoints({
                    x: 0,
                    y: 0
                }, initialPan);
                if (ignoreGesture) {
                    this._zoomPoint.x = 0;
                    this._zoomPoint.y = 0;
                    this._startZoomPoint.x = 0;
                    this._startZoomPoint.y = 0;
                    this._startZoomLevel = prevZoomLevel;
                    $f38b189616c72948$var$equalizePoints(this._startPan, initialPan);
                }
                if (currZoomLevelNeedsChange) destinationPan = {
                    x: this._calculatePanForZoomLevel('x', destinationZoomLevel),
                    y: this._calculatePanForZoomLevel('y', destinationZoomLevel)
                };
                 // set zoom level, so pan bounds are updated according to it
                currSlide.setZoomLevel(destinationZoomLevel);
                destinationPan = {
                    x: currSlide.bounds.correctPan('x', destinationPan.x),
                    y: currSlide.bounds.correctPan('y', destinationPan.y)
                }; // return zoom level and its bounds to initial
                currSlide.setZoomLevel(prevZoomLevel);
                var panNeedsChange = !$f38b189616c72948$var$pointsEqual(destinationPan, initialPan);
                if (!panNeedsChange && !currZoomLevelNeedsChange && !restoreBgOpacity) {
                    // update resolution after gesture
                    currSlide._setResolution(destinationZoomLevel);
                    currSlide.applyCurrentZoomPan(); // nothing to animate
                    return;
                }
                pswp.animations.stopAllPan();
                pswp.animations.startSpring({
                    isPan: true,
                    start: 0,
                    end: 1000,
                    velocity: 0,
                    dampingRatio: 1,
                    naturalFrequency: 40,
                    onUpdate: function(now) {
                        now /= 1000; // 0 - start, 1 - end
                        if (panNeedsChange || currZoomLevelNeedsChange) {
                            if (panNeedsChange) {
                                currSlide.pan.x = initialPan.x + (destinationPan.x - initialPan.x) * now;
                                currSlide.pan.y = initialPan.y + (destinationPan.y - initialPan.y) * now;
                            }
                            if (currZoomLevelNeedsChange) {
                                var newZoomLevel = prevZoomLevel + (destinationZoomLevel - prevZoomLevel) * now;
                                currSlide.setZoomLevel(newZoomLevel);
                            }
                            currSlide.applyCurrentZoomPan();
                        } // Restore background opacity
                        if (restoreBgOpacity && pswp.bgOpacity < 1) // We clamp opacity to keep it between 0 and 1.
                        // As progress ratio can be larger than 1 due to overshoot,
                        // and we do not want to bounce opacity.
                        pswp.applyBgOpacity($f38b189616c72948$var$clamp(initialBgOpacity + (1 - initialBgOpacity) * now, 0, 1));
                    },
                    onComplete: function() {
                        // update resolution after transition ends
                        currSlide._setResolution(destinationZoomLevel);
                        currSlide.applyCurrentZoomPan();
                    }
                });
            }
        }
    ]);
    return ZoomHandler;
}();
/**
 * @template {string} T
 * @template {string} P
 * @typedef {import('../types.js').AddPostfix<T, P>} AddPostfix<T, P>
 */ /** @typedef {import('./gestures.js').default} Gestures */ /** @typedef {import('../photoswipe.js').Point} Point */ /** @typedef {'imageClick' | 'bgClick' | 'tap' | 'doubleTap'} Actions */ /**
 * Whether the tap was performed on the main slide
 * (rather than controls or caption).
 *
 * @param {PointerEvent} event
 * @returns {boolean}
 */ function $f38b189616c72948$var$didTapOnMainContent(event) {
    return !!/** @type {HTMLElement} */ event.target.closest('.pswp__container');
}
/**
 * Tap, double-tap handler.
 */ var $f38b189616c72948$var$TapHandler = /*#__PURE__*/ function() {
    "use strict";
    function TapHandler(gestures) {
        (0, $dXdNl._)(this, TapHandler);
        this.gestures = gestures;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(TapHandler, [
        {
            /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "click",
            value: function click(point, originalEvent) {
                var targetClassList = /** @type {HTMLElement} */ originalEvent.target.classList;
                var isImageClick = targetClassList.contains('pswp__img');
                var isBackgroundClick = targetClassList.contains('pswp__item') || targetClassList.contains('pswp__zoom-wrap');
                if (isImageClick) this._doClickOrTapAction('imageClick', point, originalEvent);
                else if (isBackgroundClick) this._doClickOrTapAction('bgClick', point, originalEvent);
            }
        },
        {
            /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "tap",
            value: function tap(point, originalEvent) {
                if ($f38b189616c72948$var$didTapOnMainContent(originalEvent)) this._doClickOrTapAction('tap', point, originalEvent);
            }
        },
        {
            /**
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "doubleTap",
            value: function doubleTap(point, originalEvent) {
                if ($f38b189616c72948$var$didTapOnMainContent(originalEvent)) this._doClickOrTapAction('doubleTap', point, originalEvent);
            }
        },
        {
            /**
   * @private
   * @param {Actions} actionName
   * @param {Point} point
   * @param {PointerEvent} originalEvent
   */ key: "_doClickOrTapAction",
            value: function _doClickOrTapAction(actionName, point, originalEvent) {
                var _this$gestures$pswp$e;
                var pswp = this.gestures.pswp;
                var currSlide = pswp.currSlide;
                var actionFullName = /** @type {AddPostfix<Actions, 'Action'>} */ actionName + 'Action';
                var optionValue = pswp.options[actionFullName];
                if (pswp.dispatch(actionFullName, {
                    point: point,
                    originalEvent: originalEvent
                }).defaultPrevented) return;
                if (typeof optionValue === 'function') {
                    optionValue.call(pswp, point, originalEvent);
                    return;
                }
                switch(optionValue){
                    case 'close':
                    case 'next':
                        pswp[optionValue]();
                        break;
                    case 'zoom':
                        currSlide === null || currSlide === void 0 || currSlide.toggleZoom(point);
                        break;
                    case 'zoom-or-close':
                        // by default click zooms current image,
                        // if it can not be zoomed - gallery will be closed
                        if (currSlide !== null && currSlide !== void 0 && currSlide.isZoomable() && currSlide.zoomLevels.secondary !== currSlide.zoomLevels.initial) currSlide.toggleZoom(point);
                        else if (pswp.options.clickToCloseNonZoomable) pswp.close();
                        break;
                    case 'toggle-controls':
                        (_this$gestures$pswp$e = this.gestures.pswp.element) === null || _this$gestures$pswp$e === void 0 || _this$gestures$pswp$e.classList.toggle('pswp--ui-visible'); // if (_controlsVisible) {
                        break;
                }
            }
        }
    ]);
    return TapHandler;
}();
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').Point} Point */ // How far should user should drag
// until we can determine that the gesture is swipe and its direction
var $f38b189616c72948$var$AXIS_SWIPE_HYSTERISIS = 10; //const PAN_END_FRICTION = 0.35;
var $f38b189616c72948$var$DOUBLE_TAP_DELAY = 300; // ms
var $f38b189616c72948$var$MIN_TAP_DISTANCE = 25; // px
/**
 * Gestures class bind touch, pointer or mouse events
 * and emits drag to drag-handler and zoom events zoom-handler.
 *
 * Drag and zoom events are emited in requestAnimationFrame,
 * and only when one of pointers was actually changed.
 */ var $f38b189616c72948$var$Gestures = /*#__PURE__*/ function() {
    "use strict";
    function Gestures(pswp) {
        var _this = this;
        (0, $dXdNl._)(this, Gestures);
        this.pswp = pswp;
        /** @type {'x' | 'y' | null} */ this.dragAxis = null; // point objects are defined once and reused
        // PhotoSwipe keeps track only of two pointers, others are ignored
        /** @type {Point} */ this.p1 = {
            x: 0,
            y: 0
        }; // the first pressed pointer
        /** @type {Point} */ this.p2 = {
            x: 0,
            y: 0
        }; // the second pressed pointer
        /** @type {Point} */ this.prevP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.prevP2 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.startP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.startP2 = {
            x: 0,
            y: 0
        };
        /** @type {Point} */ this.velocity = {
            x: 0,
            y: 0
        };
        /** @type {Point}
     * @private
     */ this._lastStartP1 = {
            x: 0,
            y: 0
        };
        /** @type {Point}
     * @private
     */ this._intervalP1 = {
            x: 0,
            y: 0
        };
        /** @private */ this._numActivePoints = 0;
        /** @type {Point[]}
     * @private
     */ this._ongoingPointers = [];
        /** @private */ this._touchEventEnabled = 'ontouchstart' in window;
        /** @private */ this._pointerEventEnabled = !!window.PointerEvent;
        this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1;
        /** @private */ this._numActivePoints = 0;
        /** @private */ this._intervalTime = 0;
        /** @private */ this._velocityCalculated = false;
        this.isMultitouch = false;
        this.isDragging = false;
        this.isZooming = false;
        /** @type {number | null} */ this.raf = null;
        /** @type {NodeJS.Timeout | null}
     * @private
     */ this._tapTimer = null;
        if (!this.supportsTouch) // disable pan to next slide for non-touch devices
        pswp.options.allowPanToNext = false;
        this.drag = new $f38b189616c72948$var$DragHandler(this);
        this.zoomLevels = new $f38b189616c72948$var$ZoomHandler(this);
        this.tapHandler = new $f38b189616c72948$var$TapHandler(this);
        pswp.on('bindEvents', function() {
            pswp.events.add(pswp.scrollWrap, 'click', /** @type EventListener */ _this._onClick.bind(_this));
            if (_this._pointerEventEnabled) _this._bindEvents('pointer', 'down', 'up', 'cancel');
            else if (_this._touchEventEnabled) {
                _this._bindEvents('touch', 'start', 'end', 'cancel'); // In previous versions we also bound mouse event here,
                // in case device supports both touch and mouse events,
                // but newer versions of browsers now support PointerEvent.
                // on iOS10 if you bind touchmove/end after touchstart,
                // and you don't preventDefault touchstart (which PhotoSwipe does),
                // preventDefault will have no effect on touchmove and touchend.
                // Unless you bind it previously.
                if (pswp.scrollWrap) {
                    pswp.scrollWrap.ontouchmove = function() {};
                    pswp.scrollWrap.ontouchend = function() {};
                }
            } else _this._bindEvents('mouse', 'down', 'up');
        });
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Gestures, [
        {
            /**
   * @private
   * @param {'mouse' | 'touch' | 'pointer'} pref
   * @param {'down' | 'start'} down
   * @param {'up' | 'end'} up
   * @param {'cancel'} [cancel]
   */ key: "_bindEvents",
            value: function _bindEvents(pref, down, up, cancel) {
                var pswp = this.pswp;
                var events = pswp.events;
                var cancelEvent = cancel ? pref + cancel : '';
                events.add(pswp.scrollWrap, pref + down, /** @type EventListener */ this.onPointerDown.bind(this));
                events.add(window, pref + 'move', /** @type EventListener */ this.onPointerMove.bind(this));
                events.add(window, pref + up, /** @type EventListener */ this.onPointerUp.bind(this));
                if (cancelEvent) events.add(pswp.scrollWrap, cancelEvent, /** @type EventListener */ this.onPointerUp.bind(this));
            }
        },
        {
            /**
   * @param {PointerEvent} e
   */ key: "onPointerDown",
            value: function onPointerDown(e) {
                // We do not call preventDefault for touch events
                // to allow browser to show native dialog on longpress
                // (the one that allows to save image or open it in new tab).
                //
                // Desktop Safari allows to drag images when preventDefault isn't called on mousedown,
                // even though preventDefault IS called on mousemove. That's why we preventDefault mousedown.
                var isMousePointer = e.type === 'mousedown' || e.pointerType === 'mouse'; // Allow dragging only via left mouse button.
                // http://www.quirksmode.org/js/events_properties.html
                // https://developer.mozilla.org/en-US/docs/Web/API/event.button
                if (isMousePointer && e.button > 0) return;
                var pswp = this.pswp; // if PhotoSwipe is opening or closing
                if (!pswp.opener.isOpen) {
                    e.preventDefault();
                    return;
                }
                if (pswp.dispatch('pointerDown', {
                    originalEvent: e
                }).defaultPrevented) return;
                if (isMousePointer) {
                    pswp.mouseDetected(); // preventDefault mouse event to prevent
                    // browser image drag feature
                    this._preventPointerEventBehaviour(e, 'down');
                }
                pswp.animations.stopAll();
                this._updatePoints(e, 'down');
                if (this._numActivePoints === 1) {
                    this.dragAxis = null; // we need to store initial point to determine the main axis,
                    // drag is activated only after the axis is determined
                    $f38b189616c72948$var$equalizePoints(this.startP1, this.p1);
                }
                if (this._numActivePoints > 1) {
                    // Tap or double tap should not trigger if more than one pointer
                    this._clearTapTimer();
                    this.isMultitouch = true;
                } else this.isMultitouch = false;
            }
        },
        {
            /**
   * @param {PointerEvent} e
   */ key: "onPointerMove",
            value: function onPointerMove(e) {
                this._preventPointerEventBehaviour(e, 'move');
                if (!this._numActivePoints) return;
                this._updatePoints(e, 'move');
                if (this.pswp.dispatch('pointerMove', {
                    originalEvent: e
                }).defaultPrevented) return;
                if (this._numActivePoints === 1 && !this.isDragging) {
                    if (!this.dragAxis) this._calculateDragDirection();
                     // Drag axis was detected, emit drag.start
                    if (this.dragAxis && !this.isDragging) {
                        if (this.isZooming) {
                            this.isZooming = false;
                            this.zoomLevels.end();
                        }
                        this.isDragging = true;
                        this._clearTapTimer(); // Tap can not trigger after drag
                        // Adjust starting point
                        this._updateStartPoints();
                        this._intervalTime = Date.now(); //this._startTime = this._intervalTime;
                        this._velocityCalculated = false;
                        $f38b189616c72948$var$equalizePoints(this._intervalP1, this.p1);
                        this.velocity.x = 0;
                        this.velocity.y = 0;
                        this.drag.start();
                        this._rafStopLoop();
                        this._rafRenderLoop();
                    }
                } else if (this._numActivePoints > 1 && !this.isZooming) {
                    this._finishDrag();
                    this.isZooming = true; // Adjust starting points
                    this._updateStartPoints();
                    this.zoomLevels.start();
                    this._rafStopLoop();
                    this._rafRenderLoop();
                }
            }
        },
        {
            /**
   * @private
   */ key: "_finishDrag",
            value: function _finishDrag() {
                if (this.isDragging) {
                    this.isDragging = false; // Try to calculate velocity,
                    // if it wasn't calculated yet in drag.change
                    if (!this._velocityCalculated) this._updateVelocity(true);
                    this.drag.end();
                    this.dragAxis = null;
                }
            }
        },
        {
            /**
   * @param {PointerEvent} e
   */ key: "onPointerUp",
            value: function onPointerUp(e) {
                if (!this._numActivePoints) return;
                this._updatePoints(e, 'up');
                if (this.pswp.dispatch('pointerUp', {
                    originalEvent: e
                }).defaultPrevented) return;
                if (this._numActivePoints === 0) {
                    this._rafStopLoop();
                    if (this.isDragging) this._finishDrag();
                    else if (!this.isZooming && !this.isMultitouch) //this.zoomLevels.correctZoomPan();
                    this._finishTap(e);
                }
                if (this._numActivePoints < 2 && this.isZooming) {
                    this.isZooming = false;
                    this.zoomLevels.end();
                    if (this._numActivePoints === 1) {
                        // Since we have 1 point left, we need to reinitiate drag
                        this.dragAxis = null;
                        this._updateStartPoints();
                    }
                }
            }
        },
        {
            /**
   * @private
   */ key: "_rafRenderLoop",
            value: function _rafRenderLoop() {
                if (this.isDragging || this.isZooming) {
                    this._updateVelocity();
                    if (this.isDragging) // make sure that pointer moved since the last update
                    {
                        if (!$f38b189616c72948$var$pointsEqual(this.p1, this.prevP1)) this.drag.change();
                    } else if (!$f38b189616c72948$var$pointsEqual(this.p1, this.prevP1) || !$f38b189616c72948$var$pointsEqual(this.p2, this.prevP2)) this.zoomLevels.change();
                    this._updatePrevPoints();
                    this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
                }
            }
        },
        {
            /**
   * Update velocity at 50ms interval
   *
   * @private
   * @param {boolean} [force]
   */ key: "_updateVelocity",
            value: function _updateVelocity(force) {
                var time = Date.now();
                var duration = time - this._intervalTime;
                if (duration < 50 && !force) return;
                this.velocity.x = this._getVelocity('x', duration);
                this.velocity.y = this._getVelocity('y', duration);
                this._intervalTime = time;
                $f38b189616c72948$var$equalizePoints(this._intervalP1, this.p1);
                this._velocityCalculated = true;
            }
        },
        {
            /**
   * @private
   * @param {PointerEvent} e
   */ key: "_finishTap",
            value: function _finishTap(e) {
                var _this = this;
                var mainScroll = this.pswp.mainScroll; // Do not trigger tap events if main scroll is shifted
                if (mainScroll.isShifted()) {
                    // restore main scroll position
                    // (usually happens if stopped in the middle of animation)
                    mainScroll.moveIndexBy(0, true);
                    return;
                } // Do not trigger tap for touchcancel or pointercancel
                if (e.type.indexOf('cancel') > 0) return;
                 // Trigger click instead of tap for mouse events
                if (e.type === 'mouseup' || e.pointerType === 'mouse') {
                    this.tapHandler.click(this.startP1, e);
                    return;
                } // Disable delay if there is no doubleTapAction
                var tapDelay = this.pswp.options.doubleTapAction ? $f38b189616c72948$var$DOUBLE_TAP_DELAY : 0; // If tapTimer is defined - we tapped recently,
                // check if the current tap is close to the previous one,
                // if yes - trigger double tap
                if (this._tapTimer) {
                    this._clearTapTimer(); // Check if two taps were more or less on the same place
                    if ($f38b189616c72948$var$getDistanceBetween(this._lastStartP1, this.startP1) < $f38b189616c72948$var$MIN_TAP_DISTANCE) this.tapHandler.doubleTap(this.startP1, e);
                } else {
                    $f38b189616c72948$var$equalizePoints(this._lastStartP1, this.startP1);
                    this._tapTimer = setTimeout(function() {
                        _this.tapHandler.tap(_this.startP1, e);
                        _this._clearTapTimer();
                    }, tapDelay);
                }
            }
        },
        {
            /**
   * @private
   */ key: "_clearTapTimer",
            value: function _clearTapTimer() {
                if (this._tapTimer) {
                    clearTimeout(this._tapTimer);
                    this._tapTimer = null;
                }
            }
        },
        {
            /**
   * Get velocity for axis
   *
   * @private
   * @param {'x' | 'y'} axis
   * @param {number} duration
   * @returns {number}
   */ key: "_getVelocity",
            value: function _getVelocity(axis, duration) {
                // displacement is like distance, but can be negative.
                var displacement = this.p1[axis] - this._intervalP1[axis];
                if (Math.abs(displacement) > 1 && duration > 5) return displacement / duration;
                return 0;
            }
        },
        {
            /**
   * @private
   */ key: "_rafStopLoop",
            value: function _rafStopLoop() {
                if (this.raf) {
                    cancelAnimationFrame(this.raf);
                    this.raf = null;
                }
            }
        },
        {
            /**
   * @private
   * @param {PointerEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */ key: "_preventPointerEventBehaviour",
            value: function _preventPointerEventBehaviour(e, pointerType) {
                var preventPointerEvent = this.pswp.applyFilters('preventPointerEvent', true, e, pointerType);
                if (preventPointerEvent) e.preventDefault();
            }
        },
        {
            /**
   * Parses and normalizes points from the touch, mouse or pointer event.
   * Updates p1 and p2.
   *
   * @private
   * @param {PointerEvent | TouchEvent} e
   * @param {'up' | 'down' | 'move'} pointerType Normalized pointer type
   */ key: "_updatePoints",
            value: function _updatePoints(e, pointerType) {
                if (this._pointerEventEnabled) {
                    var pointerEvent = /** @type {PointerEvent} */ e; // Try to find the current pointer in ongoing pointers by its ID
                    var pointerIndex = this._ongoingPointers.findIndex(function(ongoingPointer) {
                        return ongoingPointer.id === pointerEvent.pointerId;
                    });
                    if (pointerType === 'up' && pointerIndex > -1) // release the pointer - remove it from ongoing
                    this._ongoingPointers.splice(pointerIndex, 1);
                    else if (pointerType === 'down' && pointerIndex === -1) // add new pointer
                    this._ongoingPointers.push(this._convertEventPosToPoint(pointerEvent, {
                        x: 0,
                        y: 0
                    }));
                    else if (pointerIndex > -1) // update existing pointer
                    this._convertEventPosToPoint(pointerEvent, this._ongoingPointers[pointerIndex]);
                    this._numActivePoints = this._ongoingPointers.length; // update points that PhotoSwipe uses
                    // to calculate position and scale
                    if (this._numActivePoints > 0) $f38b189616c72948$var$equalizePoints(this.p1, this._ongoingPointers[0]);
                    if (this._numActivePoints > 1) $f38b189616c72948$var$equalizePoints(this.p2, this._ongoingPointers[1]);
                } else {
                    var touchEvent = /** @type {TouchEvent} */ e;
                    this._numActivePoints = 0;
                    if (touchEvent.type.indexOf('touch') > -1) // Touch Event
                    // https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
                    {
                        if (touchEvent.touches && touchEvent.touches.length > 0) {
                            this._convertEventPosToPoint(touchEvent.touches[0], this.p1);
                            this._numActivePoints++;
                            if (touchEvent.touches.length > 1) {
                                this._convertEventPosToPoint(touchEvent.touches[1], this.p2);
                                this._numActivePoints++;
                            }
                        }
                    } else {
                        // Mouse Event
                        this._convertEventPosToPoint(/** @type {PointerEvent} */ e, this.p1);
                        if (pointerType === 'up') // clear all points on mouseup
                        this._numActivePoints = 0;
                        else this._numActivePoints++;
                    }
                }
            }
        },
        {
            /** update points that were used during previous rAF tick
   * @private
   */ key: "_updatePrevPoints",
            value: function _updatePrevPoints() {
                $f38b189616c72948$var$equalizePoints(this.prevP1, this.p1);
                $f38b189616c72948$var$equalizePoints(this.prevP2, this.p2);
            }
        },
        {
            /** update points at the start of gesture
   * @private
   */ key: "_updateStartPoints",
            value: function _updateStartPoints() {
                $f38b189616c72948$var$equalizePoints(this.startP1, this.p1);
                $f38b189616c72948$var$equalizePoints(this.startP2, this.p2);
                this._updatePrevPoints();
            }
        },
        {
            /** @private */ key: "_calculateDragDirection",
            value: function _calculateDragDirection() {
                if (this.pswp.mainScroll.isShifted()) // if main scroll position is shifted – direction is always horizontal
                this.dragAxis = 'x';
                else {
                    // calculate delta of the last touchmove tick
                    var diff = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
                    if (diff !== 0) {
                        // check if pointer was shifted horizontally or vertically
                        var axisToCheck = diff > 0 ? 'x' : 'y';
                        if (Math.abs(this.p1[axisToCheck] - this.startP1[axisToCheck]) >= $f38b189616c72948$var$AXIS_SWIPE_HYSTERISIS) this.dragAxis = axisToCheck;
                    }
                }
            }
        },
        {
            /**
   * Converts touch, pointer or mouse event
   * to PhotoSwipe point.
   *
   * @private
   * @param {Touch | PointerEvent} e
   * @param {Point} p
   * @returns {Point}
   */ key: "_convertEventPosToPoint",
            value: function _convertEventPosToPoint(e, p) {
                p.x = e.pageX - this.pswp.offset.x;
                p.y = e.pageY - this.pswp.offset.y;
                if ('pointerId' in e) p.id = e.pointerId;
                else if (e.identifier !== undefined) p.id = e.identifier;
                return p;
            }
        },
        {
            /**
   * @private
   * @param {PointerEvent} e
   */ key: "_onClick",
            value: function _onClick(e) {
                // Do not allow click event to pass through after drag
                if (this.pswp.mainScroll.isShifted()) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        }
    ]);
    return Gestures;
}();
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./slide/slide.js').default} Slide */ /** @typedef {{ el: HTMLDivElement; slide?: Slide }} ItemHolder */ var $f38b189616c72948$var$MAIN_SCROLL_END_FRICTION = 0.35; // const MIN_SWIPE_TRANSITION_DURATION = 250;
// const MAX_SWIPE_TRABSITION_DURATION = 500;
// const DEFAULT_SWIPE_TRANSITION_DURATION = 333;
/**
 * Handles movement of the main scrolling container
 * (for example, it repositions when user swipes left or right).
 *
 * Also stores its state.
 */ var $f38b189616c72948$var$MainScroll = /*#__PURE__*/ function() {
    "use strict";
    function MainScroll(pswp) {
        (0, $dXdNl._)(this, MainScroll);
        this.pswp = pswp;
        this.x = 0;
        this.slideWidth = 0;
        /** @private */ this._currPositionIndex = 0;
        /** @private */ this._prevPositionIndex = 0;
        /** @private */ this._containerShiftIndex = -1;
        /** @type {ItemHolder[]} */ this.itemHolders = [];
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(MainScroll, [
        {
            /**
   * Position the scroller and slide containers
   * according to viewport size.
   *
   * @param {boolean} [resizeSlides] Whether slides content should resized
   */ key: "resize",
            value: function resize(resizeSlides) {
                var _this = this;
                var pswp = this.pswp;
                var newSlideWidth = Math.round(pswp.viewportSize.x + pswp.viewportSize.x * pswp.options.spacing); // Mobile browsers might trigger a resize event during a gesture.
                // (due to toolbar appearing or hiding).
                // Avoid re-adjusting main scroll position if width wasn't changed
                var slideWidthChanged = newSlideWidth !== this.slideWidth;
                if (slideWidthChanged) {
                    this.slideWidth = newSlideWidth;
                    this.moveTo(this.getCurrSlideX());
                }
                this.itemHolders.forEach(function(itemHolder, index) {
                    if (slideWidthChanged) $f38b189616c72948$var$setTransform(itemHolder.el, (index + _this._containerShiftIndex) * _this.slideWidth);
                    if (resizeSlides && itemHolder.slide) itemHolder.slide.resize();
                });
            }
        },
        {
            /**
   * Reset X position of the main scroller to zero
   */ key: "resetPosition",
            value: function resetPosition() {
                // Position on the main scroller (offset)
                // it is independent from slide index
                this._currPositionIndex = 0;
                this._prevPositionIndex = 0; // This will force recalculation of size on next resize()
                this.slideWidth = 0; // _containerShiftIndex*viewportSize will give you amount of transform of the current slide
                this._containerShiftIndex = -1;
            }
        },
        {
            /**
   * Create and append array of three items
   * that hold data about slides in DOM
   */ key: "appendHolders",
            value: function appendHolders() {
                this.itemHolders = []; // append our three slide holders -
                // previous, current, and next
                for(var i = 0; i < 3; i++){
                    var el = $f38b189616c72948$var$createElement('pswp__item', 'div', this.pswp.container);
                    el.setAttribute('role', 'group');
                    el.setAttribute('aria-roledescription', 'slide');
                    el.setAttribute('aria-hidden', 'true'); // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
                    el.style.display = i === 1 ? 'block' : 'none';
                    this.itemHolders.push({
                        el: el //index: -1
                    });
                }
            }
        },
        {
            /**
   * Whether the main scroll can be horizontally swiped to the next or previous slide.
   * @returns {boolean}
   */ key: "canBeSwiped",
            value: function canBeSwiped() {
                return this.pswp.getNumItems() > 1;
            }
        },
        {
            /**
   * Move main scroll by X amount of slides.
   * For example:
   *   `-1` will move to the previous slide,
   *    `0` will reset the scroll position of the current slide,
   *    `3` will move three slides forward
   *
   * If loop option is enabled - index will be automatically looped too,
   * (for example `-1` will move to the last slide of the gallery).
   *
   * @param {number} diff
   * @param {boolean} [animate]
   * @param {number} [velocityX]
   * @returns {boolean} whether index was changed or not
   */ key: "moveIndexBy",
            value: function moveIndexBy(diff, animate, velocityX) {
                var _this = this;
                var pswp = this.pswp;
                var newIndex = pswp.potentialIndex + diff;
                var numSlides = pswp.getNumItems();
                if (pswp.canLoop()) {
                    newIndex = pswp.getLoopedIndex(newIndex);
                    var distance = (diff + numSlides) % numSlides;
                    if (distance <= numSlides / 2) // go forward
                    diff = distance;
                    else // go backwards
                    diff = distance - numSlides;
                } else {
                    if (newIndex < 0) newIndex = 0;
                    else if (newIndex >= numSlides) newIndex = numSlides - 1;
                    diff = newIndex - pswp.potentialIndex;
                }
                pswp.potentialIndex = newIndex;
                this._currPositionIndex -= diff;
                pswp.animations.stopMainScroll();
                var destinationX = this.getCurrSlideX();
                if (!animate) {
                    this.moveTo(destinationX);
                    this.updateCurrItem();
                } else {
                    pswp.animations.startSpring({
                        isMainScroll: true,
                        start: this.x,
                        end: destinationX,
                        velocity: velocityX || 0,
                        naturalFrequency: 30,
                        dampingRatio: 1,
                        //0.7,
                        onUpdate: function(x) {
                            _this.moveTo(x);
                        },
                        onComplete: function() {
                            _this.updateCurrItem();
                            pswp.appendHeavy();
                        }
                    });
                    var currDiff = pswp.potentialIndex - pswp.currIndex;
                    if (pswp.canLoop()) {
                        var currDistance = (currDiff + numSlides) % numSlides;
                        if (currDistance <= numSlides / 2) // go forward
                        currDiff = currDistance;
                        else // go backwards
                        currDiff = currDistance - numSlides;
                    } // Force-append new slides during transition
                    // if difference between slides is more than 1
                    if (Math.abs(currDiff) > 1) this.updateCurrItem();
                }
                return Boolean(diff);
            }
        },
        {
            /**
   * X position of the main scroll for the current slide
   * (ignores position during dragging)
   * @returns {number}
   */ key: "getCurrSlideX",
            value: function getCurrSlideX() {
                return this.slideWidth * this._currPositionIndex;
            }
        },
        {
            /**
   * Whether scroll position is shifted.
   * For example, it will return true if the scroll is being dragged or animated.
   * @returns {boolean}
   */ key: "isShifted",
            value: function isShifted() {
                return this.x !== this.getCurrSlideX();
            }
        },
        {
            /**
   * Update slides X positions and set their content
   */ key: "updateCurrItem",
            value: function updateCurrItem() {
                var _this$itemHolders$;
                var pswp = this.pswp;
                var positionDifference = this._prevPositionIndex - this._currPositionIndex;
                if (!positionDifference) return;
                this._prevPositionIndex = this._currPositionIndex;
                pswp.currIndex = pswp.potentialIndex;
                var diffAbs = Math.abs(positionDifference);
                /** @type {ItemHolder | undefined} */ var tempHolder;
                if (diffAbs >= 3) {
                    this._containerShiftIndex += positionDifference + (positionDifference > 0 ? -3 : 3);
                    diffAbs = 3; // If slides are changed by 3 screens or more - clean up previous slides
                    this.itemHolders.forEach(function(itemHolder) {
                        var _itemHolder$slide;
                        (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.destroy();
                        itemHolder.slide = undefined;
                    });
                }
                for(var i = 0; i < diffAbs; i++)if (positionDifference > 0) {
                    tempHolder = this.itemHolders.shift();
                    if (tempHolder) {
                        this.itemHolders[2] = tempHolder; // move first to last
                        this._containerShiftIndex++;
                        $f38b189616c72948$var$setTransform(tempHolder.el, (this._containerShiftIndex + 2) * this.slideWidth);
                        pswp.setContent(tempHolder, pswp.currIndex - diffAbs + i + 2);
                    }
                } else {
                    tempHolder = this.itemHolders.pop();
                    if (tempHolder) {
                        this.itemHolders.unshift(tempHolder); // move last to first
                        this._containerShiftIndex--;
                        $f38b189616c72948$var$setTransform(tempHolder.el, this._containerShiftIndex * this.slideWidth);
                        pswp.setContent(tempHolder, pswp.currIndex + diffAbs - i - 2);
                    }
                }
                 // Reset transfrom every 50ish navigations in one direction.
                //
                // Otherwise transform will keep growing indefinitely,
                // which might cause issues as browsers have a maximum transform limit.
                // I wasn't able to reach it, but just to be safe.
                // This should not cause noticable lag.
                if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
                    this.resetPosition();
                    this.resize();
                } // Pan transition might be running (and consntantly updating pan position)
                pswp.animations.stopAllPan();
                this.itemHolders.forEach(function(itemHolder, i) {
                    if (itemHolder.slide) // Slide in the 2nd holder is always active
                    itemHolder.slide.setIsActive(i === 1);
                });
                pswp.currSlide = (_this$itemHolders$ = this.itemHolders[1]) === null || _this$itemHolders$ === void 0 ? void 0 : _this$itemHolders$.slide;
                pswp.contentLoader.updateLazy(positionDifference);
                if (pswp.currSlide) pswp.currSlide.applyCurrentZoomPan();
                pswp.dispatch('change');
            }
        },
        {
            /**
   * Move the X position of the main scroll container
   *
   * @param {number} x
   * @param {boolean} [dragging]
   */ key: "moveTo",
            value: function moveTo(x, dragging) {
                if (!this.pswp.canLoop() && dragging) {
                    // Apply friction
                    var newSlideIndexOffset = (this.slideWidth * this._currPositionIndex - x) / this.slideWidth;
                    newSlideIndexOffset += this.pswp.currIndex;
                    var delta = Math.round(x - this.x);
                    if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= this.pswp.getNumItems() - 1 && delta < 0) x = this.x + delta * $f38b189616c72948$var$MAIN_SCROLL_END_FRICTION;
                }
                this.x = x;
                if (this.pswp.container) $f38b189616c72948$var$setTransform(this.pswp.container, x);
                this.pswp.dispatch('moveMainScroll', {
                    x: x,
                    dragging: dragging !== null && dragging !== void 0 ? dragging : false
                });
            }
        }
    ]);
    return MainScroll;
}();
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /**
 * @template T
 * @typedef {import('./types.js').Methods<T>} Methods<T>
 */ var $f38b189616c72948$var$KeyboardKeyCodesMap = {
    Escape: 27,
    z: 90,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    Tab: 9
};
/**
 * @template {keyof KeyboardKeyCodesMap} T
 * @param {T} key
 * @param {boolean} isKeySupported
 * @returns {T | number | undefined}
 */ var $f38b189616c72948$var$getKeyboardEventKey = function(key, isKeySupported) {
    return isKeySupported ? key : $f38b189616c72948$var$KeyboardKeyCodesMap[key];
};
/**
 * - Manages keyboard shortcuts.
 * - Helps trap focus within photoswipe.
 */ var $f38b189616c72948$var$Keyboard = /*#__PURE__*/ function() {
    "use strict";
    function Keyboard(pswp) {
        var _this = this;
        (0, $dXdNl._)(this, Keyboard);
        this.pswp = pswp;
        /** @private */ this._wasFocused = false;
        pswp.on('bindEvents', function() {
            if (pswp.options.trapFocus) {
                // Dialog was likely opened by keyboard if initial point is not defined
                if (!pswp.options.initialPointerPos) // focus causes layout,
                // which causes lag during the animation,
                // that's why we delay it until the opener transition ends
                _this._focusRoot();
                pswp.events.add(document, 'focusin', /** @type EventListener */ _this._onFocusIn.bind(_this));
            }
            pswp.events.add(document, 'keydown', /** @type EventListener */ _this._onKeyDown.bind(_this));
        });
        var lastActiveElement = /** @type {HTMLElement} */ document.activeElement;
        pswp.on('destroy', function() {
            if (pswp.options.returnFocus && lastActiveElement && _this._wasFocused) lastActiveElement.focus();
        });
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Keyboard, [
        {
            /** @private */ key: "_focusRoot",
            value: function _focusRoot() {
                if (!this._wasFocused && this.pswp.element) {
                    this.pswp.element.focus();
                    this._wasFocused = true;
                }
            }
        },
        {
            /**
   * @private
   * @param {KeyboardEvent} e
   */ key: "_onKeyDown",
            value: function _onKeyDown(e) {
                var pswp = this.pswp;
                if (pswp.dispatch('keydown', {
                    originalEvent: e
                }).defaultPrevented) return;
                if ($f38b189616c72948$var$specialKeyUsed(e)) // don't do anything if special key pressed
                // to prevent from overriding default browser actions
                // for example, in Chrome on Mac cmd+arrow-left returns to previous page
                return;
                /** @type {Methods<PhotoSwipe> | undefined} */ var keydownAction;
                /** @type {'x' | 'y' | undefined} */ var axis;
                var isForward = false;
                var isKeySupported = 'key' in e;
                switch(isKeySupported ? e.key : e.keyCode){
                    case $f38b189616c72948$var$getKeyboardEventKey('Escape', isKeySupported):
                        if (pswp.options.escKey) keydownAction = 'close';
                        break;
                    case $f38b189616c72948$var$getKeyboardEventKey('z', isKeySupported):
                        keydownAction = 'toggleZoom';
                        break;
                    case $f38b189616c72948$var$getKeyboardEventKey('ArrowLeft', isKeySupported):
                        axis = 'x';
                        break;
                    case $f38b189616c72948$var$getKeyboardEventKey('ArrowUp', isKeySupported):
                        axis = 'y';
                        break;
                    case $f38b189616c72948$var$getKeyboardEventKey('ArrowRight', isKeySupported):
                        axis = 'x';
                        isForward = true;
                        break;
                    case $f38b189616c72948$var$getKeyboardEventKey('ArrowDown', isKeySupported):
                        isForward = true;
                        axis = 'y';
                        break;
                    case $f38b189616c72948$var$getKeyboardEventKey('Tab', isKeySupported):
                        this._focusRoot();
                        break;
                } // if left/right/top/bottom key
                if (axis) {
                    // prevent page scroll
                    e.preventDefault();
                    var currSlide = pswp.currSlide;
                    if (pswp.options.arrowKeys && axis === 'x' && pswp.getNumItems() > 1) keydownAction = isForward ? 'next' : 'prev';
                    else if (currSlide && currSlide.currZoomLevel > currSlide.zoomLevels.fit) {
                        // up/down arrow keys pan the image vertically
                        // left/right arrow keys pan horizontally.
                        // Unless there is only one image,
                        // or arrowKeys option is disabled
                        currSlide.pan[axis] += isForward ? -80 : 80;
                        currSlide.panTo(currSlide.pan.x, currSlide.pan.y);
                    }
                }
                if (keydownAction) {
                    e.preventDefault(); // @ts-ignore
                    pswp[keydownAction]();
                }
            }
        },
        {
            /**
   * Trap focus inside photoswipe
   *
   * @private
   * @param {FocusEvent} e
   */ key: "_onFocusIn",
            value: function _onFocusIn(e) {
                var template = this.pswp.template;
                if (template && document !== e.target && template !== e.target && !template.contains(/** @type {Node} */ e.target)) // focus root element
                template.focus();
            }
        }
    ]);
    return Keyboard;
}();
var $f38b189616c72948$var$DEFAULT_EASING = 'cubic-bezier(.4,0,.22,1)';
/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */ /** @typedef {Object} DefaultCssAnimationProps
 *
 * @prop {HTMLElement} target
 * @prop {number} [duration]
 * @prop {string} [easing]
 * @prop {string} [transform]
 * @prop {string} [opacity]
 * */ /** @typedef {SharedAnimationProps & DefaultCssAnimationProps} CssAnimationProps */ /**
 * Runs CSS transition.
 */ var $f38b189616c72948$var$CSSAnimation = /*#__PURE__*/ function() {
    "use strict";
    function CSSAnimation(props) {
        var _this = this;
        (0, $dXdNl._)(this, CSSAnimation);
        var _props$prop;
        this.props = props;
        var target = props.target, onComplete = props.onComplete, transform = props.transform, _props_onFinish = props.onFinish, onFinish = _props_onFinish === void 0 ? function() {} : _props_onFinish, _props_duration = props.duration, duration = _props_duration === void 0 ? 333 : _props_duration, _props_easing = props.easing, easing = _props_easing === void 0 ? $f38b189616c72948$var$DEFAULT_EASING : _props_easing;
        this.onFinish = onFinish; // support only transform and opacity
        var prop = transform ? 'transform' : 'opacity';
        var propValue = (_props$prop = props[prop]) !== null && _props$prop !== void 0 ? _props$prop : '';
        /** @private */ this._target = target;
        /** @private */ this._onComplete = onComplete;
        /** @private */ this._finished = false;
        /** @private */ this._onTransitionEnd = this._onTransitionEnd.bind(this); // Using timeout hack to make sure that animation
        // starts even if the animated property was changed recently,
        // otherwise transitionend might not fire or transition won't start.
        // https://drafts.csswg.org/css-transitions/#starting
        //
        // ¯\_(ツ)_/¯
        /** @private */ this._helperTimeout = setTimeout(function() {
            $f38b189616c72948$var$setTransitionStyle(target, prop, duration, easing);
            _this._helperTimeout = setTimeout(function() {
                target.addEventListener('transitionend', _this._onTransitionEnd, false);
                target.addEventListener('transitioncancel', _this._onTransitionEnd, false); // Safari occasionally does not emit transitionend event
                // if element property was modified during the transition,
                // which may be caused by resize or third party component,
                // using timeout as a safety fallback
                _this._helperTimeout = setTimeout(function() {
                    _this._finalizeAnimation();
                }, duration + 500);
                target.style[prop] = propValue;
            }, 30); // Do not reduce this number
        }, 0);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(CSSAnimation, [
        {
            /**
   * @private
   * @param {TransitionEvent} e
   */ key: "_onTransitionEnd",
            value: function _onTransitionEnd(e) {
                if (e.target === this._target) this._finalizeAnimation();
            }
        },
        {
            /**
   * @private
   */ key: "_finalizeAnimation",
            value: function _finalizeAnimation() {
                if (!this._finished) {
                    this._finished = true;
                    this.onFinish();
                    if (this._onComplete) this._onComplete();
                }
            } // Destroy is called automatically onFinish
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this._helperTimeout) clearTimeout(this._helperTimeout);
                $f38b189616c72948$var$removeTransitionStyle(this._target);
                this._target.removeEventListener('transitionend', this._onTransitionEnd, false);
                this._target.removeEventListener('transitioncancel', this._onTransitionEnd, false);
                if (!this._finished) this._finalizeAnimation();
            }
        }
    ]);
    return CSSAnimation;
}();
var $f38b189616c72948$var$DEFAULT_NATURAL_FREQUENCY = 12;
var $f38b189616c72948$var$DEFAULT_DAMPING_RATIO = 0.75;
/**
 * Spring easing helper
 */ var $f38b189616c72948$var$SpringEaser = /*#__PURE__*/ function() {
    "use strict";
    function SpringEaser(initialVelocity, dampingRatio, naturalFrequency) {
        (0, $dXdNl._)(this, SpringEaser);
        this.velocity = initialVelocity * 1000; // convert to "pixels per second"
        // https://en.wikipedia.org/wiki/Damping_ratio
        this._dampingRatio = dampingRatio || $f38b189616c72948$var$DEFAULT_DAMPING_RATIO; // https://en.wikipedia.org/wiki/Natural_frequency
        this._naturalFrequency = naturalFrequency || $f38b189616c72948$var$DEFAULT_NATURAL_FREQUENCY;
        this._dampedFrequency = this._naturalFrequency;
        if (this._dampingRatio < 1) this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(SpringEaser, [
        {
            /**
   * @param {number} deltaPosition Difference between current and end position of the animation
   * @param {number} deltaTime Frame duration in milliseconds
   *
   * @returns {number} Displacement, relative to the end position.
   */ key: "easeFrame",
            value: function easeFrame(deltaPosition, deltaTime) {
                // Inspired by Apple Webkit and Android spring function implementation
                // https://en.wikipedia.org/wiki/Oscillation
                // https://en.wikipedia.org/wiki/Damping_ratio
                // we ignore mass (assume that it's 1kg)
                var displacement = 0;
                var coeff;
                deltaTime /= 1000;
                var naturalDumpingPow = Math.pow(Math.E, -this._dampingRatio * this._naturalFrequency * deltaTime);
                if (this._dampingRatio === 1) {
                    coeff = this.velocity + this._naturalFrequency * deltaPosition;
                    displacement = (deltaPosition + coeff * deltaTime) * naturalDumpingPow;
                    this.velocity = displacement * -this._naturalFrequency + coeff * naturalDumpingPow;
                } else if (this._dampingRatio < 1) {
                    coeff = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * deltaPosition + this.velocity);
                    var dumpedFCos = Math.cos(this._dampedFrequency * deltaTime);
                    var dumpedFSin = Math.sin(this._dampedFrequency * deltaTime);
                    displacement = naturalDumpingPow * (deltaPosition * dumpedFCos + coeff * dumpedFSin);
                    this.velocity = displacement * -this._naturalFrequency * this._dampingRatio + naturalDumpingPow * (-this._dampedFrequency * deltaPosition * dumpedFSin + this._dampedFrequency * coeff * dumpedFCos);
                } // Overdamped (>1) damping ratio is not supported
                return displacement;
            }
        }
    ]);
    return SpringEaser;
}();
/** @typedef {import('./animations.js').SharedAnimationProps} SharedAnimationProps */ /**
 * @typedef {Object} DefaultSpringAnimationProps
 *
 * @prop {number} start
 * @prop {number} end
 * @prop {number} velocity
 * @prop {number} [dampingRatio]
 * @prop {number} [naturalFrequency]
 * @prop {(end: number) => void} onUpdate
 */ /** @typedef {SharedAnimationProps & DefaultSpringAnimationProps} SpringAnimationProps */ var $f38b189616c72948$var$SpringAnimation = /*#__PURE__*/ function() {
    "use strict";
    function SpringAnimation(props) {
        var _this = this;
        (0, $dXdNl._)(this, SpringAnimation);
        this.props = props;
        this._raf = 0;
        var start = props.start, end = props.end, velocity = props.velocity, onUpdate = props.onUpdate, onComplete = props.onComplete, _props_onFinish = props.onFinish, onFinish = _props_onFinish === void 0 ? function() {} : _props_onFinish, dampingRatio = props.dampingRatio, naturalFrequency = props.naturalFrequency;
        this.onFinish = onFinish;
        var easer = new $f38b189616c72948$var$SpringEaser(velocity, dampingRatio, naturalFrequency);
        var prevTime = Date.now();
        var deltaPosition = start - end;
        var animationLoop = function() {
            if (_this._raf) {
                deltaPosition = easer.easeFrame(deltaPosition, Date.now() - prevTime); // Stop the animation if velocity is low and position is close to end
                if (Math.abs(deltaPosition) < 1 && Math.abs(easer.velocity) < 50) {
                    // Finalize the animation
                    onUpdate(end);
                    if (onComplete) onComplete();
                    _this.onFinish();
                } else {
                    prevTime = Date.now();
                    onUpdate(deltaPosition + end);
                    _this._raf = requestAnimationFrame(animationLoop);
                }
            }
        };
        this._raf = requestAnimationFrame(animationLoop);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(SpringAnimation, [
        {
            key: "destroy",
            value: function destroy() {
                if (this._raf >= 0) cancelAnimationFrame(this._raf);
                this._raf = 0;
            }
        }
    ]);
    return SpringAnimation;
}();
/** @typedef {import('./css-animation.js').CssAnimationProps} CssAnimationProps */ /** @typedef {import('./spring-animation.js').SpringAnimationProps} SpringAnimationProps */ /** @typedef {Object} SharedAnimationProps
 * @prop {string} [name]
 * @prop {boolean} [isPan]
 * @prop {boolean} [isMainScroll]
 * @prop {VoidFunction} [onComplete]
 * @prop {VoidFunction} [onFinish]
 */ /** @typedef {SpringAnimation | CSSAnimation} Animation */ /** @typedef {SpringAnimationProps | CssAnimationProps} AnimationProps */ /**
 * Manages animations
 */ var $f38b189616c72948$var$Animations = /*#__PURE__*/ function() {
    "use strict";
    function Animations() {
        (0, $dXdNl._)(this, Animations);
        /** @type {Animation[]} */ this.activeAnimations = [];
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Animations, [
        {
            /**
   * @param {SpringAnimationProps} props
   */ key: "startSpring",
            value: function startSpring(props) {
                this._start(props, true);
            }
        },
        {
            /**
   * @param {CssAnimationProps} props
   */ key: "startTransition",
            value: function startTransition(props) {
                this._start(props);
            }
        },
        {
            /**
   * @private
   * @param {AnimationProps} props
   * @param {boolean} [isSpring]
   * @returns {Animation}
   */ key: "_start",
            value: function _start(props, isSpring) {
                var _this = this;
                var animation = isSpring ? new $f38b189616c72948$var$SpringAnimation(/** @type SpringAnimationProps */ props) : new $f38b189616c72948$var$CSSAnimation(/** @type CssAnimationProps */ props);
                this.activeAnimations.push(animation);
                animation.onFinish = function() {
                    return _this.stop(animation);
                };
                return animation;
            }
        },
        {
            /**
   * @param {Animation} animation
   */ key: "stop",
            value: function stop(animation) {
                animation.destroy();
                var index = this.activeAnimations.indexOf(animation);
                if (index > -1) this.activeAnimations.splice(index, 1);
            }
        },
        {
            key: "stopAll",
            value: function stopAll() {
                // _stopAllAnimations
                this.activeAnimations.forEach(function(animation) {
                    animation.destroy();
                });
                this.activeAnimations = [];
            }
        },
        {
            /**
   * Stop all pan or zoom transitions
   */ key: "stopAllPan",
            value: function stopAllPan() {
                this.activeAnimations = this.activeAnimations.filter(function(animation) {
                    if (animation.props.isPan) {
                        animation.destroy();
                        return false;
                    }
                    return true;
                });
            }
        },
        {
            key: "stopMainScroll",
            value: function stopMainScroll() {
                this.activeAnimations = this.activeAnimations.filter(function(animation) {
                    if (animation.props.isMainScroll) {
                        animation.destroy();
                        return false;
                    }
                    return true;
                });
            }
        },
        {
            /**
   * Returns true if main scroll transition is running
   */ // isMainScrollRunning() {
            //   return this.activeAnimations.some((animation) => {
            //     return animation.props.isMainScroll;
            //   });
            // }
            /**
   * Returns true if any pan or zoom transition is running
   */ key: "isPanRunning",
            value: function isPanRunning() {
                return this.activeAnimations.some(function(animation) {
                    return animation.props.isPan;
                });
            }
        }
    ]);
    return Animations;
}();
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /**
 * Handles scroll wheel.
 * Can pan and zoom current slide image.
 */ var $f38b189616c72948$var$ScrollWheel = /*#__PURE__*/ function() {
    "use strict";
    function ScrollWheel(pswp) {
        (0, $dXdNl._)(this, ScrollWheel);
        this.pswp = pswp;
        pswp.events.add(pswp.element, 'wheel', /** @type EventListener */ this._onWheel.bind(this));
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(ScrollWheel, [
        {
            /**
   * @private
   * @param {WheelEvent} e
   */ key: "_onWheel",
            value: function _onWheel(e) {
                e.preventDefault();
                var currSlide = this.pswp.currSlide;
                var deltaX = e.deltaX, deltaY = e.deltaY;
                if (!currSlide) return;
                if (this.pswp.dispatch('wheel', {
                    originalEvent: e
                }).defaultPrevented) return;
                if (e.ctrlKey || this.pswp.options.wheelToZoom) // zoom
                {
                    if (currSlide.isZoomable()) {
                        var zoomFactor = -deltaY;
                        if (e.deltaMode === 1) zoomFactor *= 0.05;
                        else zoomFactor *= e.deltaMode ? 1 : 0.002;
                        zoomFactor = Math.pow(2, zoomFactor);
                        var destZoomLevel = currSlide.currZoomLevel * zoomFactor;
                        currSlide.zoomTo(destZoomLevel, {
                            x: e.clientX,
                            y: e.clientY
                        });
                    }
                } else // pan
                if (currSlide.isPannable()) {
                    if (e.deltaMode === 1) {
                        // 18 - average line height
                        deltaX *= 18;
                        deltaY *= 18;
                    }
                    currSlide.panTo(currSlide.pan.x - deltaX, currSlide.pan.y - deltaY);
                }
            }
        }
    ]);
    return ScrollWheel;
}();
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 * @template T
 * @typedef {import('../types.js').Methods<T>} Methods<T>
 */ /**
 * @typedef {Object} UIElementMarkupProps
 * @prop {boolean} [isCustomSVG]
 * @prop {string} inner
 * @prop {string} [outlineID]
 * @prop {number | string} [size]
 */ /**
 * @typedef {Object} UIElementData
 * @prop {DefaultUIElements | string} [name]
 * @prop {string} [className]
 * @prop {UIElementMarkup} [html]
 * @prop {boolean} [isButton]
 * @prop {keyof HTMLElementTagNameMap} [tagName]
 * @prop {string} [title]
 * @prop {string} [ariaLabel]
 * @prop {(element: HTMLElement, pswp: PhotoSwipe) => void} [onInit]
 * @prop {Methods<PhotoSwipe> | ((e: MouseEvent, element: HTMLElement, pswp: PhotoSwipe) => void)} [onClick]
 * @prop {'bar' | 'wrapper' | 'root'} [appendTo]
 * @prop {number} [order]
 */ /** @typedef {'arrowPrev' | 'arrowNext' | 'close' | 'zoom' | 'counter'} DefaultUIElements */ /** @typedef {string | UIElementMarkupProps} UIElementMarkup */ /**
 * @param {UIElementMarkup} [htmlData]
 * @returns {string}
 */ function $f38b189616c72948$var$addElementHTML(htmlData) {
    if (typeof htmlData === 'string') // Allow developers to provide full svg,
    // For example:
    // <svg viewBox="0 0 32 32" width="32" height="32" aria-hidden="true" class="pswp__icn">
    //   <path d="..." />
    //   <circle ... />
    // </svg>
    // Can also be any HTML string.
    return htmlData;
    if (!htmlData || !htmlData.isCustomSVG) return '';
    var svgData = htmlData;
    var out = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">'; // replace all %d with size
    out = out.split('%d').join(/** @type {string} */ svgData.size || 32); // Icons may contain outline/shadow,
    // to make it we "clone" base icon shape and add border to it.
    // Icon itself and border are styled via CSS.
    //
    // Property shadowID defines ID of element that should be cloned.
    if (svgData.outlineID) out += '<use class="pswp__icn-shadow" xlink:href="#' + svgData.outlineID + '"/>';
    out += svgData.inner;
    out += '</svg>';
    return out;
}
var $f38b189616c72948$var$UIElement = function UIElement(pswp, data) {
    "use strict";
    (0, $dXdNl._)(this, UIElement);
    var _container;
    var name = data.name || data.className;
    var elementHTML = data.html; // @ts-expect-error lookup only by `data.name` maybe?
    if (pswp.options[name] === false) // exit if element is disabled from options
    return;
     // Allow to override SVG icons from options
    // @ts-expect-error lookup only by `data.name` maybe?
    if (typeof pswp.options[name + 'SVG'] === 'string') // arrowPrevSVG
    // arrowNextSVG
    // closeSVG
    // zoomSVG
    // @ts-expect-error lookup only by `data.name` maybe?
    elementHTML = pswp.options[name + 'SVG'];
    pswp.dispatch('uiElementCreate', {
        data: data
    });
    var className = '';
    if (data.isButton) {
        className += 'pswp__button ';
        className += data.className || "pswp__button--".concat(data.name);
    } else className += data.className || "pswp__".concat(data.name);
    var tagName = data.isButton ? data.tagName || 'button' : data.tagName || 'div';
    tagName = /** @type {keyof HTMLElementTagNameMap} */ tagName.toLowerCase();
    /** @type {HTMLElement} */ var element = $f38b189616c72948$var$createElement(className, tagName);
    if (data.isButton) {
        if (tagName === 'button') /** @type {HTMLButtonElement} */ element.type = 'button';
        var title = data.title;
        var ariaLabel = data.ariaLabel; // @ts-expect-error lookup only by `data.name` maybe?
        if (typeof pswp.options[name + 'Title'] === 'string') // @ts-expect-error lookup only by `data.name` maybe?
        title = pswp.options[name + 'Title'];
        if (title) element.title = title;
        var ariaText = ariaLabel || title;
        if (ariaText) element.setAttribute('aria-label', ariaText);
    }
    element.innerHTML = $f38b189616c72948$var$addElementHTML(elementHTML);
    if (data.onInit) data.onInit(element, pswp);
    if (data.onClick) element.onclick = function(e) {
        if (typeof data.onClick === 'string') // @ts-ignore
        pswp[data.onClick]();
        else if (typeof data.onClick === 'function') data.onClick(e, element, pswp);
    };
     // Top bar is default position
    var appendTo = data.appendTo || 'bar';
    /** @type {HTMLElement | undefined} root element by default */ var container = pswp.element;
    if (appendTo === 'bar') {
        if (!pswp.topBar) pswp.topBar = $f38b189616c72948$var$createElement('pswp__top-bar pswp__hide-on-close', 'div', pswp.scrollWrap);
        container = pswp.topBar;
    } else {
        // element outside of top bar gets a secondary class
        // that makes element fade out on close
        element.classList.add('pswp__hide-on-close');
        if (appendTo === 'wrapper') container = pswp.scrollWrap;
    }
    (_container = container) === null || _container === void 0 || _container.appendChild(pswp.applyFilters('uiElement', element, data));
};
/*
  Backward and forward arrow buttons
 */ /** @typedef {import('./ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /**
 *
 * @param {HTMLElement} element
 * @param {PhotoSwipe} pswp
 * @param {boolean} [isNextButton]
 */ function $f38b189616c72948$var$initArrowButton(element, pswp, isNextButton) {
    element.classList.add('pswp__button--arrow'); // TODO: this should point to a unique id for this instance
    element.setAttribute('aria-controls', 'pswp__items');
    pswp.on('change', function() {
        if (!pswp.options.loop) {
            if (isNextButton) /** @type {HTMLButtonElement} */ element.disabled = !(pswp.currIndex < pswp.getNumItems() - 1);
            else /** @type {HTMLButtonElement} */ element.disabled = !(pswp.currIndex > 0);
        }
    });
}
/** @type {UIElementData} */ var $f38b189616c72948$var$arrowPrev = {
    name: 'arrowPrev',
    className: 'pswp__button--arrow--prev',
    title: 'Previous',
    order: 10,
    isButton: true,
    appendTo: 'wrapper',
    html: {
        isCustomSVG: true,
        size: 60,
        inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow'
    },
    onClick: 'prev',
    onInit: $f38b189616c72948$var$initArrowButton
};
/** @type {UIElementData} */ var $f38b189616c72948$var$arrowNext = {
    name: 'arrowNext',
    className: 'pswp__button--arrow--next',
    title: 'Next',
    order: 11,
    isButton: true,
    appendTo: 'wrapper',
    html: {
        isCustomSVG: true,
        size: 60,
        inner: '<use xlink:href="#pswp__icn-arrow"/>',
        outlineID: 'pswp__icn-arrow'
    },
    onClick: 'next',
    onInit: function(el, pswp) {
        $f38b189616c72948$var$initArrowButton(el, pswp, true);
    }
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $f38b189616c72948$var$closeButton = {
    name: 'close',
    title: 'Close',
    order: 20,
    isButton: true,
    html: {
        isCustomSVG: true,
        inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
        outlineID: 'pswp__icn-close'
    },
    onClick: 'close'
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $f38b189616c72948$var$zoomButton = {
    name: 'zoom',
    title: 'Zoom',
    order: 10,
    isButton: true,
    html: {
        isCustomSVG: true,
        // eslint-disable-next-line max-len
        inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
        outlineID: 'pswp__icn-zoom'
    },
    onClick: 'toggleZoom'
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $f38b189616c72948$var$loadingIndicator = {
    name: 'preloader',
    appendTo: 'bar',
    order: 7,
    html: {
        isCustomSVG: true,
        // eslint-disable-next-line max-len
        inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
        outlineID: 'pswp__icn-loading'
    },
    onInit: function(indicatorElement, pswp) {
        /** @type {boolean | undefined} */ var isVisible;
        /** @type {NodeJS.Timeout | null} */ var delayTimeout = null;
        /**
     * @param {string} className
     * @param {boolean} add
     */ var toggleIndicatorClass = function(className, add) {
            indicatorElement.classList.toggle('pswp__preloader--' + className, add);
        };
        /**
     * @param {boolean} visible
     */ var setIndicatorVisibility = function(visible) {
            if (isVisible !== visible) {
                isVisible = visible;
                toggleIndicatorClass('active', visible);
            }
        };
        var updatePreloaderVisibility = function() {
            var _pswp$currSlide;
            if (!((_pswp$currSlide = pswp.currSlide) !== null && _pswp$currSlide !== void 0 && _pswp$currSlide.content.isLoading())) {
                setIndicatorVisibility(false);
                if (delayTimeout) {
                    clearTimeout(delayTimeout);
                    delayTimeout = null;
                }
                return;
            }
            if (!delayTimeout) // display loading indicator with delay
            delayTimeout = setTimeout(function() {
                var _pswp$currSlide2;
                setIndicatorVisibility(Boolean((_pswp$currSlide2 = pswp.currSlide) === null || _pswp$currSlide2 === void 0 ? void 0 : _pswp$currSlide2.content.isLoading()));
                delayTimeout = null;
            }, pswp.options.preloaderDelay);
        };
        pswp.on('change', updatePreloaderVisibility);
        pswp.on('loadComplete', function(e) {
            if (pswp.currSlide === e.slide) updatePreloaderVisibility();
        }); // expose the method
        if (pswp.ui) pswp.ui.updatePreloaderVisibility = updatePreloaderVisibility;
    }
};
/** @type {import('./ui-element.js').UIElementData} UIElementData */ var $f38b189616c72948$var$counterIndicator = {
    name: 'counter',
    order: 5,
    onInit: function(counterElement, pswp) {
        pswp.on('change', function() {
            counterElement.innerText = pswp.currIndex + 1 + pswp.options.indexIndicatorSep + pswp.getNumItems();
        });
    }
};
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./ui-element.js').UIElementData} UIElementData */ /**
 * Set special class on element when image is zoomed.
 *
 * By default, it is used to adjust
 * zoom icon and zoom cursor via CSS.
 *
 * @param {HTMLElement} el
 * @param {boolean} isZoomedIn
 */ function $f38b189616c72948$var$setZoomedIn(el, isZoomedIn) {
    el.classList.toggle('pswp--zoomed-in', isZoomedIn);
}
var $f38b189616c72948$var$UI = /*#__PURE__*/ function() {
    "use strict";
    function UI(pswp) {
        (0, $dXdNl._)(this, UI);
        this.pswp = pswp;
        this.isRegistered = false;
        /** @type {UIElementData[]} */ this.uiElementsData = [];
        /** @type {(UIElement | UIElementData)[]} */ this.items = [];
        /** @type {() => void} */ this.updatePreloaderVisibility = function() {};
        /**
     * @private
     * @type {number | undefined}
     */ this._lastUpdatedZoomLevel = undefined;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(UI, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                var pswp = this.pswp;
                this.isRegistered = false;
                this.uiElementsData = [
                    $f38b189616c72948$var$closeButton,
                    $f38b189616c72948$var$arrowPrev,
                    $f38b189616c72948$var$arrowNext,
                    $f38b189616c72948$var$zoomButton,
                    $f38b189616c72948$var$loadingIndicator,
                    $f38b189616c72948$var$counterIndicator
                ];
                pswp.dispatch('uiRegister'); // sort by order
                this.uiElementsData.sort(function(a, b) {
                    // default order is 0
                    return (a.order || 0) - (b.order || 0);
                });
                this.items = [];
                this.isRegistered = true;
                this.uiElementsData.forEach(function(uiElementData) {
                    _this.registerElement(uiElementData);
                });
                pswp.on('change', function() {
                    var _pswp$element;
                    (_pswp$element = pswp.element) === null || _pswp$element === void 0 || _pswp$element.classList.toggle('pswp--one-slide', pswp.getNumItems() === 1);
                });
                pswp.on('zoomPanUpdate', function() {
                    return _this._onZoomPanUpdate();
                });
            }
        },
        {
            /**
   * @param {UIElementData} elementData
   */ key: "registerElement",
            value: function registerElement(elementData) {
                if (this.isRegistered) this.items.push(new $f38b189616c72948$var$UIElement(this.pswp, elementData));
                else this.uiElementsData.push(elementData);
            }
        },
        {
            /**
   * Fired each time zoom or pan position is changed.
   * Update classes that control visibility of zoom button and cursor icon.
   *
   * @private
   */ key: "_onZoomPanUpdate",
            value: function _onZoomPanUpdate() {
                var _this_pswp = this.pswp, template = _this_pswp.template, currSlide = _this_pswp.currSlide, options = _this_pswp.options;
                if (this.pswp.opener.isClosing || !template || !currSlide) return;
                var currZoomLevel = currSlide.currZoomLevel; // if not open yet - check against initial zoom level
                if (!this.pswp.opener.isOpen) currZoomLevel = currSlide.zoomLevels.initial;
                if (currZoomLevel === this._lastUpdatedZoomLevel) return;
                this._lastUpdatedZoomLevel = currZoomLevel;
                var currZoomLevelDiff = currSlide.zoomLevels.initial - currSlide.zoomLevels.secondary; // Initial and secondary zoom levels are almost equal
                if (Math.abs(currZoomLevelDiff) < 0.01 || !currSlide.isZoomable()) {
                    // disable zoom
                    $f38b189616c72948$var$setZoomedIn(template, false);
                    template.classList.remove('pswp--zoom-allowed');
                    return;
                }
                template.classList.add('pswp--zoom-allowed');
                var potentialZoomLevel = currZoomLevel === currSlide.zoomLevels.initial ? currSlide.zoomLevels.secondary : currSlide.zoomLevels.initial;
                $f38b189616c72948$var$setZoomedIn(template, potentialZoomLevel <= currZoomLevel);
                if (options.imageClickAction === 'zoom' || options.imageClickAction === 'zoom-or-close') template.classList.add('pswp--click-to-zoom');
            }
        }
    ]);
    return UI;
}();
/** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {{ x: number; y: number; w: number; innerRect?: { w: number; h: number; x: number; y: number } }} Bounds */ /**
 * @param {HTMLElement} el
 * @returns Bounds
 */ function $f38b189616c72948$var$getBoundsByElement(el) {
    var thumbAreaRect = el.getBoundingClientRect();
    return {
        x: thumbAreaRect.left,
        y: thumbAreaRect.top,
        w: thumbAreaRect.width
    };
}
/**
 * @param {HTMLElement} el
 * @param {number} imageWidth
 * @param {number} imageHeight
 * @returns Bounds
 */ function $f38b189616c72948$var$getCroppedBoundsByElement(el, imageWidth, imageHeight) {
    var thumbAreaRect = el.getBoundingClientRect(); // fill image into the area
    // (do they same as object-fit:cover does to retrieve coordinates)
    var hRatio = thumbAreaRect.width / imageWidth;
    var vRatio = thumbAreaRect.height / imageHeight;
    var fillZoomLevel = hRatio > vRatio ? hRatio : vRatio;
    var offsetX = (thumbAreaRect.width - imageWidth * fillZoomLevel) / 2;
    var offsetY = (thumbAreaRect.height - imageHeight * fillZoomLevel) / 2;
    /**
   * Coordinates of the image,
   * as if it was not cropped,
   * height is calculated automatically
   *
   * @type {Bounds}
   */ var bounds = {
        x: thumbAreaRect.left + offsetX,
        y: thumbAreaRect.top + offsetY,
        w: imageWidth * fillZoomLevel
    }; // Coordinates of inner crop area
    // relative to the image
    bounds.innerRect = {
        w: thumbAreaRect.width,
        h: thumbAreaRect.height,
        x: offsetX,
        y: offsetY
    };
    return bounds;
}
/**
 * Get dimensions of thumbnail image
 * (click on which opens photoswipe or closes photoswipe to)
 *
 * @param {number} index
 * @param {SlideData} itemData
 * @param {PhotoSwipe} instance PhotoSwipe instance
 * @returns {Bounds | undefined}
 */ function $f38b189616c72948$var$getThumbBounds(index, itemData, instance) {
    // legacy event, before filters were introduced
    var event = instance.dispatch('thumbBounds', {
        index: index,
        itemData: itemData,
        instance: instance
    }); // @ts-expect-error
    if (event.thumbBounds) // @ts-expect-error
    return event.thumbBounds;
    var element = itemData.element;
    /** @type {Bounds | undefined} */ var thumbBounds;
    /** @type {HTMLElement | null | undefined} */ var thumbnail;
    if (element && instance.options.thumbSelector !== false) {
        var thumbSelector = instance.options.thumbSelector || 'img';
        thumbnail = element.matches(thumbSelector) ? element : /** @type {HTMLElement | null} */ element.querySelector(thumbSelector);
    }
    thumbnail = instance.applyFilters('thumbEl', thumbnail, itemData, index);
    if (thumbnail) {
        if (!itemData.thumbCropped) thumbBounds = $f38b189616c72948$var$getBoundsByElement(thumbnail);
        else thumbBounds = $f38b189616c72948$var$getCroppedBoundsByElement(thumbnail, itemData.width || itemData.w || 0, itemData.height || itemData.h || 0);
    }
    return instance.applyFilters('thumbBounds', thumbBounds, itemData, index);
}
/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ /** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */ /** @typedef {import('../photoswipe.js').DataSource} DataSource */ /** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('../slide/content.js').default} ContentDefault */ /** @typedef {import('../slide/slide.js').default} Slide */ /** @typedef {import('../slide/slide.js').SlideData} SlideData */ /** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */ /** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */ /**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */ /** @typedef {{ x?: number; y?: number }} Point */ /**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */ /**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thumbnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
 *
 */ /**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */ /**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */ var $f38b189616c72948$var$PhotoSwipeEvent = /*#__PURE__*/ function() {
    "use strict";
    function PhotoSwipeEvent(type, details) {
        (0, $dXdNl._)(this, PhotoSwipeEvent);
        this.type = type;
        this.defaultPrevented = false;
        if (details) Object.assign(this, details);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PhotoSwipeEvent, [
        {
            key: "preventDefault",
            value: function preventDefault() {
                this.defaultPrevented = true;
            }
        }
    ]);
    return PhotoSwipeEvent;
}();
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */ var $f38b189616c72948$var$Eventable = /*#__PURE__*/ function() {
    "use strict";
    function Eventable() {
        (0, $dXdNl._)(this, Eventable);
        /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */ this._listeners = {};
        /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */ this._filters = {};
        /** @type {PhotoSwipe | undefined} */ this.pswp = undefined;
        /** @type {PhotoSwipeOptions | undefined} */ this.options = undefined;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Eventable, [
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */ key: "addFilter",
            value: function addFilter(name, fn) {
                var priority = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
                var _this$_filters$name, _this$_filters$name2, _this$pswp;
                if (!this._filters[name]) this._filters[name] = [];
                (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
                    fn: fn,
                    priority: priority
                });
                (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort(function(f1, f2) {
                    return f1.priority - f2.priority;
                });
                (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   */ key: "removeFilter",
            value: function removeFilter(name, fn) {
                if (this._filters[name]) // @ts-expect-error
                this._filters[name] = this._filters[name].filter(function(filter) {
                    return filter.fn !== fn;
                });
                if (this.pswp) this.pswp.removeFilter(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
   * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
   */ key: "applyFilters",
            value: function applyFilters(name) {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this$_filters$name3;
                (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(function(filter) {
                    // @ts-expect-error
                    args[0] = filter.fn.apply(_this, args);
                });
                return args[0];
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "on",
            value: function on(name, fn) {
                var _this$_listeners$name, _this$pswp2;
                if (!this._listeners[name]) this._listeners[name] = [];
                (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
                // also bind events to PhotoSwipe Core,
                // if it's open.
                (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {EventCallback<T>} fn
   */ key: "off",
            value: function off(name, fn) {
                var _this$pswp3;
                if (this._listeners[name]) // @ts-expect-error
                this._listeners[name] = this._listeners[name].filter(function(listener) {
                    return fn !== listener;
                });
                (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
            }
        },
        {
            /**
   * @template {keyof PhotoSwipeEventsMap} T
   * @param {T} name
   * @param {PhotoSwipeEventsMap[T]} [details]
   * @returns {AugmentedEvent<T>}
   */ key: "dispatch",
            value: function dispatch(name, details) {
                var _this = this;
                var _this$_listeners$name2;
                if (this.pswp) return this.pswp.dispatch(name, details);
                var event = /** @type {AugmentedEvent<T>} */ new $f38b189616c72948$var$PhotoSwipeEvent(name, details);
                (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(function(listener) {
                    listener.call(_this, event);
                });
                return event;
            }
        }
    ]);
    return Eventable;
}();
var $f38b189616c72948$var$Placeholder = /*#__PURE__*/ function() {
    "use strict";
    function Placeholder(imageSrc, container) {
        (0, $dXdNl._)(this, Placeholder);
        // Create placeholder
        // (stretched thumbnail or simple div behind the main image)
        /** @type {HTMLImageElement | HTMLDivElement | null} */ this.element = $f38b189616c72948$var$createElement('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);
        if (imageSrc) {
            var imgEl = /** @type {HTMLImageElement} */ this.element;
            imgEl.decoding = 'async';
            imgEl.alt = '';
            imgEl.src = imageSrc;
            imgEl.setAttribute('role', 'presentation');
        }
        this.element.setAttribute('aria-hidden', 'true');
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Placeholder, [
        {
            /**
   * @param {number} width
   * @param {number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.element.tagName === 'IMG') {
                    // Use transform scale() to modify img placeholder size
                    // (instead of changing width/height directly).
                    // This helps with performance, specifically in iOS15 Safari.
                    $f38b189616c72948$var$setWidthHeight(this.element, 250, 'auto');
                    this.element.style.transformOrigin = '0 0';
                    this.element.style.transform = $f38b189616c72948$var$toTransformString(0, 0, width / 250);
                } else $f38b189616c72948$var$setWidthHeight(this.element, width, height);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this$element;
                if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) this.element.remove();
                this.element = null;
            }
        }
    ]);
    return Placeholder;
}();
/** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../util/util.js').LoadState} LoadState */ var $f38b189616c72948$var$Content = /*#__PURE__*/ function() {
    "use strict";
    function Content(itemData, instance, index) {
        (0, $dXdNl._)(this, Content);
        this.instance = instance;
        this.data = itemData;
        this.index = index;
        /** @type {HTMLImageElement | HTMLDivElement | undefined} */ this.element = undefined;
        /** @type {Placeholder | undefined} */ this.placeholder = undefined;
        /** @type {Slide | undefined} */ this.slide = undefined;
        this.displayedImageWidth = 0;
        this.displayedImageHeight = 0;
        this.width = Number(this.data.w) || Number(this.data.width) || 0;
        this.height = Number(this.data.h) || Number(this.data.height) || 0;
        this.isAttached = false;
        this.hasSlide = false;
        this.isDecoding = false;
        /** @type {LoadState} */ this.state = $f38b189616c72948$var$LOAD_STATE.IDLE;
        if (this.data.type) this.type = this.data.type;
        else if (this.data.src) this.type = 'image';
        else this.type = 'html';
        this.instance.dispatch('contentInit', {
            content: this
        });
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Content, [
        {
            key: "removePlaceholder",
            value: function removePlaceholder() {
                var _this = this;
                if (this.placeholder && !this.keepPlaceholder()) // With delay, as image might be loaded, but not rendered
                setTimeout(function() {
                    if (_this.placeholder) {
                        _this.placeholder.destroy();
                        _this.placeholder = undefined;
                    }
                }, 1000);
            }
        },
        {
            /**
   * Preload content
   *
   * @param {boolean} isLazy
   * @param {boolean} [reload]
   */ key: "load",
            value: function load(isLazy, reload) {
                if (this.slide && this.usePlaceholder()) {
                    if (!this.placeholder) {
                        var placeholderSrc = this.instance.applyFilters('placeholderSrc', // as rendering (even small stretched thumbnail) is an expensive operation
                        this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
                        this.placeholder = new $f38b189616c72948$var$Placeholder(placeholderSrc, this.slide.container);
                    } else {
                        var placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created
                        if (placeholderEl && !placeholderEl.parentElement) this.slide.container.prepend(placeholderEl);
                    }
                }
                if (this.element && !reload) return;
                if (this.instance.dispatch('contentLoad', {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                if (this.isImageContent()) {
                    this.element = $f38b189616c72948$var$createElement('pswp__img', 'img'); // Start loading only after width is defined, as sizes might depend on it.
                    // Due to Safari feature, we must define sizes before srcset.
                    if (this.displayedImageWidth) this.loadImage(isLazy);
                } else {
                    this.element = $f38b189616c72948$var$createElement('pswp__content', 'div');
                    this.element.innerHTML = this.data.html || '';
                }
                if (reload && this.slide) this.slide.updateContentSize(true);
            }
        },
        {
            /**
   * Preload image
   *
   * @param {boolean} isLazy
   */ key: "loadImage",
            value: function loadImage(isLazy) {
                var _this = this;
                var _this$data$src, _this$data$alt;
                if (!this.isImageContent() || !this.element || this.instance.dispatch('contentLoadImage', {
                    content: this,
                    isLazy: isLazy
                }).defaultPrevented) return;
                var imageElement = /** @type HTMLImageElement */ this.element;
                this.updateSrcsetSizes();
                if (this.data.srcset) imageElement.srcset = this.data.srcset;
                imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
                imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
                this.state = $f38b189616c72948$var$LOAD_STATE.LOADING;
                if (imageElement.complete) this.onLoaded();
                else {
                    imageElement.onload = function() {
                        _this.onLoaded();
                    };
                    imageElement.onerror = function() {
                        _this.onError();
                    };
                }
            }
        },
        {
            /**
   * Assign slide to content
   *
   * @param {Slide} slide
   */ key: "setSlide",
            value: function setSlide(slide) {
                this.slide = slide;
                this.hasSlide = true;
                this.instance = slide.pswp; // todo: do we need to unset slide?
            }
        },
        {
            /**
   * Content load success handler
   */ key: "onLoaded",
            value: function onLoaded() {
                this.state = $f38b189616c72948$var$LOAD_STATE.LOADED;
                if (this.slide && this.element) {
                    this.instance.dispatch('loadComplete', {
                        slide: this.slide,
                        content: this
                    }); // if content is reloaded
                    if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
                        this.append();
                        this.slide.updateContentSize(true);
                    }
                    if (this.state === $f38b189616c72948$var$LOAD_STATE.LOADED || this.state === $f38b189616c72948$var$LOAD_STATE.ERROR) this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Content load error handler
   */ key: "onError",
            value: function onError() {
                this.state = $f38b189616c72948$var$LOAD_STATE.ERROR;
                if (this.slide) {
                    this.displayError();
                    this.instance.dispatch('loadComplete', {
                        slide: this.slide,
                        isError: true,
                        content: this
                    });
                    this.instance.dispatch('loadError', {
                        slide: this.slide,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {Boolean} If the content is currently loading
   */ key: "isLoading",
            value: function isLoading() {
                return this.instance.applyFilters('isContentLoading', this.state === $f38b189616c72948$var$LOAD_STATE.LOADING, this);
            }
        },
        {
            /**
   * @returns {Boolean} If the content is in error state
   */ key: "isError",
            value: function isError() {
                return this.state === $f38b189616c72948$var$LOAD_STATE.ERROR;
            }
        },
        {
            /**
   * @returns {boolean} If the content is image
   */ key: "isImageContent",
            value: function isImageContent() {
                return this.type === 'image';
            }
        },
        {
            /**
   * Update content size
   *
   * @param {Number} width
   * @param {Number} height
   */ key: "setDisplayedSize",
            value: function setDisplayedSize(width, height) {
                if (!this.element) return;
                if (this.placeholder) this.placeholder.setDisplayedSize(width, height);
                if (this.instance.dispatch('contentResize', {
                    content: this,
                    width: width,
                    height: height
                }).defaultPrevented) return;
                $f38b189616c72948$var$setWidthHeight(this.element, width, height);
                if (this.isImageContent() && !this.isError()) {
                    var isInitialSizeUpdate = !this.displayedImageWidth && width;
                    this.displayedImageWidth = width;
                    this.displayedImageHeight = height;
                    if (isInitialSizeUpdate) this.loadImage(false);
                    else this.updateSrcsetSizes();
                    if (this.slide) this.instance.dispatch('imageSizeChange', {
                        slide: this.slide,
                        width: width,
                        height: height,
                        content: this
                    });
                }
            }
        },
        {
            /**
   * @returns {boolean} If the content can be zoomed
   */ key: "isZoomable",
            value: function isZoomable() {
                return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== $f38b189616c72948$var$LOAD_STATE.ERROR, this);
            }
        },
        {
            /**
   * Update image srcset sizes attribute based on width and height
   */ key: "updateSrcsetSizes",
            value: function updateSrcsetSizes() {
                // Handle srcset sizes attribute.
                //
                // Never lower quality, if it was increased previously.
                // Chrome does this automatically, Firefox and Safari do not,
                // so we store largest used size in dataset.
                if (!this.isImageContent() || !this.element || !this.data.srcset) return;
                var image = /** @type HTMLImageElement */ this.element;
                var sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
                if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
                    image.sizes = sizesWidth + 'px';
                    image.dataset.largestUsedSize = String(sizesWidth);
                }
            }
        },
        {
            /**
   * @returns {boolean} If content should use a placeholder (from msrc by default)
   */ key: "usePlaceholder",
            value: function usePlaceholder() {
                return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
            }
        },
        {
            /**
   * Preload content with lazy-loading param
   */ key: "lazyLoad",
            value: function lazyLoad() {
                if (this.instance.dispatch('contentLazyLoad', {
                    content: this
                }).defaultPrevented) return;
                this.load(true);
            }
        },
        {
            /**
   * @returns {boolean} If placeholder should be kept after content is loaded
   */ key: "keepPlaceholder",
            value: function keepPlaceholder() {
                return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
            }
        },
        {
            /**
   * Destroy the content
   */ key: "destroy",
            value: function destroy() {
                this.hasSlide = false;
                this.slide = undefined;
                if (this.instance.dispatch('contentDestroy', {
                    content: this
                }).defaultPrevented) return;
                this.remove();
                if (this.placeholder) {
                    this.placeholder.destroy();
                    this.placeholder = undefined;
                }
                if (this.isImageContent() && this.element) {
                    this.element.onload = null;
                    this.element.onerror = null;
                    this.element = undefined;
                }
            }
        },
        {
            /**
   * Display error message
   */ key: "displayError",
            value: function displayError() {
                if (this.slide) {
                    var _this$instance$option, _this$instance$option2;
                    var errorMsgEl = $f38b189616c72948$var$createElement('pswp__error-msg', 'div');
                    errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : '';
                    errorMsgEl = /** @type {HTMLDivElement} */ this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
                    this.element = $f38b189616c72948$var$createElement('pswp__content pswp__error-msg-container', 'div');
                    this.element.appendChild(errorMsgEl);
                    this.slide.container.innerText = '';
                    this.slide.container.appendChild(this.element);
                    this.slide.updateContentSize(true);
                    this.removePlaceholder();
                }
            }
        },
        {
            /**
   * Append the content
   */ key: "append",
            value: function append() {
                var _this = this;
                if (this.isAttached || !this.element) return;
                this.isAttached = true;
                if (this.state === $f38b189616c72948$var$LOAD_STATE.ERROR) {
                    this.displayError();
                    return;
                }
                if (this.instance.dispatch('contentAppend', {
                    content: this
                }).defaultPrevented) return;
                var supportsDecode = 'decode' in this.element;
                if (this.isImageContent()) {
                    // Use decode() on nearby slides
                    //
                    // Nearby slide images are in DOM and not hidden via display:none.
                    // However, they are placed offscreen (to the left and right side).
                    //
                    // Some browsers do not composite the image until it's actually visible,
                    // using decode() helps.
                    //
                    // You might ask "why dont you just decode() and then append all images",
                    // that's because I want to show image before it's fully loaded,
                    // as browser can render parts of image while it is loading.
                    // We do not do this in Safari due to partial loading bug.
                    if (supportsDecode && this.slide && (!this.slide.isActive || $f38b189616c72948$var$isSafari())) {
                        this.isDecoding = true; // purposefully using finally instead of then,
                        // as if srcset sizes changes dynamically - it may cause decode error
                        /** @type {HTMLImageElement} */ this.element.decode().catch(function() {}).finally(function() {
                            _this.isDecoding = false;
                            _this.appendImage();
                        });
                    } else this.appendImage();
                } else if (this.slide && !this.element.parentNode) this.slide.container.appendChild(this.element);
            }
        },
        {
            /**
   * Activate the slide,
   * active slide is generally the current one,
   * meaning the user can see it.
   */ key: "activate",
            value: function activate() {
                if (this.instance.dispatch('contentActivate', {
                    content: this
                }).defaultPrevented || !this.slide) return;
                if (this.isImageContent() && this.isDecoding && !$f38b189616c72948$var$isSafari()) // add image to slide when it becomes active,
                // even if it's not finished decoding
                this.appendImage();
                else if (this.isError()) this.load(false, true); // try to reload
                if (this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'false');
            }
        },
        {
            /**
   * Deactivate the content
   */ key: "deactivate",
            value: function deactivate() {
                this.instance.dispatch('contentDeactivate', {
                    content: this
                });
                if (this.slide && this.slide.holderElement) this.slide.holderElement.setAttribute('aria-hidden', 'true');
            }
        },
        {
            /**
   * Remove the content from DOM
   */ key: "remove",
            value: function remove() {
                this.isAttached = false;
                if (this.instance.dispatch('contentRemove', {
                    content: this
                }).defaultPrevented) return;
                if (this.element && this.element.parentNode) this.element.remove();
                if (this.placeholder && this.placeholder.element) this.placeholder.element.remove();
            }
        },
        {
            /**
   * Append the image content to slide container
   */ key: "appendImage",
            value: function appendImage() {
                if (!this.isAttached) return;
                if (this.instance.dispatch('contentAppendImage', {
                    content: this
                }).defaultPrevented) return;
                 // ensure that element exists and is not already appended
                if (this.slide && this.element && !this.element.parentNode) this.slide.container.appendChild(this.element);
                if (this.state === $f38b189616c72948$var$LOAD_STATE.LOADED || this.state === $f38b189616c72948$var$LOAD_STATE.ERROR) this.removePlaceholder();
            }
        }
    ]);
    return Content;
}();
/** @typedef {import('./content.js').default} Content */ /** @typedef {import('./slide.js').default} Slide */ /** @typedef {import('./slide.js').SlideData} SlideData */ /** @typedef {import('../core/base.js').default} PhotoSwipeBase */ /** @typedef {import('../photoswipe.js').default} PhotoSwipe */ var $f38b189616c72948$var$MIN_SLIDES_TO_CACHE = 5;
/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */ function $f38b189616c72948$var$lazyLoadData(itemData, instance, index) {
    var content = instance.createContentFromData(itemData, index);
    /** @type {ZoomLevel | undefined} */ var zoomLevel;
    var options = instance.options; // We need to know dimensions of the image to preload it,
    // as it might use srcset, and we need to define sizes
    if (options) {
        zoomLevel = new $f38b189616c72948$var$ZoomLevel(options, itemData, -1);
        var viewportSize;
        if (instance.pswp) viewportSize = instance.pswp.viewportSize;
        else viewportSize = $f38b189616c72948$var$getViewportSize(options, instance);
        var panAreaSize = $f38b189616c72948$var$getPanAreaSize(options, viewportSize, itemData, index);
        zoomLevel.update(content.width, content.height, panAreaSize);
    }
    content.lazyLoad();
    if (zoomLevel) content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
    return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */ function $f38b189616c72948$var$lazyLoadSlide(index, instance) {
    var itemData = instance.getItemData(index);
    if (instance.dispatch('lazyLoadSlide', {
        index: index,
        itemData: itemData
    }).defaultPrevented) return;
    return $f38b189616c72948$var$lazyLoadData(itemData, instance, index);
}
var $f38b189616c72948$var$ContentLoader = /*#__PURE__*/ function() {
    "use strict";
    function ContentLoader(pswp) {
        (0, $dXdNl._)(this, ContentLoader);
        this.pswp = pswp; // Total amount of cached images
        this.limit = Math.max(pswp.options.preload[0] + pswp.options.preload[1] + 1, $f38b189616c72948$var$MIN_SLIDES_TO_CACHE);
        /** @type {Content[]} */ this._cachedItems = [];
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(ContentLoader, [
        {
            /**
   * Lazy load nearby slides based on `preload` option.
   *
   * @param {number} [diff] Difference between slide indexes that was changed recently, or 0.
   */ key: "updateLazy",
            value: function updateLazy(diff) {
                var pswp = this.pswp;
                if (pswp.dispatch('lazyLoad').defaultPrevented) return;
                var preload = pswp.options.preload;
                var isForward = diff === undefined ? true : diff >= 0;
                var i; // preload[1] - num items to preload in forward direction
                for(i = 0; i <= preload[1]; i++)this.loadSlideByIndex(pswp.currIndex + (isForward ? i : -i));
                 // preload[0] - num items to preload in backward direction
                for(i = 1; i <= preload[0]; i++)this.loadSlideByIndex(pswp.currIndex + (isForward ? -i : i));
            }
        },
        {
            /**
   * @param {number} initialIndex
   */ key: "loadSlideByIndex",
            value: function loadSlideByIndex(initialIndex) {
                var index = this.pswp.getLoopedIndex(initialIndex); // try to get cached content
                var content = this.getContentByIndex(index);
                if (!content) {
                    // no cached content, so try to load from scratch:
                    content = $f38b189616c72948$var$lazyLoadSlide(index, this.pswp); // if content can be loaded, add it to cache:
                    if (content) this.addToCache(content);
                }
            }
        },
        {
            /**
   * @param {Slide} slide
   * @returns {Content}
   */ key: "getContentBySlide",
            value: function getContentBySlide(slide) {
                var content = this.getContentByIndex(slide.index);
                if (!content) {
                    // create content if not found in cache
                    content = this.pswp.createContentFromData(slide.data, slide.index);
                    this.addToCache(content);
                } // assign slide to content
                content.setSlide(slide);
                return content;
            }
        },
        {
            /**
   * @param {Content} content
   */ key: "addToCache",
            value: function addToCache(content) {
                // move to the end of array
                this.removeByIndex(content.index);
                this._cachedItems.push(content);
                if (this._cachedItems.length > this.limit) {
                    // Destroy the first content that's not attached
                    var indexToRemove = this._cachedItems.findIndex(function(item) {
                        return !item.isAttached && !item.hasSlide;
                    });
                    if (indexToRemove !== -1) {
                        var removedItem = this._cachedItems.splice(indexToRemove, 1)[0];
                        removedItem.destroy();
                    }
                }
            }
        },
        {
            /**
   * Removes an image from cache, does not destroy() it, just removes.
   *
   * @param {number} index
   */ key: "removeByIndex",
            value: function removeByIndex(index) {
                var indexToRemove = this._cachedItems.findIndex(function(item) {
                    return item.index === index;
                });
                if (indexToRemove !== -1) this._cachedItems.splice(indexToRemove, 1);
            }
        },
        {
            /**
   * @param {number} index
   * @returns {Content | undefined}
   */ key: "getContentByIndex",
            value: function getContentByIndex(index) {
                return this._cachedItems.find(function(content) {
                    return content.index === index;
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._cachedItems.forEach(function(content) {
                    return content.destroy();
                });
                this._cachedItems = [];
            }
        }
    ]);
    return ContentLoader;
}();
/** @typedef {import("../photoswipe.js").default} PhotoSwipe */ /** @typedef {import("../slide/slide.js").SlideData} SlideData */ /**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */ var $f38b189616c72948$var$PhotoSwipeBase = /*#__PURE__*/ function(Eventable) {
    "use strict";
    (0, $l3RwB._)(PhotoSwipeBase, Eventable);
    function PhotoSwipeBase() {
        (0, $dXdNl._)(this, PhotoSwipeBase);
        return (0, $lPOtB._)(this, PhotoSwipeBase, arguments);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PhotoSwipeBase, [
        {
            /**
   * Get total number of slides
   *
   * @returns {number}
   */ key: "getNumItems",
            value: function getNumItems() {
                var _this$options;
                var numItems = 0;
                var dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
                if (dataSource && 'length' in dataSource) // may be an array or just object with length property
                numItems = dataSource.length;
                else if (dataSource && 'gallery' in dataSource) {
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    if (dataSource.items) numItems = dataSource.items.length;
                } // legacy event, before filters were introduced
                var event = this.dispatch('numItems', {
                    dataSource: dataSource,
                    numItems: numItems
                });
                return this.applyFilters('numItems', event.numItems, dataSource);
            }
        },
        {
            /**
   * @param {SlideData} slideData
   * @param {number} index
   * @returns {Content}
   */ key: "createContentFromData",
            value: function createContentFromData(slideData, index) {
                return new $f38b189616c72948$var$Content(slideData, this, index);
            }
        },
        {
            /**
   * Get item data by index.
   *
   * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
   * For example, it may contain properties like
   * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
   *
   * @param {number} index
   * @returns {SlideData}
   */ key: "getItemData",
            value: function getItemData(index) {
                var _this$options2;
                var dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
                /** @type {SlideData | HTMLElement} */ var dataSourceItem = {};
                if (Array.isArray(dataSource)) // Datasource is an array of elements
                dataSourceItem = dataSource[index];
                else if (dataSource && 'gallery' in dataSource) {
                    // dataSource has gallery property,
                    // thus it was created by Lightbox, based on
                    // gallery and children options
                    // query DOM elements
                    if (!dataSource.items) dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
                    dataSourceItem = dataSource.items[index];
                }
                var itemData = dataSourceItem;
                if (itemData instanceof Element) itemData = this._domElementToItemData(itemData);
                 // Dispatching the itemData event,
                // it's a legacy verion before filters were introduced
                var event = this.dispatch('itemData', {
                    itemData: itemData || {},
                    index: index
                });
                return this.applyFilters('itemData', event.itemData, index);
            }
        },
        {
            /**
   * Get array of gallery DOM elements,
   * based on childSelector and gallery element.
   *
   * @param {HTMLElement} galleryElement
   * @returns {HTMLElement[]}
   */ key: "_getGalleryDOMElements",
            value: function _getGalleryDOMElements(galleryElement) {
                var _this$options3, _this$options4;
                if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) return $f38b189616c72948$var$getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
                return [
                    galleryElement
                ];
            }
        },
        {
            /**
   * Converts DOM element to item data object.
   *
   * @param {HTMLElement} element DOM element
   * @returns {SlideData}
   */ key: "_domElementToItemData",
            value: function _domElementToItemData(element) {
                /** @type {SlideData} */ var itemData = {
                    element: element
                };
                var linkEl = /** @type {HTMLAnchorElement} */ element.tagName === 'A' ? element : element.querySelector('a');
                if (linkEl) {
                    // src comes from data-pswp-src attribute,
                    // if it's empty link href is used
                    itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
                    if (linkEl.dataset.pswpSrcset) itemData.srcset = linkEl.dataset.pswpSrcset;
                    itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
                    itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties
                    itemData.w = itemData.width;
                    itemData.h = itemData.height;
                    if (linkEl.dataset.pswpType) itemData.type = linkEl.dataset.pswpType;
                    var thumbnailEl = element.querySelector('img');
                    if (thumbnailEl) {
                        var _thumbnailEl$getAttri;
                        // msrc is URL to placeholder image that's displayed before large image is loaded
                        // by default it's displayed only for the first slide
                        itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
                        itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : '';
                    }
                    if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) itemData.thumbCropped = true;
                }
                return this.applyFilters('domItemData', itemData, element, linkEl);
            }
        },
        {
            /**
   * Lazy-load by slide data
   *
   * @param {SlideData} itemData Data about the slide
   * @param {number} index
   * @returns {Content} Image that is being decoded or false.
   */ key: "lazyLoadData",
            value: function lazyLoadData1(itemData, index) {
                return $f38b189616c72948$var$lazyLoadData(itemData, this, index);
            }
        }
    ]);
    return PhotoSwipeBase;
}($f38b189616c72948$var$Eventable);
/** @typedef {import('./photoswipe.js').default} PhotoSwipe */ /** @typedef {import('./slide/get-thumb-bounds.js').Bounds} Bounds */ /** @typedef {import('./util/animations.js').AnimationProps} AnimationProps */ // some browsers do not paint
// elements which opacity is set to 0,
// since we need to pre-render elements for the animation -
// we set it to the minimum amount
var $f38b189616c72948$var$MIN_OPACITY = 0.003;
/**
 * Manages opening and closing transitions of the PhotoSwipe.
 *
 * It can perform zoom, fade or no transition.
 */ var $f38b189616c72948$var$Opener = /*#__PURE__*/ function() {
    "use strict";
    function Opener(pswp) {
        (0, $dXdNl._)(this, Opener);
        this.pswp = pswp;
        this.isClosed = true;
        this.isOpen = false;
        this.isClosing = false;
        this.isOpening = false;
        /**
     * @private
     * @type {number | false | undefined}
     */ this._duration = undefined;
        /** @private */ this._useAnimation = false;
        /** @private */ this._croppedZoom = false;
        /** @private */ this._animateRootOpacity = false;
        /** @private */ this._animateBgOpacity = false;
        /**
     * @private
     * @type { HTMLDivElement | HTMLImageElement | null | undefined }
     */ this._placeholder = undefined;
        /**
     * @private
     * @type { HTMLDivElement | undefined }
     */ this._opacityElement = undefined;
        /**
     * @private
     * @type { HTMLDivElement | undefined }
     */ this._cropContainer1 = undefined;
        /**
     * @private
     * @type { HTMLElement | null | undefined }
     */ this._cropContainer2 = undefined;
        /**
     * @private
     * @type {Bounds | undefined}
     */ this._thumbBounds = undefined;
        this._prepareOpen = this._prepareOpen.bind(this); // Override initial zoom and pan position
        pswp.on('firstZoomPan', this._prepareOpen);
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(Opener, [
        {
            key: "open",
            value: function open() {
                this._prepareOpen();
                this._start();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                if (this.isClosed || this.isClosing || this.isOpening) // if we close during opening animation
                // for now do nothing,
                // browsers aren't good at changing the direction of the CSS transition
                return;
                var slide = this.pswp.currSlide;
                this.isOpen = false;
                this.isOpening = false;
                this.isClosing = true;
                this._duration = this.pswp.options.hideAnimationDuration;
                if (slide && slide.currZoomLevel * slide.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
                this._applyStartProps();
                setTimeout(function() {
                    _this._start();
                }, this._croppedZoom ? 30 : 0);
            }
        },
        {
            /** @private */ key: "_prepareOpen",
            value: function _prepareOpen() {
                this.pswp.off('firstZoomPan', this._prepareOpen);
                if (!this.isOpening) {
                    var slide = this.pswp.currSlide;
                    this.isOpening = true;
                    this.isClosing = false;
                    this._duration = this.pswp.options.showAnimationDuration;
                    if (slide && slide.zoomLevels.initial * slide.width >= this.pswp.options.maxWidthToAnimate) this._duration = 0;
                    this._applyStartProps();
                }
            }
        },
        {
            /** @private */ key: "_applyStartProps",
            value: function _applyStartProps() {
                var pswp = this.pswp;
                var slide = this.pswp.currSlide;
                var options = pswp.options;
                if (options.showHideAnimationType === 'fade') {
                    options.showHideOpacity = true;
                    this._thumbBounds = undefined;
                } else if (options.showHideAnimationType === 'none') {
                    options.showHideOpacity = false;
                    this._duration = 0;
                    this._thumbBounds = undefined;
                } else if (this.isOpening && pswp._initialThumbBounds) // Use initial bounds if defined
                this._thumbBounds = pswp._initialThumbBounds;
                else this._thumbBounds = this.pswp.getThumbBounds();
                this._placeholder = slide === null || slide === void 0 ? void 0 : slide.getPlaceholderElement();
                pswp.animations.stopAll(); // Discard animations when duration is less than 50ms
                this._useAnimation = Boolean(this._duration && this._duration > 50);
                this._animateZoom = Boolean(this._thumbBounds) && (slide === null || slide === void 0 ? void 0 : slide.content.usePlaceholder()) && (!this.isClosing || !pswp.mainScroll.isShifted());
                if (!this._animateZoom) {
                    this._animateRootOpacity = true;
                    if (this.isOpening && slide) {
                        slide.zoomAndPanToInitial();
                        slide.applyCurrentZoomPan();
                    }
                } else {
                    var _options$showHideOpac;
                    this._animateRootOpacity = (_options$showHideOpac = options.showHideOpacity) !== null && _options$showHideOpac !== void 0 ? _options$showHideOpac : false;
                }
                this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > $f38b189616c72948$var$MIN_OPACITY;
                this._opacityElement = this._animateRootOpacity ? pswp.element : pswp.bg;
                if (!this._useAnimation) {
                    this._duration = 0;
                    this._animateZoom = false;
                    this._animateBgOpacity = false;
                    this._animateRootOpacity = true;
                    if (this.isOpening) {
                        if (pswp.element) pswp.element.style.opacity = String($f38b189616c72948$var$MIN_OPACITY);
                        pswp.applyBgOpacity(1);
                    }
                    return;
                }
                if (this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect) {
                    var _this$pswp$currSlide;
                    // Properties are used when animation from cropped thumbnail
                    this._croppedZoom = true;
                    this._cropContainer1 = this.pswp.container;
                    this._cropContainer2 = (_this$pswp$currSlide = this.pswp.currSlide) === null || _this$pswp$currSlide === void 0 ? void 0 : _this$pswp$currSlide.holderElement;
                    if (pswp.container) {
                        pswp.container.style.overflow = 'hidden';
                        pswp.container.style.width = pswp.viewportSize.x + 'px';
                    }
                } else this._croppedZoom = false;
                if (this.isOpening) {
                    // Apply styles before opening transition
                    if (this._animateRootOpacity) {
                        if (pswp.element) pswp.element.style.opacity = String($f38b189616c72948$var$MIN_OPACITY);
                        pswp.applyBgOpacity(1);
                    } else {
                        if (this._animateBgOpacity && pswp.bg) pswp.bg.style.opacity = String($f38b189616c72948$var$MIN_OPACITY);
                        if (pswp.element) pswp.element.style.opacity = '1';
                    }
                    if (this._animateZoom) {
                        this._setClosedStateZoomPan();
                        if (this._placeholder) {
                            // tell browser that we plan to animate the placeholder
                            this._placeholder.style.willChange = 'transform'; // hide placeholder to allow hiding of
                            // elements that overlap it (such as icons over the thumbnail)
                            this._placeholder.style.opacity = String($f38b189616c72948$var$MIN_OPACITY);
                        }
                    }
                } else if (this.isClosing) {
                    // hide nearby slides to make sure that
                    // they are not painted during the transition
                    if (pswp.mainScroll.itemHolders[0]) pswp.mainScroll.itemHolders[0].el.style.display = 'none';
                    if (pswp.mainScroll.itemHolders[2]) pswp.mainScroll.itemHolders[2].el.style.display = 'none';
                    if (this._croppedZoom) {
                        if (pswp.mainScroll.x !== 0) {
                            // shift the main scroller to zero position
                            pswp.mainScroll.resetPosition();
                            pswp.mainScroll.resize();
                        }
                    }
                }
            }
        },
        {
            /** @private */ key: "_start",
            value: function _start() {
                var _this = this;
                if (this.isOpening && this._useAnimation && this._placeholder && this._placeholder.tagName === 'IMG') // To ensure smooth animation
                // we wait till the current slide image placeholder is decoded,
                // but no longer than 250ms,
                // and no shorter than 50ms
                // (just using requestanimationframe is not enough in Firefox,
                // for some reason)
                new Promise(function(resolve) {
                    var decoded = false;
                    var isDelaying = true;
                    $f38b189616c72948$var$decodeImage(/** @type {HTMLImageElement} */ _this._placeholder).finally(function() {
                        decoded = true;
                        if (!isDelaying) resolve(true);
                    });
                    setTimeout(function() {
                        isDelaying = false;
                        if (decoded) resolve(true);
                    }, 50);
                    setTimeout(resolve, 250);
                }).finally(function() {
                    return _this._initiate();
                });
                else this._initiate();
            }
        },
        {
            /** @private */ key: "_initiate",
            value: function _initiate() {
                var _this$pswp$element, _this$pswp$element2;
                (_this$pswp$element = this.pswp.element) === null || _this$pswp$element === void 0 || _this$pswp$element.style.setProperty('--pswp-transition-duration', this._duration + 'ms');
                this.pswp.dispatch(this.isOpening ? 'openingAnimationStart' : 'closingAnimationStart'); // legacy event
                this.pswp.dispatch(/** @type {'initialZoomIn' | 'initialZoomOut'} */ 'initialZoom' + (this.isOpening ? 'In' : 'Out'));
                (_this$pswp$element2 = this.pswp.element) === null || _this$pswp$element2 === void 0 || _this$pswp$element2.classList.toggle('pswp--ui-visible', this.isOpening);
                if (this.isOpening) {
                    if (this._placeholder) // unhide the placeholder
                    this._placeholder.style.opacity = '1';
                    this._animateToOpenState();
                } else if (this.isClosing) this._animateToClosedState();
                if (!this._useAnimation) this._onAnimationComplete();
            }
        },
        {
            /** @private */ key: "_onAnimationComplete",
            value: function _onAnimationComplete() {
                var pswp = this.pswp;
                this.isOpen = this.isOpening;
                this.isClosed = this.isClosing;
                this.isOpening = false;
                this.isClosing = false;
                pswp.dispatch(this.isOpen ? 'openingAnimationEnd' : 'closingAnimationEnd'); // legacy event
                pswp.dispatch(/** @type {'initialZoomInEnd' | 'initialZoomOutEnd'} */ 'initialZoom' + (this.isOpen ? 'InEnd' : 'OutEnd'));
                if (this.isClosed) pswp.destroy();
                else if (this.isOpen) {
                    var _pswp$currSlide;
                    if (this._animateZoom && pswp.container) {
                        pswp.container.style.overflow = 'visible';
                        pswp.container.style.width = '100%';
                    }
                    (_pswp$currSlide = pswp.currSlide) === null || _pswp$currSlide === void 0 || _pswp$currSlide.applyCurrentZoomPan();
                }
            }
        },
        {
            /** @private */ key: "_animateToOpenState",
            value: function _animateToOpenState() {
                var pswp = this.pswp;
                if (this._animateZoom) {
                    if (this._croppedZoom && this._cropContainer1 && this._cropContainer2) {
                        this._animateTo(this._cropContainer1, 'transform', 'translate3d(0,0,0)');
                        this._animateTo(this._cropContainer2, 'transform', 'none');
                    }
                    if (pswp.currSlide) {
                        pswp.currSlide.zoomAndPanToInitial();
                        this._animateTo(pswp.currSlide.container, 'transform', pswp.currSlide.getCurrentTransform());
                    }
                }
                if (this._animateBgOpacity && pswp.bg) this._animateTo(pswp.bg, 'opacity', String(pswp.options.bgOpacity));
                if (this._animateRootOpacity && pswp.element) this._animateTo(pswp.element, 'opacity', '1');
            }
        },
        {
            /** @private */ key: "_animateToClosedState",
            value: function _animateToClosedState() {
                var pswp = this.pswp;
                if (this._animateZoom) this._setClosedStateZoomPan(true);
                 // do not animate opacity if it's already at 0
                if (this._animateBgOpacity && pswp.bgOpacity > 0.01 && pswp.bg) this._animateTo(pswp.bg, 'opacity', '0');
                if (this._animateRootOpacity && pswp.element) this._animateTo(pswp.element, 'opacity', '0');
            }
        },
        {
            /**
   * @private
   * @param {boolean} [animate]
   */ key: "_setClosedStateZoomPan",
            value: function _setClosedStateZoomPan(animate) {
                if (!this._thumbBounds) return;
                var pswp = this.pswp;
                var innerRect = this._thumbBounds.innerRect;
                var currSlide = pswp.currSlide, viewportSize = pswp.viewportSize;
                if (this._croppedZoom && innerRect && this._cropContainer1 && this._cropContainer2) {
                    var containerOnePanX = -viewportSize.x + (this._thumbBounds.x - innerRect.x) + innerRect.w;
                    var containerOnePanY = -viewportSize.y + (this._thumbBounds.y - innerRect.y) + innerRect.h;
                    var containerTwoPanX = viewportSize.x - innerRect.w;
                    var containerTwoPanY = viewportSize.y - innerRect.h;
                    if (animate) {
                        this._animateTo(this._cropContainer1, 'transform', $f38b189616c72948$var$toTransformString(containerOnePanX, containerOnePanY));
                        this._animateTo(this._cropContainer2, 'transform', $f38b189616c72948$var$toTransformString(containerTwoPanX, containerTwoPanY));
                    } else {
                        $f38b189616c72948$var$setTransform(this._cropContainer1, containerOnePanX, containerOnePanY);
                        $f38b189616c72948$var$setTransform(this._cropContainer2, containerTwoPanX, containerTwoPanY);
                    }
                }
                if (currSlide) {
                    $f38b189616c72948$var$equalizePoints(currSlide.pan, innerRect || this._thumbBounds);
                    currSlide.currZoomLevel = this._thumbBounds.w / currSlide.width;
                    if (animate) this._animateTo(currSlide.container, 'transform', currSlide.getCurrentTransform());
                    else currSlide.applyCurrentZoomPan();
                }
            }
        },
        {
            /**
   * @private
   * @param {HTMLElement} target
   * @param {'transform' | 'opacity'} prop
   * @param {string} propValue
   */ key: "_animateTo",
            value: function _animateTo(target, prop, propValue) {
                var _this = this;
                if (!this._duration) {
                    target.style[prop] = propValue;
                    return;
                }
                var animations = this.pswp.animations;
                /** @type {AnimationProps} */ var animProps = {
                    duration: this._duration,
                    easing: this.pswp.options.easing,
                    onComplete: function() {
                        if (!animations.activeAnimations.length) _this._onAnimationComplete();
                    },
                    target: target
                };
                animProps[prop] = propValue;
                animations.startTransition(animProps);
            }
        }
    ]);
    return Opener;
}();
/**
 * @template T
 * @typedef {import('./types.js').Type<T>} Type<T>
 */ /** @typedef {import('./slide/slide.js').SlideData} SlideData */ /** @typedef {import('./slide/zoom-level.js').ZoomLevelOption} ZoomLevelOption */ /** @typedef {import('./ui/ui-element.js').UIElementData} UIElementData */ /** @typedef {import('./main-scroll.js').ItemHolder} ItemHolder */ /** @typedef {import('./core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */ /** @typedef {import('./core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */ /** @typedef {import('./slide/get-thumb-bounds').Bounds} Bounds */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').EventCallback<T>} EventCallback<T>
 */ /**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('./core/eventable.js').AugmentedEvent<T>} AugmentedEvent<T>
 */ /** @typedef {{ x: number; y: number; id?: string | number }} Point */ /** @typedef {{ top: number; bottom: number; left: number; right: number }} Padding */ /** @typedef {SlideData[]} DataSourceArray */ /** @typedef {{ gallery: HTMLElement; items?: HTMLElement[] }} DataSourceObject */ /** @typedef {DataSourceArray | DataSourceObject} DataSource */ /** @typedef {(point: Point, originalEvent: PointerEvent) => void} ActionFn */ /** @typedef {'close' | 'next' | 'zoom' | 'zoom-or-close' | 'toggle-controls'} ActionType */ /** @typedef {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} PhotoSwipeModule */ /** @typedef {PhotoSwipeModule | Promise<PhotoSwipeModule> | (() => Promise<PhotoSwipeModule>)} PhotoSwipeModuleOption */ /**
 * @typedef {string | NodeListOf<HTMLElement> | HTMLElement[] | HTMLElement} ElementProvider
 */ /** @typedef {Partial<PreparedPhotoSwipeOptions>} PhotoSwipeOptions https://photoswipe.com/options/ */ /**
 * @typedef {Object} PreparedPhotoSwipeOptions
 *
 * @prop {DataSource} [dataSource]
 * Pass an array of any items via dataSource option. Its length will determine amount of slides
 * (which may be modified further from numItems event).
 *
 * Each item should contain data that you need to generate slide
 * (for image slide it would be src (image URL), width (image width), height, srcset, alt).
 *
 * If these properties are not present in your initial array, you may "pre-parse" each item from itemData filter.
 *
 * @prop {number} bgOpacity
 * Background backdrop opacity, always define it via this option and not via CSS rgba color.
 *
 * @prop {number} spacing
 * Spacing between slides. Defined as ratio relative to the viewport width (0.1 = 10% of viewport).
 *
 * @prop {boolean} allowPanToNext
 * Allow swipe navigation to the next slide when the current slide is zoomed. Does not apply to mouse events.
 *
 * @prop {boolean} loop
 * If set to true you'll be able to swipe from the last to the first image.
 * Option is always false when there are less than 3 slides.
 *
 * @prop {boolean} [wheelToZoom]
 * By default PhotoSwipe zooms image with ctrl-wheel, if you enable this option - image will zoom just via wheel.
 *
 * @prop {boolean} pinchToClose
 * Pinch touch gesture to close the gallery.
 *
 * @prop {boolean} closeOnVerticalDrag
 * Vertical drag gesture to close the PhotoSwipe.
 *
 * @prop {Padding} [padding]
 * Slide area padding (in pixels).
 *
 * @prop {(viewportSize: Point, itemData: SlideData, index: number) => Padding} [paddingFn]
 * The option is checked frequently, so make sure it's performant. Overrides padding option if defined. For example:
 *
 * @prop {number | false} hideAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} showAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {number | false} zoomAnimationDuration
 * Transition duration in milliseconds, can be 0.
 *
 * @prop {string} easing
 * String, 'cubic-bezier(.4,0,.22,1)'. CSS easing function for open/close/zoom transitions.
 *
 * @prop {boolean} escKey
 * Esc key to close.
 *
 * @prop {boolean} arrowKeys
 * Left/right arrow keys for navigation.
 *
 * @prop {boolean} trapFocus
 * Trap focus within PhotoSwipe element while it's open.
 *
 * @prop {boolean} returnFocus
 * Restore focus the last active element after PhotoSwipe is closed.
 *
 * @prop {boolean} clickToCloseNonZoomable
 * If image is not zoomable (for example, smaller than viewport) it can be closed by clicking on it.
 *
 * @prop {ActionType | ActionFn | false} imageClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} bgClickAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} tapAction
 * Refer to click and tap actions page.
 *
 * @prop {ActionType | ActionFn | false} doubleTapAction
 * Refer to click and tap actions page.
 *
 * @prop {number} preloaderDelay
 * Delay before the loading indicator will be displayed,
 * if image is loaded during it - the indicator will not be displayed at all. Can be zero.
 *
 * @prop {string} indexIndicatorSep
 * Used for slide count indicator ("1 of 10 ").
 *
 * @prop {(options: PhotoSwipeOptions, pswp: PhotoSwipeBase) => Point} [getViewportSizeFn]
 * A function that should return slide viewport width and height, in format {x: 100, y: 100}.
 *
 * @prop {string} errorMsg
 * Message to display when the image wasn't able to load. If you need to display HTML - use contentErrorElement filter.
 *
 * @prop {[number, number]} preload
 * Lazy loading of nearby slides based on direction of movement. Should be an array with two integers,
 * first one - number of items to preload before the current image, second one - after the current image.
 * Two nearby images are always loaded.
 *
 * @prop {string} [mainClass]
 * Class that will be added to the root element of PhotoSwipe, may contain multiple separated by space.
 * Example on Styling page.
 *
 * @prop {HTMLElement} [appendToEl]
 * Element to which PhotoSwipe dialog will be appended when it opens.
 *
 * @prop {number} maxWidthToAnimate
 * Maximum width of image to animate, if initial rendered image width
 * is larger than this value - the opening/closing transition will be automatically disabled.
 *
 * @prop {string} [closeTitle]
 * Translating
 *
 * @prop {string} [zoomTitle]
 * Translating
 *
 * @prop {string} [arrowPrevTitle]
 * Translating
 *
 * @prop {string} [arrowNextTitle]
 * Translating
 *
 * @prop {'zoom' | 'fade' | 'none'} [showHideAnimationType]
 * To adjust opening or closing transition type use lightbox option `showHideAnimationType` (`String`).
 * It supports three values - `zoom` (default), `fade` (default if there is no thumbnail) and `none`.
 *
 * Animations are automatically disabled if user `(prefers-reduced-motion: reduce)`.
 *
 * @prop {number} index
 * Defines start slide index.
 *
 * @prop {(e: MouseEvent) => number} [getClickedIndexFn]
 *
 * @prop {boolean} [arrowPrev]
 * @prop {boolean} [arrowNext]
 * @prop {boolean} [zoom]
 * @prop {boolean} [close]
 * @prop {boolean} [counter]
 *
 * @prop {string} [arrowPrevSVG]
 * @prop {string} [arrowNextSVG]
 * @prop {string} [zoomSVG]
 * @prop {string} [closeSVG]
 * @prop {string} [counterSVG]
 *
 * @prop {string} [arrowPrevTitle]
 * @prop {string} [arrowNextTitle]
 * @prop {string} [zoomTitle]
 * @prop {string} [closeTitle]
 * @prop {string} [counterTitle]
 *
 * @prop {ZoomLevelOption} [initialZoomLevel]
 * @prop {ZoomLevelOption} [secondaryZoomLevel]
 * @prop {ZoomLevelOption} [maxZoomLevel]
 *
 * @prop {boolean} [mouseMovePan]
 * @prop {Point | null} [initialPointerPos]
 * @prop {boolean} [showHideOpacity]
 *
 * @prop {PhotoSwipeModuleOption} [pswpModule]
 * @prop {() => Promise<any>} [openPromise]
 * @prop {boolean} [preloadFirstSlide]
 * @prop {ElementProvider} [gallery]
 * @prop {string} [gallerySelector]
 * @prop {ElementProvider} [children]
 * @prop {string} [childSelector]
 * @prop {string | false} [thumbSelector]
 */ /** @type {PreparedPhotoSwipeOptions} */ var $f38b189616c72948$var$defaultOptions = {
    allowPanToNext: true,
    spacing: 0.1,
    loop: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
    hideAnimationDuration: 333,
    showAnimationDuration: 333,
    zoomAnimationDuration: 333,
    escKey: true,
    arrowKeys: true,
    trapFocus: true,
    returnFocus: true,
    maxWidthToAnimate: 4000,
    clickToCloseNonZoomable: true,
    imageClickAction: 'zoom-or-close',
    bgClickAction: 'close',
    tapAction: 'toggle-controls',
    doubleTapAction: 'zoom',
    indexIndicatorSep: ' / ',
    preloaderDelay: 2000,
    bgOpacity: 0.8,
    index: 0,
    errorMsg: 'The image cannot be loaded',
    preload: [
        1,
        2
    ],
    easing: 'cubic-bezier(.4,0,.22,1)'
};
/**
 * PhotoSwipe Core
 */ var $f38b189616c72948$export$2e2bcd8739ae039 = /*#__PURE__*/ function(PhotoSwipeBase) {
    "use strict";
    (0, $l3RwB._)(PhotoSwipe, PhotoSwipeBase);
    function PhotoSwipe(options) {
        (0, $dXdNl._)(this, PhotoSwipe);
        var _this;
        _this = (0, $lPOtB._)(this, PhotoSwipe);
        _this.options = _this._prepareOptions(options || {});
        /**
     * offset of viewport relative to document
     *
     * @type {Point}
     */ _this.offset = {
            x: 0,
            y: 0
        };
        /**
     * @type {Point}
     * @private
     */ _this._prevViewportSize = {
            x: 0,
            y: 0
        };
        /**
     * Size of scrollable PhotoSwipe viewport
     *
     * @type {Point}
     */ _this.viewportSize = {
            x: 0,
            y: 0
        };
        /**
     * background (backdrop) opacity
     */ _this.bgOpacity = 1;
        _this.currIndex = 0;
        _this.potentialIndex = 0;
        _this.isOpen = false;
        _this.isDestroying = false;
        _this.hasMouse = false;
        /**
     * @private
     * @type {SlideData}
     */ _this._initialItemData = {};
        /** @type {Bounds | undefined} */ _this._initialThumbBounds = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.topBar = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.element = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.template = undefined;
        /** @type {HTMLDivElement | undefined} */ _this.container = undefined;
        /** @type {HTMLElement | undefined} */ _this.scrollWrap = undefined;
        /** @type {Slide | undefined} */ _this.currSlide = undefined;
        _this.events = new $f38b189616c72948$var$DOMEvents();
        _this.animations = new $f38b189616c72948$var$Animations();
        _this.mainScroll = new $f38b189616c72948$var$MainScroll(_this);
        _this.gestures = new $f38b189616c72948$var$Gestures(_this);
        _this.opener = new $f38b189616c72948$var$Opener(_this);
        _this.keyboard = new $f38b189616c72948$var$Keyboard(_this);
        _this.contentLoader = new $f38b189616c72948$var$ContentLoader(_this);
        return _this;
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PhotoSwipe, [
        {
            /** @returns {boolean} */ key: "init",
            value: function init() {
                var _this = this;
                if (this.isOpen || this.isDestroying) return false;
                this.isOpen = true;
                this.dispatch('init'); // legacy
                this.dispatch('beforeOpen');
                this._createMainStructure(); // add classes to the root element of PhotoSwipe
                var rootClasses = 'pswp--open';
                if (this.gestures.supportsTouch) rootClasses += ' pswp--touch';
                if (this.options.mainClass) rootClasses += ' ' + this.options.mainClass;
                if (this.element) this.element.className += ' ' + rootClasses;
                this.currIndex = this.options.index || 0;
                this.potentialIndex = this.currIndex;
                this.dispatch('firstUpdate'); // starting index can be modified here
                // initialize scroll wheel handler to block the scroll
                this.scrollWheel = new $f38b189616c72948$var$ScrollWheel(this); // sanitize index
                if (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) this.currIndex = 0;
                if (!this.gestures.supportsTouch) // enable mouse features if no touch support detected
                this.mouseDetected();
                 // causes forced synchronous layout
                this.updateSize();
                this.offset.y = window.pageYOffset;
                this._initialItemData = this.getItemData(this.currIndex);
                this.dispatch('gettingData', {
                    index: this.currIndex,
                    data: this._initialItemData,
                    slide: undefined
                }); // *Layout* - calculate size and position of elements here
                this._initialThumbBounds = this.getThumbBounds();
                this.dispatch('initialLayout');
                this.on('openingAnimationEnd', function() {
                    var itemHolders = _this.mainScroll.itemHolders; // Add content to the previous and next slide
                    if (itemHolders[0]) {
                        itemHolders[0].el.style.display = 'block';
                        _this.setContent(itemHolders[0], _this.currIndex - 1);
                    }
                    if (itemHolders[2]) {
                        itemHolders[2].el.style.display = 'block';
                        _this.setContent(itemHolders[2], _this.currIndex + 1);
                    }
                    _this.appendHeavy();
                    _this.contentLoader.updateLazy();
                    _this.events.add(window, 'resize', _this._handlePageResize.bind(_this));
                    _this.events.add(window, 'scroll', _this._updatePageScrollOffset.bind(_this));
                    _this.dispatch('bindEvents');
                }); // set content for center slide (first time)
                if (this.mainScroll.itemHolders[1]) this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
                this.dispatch('change');
                this.opener.open();
                this.dispatch('afterInit');
                return true;
            }
        },
        {
            /**
   * Get looped slide index
   * (for example, -1 will return the last slide)
   *
   * @param {number} index
   * @returns {number}
   */ key: "getLoopedIndex",
            value: function getLoopedIndex(index) {
                var numSlides = this.getNumItems();
                if (this.options.loop) {
                    if (index > numSlides - 1) index -= numSlides;
                    if (index < 0) index += numSlides;
                }
                return $f38b189616c72948$var$clamp(index, 0, numSlides - 1);
            }
        },
        {
            key: "appendHeavy",
            value: function appendHeavy() {
                this.mainScroll.itemHolders.forEach(function(itemHolder) {
                    var _itemHolder$slide;
                    (_itemHolder$slide = itemHolder.slide) === null || _itemHolder$slide === void 0 || _itemHolder$slide.appendHeavy();
                });
            }
        },
        {
            /**
   * Change the slide
   * @param {number} index New index
   */ key: "goTo",
            value: function goTo(index) {
                this.mainScroll.moveIndexBy(this.getLoopedIndex(index) - this.potentialIndex);
            }
        },
        {
            /**
   * Go to the next slide.
   */ key: "next",
            value: function next() {
                this.goTo(this.potentialIndex + 1);
            }
        },
        {
            /**
   * Go to the previous slide.
   */ key: "prev",
            value: function prev() {
                this.goTo(this.potentialIndex - 1);
            }
        },
        {
            /**
   * @see slide/slide.js zoomTo
   *
   * @param {Parameters<Slide['zoomTo']>} args
   */ key: "zoomTo",
            value: function zoomTo() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this$currSlide;
                var _this$currSlide1;
                (_this$currSlide1 = this.currSlide) === null || _this$currSlide1 === void 0 || (_this$currSlide = _this$currSlide1).zoomTo.apply(_this$currSlide, (0, $cfh0a._)(args));
            }
        },
        {
            /**
   * @see slide/slide.js toggleZoom
   */ key: "toggleZoom",
            value: function toggleZoom() {
                var _this$currSlide2;
                (_this$currSlide2 = this.currSlide) === null || _this$currSlide2 === void 0 || _this$currSlide2.toggleZoom();
            }
        },
        {
            /**
   * Close the gallery.
   * After closing transition ends - destroy it
   */ key: "close",
            value: function close() {
                if (!this.opener.isOpen || this.isDestroying) return;
                this.isDestroying = true;
                this.dispatch('close');
                this.events.removeAll();
                this.opener.close();
            }
        },
        {
            /**
   * Destroys the gallery:
   * - instantly closes the gallery
   * - unbinds events,
   * - cleans intervals and timeouts
   * - removes elements from DOM
   */ key: "destroy",
            value: function destroy() {
                var _this$element;
                if (!this.isDestroying) {
                    this.options.showHideAnimationType = 'none';
                    this.close();
                    return;
                }
                this.dispatch('destroy');
                this._listeners = {};
                if (this.scrollWrap) {
                    this.scrollWrap.ontouchmove = null;
                    this.scrollWrap.ontouchend = null;
                }
                (_this$element = this.element) === null || _this$element === void 0 || _this$element.remove();
                this.mainScroll.itemHolders.forEach(function(itemHolder) {
                    var _itemHolder$slide2;
                    (_itemHolder$slide2 = itemHolder.slide) === null || _itemHolder$slide2 === void 0 || _itemHolder$slide2.destroy();
                });
                this.contentLoader.destroy();
                this.events.removeAll();
            }
        },
        {
            /**
   * Refresh/reload content of a slide by its index
   *
   * @param {number} slideIndex
   */ key: "refreshSlideContent",
            value: function refreshSlideContent(slideIndex) {
                var _this = this;
                this.contentLoader.removeByIndex(slideIndex);
                this.mainScroll.itemHolders.forEach(function(itemHolder, i) {
                    var _this$currSlide$index, _this$currSlide3;
                    var potentialHolderIndex = ((_this$currSlide$index = (_this$currSlide3 = _this.currSlide) === null || _this$currSlide3 === void 0 ? void 0 : _this$currSlide3.index) !== null && _this$currSlide$index !== void 0 ? _this$currSlide$index : 0) - 1 + i;
                    if (_this.canLoop()) potentialHolderIndex = _this.getLoopedIndex(potentialHolderIndex);
                    if (potentialHolderIndex === slideIndex) {
                        // set the new slide content
                        _this.setContent(itemHolder, slideIndex, true); // activate the new slide if it's current
                        if (i === 1) {
                            var _itemHolder$slide3;
                            _this.currSlide = itemHolder.slide;
                            (_itemHolder$slide3 = itemHolder.slide) === null || _itemHolder$slide3 === void 0 || _itemHolder$slide3.setIsActive(true);
                        }
                    }
                });
                this.dispatch('change');
            }
        },
        {
            /**
   * Set slide content
   *
   * @param {ItemHolder} holder mainScroll.itemHolders array item
   * @param {number} index Slide index
   * @param {boolean} [force] If content should be set even if index wasn't changed
   */ key: "setContent",
            value: function setContent(holder, index, force) {
                if (this.canLoop()) index = this.getLoopedIndex(index);
                if (holder.slide) {
                    if (holder.slide.index === index && !force) // exit if holder already contains this slide
                    // this could be common when just three slides are used
                    return;
                     // destroy previous slide
                    holder.slide.destroy();
                    holder.slide = undefined;
                } // exit if no loop and index is out of bounds
                if (!this.canLoop() && (index < 0 || index >= this.getNumItems())) return;
                var itemData = this.getItemData(index);
                holder.slide = new $f38b189616c72948$var$Slide(itemData, index, this); // set current slide
                if (index === this.currIndex) this.currSlide = holder.slide;
                holder.slide.append(holder.el);
            }
        },
        {
            /** @returns {Point} */ key: "getViewportCenterPoint",
            value: function getViewportCenterPoint() {
                return {
                    x: this.viewportSize.x / 2,
                    y: this.viewportSize.y / 2
                };
            }
        },
        {
            /**
   * Update size of all elements.
   * Executed on init and on page resize.
   *
   * @param {boolean} [force] Update size even if size of viewport was not changed.
   */ key: "updateSize",
            value: function updateSize(force) {
                // let item;
                // let itemIndex;
                if (this.isDestroying) // exit if PhotoSwipe is closed or closing
                // (to avoid errors, as resize event might be delayed)
                return;
                 //const newWidth = this.scrollWrap.clientWidth;
                //const newHeight = this.scrollWrap.clientHeight;
                var newViewportSize = $f38b189616c72948$var$getViewportSize(this.options, this);
                if (!force && $f38b189616c72948$var$pointsEqual(newViewportSize, this._prevViewportSize)) // Exit if dimensions were not changed
                return;
                 //this._prevViewportSize.x = newWidth;
                //this._prevViewportSize.y = newHeight;
                $f38b189616c72948$var$equalizePoints(this._prevViewportSize, newViewportSize);
                this.dispatch('beforeResize');
                $f38b189616c72948$var$equalizePoints(this.viewportSize, this._prevViewportSize);
                this._updatePageScrollOffset();
                this.dispatch('viewportSize'); // Resize slides only after opener animation is finished
                // and don't re-calculate size on inital size update
                this.mainScroll.resize(this.opener.isOpen);
                if (!this.hasMouse && window.matchMedia('(any-hover: hover)').matches) this.mouseDetected();
                this.dispatch('resize');
            }
        },
        {
            /**
   * @param {number} opacity
   */ key: "applyBgOpacity",
            value: function applyBgOpacity(opacity) {
                this.bgOpacity = Math.max(opacity, 0);
                if (this.bg) this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity);
            }
        },
        {
            /**
   * Whether mouse is detected
   */ key: "mouseDetected",
            value: function mouseDetected() {
                if (!this.hasMouse) {
                    var _this$element2;
                    this.hasMouse = true;
                    (_this$element2 = this.element) === null || _this$element2 === void 0 || _this$element2.classList.add('pswp--has_mouse');
                }
            }
        },
        {
            /**
   * Page resize event handler
   *
   * @private
   */ key: "_handlePageResize",
            value: function _handlePageResize() {
                var _this = this;
                this.updateSize(); // In iOS webview, if element size depends on document size,
                // it'll be measured incorrectly in resize event
                //
                // https://bugs.webkit.org/show_bug.cgi?id=170595
                // https://hackernoon.com/onresize-event-broken-in-mobile-safari-d8469027bf4d
                if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) setTimeout(function() {
                    _this.updateSize();
                }, 500);
            }
        },
        {
            /**
   * Page scroll offset is used
   * to get correct coordinates
   * relative to PhotoSwipe viewport.
   *
   * @private
   */ key: "_updatePageScrollOffset",
            value: function _updatePageScrollOffset() {
                this.setScrollOffset(0, window.pageYOffset);
            }
        },
        {
            /**
   * @param {number} x
   * @param {number} y
   */ key: "setScrollOffset",
            value: function setScrollOffset(x, y) {
                this.offset.x = x;
                this.offset.y = y;
                this.dispatch('updateScrollOffset');
            }
        },
        {
            /**
   * Create main HTML structure of PhotoSwipe,
   * and add it to DOM
   *
   * @private
   */ key: "_createMainStructure",
            value: function _createMainStructure() {
                // root DOM element of PhotoSwipe (.pswp)
                this.element = $f38b189616c72948$var$createElement('pswp', 'div');
                this.element.setAttribute('tabindex', '-1');
                this.element.setAttribute('role', 'dialog'); // template is legacy prop
                this.template = this.element; // Background is added as a separate element,
                // as animating opacity is faster than animating rgba()
                this.bg = $f38b189616c72948$var$createElement('pswp__bg', 'div', this.element);
                this.scrollWrap = $f38b189616c72948$var$createElement('pswp__scroll-wrap', 'section', this.element);
                this.container = $f38b189616c72948$var$createElement('pswp__container', 'div', this.scrollWrap); // aria pattern: carousel
                this.scrollWrap.setAttribute('aria-roledescription', 'carousel');
                this.container.setAttribute('aria-live', 'off');
                this.container.setAttribute('id', 'pswp__items');
                this.mainScroll.appendHolders();
                this.ui = new $f38b189616c72948$var$UI(this);
                this.ui.init(); // append to DOM
                (this.options.appendToEl || document.body).appendChild(this.element);
            }
        },
        {
            /**
   * Get position and dimensions of small thumbnail
   *   {x:,y:,w:}
   *
   * Height is optional (calculated based on the large image)
   *
   * @returns {Bounds | undefined}
   */ key: "getThumbBounds",
            value: function getThumbBounds1() {
                return $f38b189616c72948$var$getThumbBounds(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this);
            }
        },
        {
            /**
   * If the PhotoSwipe can have continuous loop
   * @returns Boolean
   */ key: "canLoop",
            value: function canLoop() {
                return this.options.loop && this.getNumItems() > 2;
            }
        },
        {
            /**
   * @private
   * @param {PhotoSwipeOptions} options
   * @returns {PreparedPhotoSwipeOptions}
   */ key: "_prepareOptions",
            value: function _prepareOptions(options) {
                if (window.matchMedia('(prefers-reduced-motion), (update: slow)').matches) {
                    options.showHideAnimationType = 'none';
                    options.zoomAnimationDuration = 0;
                }
                /** @type {PreparedPhotoSwipeOptions} */ return (0, $a9846c98c872cb75$export$71511d61b312f219)({}, $f38b189616c72948$var$defaultOptions, options);
            }
        }
    ]);
    return PhotoSwipe;
}($f38b189616c72948$var$PhotoSwipeBase);


/**
 * PhotoSwipe Dynamic Caption plugin v1.2.7
 * https://github.com/dimsemenov/photoswipe-dynamic-caption-plugin
 * 
 * By https://dimsemenov.com
 */ 
var $dXdNl = parcelRequire("dXdNl");


var $cbc1a6e6e1eedade$var$defaultOptions = {
    captionContent: '.pswp-caption-content',
    type: 'auto',
    horizontalEdgeThreshold: 20,
    mobileCaptionOverlapRatio: 0.3,
    mobileLayoutBreakpoint: 600,
    verticallyCenterImage: false
};
var $cbc1a6e6e1eedade$var$PhotoSwipeDynamicCaption = /*#__PURE__*/ function() {
    "use strict";
    function PhotoSwipeDynamicCaption(lightbox, options) {
        var _this = this;
        (0, $dXdNl._)(this, PhotoSwipeDynamicCaption);
        this.options = (0, $a9846c98c872cb75$export$71511d61b312f219)({}, $cbc1a6e6e1eedade$var$defaultOptions, options);
        this.lightbox = lightbox;
        this.lightbox.on('init', function() {
            _this.pswp = _this.lightbox.pswp;
            _this.initCaption();
        });
    }
    (0, $4015c67c6c377176$export$71511d61b312f219)(PhotoSwipeDynamicCaption, [
        {
            key: "initCaption",
            value: function initCaption() {
                var _this = this;
                var pswp = this.pswp;
                pswp.on('change', function() {
                    // make sure caption is displayed after slides are switched
                    _this.showCaption(_this.pswp.currSlide);
                });
                pswp.on('calcSlideSize', function(e) {
                    return _this.onCalcSlideSize(e);
                });
                pswp.on('slideDestroy', function(e) {
                    if (e.slide.dynamicCaption) {
                        if (e.slide.dynamicCaption.element) e.slide.dynamicCaption.element.remove();
                        delete e.slide.dynamicCaption;
                    }
                });
                // hide caption if zoomed
                pswp.on('zoomPanUpdate', function(param) {
                    var slide = param.slide;
                    if (pswp.opener.isOpen && slide.dynamicCaption) {
                        if (slide.currZoomLevel > slide.zoomLevels.initial) _this.hideCaption(slide);
                        else _this.showCaption(slide);
                        // move caption on vertical drag
                        if (slide.dynamicCaption.element) {
                            var captionYOffset = 0;
                            if (slide.currZoomLevel <= slide.zoomLevels.initial) {
                                var shiftedAmount = slide.pan.y - slide.bounds.center.y;
                                if (Math.abs(shiftedAmount) > 1) captionYOffset = shiftedAmount;
                            }
                            _this.setCaptionYOffset(slide.dynamicCaption.element, captionYOffset);
                        }
                        _this.adjustPanArea(slide, slide.currZoomLevel);
                    }
                });
                pswp.on('beforeZoomTo', function(e) {
                    _this.adjustPanArea(pswp.currSlide, e.destZoomLevel);
                });
                // Stop default action of tap when tapping on the caption
                pswp.on('tapAction', function(e) {
                    if (e.originalEvent.target.closest('.pswp__dynamic-caption')) e.preventDefault();
                });
            }
        },
        {
            key: "adjustPanArea",
            value: function adjustPanArea(slide, zoomLevel) {
                if (slide.dynamicCaption && slide.dynamicCaption.adjustedPanAreaSize) {
                    if (zoomLevel > slide.zoomLevels.initial) {
                        slide.panAreaSize.x = slide.dynamicCaption.originalPanAreaSize.x;
                        slide.panAreaSize.y = slide.dynamicCaption.originalPanAreaSize.y;
                    } else {
                        // Restore panAreaSize after we zoom back to initial position
                        slide.panAreaSize.x = slide.dynamicCaption.adjustedPanAreaSize.x;
                        slide.panAreaSize.y = slide.dynamicCaption.adjustedPanAreaSize.y;
                    }
                }
            }
        },
        {
            key: "useMobileLayout",
            value: function useMobileLayout() {
                var mobileLayoutBreakpoint = this.options.mobileLayoutBreakpoint;
                if (typeof mobileLayoutBreakpoint === 'function') return mobileLayoutBreakpoint.call(this);
                else if (typeof mobileLayoutBreakpoint === 'number') {
                    if (window.innerWidth < mobileLayoutBreakpoint) return true;
                }
                return false;
            }
        },
        {
            key: "hideCaption",
            value: function hideCaption(slide) {
                if (slide.dynamicCaption && !slide.dynamicCaption.hidden) {
                    var captionElement = slide.dynamicCaption.element;
                    if (!captionElement) return;
                    slide.dynamicCaption.hidden = true;
                    captionElement.classList.add('pswp__dynamic-caption--faded');
                    // Disable caption visibility with the delay, so it's not interactable 
                    if (slide.captionFadeTimeout) clearTimeout(slide.captionFadeTimeout);
                    slide.captionFadeTimeout = setTimeout(function() {
                        captionElement.style.visibility = 'hidden';
                        delete slide.captionFadeTimeout;
                    }, 400);
                }
            }
        },
        {
            key: "setCaptionYOffset",
            value: function setCaptionYOffset(el, y) {
                el.style.transform = "translateY(".concat(y, "px)");
            }
        },
        {
            key: "showCaption",
            value: function showCaption(slide) {
                if (slide.dynamicCaption && slide.dynamicCaption.hidden) {
                    var captionElement = slide.dynamicCaption.element;
                    if (!captionElement) return;
                    slide.dynamicCaption.hidden = false;
                    captionElement.style.visibility = 'visible';
                    clearTimeout(slide.captionFadeTimeout);
                    slide.captionFadeTimeout = setTimeout(function() {
                        captionElement.classList.remove('pswp__dynamic-caption--faded');
                        delete slide.captionFadeTimeout;
                    }, 50);
                }
            }
        },
        {
            key: "setCaptionPosition",
            value: function setCaptionPosition(captionEl, x, y) {
                var isOnHorizontalEdge = x <= this.options.horizontalEdgeThreshold;
                captionEl.classList[isOnHorizontalEdge ? 'add' : 'remove']('pswp__dynamic-caption--on-hor-edge');
                captionEl.style.left = x + 'px';
                captionEl.style.top = y + 'px';
            }
        },
        {
            key: "setCaptionWidth",
            value: function setCaptionWidth(captionEl, width) {
                if (!width) captionEl.style.removeProperty('width');
                else captionEl.style.width = width + 'px';
            }
        },
        {
            key: "setCaptionType",
            value: function setCaptionType(captionEl, type) {
                var prevType = captionEl.dataset.pswpCaptionType;
                if (type !== prevType) {
                    captionEl.classList.add('pswp__dynamic-caption--' + type);
                    captionEl.classList.remove('pswp__dynamic-caption--' + prevType);
                    captionEl.dataset.pswpCaptionType = type;
                }
            }
        },
        {
            key: "updateCaptionPosition",
            value: function updateCaptionPosition(slide) {
                if (!slide.dynamicCaption || !slide.dynamicCaption.type || !slide.dynamicCaption.element) return;
                if (slide.dynamicCaption.type === 'mobile') {
                    this.setCaptionType(slide.dynamicCaption.element, slide.dynamicCaption.type);
                    slide.dynamicCaption.element.style.removeProperty('left');
                    slide.dynamicCaption.element.style.removeProperty('top');
                    this.setCaptionWidth(slide.dynamicCaption.element, false);
                    return;
                }
                var zoomLevel = slide.zoomLevels.initial;
                var imageWidth = Math.ceil(slide.width * zoomLevel);
                var imageHeight = Math.ceil(slide.height * zoomLevel);
                this.setCaptionType(slide.dynamicCaption.element, slide.dynamicCaption.type);
                if (slide.dynamicCaption.type === 'aside') {
                    this.setCaptionPosition(slide.dynamicCaption.element, slide.bounds.center.x + imageWidth, slide.bounds.center.y);
                    this.setCaptionWidth(slide.dynamicCaption.element, false);
                } else if (slide.dynamicCaption.type === 'below') {
                    this.setCaptionPosition(slide.dynamicCaption.element, slide.bounds.center.x, slide.bounds.center.y + imageHeight);
                    this.setCaptionWidth(slide.dynamicCaption.element, imageWidth);
                }
            }
        },
        {
            key: "onCalcSlideSize",
            value: function onCalcSlideSize(e) {
                var slide = e.slide;
                var captionSize;
                var useMobileVersion;
                if (!slide.dynamicCaption) {
                    slide.dynamicCaption = {
                        element: undefined,
                        type: false,
                        hidden: false
                    };
                    var captionHTML = this.getCaptionHTML(slide);
                    if (!captionHTML) return;
                    slide.dynamicCaption.element = document.createElement('div');
                    slide.dynamicCaption.element.className = 'pswp__dynamic-caption pswp__hide-on-close';
                    slide.dynamicCaption.element.innerHTML = captionHTML;
                    this.pswp.dispatch('dynamicCaptionUpdateHTML', {
                        captionElement: slide.dynamicCaption.element,
                        slide: slide
                    });
                    slide.holderElement.appendChild(slide.dynamicCaption.element);
                }
                if (!slide.dynamicCaption.element) return;
                this.storeOriginalPanAreaSize(slide);
                slide.bounds.update(slide.zoomLevels.initial);
                if (this.useMobileLayout()) {
                    slide.dynamicCaption.type = 'mobile';
                    useMobileVersion = true;
                } else if (this.options.type === 'auto') {
                    if (slide.bounds.center.x > slide.bounds.center.y) slide.dynamicCaption.type = 'aside';
                    else slide.dynamicCaption.type = 'below';
                } else slide.dynamicCaption.type = this.options.type;
                var imageWidth = Math.ceil(slide.width * slide.zoomLevels.initial);
                var imageHeight = Math.ceil(slide.height * slide.zoomLevels.initial);
                this.setCaptionType(slide.dynamicCaption.element, slide.dynamicCaption.type);
                if (slide.dynamicCaption.type === 'aside') {
                    this.setCaptionWidth(slide.dynamicCaption.element, false);
                    captionSize = this.measureCaptionSize(slide.dynamicCaption.element, e.slide);
                    var captionWidth = captionSize.x;
                    var horizontalEnding = imageWidth + slide.bounds.center.x;
                    var horizontalLeftover = slide.panAreaSize.x - horizontalEnding;
                    if (horizontalLeftover <= captionWidth) {
                        slide.panAreaSize.x -= captionWidth;
                        this.recalculateZoomLevelAndBounds(slide);
                    }
                } else if (slide.dynamicCaption.type === 'below' || useMobileVersion) {
                    this.setCaptionWidth(slide.dynamicCaption.element, useMobileVersion ? this.pswp.viewportSize.x : imageWidth);
                    captionSize = this.measureCaptionSize(slide.dynamicCaption.element, e.slide);
                    var captionHeight = captionSize.y;
                    if (this.options.verticallyCenterImage) {
                        slide.panAreaSize.y -= captionHeight;
                        this.recalculateZoomLevelAndBounds(slide);
                    } else {
                        // Lift up the image only by caption height
                        // vertical ending of the image
                        var verticalEnding = imageHeight + slide.bounds.center.y;
                        // height between bottom of the screen and ending of the image
                        // (before any adjustments applied) 
                        var verticalLeftover = slide.panAreaSize.y - verticalEnding;
                        var initialPanAreaHeight = slide.panAreaSize.y;
                        if (verticalLeftover <= captionHeight) {
                            // lift up the image to give more space for caption
                            slide.panAreaSize.y -= Math.min((captionHeight - verticalLeftover) * 2, captionHeight);
                            // we reduce viewport size, thus we need to update zoom level and pan bounds
                            this.recalculateZoomLevelAndBounds(slide);
                            var maxPositionX = slide.panAreaSize.x * this.options.mobileCaptionOverlapRatio / 2;
                            // Do not reduce viewport height if too few space available
                            if (useMobileVersion && slide.bounds.center.x > maxPositionX) {
                                // Restore the default position
                                slide.panAreaSize.y = initialPanAreaHeight;
                                this.recalculateZoomLevelAndBounds(slide);
                            }
                        }
                    }
                }
                this.storeAdjustedPanAreaSize(slide);
                this.updateCaptionPosition(slide);
            }
        },
        {
            key: "measureCaptionSize",
            value: function measureCaptionSize(captionEl, slide) {
                var rect = captionEl.getBoundingClientRect();
                var event = this.pswp.dispatch('dynamicCaptionMeasureSize', {
                    captionEl: captionEl,
                    slide: slide,
                    captionSize: {
                        x: rect.width,
                        y: rect.height
                    }
                });
                return event.captionSize;
            }
        },
        {
            key: "recalculateZoomLevelAndBounds",
            value: function recalculateZoomLevelAndBounds(slide) {
                slide.zoomLevels.update(slide.width, slide.height, slide.panAreaSize);
                slide.bounds.update(slide.zoomLevels.initial);
            }
        },
        {
            key: "storeAdjustedPanAreaSize",
            value: function storeAdjustedPanAreaSize(slide) {
                if (slide.dynamicCaption) {
                    if (!slide.dynamicCaption.adjustedPanAreaSize) slide.dynamicCaption.adjustedPanAreaSize = {};
                    slide.dynamicCaption.adjustedPanAreaSize.x = slide.panAreaSize.x;
                    slide.dynamicCaption.adjustedPanAreaSize.y = slide.panAreaSize.y;
                }
            }
        },
        {
            key: "storeOriginalPanAreaSize",
            value: function storeOriginalPanAreaSize(slide) {
                if (slide.dynamicCaption) {
                    if (!slide.dynamicCaption.originalPanAreaSize) slide.dynamicCaption.originalPanAreaSize = {};
                    slide.dynamicCaption.originalPanAreaSize.x = slide.panAreaSize.x;
                    slide.dynamicCaption.originalPanAreaSize.y = slide.panAreaSize.y;
                }
            }
        },
        {
            key: "getCaptionHTML",
            value: function getCaptionHTML(slide) {
                if (typeof this.options.captionContent === 'function') return this.options.captionContent.call(this, slide);
                var currSlideElement = slide.data.element;
                var captionHTML = '';
                if (currSlideElement) {
                    var hiddenCaption = currSlideElement.querySelector(this.options.captionContent);
                    if (hiddenCaption) // get caption from element with class pswp-caption-content
                    captionHTML = hiddenCaption.innerHTML;
                    else {
                        var img = currSlideElement.querySelector('img');
                        if (img) // get caption from alt attribute
                        captionHTML = img.getAttribute('alt');
                    }
                }
                return captionHTML;
            }
        }
    ]);
    return PhotoSwipeDynamicCaption;
}();
var $cbc1a6e6e1eedade$export$2e2bcd8739ae039 = $cbc1a6e6e1eedade$var$PhotoSwipeDynamicCaption;


var $2e218e1f75469fbf$exports = {};
/**
 * Cookies EU banner v2.0.1 - Manage display of banner to accept/reject cookies from tracking services like Google Analytics
 * ------------------------
 * @link http://alex-d.github.io/Cookies-EU-banner/
 * @license MIT
 * @author Alex-D
 *         Twitter : @AlexandreDemode
 *         Website : alex-d.fr
 */ (function(root, factory, undefined1) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([], factory);
    else $2e218e1f75469fbf$exports = factory();
})(window, function() {
    'use strict';
    var CookiesEuBanner, document = window.document;
    CookiesEuBanner = function(launchFunction, waitAccept, useLocalStorage, undefined1) {
        if (!(this instanceof CookiesEuBanner)) return new CookiesEuBanner(launchFunction);
        this.cookieTimeout = 33696000000; // 13 months in milliseconds
        this.bots = /bot|crawler|spider|crawling/i;
        this.cookieName = 'hasConsent';
        this.trackingCookiesNames = [
            '__utma',
            '__utmb',
            '__utmc',
            '__utmt',
            '__utmv',
            '__utmz',
            '_ga',
            '_gat',
            '_gid'
        ];
        this.launchFunction = launchFunction;
        this.waitAccept = waitAccept || false;
        this.useLocalStorage = useLocalStorage || false;
        this.init();
    };
    CookiesEuBanner.prototype = {
        init: function init() {
            // Detect if the visitor is a bot or not
            // Prevent for search engine take the cookie alert message as main content of the page
            var isBot = this.bots.test(navigator.userAgent);
            // Check if DoNotTrack is activated
            var dnt = navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack;
            var isToTrack = dnt !== null && dnt !== undefined ? dnt && dnt !== 'yes' && dnt !== 1 && dnt !== '1' : true;
            // Do nothing if it is a bot
            // If DoNotTrack is activated, do nothing too
            if (isBot || !isToTrack || this.hasConsent() === false) {
                this.removeBanner(0);
                return false;
            }
            // User has already consent to use cookies to tracking
            if (this.hasConsent() === true) {
                // Launch user custom function
                this.launchFunction();
                return true;
            }
            // If it's not a bot, no DoNotTrack and not already accept, so show banner
            this.showBanner();
            if (!this.waitAccept) // Accept cookies by default for the next page
            this.setConsent(true);
        },
        /*
     * Show banner at the top of the page
     */ showBanner: function showBanner() {
            var _this = this, getElementById = document.getElementById.bind(document), banner = getElementById('cookies-eu-banner'), rejectButton = getElementById('cookies-eu-reject'), acceptButton = getElementById('cookies-eu-accept'), moreLink = getElementById('cookies-eu-more'), waitRemove = banner.dataset.waitRemove === undefined ? 0 : parseInt(banner.dataset.waitRemove), // Variables for minification optimization
            addClickListener = this.addClickListener, removeBanner = _this.removeBanner.bind(_this, waitRemove);
            banner.style.display = 'block';
            if (moreLink) addClickListener(moreLink, function() {
                _this.deleteCookie(_this.cookieName);
            });
            if (acceptButton) addClickListener(acceptButton, function() {
                removeBanner();
                _this.setConsent(true);
                _this.launchFunction();
            });
            if (rejectButton) addClickListener(rejectButton, function() {
                removeBanner();
                _this.setConsent(false);
                // Delete existing tracking cookies
                _this.trackingCookiesNames.map(_this.deleteCookie);
            });
        },
        /*
     * Set consent cookie or localStorage
     */ setConsent: function setConsent(consent) {
            if (this.useLocalStorage) return localStorage.setItem(this.cookieName, consent);
            this.setCookie(this.cookieName, consent);
        },
        /*
     * Check if user already consent
     */ hasConsent: function hasConsent() {
            var cookieName = this.cookieName;
            var isCookieSetTo = function isCookieSetTo(value) {
                return document.cookie.indexOf(cookieName + '=' + value) > -1 || localStorage.getItem(cookieName) === value;
            };
            if (isCookieSetTo('true')) return true;
            else if (isCookieSetTo('false')) return false;
            return null;
        },
        /*
     * Create/update cookie
     */ setCookie: function setCookie(name, value) {
            var date = new Date();
            date.setTime(date.getTime() + this.cookieTimeout);
            document.cookie = name + '=' + value + ';expires=' + date.toGMTString() + ';path=/';
        },
        /*
     * Delete cookie by changing expire
     */ deleteCookie: function deleteCookie(name) {
            var hostname = document.location.hostname.replace(/^www\./, ''), commonSuffix = '; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/';
            document.cookie = name + '=; domain=.' + hostname + commonSuffix;
            document.cookie = name + '=' + commonSuffix;
        },
        addClickListener: function addClickListener(DOMElement, callback) {
            if (DOMElement.attachEvent) return DOMElement.attachEvent('onclick', callback);
            // For all major browsers, except IE 8 and earlier
            DOMElement.addEventListener('click', callback);
        },
        /*
     * Delays removal of banner allowing developers
     * to specify their own transition effects
     */ removeBanner: function removeBanner(wait) {
            setTimeout(function() {
                var banner = document.getElementById('cookies-eu-banner');
                if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
            }, wait);
        }
    };
    return CookiesEuBanner;
});


// packages/alpinejs/src/scheduler.js
function $829c750286ec3a2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $829c750286ec3a2c$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $829c750286ec3a2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $829c750286ec3a2c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var $40EBy = parcelRequire("40EBy");
function $ca516d8776d79507$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



var $cfh0a = parcelRequire("cfh0a");

var $j2WbH = parcelRequire("j2WbH");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $j2WbH = parcelRequire("j2WbH");
var $15f39fe0df078b1e$var$extendStatics = function extendStatics1(d, b) {
    $15f39fe0df078b1e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $15f39fe0df078b1e$var$extendStatics(d, b);
};
function $15f39fe0df078b1e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $15f39fe0df078b1e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $15f39fe0df078b1e$export$18ce0697a983be9b = function __assign1() {
    $15f39fe0df078b1e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15f39fe0df078b1e$export$18ce0697a983be9b.apply(this, arguments);
};
function $15f39fe0df078b1e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $15f39fe0df078b1e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $j2WbH._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $15f39fe0df078b1e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $15f39fe0df078b1e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $j2WbH._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $15f39fe0df078b1e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $15f39fe0df078b1e$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $j2WbH._)(x)) === "symbol" ? x : "".concat(x);
}
function $15f39fe0df078b1e$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $j2WbH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $15f39fe0df078b1e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $j2WbH._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $15f39fe0df078b1e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $15f39fe0df078b1e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $15f39fe0df078b1e$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $15f39fe0df078b1e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $15f39fe0df078b1e$export$45d3717a4c69092e(o, m, p);
}
function $15f39fe0df078b1e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $15f39fe0df078b1e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $15f39fe0df078b1e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($15f39fe0df078b1e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $15f39fe0df078b1e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $15f39fe0df078b1e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $15f39fe0df078b1e$export$10c90e4f7922046c(v) {
    return this instanceof $15f39fe0df078b1e$export$10c90e4f7922046c ? (this.v = v, this) : new $15f39fe0df078b1e$export$10c90e4f7922046c(v);
}
function $15f39fe0df078b1e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $15f39fe0df078b1e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $15f39fe0df078b1e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $15f39fe0df078b1e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $15f39fe0df078b1e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $15f39fe0df078b1e$export$19a8beecd37a4c45 === "function" ? $15f39fe0df078b1e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $15f39fe0df078b1e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $15f39fe0df078b1e$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $15f39fe0df078b1e$var$ownKeys = function ownKeys1(o) {
    $15f39fe0df078b1e$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $15f39fe0df078b1e$var$ownKeys(o);
};
function $15f39fe0df078b1e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $15f39fe0df078b1e$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $15f39fe0df078b1e$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $15f39fe0df078b1e$var$__setModuleDefault(result, mod);
    return result;
}
function $15f39fe0df078b1e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $15f39fe0df078b1e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $15f39fe0df078b1e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $15f39fe0df078b1e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $j2WbH._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $15f39fe0df078b1e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $15f39fe0df078b1e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $15f39fe0df078b1e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $15f39fe0df078b1e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $15f39fe0df078b1e$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $15f39fe0df078b1e$export$2e2bcd8739ae039 = {
    __extends: $15f39fe0df078b1e$export$a8ba968b8961cb8a,
    __assign: $15f39fe0df078b1e$export$18ce0697a983be9b,
    __rest: $15f39fe0df078b1e$export$3c9a16f847548506,
    __decorate: $15f39fe0df078b1e$export$29e00dfd3077644b,
    __param: $15f39fe0df078b1e$export$d5ad3fd78186038f,
    __esDecorate: $15f39fe0df078b1e$export$3a84e1ae4e97e9b0,
    __runInitializers: $15f39fe0df078b1e$export$d831c04e792af3d,
    __propKey: $15f39fe0df078b1e$export$6a2a36740a146cb8,
    __setFunctionName: $15f39fe0df078b1e$export$d1a06452d3489bc7,
    __metadata: $15f39fe0df078b1e$export$f1db080c865becb9,
    __awaiter: $15f39fe0df078b1e$export$1050f835b63b671e,
    __generator: $15f39fe0df078b1e$export$67ebef60e6f28a6,
    __createBinding: $15f39fe0df078b1e$export$45d3717a4c69092e,
    __exportStar: $15f39fe0df078b1e$export$f33643c0debef087,
    __values: $15f39fe0df078b1e$export$19a8beecd37a4c45,
    __read: $15f39fe0df078b1e$export$8d051b38c9118094,
    __spread: $15f39fe0df078b1e$export$afc72e2116322959,
    __spreadArrays: $15f39fe0df078b1e$export$6388937ca91ccae8,
    __spreadArray: $15f39fe0df078b1e$export$1216008129fb82ed,
    __await: $15f39fe0df078b1e$export$10c90e4f7922046c,
    __asyncGenerator: $15f39fe0df078b1e$export$e427f37a30a4de9b,
    __asyncDelegator: $15f39fe0df078b1e$export$bbd80228419bb833,
    __asyncValues: $15f39fe0df078b1e$export$e3b29a3d6162315f,
    __makeTemplateObject: $15f39fe0df078b1e$export$4fb47efe1390b86f,
    __importStar: $15f39fe0df078b1e$export$c21735bcef00d192,
    __importDefault: $15f39fe0df078b1e$export$da59b14a69baef04,
    __classPrivateFieldGet: $15f39fe0df078b1e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $15f39fe0df078b1e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $15f39fe0df078b1e$export$81fdc39f203e4e04,
    __addDisposableResource: $15f39fe0df078b1e$export$88ac25d8e944e405,
    __disposeResources: $15f39fe0df078b1e$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $15f39fe0df078b1e$export$889dfb5d17574b0b
};


function $96cefe9acc8d79bc$var$_templateObject() {
    var _$data = (0, $ca516d8776d79507$export$71511d61b312f219)([
        "Cannot find directive `",
        "`. `",
        "` will use the default order of execution"
    ], [
        "Cannot find directive \\`",
        "\\`. \\`",
        "\\` will use the default order of execution"
    ]);
    $96cefe9acc8d79bc$var$_templateObject = function _templateObject() {
        return _$data;
    };
    return _$data;
}
var $96cefe9acc8d79bc$var$flushPending = false;
var $96cefe9acc8d79bc$var$flushing = false;
var $96cefe9acc8d79bc$var$queue = [];
var $96cefe9acc8d79bc$var$lastFlushedIndex = -1;
function $96cefe9acc8d79bc$var$scheduler(callback) {
    $96cefe9acc8d79bc$var$queueJob(callback);
}
function $96cefe9acc8d79bc$var$queueJob(job) {
    if (!$96cefe9acc8d79bc$var$queue.includes(job)) $96cefe9acc8d79bc$var$queue.push(job);
    $96cefe9acc8d79bc$var$queueFlush();
}
function $96cefe9acc8d79bc$var$dequeueJob(job) {
    var index = $96cefe9acc8d79bc$var$queue.indexOf(job);
    if (index !== -1 && index > $96cefe9acc8d79bc$var$lastFlushedIndex) $96cefe9acc8d79bc$var$queue.splice(index, 1);
}
function $96cefe9acc8d79bc$var$queueFlush() {
    if (!$96cefe9acc8d79bc$var$flushing && !$96cefe9acc8d79bc$var$flushPending) {
        $96cefe9acc8d79bc$var$flushPending = true;
        queueMicrotask($96cefe9acc8d79bc$var$flushJobs);
    }
}
function $96cefe9acc8d79bc$var$flushJobs() {
    $96cefe9acc8d79bc$var$flushPending = false;
    $96cefe9acc8d79bc$var$flushing = true;
    for(var i = 0; i < $96cefe9acc8d79bc$var$queue.length; i++){
        $96cefe9acc8d79bc$var$queue[i]();
        $96cefe9acc8d79bc$var$lastFlushedIndex = i;
    }
    $96cefe9acc8d79bc$var$queue.length = 0;
    $96cefe9acc8d79bc$var$lastFlushedIndex = -1;
    $96cefe9acc8d79bc$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $96cefe9acc8d79bc$var$reactive;
var $96cefe9acc8d79bc$var$effect;
var $96cefe9acc8d79bc$var$release;
var $96cefe9acc8d79bc$var$raw;
var $96cefe9acc8d79bc$var$shouldSchedule = true;
function $96cefe9acc8d79bc$var$disableEffectScheduling(callback) {
    $96cefe9acc8d79bc$var$shouldSchedule = false;
    callback();
    $96cefe9acc8d79bc$var$shouldSchedule = true;
}
function $96cefe9acc8d79bc$var$setReactivityEngine(engine) {
    $96cefe9acc8d79bc$var$reactive = engine.reactive;
    $96cefe9acc8d79bc$var$release = engine.release;
    $96cefe9acc8d79bc$var$effect = function(callback) {
        return engine.effect(callback, {
            scheduler: function(task) {
                if ($96cefe9acc8d79bc$var$shouldSchedule) $96cefe9acc8d79bc$var$scheduler(task);
                else task();
            }
        });
    };
    $96cefe9acc8d79bc$var$raw = engine.raw;
}
function $96cefe9acc8d79bc$var$overrideEffect(override) {
    $96cefe9acc8d79bc$var$effect = override;
}
function $96cefe9acc8d79bc$var$elementBoundEffect(el) {
    var cleanup2 = function() {};
    var wrappedEffect = function(callback) {
        var effectReference = $96cefe9acc8d79bc$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = function() {
                el._x_effects.forEach(function(i) {
                    return i();
                });
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = function() {
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $96cefe9acc8d79bc$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        function() {
            cleanup2();
        }
    ];
}
function $96cefe9acc8d79bc$var$watch(getter, callback) {
    var firstTime = true;
    var oldValue;
    var effectReference = $96cefe9acc8d79bc$var$effect(function() {
        var value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(function() {
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return function() {
        return $96cefe9acc8d79bc$var$release(effectReference);
    };
}
// packages/alpinejs/src/mutation.js
var $96cefe9acc8d79bc$var$onAttributeAddeds = [];
var $96cefe9acc8d79bc$var$onElRemoveds = [];
var $96cefe9acc8d79bc$var$onElAddeds = [];
function $96cefe9acc8d79bc$var$onElAdded(callback) {
    $96cefe9acc8d79bc$var$onElAddeds.push(callback);
}
function $96cefe9acc8d79bc$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $96cefe9acc8d79bc$var$onElRemoveds.push(callback);
    }
}
function $96cefe9acc8d79bc$var$onAttributesAdded(callback) {
    $96cefe9acc8d79bc$var$onAttributeAddeds.push(callback);
}
function $96cefe9acc8d79bc$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $96cefe9acc8d79bc$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(function(param) {
        var _param = (0, $40EBy._)(param, 2), name = _param[0], value = _param[1];
        if (names === void 0 || names.includes(name)) {
            value.forEach(function(i) {
                return i();
            });
            delete el._x_attributeCleanups[name];
        }
    });
}
function $96cefe9acc8d79bc$var$cleanupElement(el) {
    var _el__x_effects, _el__x_cleanups;
    (_el__x_effects = el._x_effects) === null || _el__x_effects === void 0 ? void 0 : _el__x_effects.forEach($96cefe9acc8d79bc$var$dequeueJob);
    while((_el__x_cleanups = el._x_cleanups) === null || _el__x_cleanups === void 0 ? void 0 : _el__x_cleanups.length)el._x_cleanups.pop()();
}
var $96cefe9acc8d79bc$var$observer = new MutationObserver($96cefe9acc8d79bc$var$onMutate);
var $96cefe9acc8d79bc$var$currentlyObserving = false;
function $96cefe9acc8d79bc$var$startObservingMutations() {
    $96cefe9acc8d79bc$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $96cefe9acc8d79bc$var$currentlyObserving = true;
}
function $96cefe9acc8d79bc$var$stopObservingMutations() {
    $96cefe9acc8d79bc$var$flushObserver();
    $96cefe9acc8d79bc$var$observer.disconnect();
    $96cefe9acc8d79bc$var$currentlyObserving = false;
}
var $96cefe9acc8d79bc$var$queuedMutations = [];
function $96cefe9acc8d79bc$var$flushObserver() {
    var records = $96cefe9acc8d79bc$var$observer.takeRecords();
    $96cefe9acc8d79bc$var$queuedMutations.push(function() {
        return records.length > 0 && $96cefe9acc8d79bc$var$onMutate(records);
    });
    var queueLengthWhenTriggered = $96cefe9acc8d79bc$var$queuedMutations.length;
    queueMicrotask(function() {
        if ($96cefe9acc8d79bc$var$queuedMutations.length === queueLengthWhenTriggered) while($96cefe9acc8d79bc$var$queuedMutations.length > 0)$96cefe9acc8d79bc$var$queuedMutations.shift()();
    });
}
function $96cefe9acc8d79bc$var$mutateDom(callback) {
    if (!$96cefe9acc8d79bc$var$currentlyObserving) return callback();
    $96cefe9acc8d79bc$var$stopObservingMutations();
    var result = callback();
    $96cefe9acc8d79bc$var$startObservingMutations();
    return result;
}
var $96cefe9acc8d79bc$var$isCollecting = false;
var $96cefe9acc8d79bc$var$deferredMutations = [];
function $96cefe9acc8d79bc$var$deferMutations() {
    $96cefe9acc8d79bc$var$isCollecting = true;
}
function $96cefe9acc8d79bc$var$flushAndStopDeferringMutations() {
    $96cefe9acc8d79bc$var$isCollecting = false;
    $96cefe9acc8d79bc$var$onMutate($96cefe9acc8d79bc$var$deferredMutations);
    $96cefe9acc8d79bc$var$deferredMutations = [];
}
function $96cefe9acc8d79bc$var$onMutate(mutations) {
    var _loop = function(i) {
        if (mutations[i].target._x_ignoreMutationObserver) return "continue";
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach(function(node) {
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            var el = mutations[i].target;
            var name = mutations[i].attributeName;
            var oldValue = mutations[i].oldValue;
            var add2 = function() {
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            var remove = function() {
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    };
    if ($96cefe9acc8d79bc$var$isCollecting) {
        $96cefe9acc8d79bc$var$deferredMutations = $96cefe9acc8d79bc$var$deferredMutations.concat(mutations);
        return;
    }
    var addedNodes = [];
    var removedNodes = /* @__PURE__ */ new Set();
    var addedAttributes = /* @__PURE__ */ new Map();
    var removedAttributes = /* @__PURE__ */ new Map();
    for(var i = 0; i < mutations.length; i++)_loop(i);
    removedAttributes.forEach(function(attrs, el) {
        $96cefe9acc8d79bc$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach(function(attrs, el) {
        $96cefe9acc8d79bc$var$onAttributeAddeds.forEach(function(i) {
            return i(el, attrs);
        });
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop1 = function() {
            var node = _step.value;
            if (addedNodes.some(function(i) {
                return i.contains(node);
            })) return "continue";
            $96cefe9acc8d79bc$var$onElRemoveds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator = removedNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        var _loop2 = function() {
            var node = _step1.value;
            if (!node.isConnected) return "continue";
            $96cefe9acc8d79bc$var$onElAddeds.forEach(function(i) {
                return i(node);
            });
        };
        for(var _iterator1 = addedNodes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop2();
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $96cefe9acc8d79bc$var$scope(node) {
    return $96cefe9acc8d79bc$var$mergeProxies($96cefe9acc8d79bc$var$closestDataStack(node));
}
function $96cefe9acc8d79bc$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2
    ].concat((0, $cfh0a._)($96cefe9acc8d79bc$var$closestDataStack(referenceNode || node)));
    return function() {
        node._x_dataStack = node._x_dataStack.filter(function(i) {
            return i !== data2;
        });
    };
}
function $96cefe9acc8d79bc$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $96cefe9acc8d79bc$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $96cefe9acc8d79bc$var$closestDataStack(node.parentNode);
}
function $96cefe9acc8d79bc$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $96cefe9acc8d79bc$var$mergeProxyTrap);
}
var $96cefe9acc8d79bc$var$mergeProxyTrap = {
    ownKeys: function(param) {
        var objects = param.objects;
        return Array.from(new Set(objects.flatMap(function(i) {
            return Object.keys(i);
        })));
    },
    has: function(param, name) {
        var objects = param.objects;
        if (name == Symbol.unscopables) return false;
        return objects.some(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name);
        });
    },
    get: function(param, name, thisProxy) {
        var objects = param.objects;
        if (name == "toJSON") return $96cefe9acc8d79bc$var$collapseProxies;
        return Reflect.get(objects.find(function(obj) {
            return Reflect.has(obj, name);
        }) || {}, name, thisProxy);
    },
    set: function(param, name, value, thisProxy) {
        var objects = param.objects;
        var target = objects.find(function(obj) {
            return Object.prototype.hasOwnProperty.call(obj, name);
        }) || objects[objects.length - 1];
        var descriptor = Object.getOwnPropertyDescriptor(target, name);
        if ((descriptor === null || descriptor === void 0 ? void 0 : descriptor.set) && (descriptor === null || descriptor === void 0 ? void 0 : descriptor.get)) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $96cefe9acc8d79bc$var$collapseProxies() {
    var _this = this;
    var keys = Reflect.ownKeys(this);
    return keys.reduce(function(acc, key) {
        acc[key] = Reflect.get(_this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $96cefe9acc8d79bc$var$initInterceptors(data2) {
    var isObject2 = function(val) {
        return (typeof val === "undefined" ? "undefined" : (0, $j2WbH._)(val)) === "object" && !Array.isArray(val) && val !== null;
    };
    var recurse = function(obj) {
        var basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(function(param) {
            var _param = (0, $40EBy._)(param, 2), key = _param[0], _param_ = _param[1], value = _param_.value, enumerable = _param_.enumerable;
            if (enumerable === false || value === void 0) return;
            if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null && value.__v_skip) return;
            var path = basePath === "" ? key : "".concat(basePath, ".").concat(key);
            if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $96cefe9acc8d79bc$var$interceptor(callback) {
    var mutateObj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize: function(data2, path, key) {
            return callback(this.initialValue, function() {
                return $96cefe9acc8d79bc$var$get(data2, path);
            }, function(value) {
                return $96cefe9acc8d79bc$var$set(data2, path, value);
            }, path, key);
        }
    };
    mutateObj(obj);
    return function(initialValue) {
        if ((typeof initialValue === "undefined" ? "undefined" : (0, $j2WbH._)(initialValue)) === "object" && initialValue !== null && initialValue._x_interceptor) {
            var initialize = obj.initialize.bind(obj);
            obj.initialize = function(data2, path, key) {
                var innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $96cefe9acc8d79bc$var$get(obj, path) {
    return path.split(".").reduce(function(carry, segment) {
        return carry[segment];
    }, obj);
}
function $96cefe9acc8d79bc$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $96cefe9acc8d79bc$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $96cefe9acc8d79bc$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $96cefe9acc8d79bc$var$magics = {};
function $96cefe9acc8d79bc$var$magic(name, callback) {
    $96cefe9acc8d79bc$var$magics[name] = callback;
}
function $96cefe9acc8d79bc$var$injectMagics(obj, el) {
    var memoizedUtilities = $96cefe9acc8d79bc$var$getUtilities(el);
    Object.entries($96cefe9acc8d79bc$var$magics).forEach(function(param) {
        var _param = (0, $40EBy._)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, "$".concat(name), {
            get: function() {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $96cefe9acc8d79bc$var$getUtilities(el) {
    var _getElementBoundUtilities = (0, $40EBy._)($96cefe9acc8d79bc$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    var utils = (0, $a9846c98c872cb75$export$71511d61b312f219)({
        interceptor: $96cefe9acc8d79bc$var$interceptor
    }, utilities);
    $96cefe9acc8d79bc$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $96cefe9acc8d79bc$var$tryCatch(el, expression, callback) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        args[_key - 3] = arguments[_key];
    }
    try {
        return callback.apply(void 0, (0, $cfh0a._)(args));
    } catch (e) {
        $96cefe9acc8d79bc$var$handleError(e, el, expression);
    }
}
function $96cefe9acc8d79bc$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 !== null && error2 !== void 0 ? error2 : {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn("Alpine Expression Error: ".concat(error2.message, "\n\n").concat(expression ? 'Expression: "' + expression + '"\n\n' : ""), el);
    setTimeout(function() {
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions = true;
function $96cefe9acc8d79bc$var$dontAutoEvaluateFunctions(callback) {
    var cache = $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions;
    $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions = false;
    var result = callback();
    $96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $96cefe9acc8d79bc$var$evaluate(el, expression) {
    var extras = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var result;
    $96cefe9acc8d79bc$var$evaluateLater(el, expression)(function(value) {
        return result = value;
    }, extras);
    return result;
}
function $96cefe9acc8d79bc$var$evaluateLater() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $96cefe9acc8d79bc$var$theEvaluatorFunction.apply(void 0, (0, $cfh0a._)(args));
}
var $96cefe9acc8d79bc$var$theEvaluatorFunction = $96cefe9acc8d79bc$var$normalEvaluator;
function $96cefe9acc8d79bc$var$setEvaluator(newEvaluator) {
    $96cefe9acc8d79bc$var$theEvaluatorFunction = newEvaluator;
}
function $96cefe9acc8d79bc$var$normalEvaluator(el, expression) {
    var overriddenMagics = {};
    $96cefe9acc8d79bc$var$injectMagics(overriddenMagics, el);
    var dataStack = [
        overriddenMagics
    ].concat((0, $cfh0a._)($96cefe9acc8d79bc$var$closestDataStack(el)));
    var evaluator = typeof expression === "function" ? $96cefe9acc8d79bc$var$generateEvaluatorFromFunction(dataStack, expression) : $96cefe9acc8d79bc$var$generateEvaluatorFromString(dataStack, expression, el);
    return $96cefe9acc8d79bc$var$tryCatch.bind(null, el, expression, evaluator);
}
function $96cefe9acc8d79bc$var$generateEvaluatorFromFunction(dataStack, func) {
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params;
        var result = func.apply($96cefe9acc8d79bc$var$mergeProxies([
            scope2
        ].concat((0, $cfh0a._)(dataStack))), params);
        $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, result);
    };
}
var $96cefe9acc8d79bc$var$evaluatorMemo = {};
function $96cefe9acc8d79bc$var$generateFunctionFromString(expression, el) {
    if ($96cefe9acc8d79bc$var$evaluatorMemo[expression]) return $96cefe9acc8d79bc$var$evaluatorMemo[expression];
    var AsyncFunction = Object.getPrototypeOf(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $829c750286ec3a2c$export$71511d61b312f219)(function() {
            return (0, $15f39fe0df078b1e$export$67ebef60e6f28a6)(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    }).constructor;
    var rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? "(async()=>{ ".concat(expression, " })()") : expression;
    var safeAsyncFunction = function() {
        try {
            var func2 = new AsyncFunction([
                "__self",
                "scope"
            ], "with (scope) { __self.result = ".concat(rightSideSafeExpression, " }; __self.finished = true; return __self.result;"));
            Object.defineProperty(func2, "name", {
                value: "[Alpine] ".concat(expression)
            });
            return func2;
        } catch (error2) {
            $96cefe9acc8d79bc$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    var func = safeAsyncFunction();
    $96cefe9acc8d79bc$var$evaluatorMemo[expression] = func;
    return func;
}
function $96cefe9acc8d79bc$var$generateEvaluatorFromString(dataStack, expression, el) {
    var func = $96cefe9acc8d79bc$var$generateFunctionFromString(expression, el);
    return function() {
        var receiver = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, tmp = _ref.scope, scope2 = tmp === void 0 ? {} : tmp, _ref_params = _ref.params, params = _ref_params === void 0 ? [] : _ref_params;
        func.result = void 0;
        func.finished = false;
        var completeScope = $96cefe9acc8d79bc$var$mergeProxies([
            scope2
        ].concat((0, $cfh0a._)(dataStack)));
        if (typeof func === "function") {
            var promise = func(func, completeScope).catch(function(error2) {
                return $96cefe9acc8d79bc$var$handleError(error2, el, expression);
            });
            if (func.finished) {
                $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then(function(result) {
                $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch(function(error2) {
                return $96cefe9acc8d79bc$var$handleError(error2, el, expression);
            }).finally(function() {
                return func.result = void 0;
            });
        }
    };
}
function $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($96cefe9acc8d79bc$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        var result = value.apply(scope2, params);
        if (result instanceof Promise) result.then(function(i) {
            return $96cefe9acc8d79bc$var$runIfTypeOfFunction(receiver, i, scope2, params);
        }).catch(function(error2) {
            return $96cefe9acc8d79bc$var$handleError(error2, el, value);
        });
        else receiver(result);
    } else if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value instanceof Promise) value.then(function(i) {
        return receiver(i);
    });
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $96cefe9acc8d79bc$var$prefixAsString = "x-";
function $96cefe9acc8d79bc$var$prefix() {
    var subject = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return $96cefe9acc8d79bc$var$prefixAsString + subject;
}
function $96cefe9acc8d79bc$var$setPrefix(newPrefix) {
    $96cefe9acc8d79bc$var$prefixAsString = newPrefix;
}
var $96cefe9acc8d79bc$var$directiveHandlers = {};
function $96cefe9acc8d79bc$var$directive(name, callback) {
    $96cefe9acc8d79bc$var$directiveHandlers[name] = callback;
    return {
        before: function(directive2) {
            if (!$96cefe9acc8d79bc$var$directiveHandlers[directive2]) {
                console.warn(String.raw($96cefe9acc8d79bc$var$_templateObject(), directive2, name));
                return;
            }
            var pos = $96cefe9acc8d79bc$var$directiveOrder.indexOf(directive2);
            $96cefe9acc8d79bc$var$directiveOrder.splice(pos >= 0 ? pos : $96cefe9acc8d79bc$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $96cefe9acc8d79bc$var$directiveExists(name) {
    return Object.keys($96cefe9acc8d79bc$var$directiveHandlers).includes(name);
}
function $96cefe9acc8d79bc$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        var vAttributes = Object.entries(el._x_virtualDirectives).map(function(param) {
            var _param = (0, $40EBy._)(param, 2), name = _param[0], value = _param[1];
            return {
                name: name,
                value: value
            };
        });
        var staticAttributes = $96cefe9acc8d79bc$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map(function(attribute) {
            if (staticAttributes.find(function(attr) {
                return attr.name === attribute.name;
            })) return {
                name: "x-bind:".concat(attribute.name),
                value: '"'.concat(attribute.value, '"')
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    var transformedAttributeMap = {};
    var directives2 = attributes.map($96cefe9acc8d79bc$var$toTransformedAttributes(function(newName, oldName) {
        return transformedAttributeMap[newName] = oldName;
    })).filter($96cefe9acc8d79bc$var$outNonAlpineAttributes).map($96cefe9acc8d79bc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($96cefe9acc8d79bc$var$byPriority);
    return directives2.map(function(directive2) {
        return $96cefe9acc8d79bc$var$getDirectiveHandler(el, directive2);
    });
}
function $96cefe9acc8d79bc$var$attributesOnly(attributes) {
    return Array.from(attributes).map($96cefe9acc8d79bc$var$toTransformedAttributes()).filter(function(attr) {
        return !$96cefe9acc8d79bc$var$outNonAlpineAttributes(attr);
    });
}
var $96cefe9acc8d79bc$var$isDeferringHandlers = false;
var $96cefe9acc8d79bc$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $96cefe9acc8d79bc$var$currentHandlerStackKey = Symbol();
function $96cefe9acc8d79bc$var$deferHandlingDirectives(callback) {
    $96cefe9acc8d79bc$var$isDeferringHandlers = true;
    var key = Symbol();
    $96cefe9acc8d79bc$var$currentHandlerStackKey = key;
    $96cefe9acc8d79bc$var$directiveHandlerStacks.set(key, []);
    var flushHandlers = function() {
        while($96cefe9acc8d79bc$var$directiveHandlerStacks.get(key).length)$96cefe9acc8d79bc$var$directiveHandlerStacks.get(key).shift()();
        $96cefe9acc8d79bc$var$directiveHandlerStacks.delete(key);
    };
    var stopDeferring = function() {
        $96cefe9acc8d79bc$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $96cefe9acc8d79bc$var$getElementBoundUtilities(el) {
    var cleanups = [];
    var cleanup2 = function(callback) {
        return cleanups.push(callback);
    };
    var _elementBoundEffect = (0, $40EBy._)($96cefe9acc8d79bc$var$elementBoundEffect(el), 2), effect3 = _elementBoundEffect[0], cleanupEffect = _elementBoundEffect[1];
    cleanups.push(cleanupEffect);
    var utilities = {
        Alpine: $96cefe9acc8d79bc$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $96cefe9acc8d79bc$var$evaluateLater.bind($96cefe9acc8d79bc$var$evaluateLater, el),
        evaluate: $96cefe9acc8d79bc$var$evaluate.bind($96cefe9acc8d79bc$var$evaluate, el)
    };
    var doCleanup = function() {
        return cleanups.forEach(function(i) {
            return i();
        });
    };
    return [
        utilities,
        doCleanup
    ];
}
function $96cefe9acc8d79bc$var$getDirectiveHandler(el, directive2) {
    var noop = function() {};
    var handler4 = $96cefe9acc8d79bc$var$directiveHandlers[directive2.type] || noop;
    var _getElementBoundUtilities = (0, $40EBy._)($96cefe9acc8d79bc$var$getElementBoundUtilities(el), 2), utilities = _getElementBoundUtilities[0], cleanup2 = _getElementBoundUtilities[1];
    $96cefe9acc8d79bc$var$onAttributeRemoved(el, directive2.original, cleanup2);
    var fullHandler = function() {
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $96cefe9acc8d79bc$var$isDeferringHandlers ? $96cefe9acc8d79bc$var$directiveHandlerStacks.get($96cefe9acc8d79bc$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $96cefe9acc8d79bc$var$startingWith = function(subject, replacement) {
    return function(param) {
        var name = param.name, value = param.value;
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
};
var $96cefe9acc8d79bc$var$into = function(i) {
    return i;
};
function $96cefe9acc8d79bc$var$toTransformedAttributes() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    return function(param) {
        var name = param.name, value = param.value;
        var _attributeTransformers_reduce = $96cefe9acc8d79bc$var$attributeTransformers.reduce(function(carry, transform) {
            return transform(carry);
        }, {
            name: name,
            value: value
        }), newName = _attributeTransformers_reduce.name, newValue = _attributeTransformers_reduce.value;
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $96cefe9acc8d79bc$var$attributeTransformers = [];
function $96cefe9acc8d79bc$var$mapAttributes(callback) {
    $96cefe9acc8d79bc$var$attributeTransformers.push(callback);
}
function $96cefe9acc8d79bc$var$outNonAlpineAttributes(param) {
    var name = param.name;
    return $96cefe9acc8d79bc$var$alpineAttributeRegex().test(name);
}
var $96cefe9acc8d79bc$var$alpineAttributeRegex = function() {
    return new RegExp("^".concat($96cefe9acc8d79bc$var$prefixAsString, "([^:^.]+)\\b"));
};
function $96cefe9acc8d79bc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return function(param) {
        var name = param.name, value = param.value;
        var typeMatch = name.match($96cefe9acc8d79bc$var$alpineAttributeRegex());
        var valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        var modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        var original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map(function(i) {
                return i.replace(".", "");
            }),
            expression: value,
            original: original
        };
    };
}
var $96cefe9acc8d79bc$var$DEFAULT = "DEFAULT";
var $96cefe9acc8d79bc$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $96cefe9acc8d79bc$var$DEFAULT,
    "teleport"
];
function $96cefe9acc8d79bc$var$byPriority(a, b) {
    var typeA = $96cefe9acc8d79bc$var$directiveOrder.indexOf(a.type) === -1 ? $96cefe9acc8d79bc$var$DEFAULT : a.type;
    var typeB = $96cefe9acc8d79bc$var$directiveOrder.indexOf(b.type) === -1 ? $96cefe9acc8d79bc$var$DEFAULT : b.type;
    return $96cefe9acc8d79bc$var$directiveOrder.indexOf(typeA) - $96cefe9acc8d79bc$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $96cefe9acc8d79bc$var$dispatch(el, name) {
    var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $96cefe9acc8d79bc$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach(function(el2) {
            return $96cefe9acc8d79bc$var$walk(el2, callback);
        });
        return;
    }
    var skip = false;
    callback(el, function() {
        return skip = true;
    });
    if (skip) return;
    var node = el.firstElementChild;
    while(node){
        $96cefe9acc8d79bc$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $96cefe9acc8d79bc$var$warn(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "Alpine Warning: ".concat(message)
    ].concat((0, $cfh0a._)(args)));
}
// packages/alpinejs/src/lifecycle.js
var $96cefe9acc8d79bc$var$started = false;
function $96cefe9acc8d79bc$var$start() {
    if ($96cefe9acc8d79bc$var$started) $96cefe9acc8d79bc$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $96cefe9acc8d79bc$var$started = true;
    if (!document.body) $96cefe9acc8d79bc$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $96cefe9acc8d79bc$var$dispatch(document, "alpine:init");
    $96cefe9acc8d79bc$var$dispatch(document, "alpine:initializing");
    $96cefe9acc8d79bc$var$startObservingMutations();
    $96cefe9acc8d79bc$var$onElAdded(function(el) {
        return $96cefe9acc8d79bc$var$initTree(el, $96cefe9acc8d79bc$var$walk);
    });
    $96cefe9acc8d79bc$var$onElRemoved(function(el) {
        return $96cefe9acc8d79bc$var$destroyTree(el);
    });
    $96cefe9acc8d79bc$var$onAttributesAdded(function(el, attrs) {
        $96cefe9acc8d79bc$var$directives(el, attrs).forEach(function(handle) {
            return handle();
        });
    });
    var outNestedComponents = function(el) {
        return !$96cefe9acc8d79bc$var$closestRoot(el.parentElement, true);
    };
    Array.from(document.querySelectorAll($96cefe9acc8d79bc$var$allSelectors().join(","))).filter(outNestedComponents).forEach(function(el) {
        $96cefe9acc8d79bc$var$initTree(el);
    });
    $96cefe9acc8d79bc$var$dispatch(document, "alpine:initialized");
    setTimeout(function() {
        $96cefe9acc8d79bc$var$warnAboutMissingPlugins();
    });
}
var $96cefe9acc8d79bc$var$rootSelectorCallbacks = [];
var $96cefe9acc8d79bc$var$initSelectorCallbacks = [];
function $96cefe9acc8d79bc$var$rootSelectors() {
    return $96cefe9acc8d79bc$var$rootSelectorCallbacks.map(function(fn) {
        return fn();
    });
}
function $96cefe9acc8d79bc$var$allSelectors() {
    return $96cefe9acc8d79bc$var$rootSelectorCallbacks.concat($96cefe9acc8d79bc$var$initSelectorCallbacks).map(function(fn) {
        return fn();
    });
}
function $96cefe9acc8d79bc$var$addRootSelector(selectorCallback) {
    $96cefe9acc8d79bc$var$rootSelectorCallbacks.push(selectorCallback);
}
function $96cefe9acc8d79bc$var$addInitSelector(selectorCallback) {
    $96cefe9acc8d79bc$var$initSelectorCallbacks.push(selectorCallback);
}
function $96cefe9acc8d79bc$var$closestRoot(el) {
    var includeInitSelectors = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return $96cefe9acc8d79bc$var$findClosest(el, function(element) {
        var selectors = includeInitSelectors ? $96cefe9acc8d79bc$var$allSelectors() : $96cefe9acc8d79bc$var$rootSelectors();
        if (selectors.some(function(selector) {
            return element.matches(selector);
        })) return true;
    });
}
function $96cefe9acc8d79bc$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $96cefe9acc8d79bc$var$findClosest(el.parentElement, callback);
}
function $96cefe9acc8d79bc$var$isRoot(el) {
    return $96cefe9acc8d79bc$var$rootSelectors().some(function(selector) {
        return el.matches(selector);
    });
}
var $96cefe9acc8d79bc$var$initInterceptors2 = [];
function $96cefe9acc8d79bc$var$interceptInit(callback) {
    $96cefe9acc8d79bc$var$initInterceptors2.push(callback);
}
var $96cefe9acc8d79bc$var$markerDispenser = 1;
function $96cefe9acc8d79bc$var$initTree(el) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $96cefe9acc8d79bc$var$walk, intercept = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    if ($96cefe9acc8d79bc$var$findClosest(el, function(i) {
        return i._x_ignore;
    })) return;
    $96cefe9acc8d79bc$var$deferHandlingDirectives(function() {
        walker(el, function(el2, skip) {
            if (el2._x_marker) return;
            intercept(el2, skip);
            $96cefe9acc8d79bc$var$initInterceptors2.forEach(function(i) {
                return i(el2, skip);
            });
            $96cefe9acc8d79bc$var$directives(el2, el2.attributes).forEach(function(handle) {
                return handle();
            });
            if (!el2._x_ignore) el2._x_marker = $96cefe9acc8d79bc$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $96cefe9acc8d79bc$var$destroyTree(root) {
    var walker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $96cefe9acc8d79bc$var$walk;
    walker(root, function(el) {
        $96cefe9acc8d79bc$var$cleanupElement(el);
        $96cefe9acc8d79bc$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $96cefe9acc8d79bc$var$warnAboutMissingPlugins() {
    var pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(function(param) {
        var _param = (0, $40EBy._)(param, 3), plugin2 = _param[0], directive2 = _param[1], selectors = _param[2];
        if ($96cefe9acc8d79bc$var$directiveExists(directive2)) return;
        selectors.some(function(selector) {
            if (document.querySelector(selector)) {
                $96cefe9acc8d79bc$var$warn('found "'.concat(selector, '", but missing ').concat(plugin2, " plugin"));
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $96cefe9acc8d79bc$var$tickStack = [];
var $96cefe9acc8d79bc$var$isHolding = false;
function $96cefe9acc8d79bc$var$nextTick() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    queueMicrotask(function() {
        $96cefe9acc8d79bc$var$isHolding || setTimeout(function() {
            $96cefe9acc8d79bc$var$releaseNextTicks();
        });
    });
    return new Promise(function(res) {
        $96cefe9acc8d79bc$var$tickStack.push(function() {
            callback();
            res();
        });
    });
}
function $96cefe9acc8d79bc$var$releaseNextTicks() {
    $96cefe9acc8d79bc$var$isHolding = false;
    while($96cefe9acc8d79bc$var$tickStack.length)$96cefe9acc8d79bc$var$tickStack.shift()();
}
function $96cefe9acc8d79bc$var$holdNextTicks() {
    $96cefe9acc8d79bc$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $96cefe9acc8d79bc$var$setClasses(el, value) {
    if (Array.isArray(value)) return $96cefe9acc8d79bc$var$setClassesFromString(el, value.join(" "));
    else if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null) return $96cefe9acc8d79bc$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $96cefe9acc8d79bc$var$setClasses(el, value());
    return $96cefe9acc8d79bc$var$setClassesFromString(el, value);
}
function $96cefe9acc8d79bc$var$setClassesFromString(el, classString) {
    var split = function(classString2) {
        return classString2.split(" ").filter(Boolean);
    };
    var missingClasses = function(classString2) {
        return classString2.split(" ").filter(function(i) {
            return !el.classList.contains(i);
        }).filter(Boolean);
    };
    var addClassesAndReturnUndo = function(classes) {
        var _el_classList;
        (_el_classList = el.classList).add.apply(_el_classList, (0, $cfh0a._)(classes));
        return function() {
            var _el_classList;
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $cfh0a._)(classes));
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $96cefe9acc8d79bc$var$setClassesFromObject(el, classObject) {
    var split = function(classString) {
        return classString.split(" ").filter(Boolean);
    };
    var forAdd = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $40EBy._)(param, 2), classString = _param[0], bool = _param[1];
        return bool ? split(classString) : false;
    }).filter(Boolean);
    var forRemove = Object.entries(classObject).flatMap(function(param) {
        var _param = (0, $40EBy._)(param, 2), classString = _param[0], bool = _param[1];
        return !bool ? split(classString) : false;
    }).filter(Boolean);
    var added = [];
    var removed = [];
    forRemove.forEach(function(i) {
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach(function(i) {
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return function() {
        removed.forEach(function(i) {
            return el.classList.add(i);
        });
        added.forEach(function(i) {
            return el.classList.remove(i);
        });
    };
}
// packages/alpinejs/src/utils/styles.js
function $96cefe9acc8d79bc$var$setStyles(el, value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null) return $96cefe9acc8d79bc$var$setStylesFromObject(el, value);
    return $96cefe9acc8d79bc$var$setStylesFromString(el, value);
}
function $96cefe9acc8d79bc$var$setStylesFromObject(el, value) {
    var previousStyles = {};
    Object.entries(value).forEach(function(param) {
        var _param = (0, $40EBy._)(param, 2), key = _param[0], value2 = _param[1];
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $96cefe9acc8d79bc$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(function() {
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return function() {
        $96cefe9acc8d79bc$var$setStyles(el, previousStyles);
    };
}
function $96cefe9acc8d79bc$var$setStylesFromString(el, value) {
    var cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return function() {
        el.setAttribute("style", cache || "");
    };
}
function $96cefe9acc8d79bc$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $96cefe9acc8d79bc$var$once(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    var called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$96cefe9acc8d79bc$var$directive("transition", function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $96cefe9acc8d79bc$var$registerTransitionsFromHelper(el, modifiers, value);
    else $96cefe9acc8d79bc$var$registerTransitionsFromClassString(el, expression, value);
});
function $96cefe9acc8d79bc$var$registerTransitionsFromClassString(el, classString, stage) {
    $96cefe9acc8d79bc$var$registerTransitionObject(el, $96cefe9acc8d79bc$var$setClasses, "");
    var directiveStorageMap = {
        "enter": function(classes) {
            el._x_transition.enter.during = classes;
        },
        "enter-start": function(classes) {
            el._x_transition.enter.start = classes;
        },
        "enter-end": function(classes) {
            el._x_transition.enter.end = classes;
        },
        "leave": function(classes) {
            el._x_transition.leave.during = classes;
        },
        "leave-start": function(classes) {
            el._x_transition.leave.start = classes;
        },
        "leave-end": function(classes) {
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $96cefe9acc8d79bc$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $96cefe9acc8d79bc$var$registerTransitionObject(el, $96cefe9acc8d79bc$var$setStyles);
    var doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    var transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    var transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index < modifiers.indexOf("out");
    });
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter(function(i, index) {
        return index > modifiers.indexOf("out");
    });
    var wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    var wantsOpacity = wantsAll || modifiers.includes("opacity");
    var wantsScale = wantsAll || modifiers.includes("scale");
    var opacityValue = wantsOpacity ? 0 : 1;
    var scaleValue = wantsScale ? $96cefe9acc8d79bc$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    var delay = $96cefe9acc8d79bc$var$modifierValue(modifiers, "delay", 0) / 1e3;
    var origin = $96cefe9acc8d79bc$var$modifierValue(modifiers, "origin", "center");
    var property = "opacity, transform";
    var durationIn = $96cefe9acc8d79bc$var$modifierValue(modifiers, "duration", 150) / 1e3;
    var durationOut = $96cefe9acc8d79bc$var$modifierValue(modifiers, "duration", 75) / 1e3;
    var easing = "cubic-bezier(0.4, 0.0, 0.2, 1)";
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationIn, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: "scale(1)"
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: "".concat(delay, "s"),
            transitionProperty: property,
            transitionDuration: "".concat(durationOut, "s"),
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: "scale(1)"
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: "scale(".concat(scaleValue, ")")
        };
    }
}
function $96cefe9acc8d79bc$var$registerTransitionObject(el, setFunction) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $96cefe9acc8d79bc$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out: function() {
            var before = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {}, after = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
            $96cefe9acc8d79bc$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    var nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    var clickAwayCompatibleShow = function() {
        return nextTick2(show);
    };
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise(function(resolve, reject) {
        el._x_transition.out(function() {}, function() {
            return resolve(hide);
        });
        el._x_transitioning && el._x_transitioning.beforeCancel(function() {
            return reject({
                isFromCancelledTransition: true
            });
        });
    }) : Promise.resolve(hide);
    queueMicrotask(function() {
        var closest = $96cefe9acc8d79bc$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(function() {
            var hideAfterChildren = function(el2) {
                var carry = Promise.all([
                    el2._x_hidePromise
                ].concat((0, $cfh0a._)((el2._x_hideChildren || []).map(hideAfterChildren)))).then(function(param) {
                    var _param = (0, $40EBy._)(param, 1), i = _param[0];
                    return i === null || i === void 0 ? void 0 : i();
                });
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch(function(e) {
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $96cefe9acc8d79bc$var$closestHide(el) {
    var parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $96cefe9acc8d79bc$var$closestHide(parent);
}
function $96cefe9acc8d79bc$var$transition(el, setFunction) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, during = _ref.during, start2 = _ref.start, end = _ref.end, before = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, after = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {};
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    var undoStart, undoDuring, undoEnd;
    $96cefe9acc8d79bc$var$performTransition(el, {
        start: function() {
            undoStart = setFunction(el, start2);
        },
        during: function() {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end: function() {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup: function() {
            undoDuring();
            undoEnd();
        }
    });
}
function $96cefe9acc8d79bc$var$performTransition(el, stages) {
    var interrupted, reachedBefore, reachedEnd;
    var finish = $96cefe9acc8d79bc$var$once(function() {
        $96cefe9acc8d79bc$var$mutateDom(function() {
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $96cefe9acc8d79bc$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel: function(callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $96cefe9acc8d79bc$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $96cefe9acc8d79bc$var$mutateDom(function() {
        stages.start();
        stages.during();
    });
    $96cefe9acc8d79bc$var$holdNextTicks();
    requestAnimationFrame(function() {
        if (interrupted) return;
        var duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        var delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $96cefe9acc8d79bc$var$mutateDom(function() {
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(function() {
            if (interrupted) return;
            $96cefe9acc8d79bc$var$mutateDom(function() {
                stages.end();
            });
            $96cefe9acc8d79bc$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $96cefe9acc8d79bc$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    var rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        var match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $96cefe9acc8d79bc$var$isCloning = false;
function $96cefe9acc8d79bc$var$skipDuringClone(callback) {
    var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {};
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $96cefe9acc8d79bc$var$isCloning ? fallback.apply(void 0, (0, $cfh0a._)(args)) : callback.apply(void 0, (0, $cfh0a._)(args));
    };
}
function $96cefe9acc8d79bc$var$onlyDuringClone(callback) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $96cefe9acc8d79bc$var$isCloning && callback.apply(void 0, (0, $cfh0a._)(args));
    };
}
var $96cefe9acc8d79bc$var$interceptors = [];
function $96cefe9acc8d79bc$var$interceptClone(callback) {
    $96cefe9acc8d79bc$var$interceptors.push(callback);
}
function $96cefe9acc8d79bc$var$cloneNode(from, to) {
    $96cefe9acc8d79bc$var$interceptors.forEach(function(i) {
        return i(from, to);
    });
    $96cefe9acc8d79bc$var$isCloning = true;
    $96cefe9acc8d79bc$var$dontRegisterReactiveSideEffects(function() {
        $96cefe9acc8d79bc$var$initTree(to, function(el, callback) {
            callback(el, function() {});
        });
    });
    $96cefe9acc8d79bc$var$isCloning = false;
}
var $96cefe9acc8d79bc$var$isCloningLegacy = false;
function $96cefe9acc8d79bc$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $96cefe9acc8d79bc$var$isCloning = true;
    $96cefe9acc8d79bc$var$isCloningLegacy = true;
    $96cefe9acc8d79bc$var$dontRegisterReactiveSideEffects(function() {
        $96cefe9acc8d79bc$var$cloneTree(newEl);
    });
    $96cefe9acc8d79bc$var$isCloning = false;
    $96cefe9acc8d79bc$var$isCloningLegacy = false;
}
function $96cefe9acc8d79bc$var$cloneTree(el) {
    var hasRunThroughFirstEl = false;
    var shallowWalker = function(el2, callback) {
        $96cefe9acc8d79bc$var$walk(el2, function(el3, skip) {
            if (hasRunThroughFirstEl && $96cefe9acc8d79bc$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $96cefe9acc8d79bc$var$initTree(el, shallowWalker);
}
function $96cefe9acc8d79bc$var$dontRegisterReactiveSideEffects(callback) {
    var cache = $96cefe9acc8d79bc$var$effect;
    $96cefe9acc8d79bc$var$overrideEffect(function(callback2, el) {
        var storedEffect = cache(callback2);
        $96cefe9acc8d79bc$var$release(storedEffect);
        return function() {};
    });
    callback();
    $96cefe9acc8d79bc$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $96cefe9acc8d79bc$var$bind(el, name, value) {
    var modifiers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!el._x_bindings) el._x_bindings = $96cefe9acc8d79bc$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $96cefe9acc8d79bc$var$camelCase(name) : name;
    switch(name){
        case "value":
            $96cefe9acc8d79bc$var$bindInputValue(el, value);
            break;
        case "style":
            $96cefe9acc8d79bc$var$bindStyles(el, value);
            break;
        case "class":
            $96cefe9acc8d79bc$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $96cefe9acc8d79bc$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $96cefe9acc8d79bc$var$bindAttribute(el, name, value);
            break;
    }
}
function $96cefe9acc8d79bc$var$bindInputValue(el, value) {
    if ($96cefe9acc8d79bc$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $96cefe9acc8d79bc$var$safeParseBoolean(el.value) === value;
            else el.checked = $96cefe9acc8d79bc$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($96cefe9acc8d79bc$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some(function(val) {
            return $96cefe9acc8d79bc$var$checkedAttrLooseCompare(val, el.value);
        });
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $96cefe9acc8d79bc$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $96cefe9acc8d79bc$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $96cefe9acc8d79bc$var$setClasses(el, value);
}
function $96cefe9acc8d79bc$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $96cefe9acc8d79bc$var$setStyles(el, value);
}
function $96cefe9acc8d79bc$var$bindAttributeAndProperty(el, name, value) {
    $96cefe9acc8d79bc$var$bindAttribute(el, name, value);
    $96cefe9acc8d79bc$var$setPropertyIfChanged(el, name, value);
}
function $96cefe9acc8d79bc$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $96cefe9acc8d79bc$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($96cefe9acc8d79bc$var$isBooleanAttr(name)) value = name;
        $96cefe9acc8d79bc$var$setIfChanged(el, name, value);
    }
}
function $96cefe9acc8d79bc$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $96cefe9acc8d79bc$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $96cefe9acc8d79bc$var$updateSelect(el, value) {
    var arrayWrappedValue = [].concat(value).map(function(value2) {
        return value2 + "";
    });
    Array.from(el.options).forEach(function(option) {
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $96cefe9acc8d79bc$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $96cefe9acc8d79bc$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $96cefe9acc8d79bc$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $96cefe9acc8d79bc$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $96cefe9acc8d79bc$var$isBooleanAttr(attrName) {
    return $96cefe9acc8d79bc$var$booleanAttributes.has(attrName);
}
function $96cefe9acc8d79bc$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $96cefe9acc8d79bc$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $96cefe9acc8d79bc$var$getAttributeBinding(el, name, fallback);
}
function $96cefe9acc8d79bc$var$extractProp(el, name, fallback) {
    var extract = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        var binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $96cefe9acc8d79bc$var$dontAutoEvaluateFunctions(function() {
            return $96cefe9acc8d79bc$var$evaluate(el, binding.expression);
        });
    }
    return $96cefe9acc8d79bc$var$getAttributeBinding(el, name, fallback);
}
function $96cefe9acc8d79bc$var$getAttributeBinding(el, name, fallback) {
    var attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($96cefe9acc8d79bc$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $96cefe9acc8d79bc$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $96cefe9acc8d79bc$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $96cefe9acc8d79bc$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function later() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $96cefe9acc8d79bc$var$throttle(func, limit) {
    var inThrottle;
    return function() {
        var context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function() {
                return inThrottle = false;
            }, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $96cefe9acc8d79bc$var$entangle(param, param1) {
    var outerGet = param.get, outerSet = param.set, innerGet = param1.get, innerSet = param1.set;
    var firstRun = true;
    var outerHash;
    var innerHash;
    var reference = $96cefe9acc8d79bc$var$effect(function() {
        var outer = outerGet();
        var inner = innerGet();
        if (firstRun) {
            innerSet($96cefe9acc8d79bc$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            var outerHashLatest = JSON.stringify(outer);
            var innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($96cefe9acc8d79bc$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($96cefe9acc8d79bc$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return function() {
        $96cefe9acc8d79bc$var$release(reference);
    };
}
function $96cefe9acc8d79bc$var$cloneIfObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $96cefe9acc8d79bc$var$plugin(callback) {
    var callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach(function(i) {
        return i($96cefe9acc8d79bc$var$alpine_default);
    });
}
// packages/alpinejs/src/store.js
var $96cefe9acc8d79bc$var$stores = {};
var $96cefe9acc8d79bc$var$isReactive = false;
function $96cefe9acc8d79bc$var$store(name, value) {
    if (!$96cefe9acc8d79bc$var$isReactive) {
        $96cefe9acc8d79bc$var$stores = $96cefe9acc8d79bc$var$reactive($96cefe9acc8d79bc$var$stores);
        $96cefe9acc8d79bc$var$isReactive = true;
    }
    if (value === void 0) return $96cefe9acc8d79bc$var$stores[name];
    $96cefe9acc8d79bc$var$stores[name] = value;
    $96cefe9acc8d79bc$var$initInterceptors($96cefe9acc8d79bc$var$stores[name]);
    if ((typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $96cefe9acc8d79bc$var$stores[name].init();
}
function $96cefe9acc8d79bc$var$getStores() {
    return $96cefe9acc8d79bc$var$stores;
}
// packages/alpinejs/src/binds.js
var $96cefe9acc8d79bc$var$binds = {};
function $96cefe9acc8d79bc$var$bind2(name, bindings) {
    var getBindings = typeof bindings !== "function" ? function() {
        return bindings;
    } : bindings;
    if (name instanceof Element) return $96cefe9acc8d79bc$var$applyBindingsObject(name, getBindings());
    else $96cefe9acc8d79bc$var$binds[name] = getBindings;
    return function() {};
}
function $96cefe9acc8d79bc$var$injectBindingProviders(obj) {
    Object.entries($96cefe9acc8d79bc$var$binds).forEach(function(param) {
        var _param = (0, $40EBy._)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.apply(void 0, (0, $cfh0a._)(args));
                };
            }
        });
    });
    return obj;
}
function $96cefe9acc8d79bc$var$applyBindingsObject(el, obj, original) {
    var cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    var attributes = Object.entries(obj).map(function(param) {
        var _param = (0, $40EBy._)(param, 2), name = _param[0], value = _param[1];
        return {
            name: name,
            value: value
        };
    });
    var staticAttributes = $96cefe9acc8d79bc$var$attributesOnly(attributes);
    attributes = attributes.map(function(attribute) {
        if (staticAttributes.find(function(attr) {
            return attr.name === attribute.name;
        })) return {
            name: "x-bind:".concat(attribute.name),
            value: '"'.concat(attribute.value, '"')
        };
        return attribute;
    });
    $96cefe9acc8d79bc$var$directives(el, attributes, original).map(function(handle) {
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return function() {
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $96cefe9acc8d79bc$var$datas = {};
function $96cefe9acc8d79bc$var$data(name, callback) {
    $96cefe9acc8d79bc$var$datas[name] = callback;
}
function $96cefe9acc8d79bc$var$injectDataProviders(obj, context) {
    Object.entries($96cefe9acc8d79bc$var$datas).forEach(function(param) {
        var _param = (0, $40EBy._)(param, 2), name = _param[0], callback = _param[1];
        Object.defineProperty(obj, name, {
            get: function() {
                var _this = this;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return callback.bind(context).apply(_this, (0, $cfh0a._)(args));
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $96cefe9acc8d79bc$var$Alpine = {
    get reactive () {
        return $96cefe9acc8d79bc$var$reactive;
    },
    get release () {
        return $96cefe9acc8d79bc$var$release;
    },
    get effect () {
        return $96cefe9acc8d79bc$var$effect;
    },
    get raw () {
        return $96cefe9acc8d79bc$var$raw;
    },
    version: "3.14.8",
    flushAndStopDeferringMutations: $96cefe9acc8d79bc$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $96cefe9acc8d79bc$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $96cefe9acc8d79bc$var$disableEffectScheduling,
    startObservingMutations: $96cefe9acc8d79bc$var$startObservingMutations,
    stopObservingMutations: $96cefe9acc8d79bc$var$stopObservingMutations,
    setReactivityEngine: $96cefe9acc8d79bc$var$setReactivityEngine,
    onAttributeRemoved: $96cefe9acc8d79bc$var$onAttributeRemoved,
    onAttributesAdded: $96cefe9acc8d79bc$var$onAttributesAdded,
    closestDataStack: $96cefe9acc8d79bc$var$closestDataStack,
    skipDuringClone: $96cefe9acc8d79bc$var$skipDuringClone,
    onlyDuringClone: $96cefe9acc8d79bc$var$onlyDuringClone,
    addRootSelector: $96cefe9acc8d79bc$var$addRootSelector,
    addInitSelector: $96cefe9acc8d79bc$var$addInitSelector,
    interceptClone: $96cefe9acc8d79bc$var$interceptClone,
    addScopeToNode: $96cefe9acc8d79bc$var$addScopeToNode,
    deferMutations: $96cefe9acc8d79bc$var$deferMutations,
    mapAttributes: $96cefe9acc8d79bc$var$mapAttributes,
    evaluateLater: $96cefe9acc8d79bc$var$evaluateLater,
    interceptInit: $96cefe9acc8d79bc$var$interceptInit,
    setEvaluator: $96cefe9acc8d79bc$var$setEvaluator,
    mergeProxies: $96cefe9acc8d79bc$var$mergeProxies,
    extractProp: $96cefe9acc8d79bc$var$extractProp,
    findClosest: $96cefe9acc8d79bc$var$findClosest,
    onElRemoved: $96cefe9acc8d79bc$var$onElRemoved,
    closestRoot: $96cefe9acc8d79bc$var$closestRoot,
    destroyTree: $96cefe9acc8d79bc$var$destroyTree,
    interceptor: $96cefe9acc8d79bc$var$interceptor,
    // INTERNAL: not public API and is subject to change without major release.
    transition: $96cefe9acc8d79bc$var$transition,
    // INTERNAL
    setStyles: $96cefe9acc8d79bc$var$setStyles,
    // INTERNAL
    mutateDom: $96cefe9acc8d79bc$var$mutateDom,
    directive: $96cefe9acc8d79bc$var$directive,
    entangle: $96cefe9acc8d79bc$var$entangle,
    throttle: $96cefe9acc8d79bc$var$throttle,
    debounce: $96cefe9acc8d79bc$var$debounce,
    evaluate: $96cefe9acc8d79bc$var$evaluate,
    initTree: $96cefe9acc8d79bc$var$initTree,
    nextTick: $96cefe9acc8d79bc$var$nextTick,
    prefixed: $96cefe9acc8d79bc$var$prefix,
    prefix: $96cefe9acc8d79bc$var$setPrefix,
    plugin: $96cefe9acc8d79bc$var$plugin,
    magic: $96cefe9acc8d79bc$var$magic,
    store: $96cefe9acc8d79bc$var$store,
    start: $96cefe9acc8d79bc$var$start,
    clone: $96cefe9acc8d79bc$var$clone,
    // INTERNAL
    cloneNode: $96cefe9acc8d79bc$var$cloneNode,
    // INTERNAL
    bound: $96cefe9acc8d79bc$var$getBinding,
    $data: $96cefe9acc8d79bc$var$scope,
    watch: $96cefe9acc8d79bc$var$watch,
    walk: $96cefe9acc8d79bc$var$walk,
    data: $96cefe9acc8d79bc$var$data,
    bind: $96cefe9acc8d79bc$var$bind2
};
var $96cefe9acc8d79bc$var$alpine_default = $96cefe9acc8d79bc$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $96cefe9acc8d79bc$var$makeMap(str, expectsLowerCase) {
    var map = /* @__PURE__ */ Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return !!map[val.toLowerCase()];
    } : function(val) {
        return !!map[val];
    };
}
var $96cefe9acc8d79bc$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $96cefe9acc8d79bc$var$isBooleanAttr2 = /* @__PURE__ */ $96cefe9acc8d79bc$var$makeMap($96cefe9acc8d79bc$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
var $96cefe9acc8d79bc$var$EMPTY_OBJ = Object.freeze({});
var $96cefe9acc8d79bc$var$EMPTY_ARR = Object.freeze([]);
var $96cefe9acc8d79bc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $96cefe9acc8d79bc$var$hasOwn = function(val, key) {
    return $96cefe9acc8d79bc$var$hasOwnProperty.call(val, key);
};
var $96cefe9acc8d79bc$var$isArray = Array.isArray;
var $96cefe9acc8d79bc$var$isMap = function(val) {
    return $96cefe9acc8d79bc$var$toTypeString(val) === "[object Map]";
};
var $96cefe9acc8d79bc$var$isString = function(val) {
    return typeof val === "string";
};
var $96cefe9acc8d79bc$var$isSymbol = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $j2WbH._)(val)) === "symbol";
};
var $96cefe9acc8d79bc$var$isObject = function(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $j2WbH._)(val)) === "object";
};
var $96cefe9acc8d79bc$var$objectToString = Object.prototype.toString;
var $96cefe9acc8d79bc$var$toTypeString = function(value) {
    return $96cefe9acc8d79bc$var$objectToString.call(value);
};
var $96cefe9acc8d79bc$var$toRawType = function(value) {
    return $96cefe9acc8d79bc$var$toTypeString(value).slice(8, -1);
};
var $96cefe9acc8d79bc$var$isIntegerKey = function(key) {
    return $96cefe9acc8d79bc$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $96cefe9acc8d79bc$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $96cefe9acc8d79bc$var$camelizeRE = /-(\w)/g;
var $96cefe9acc8d79bc$var$camelize = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str.replace($96cefe9acc8d79bc$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $96cefe9acc8d79bc$var$hyphenateRE = /\B([A-Z])/g;
var $96cefe9acc8d79bc$var$hyphenate = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str.replace($96cefe9acc8d79bc$var$hyphenateRE, "-$1").toLowerCase();
});
var $96cefe9acc8d79bc$var$capitalize = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $96cefe9acc8d79bc$var$toHandlerKey = $96cefe9acc8d79bc$var$cacheStringFunction(function(str) {
    return str ? "on".concat($96cefe9acc8d79bc$var$capitalize(str)) : "";
});
var $96cefe9acc8d79bc$var$hasChanged = function(value, oldValue) {
    return value !== oldValue && (value === value || oldValue === oldValue);
};
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $96cefe9acc8d79bc$var$targetMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$effectStack = [];
var $96cefe9acc8d79bc$var$activeEffect;
var $96cefe9acc8d79bc$var$ITERATE_KEY = Symbol("iterate");
var $96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $96cefe9acc8d79bc$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $96cefe9acc8d79bc$var$effect2(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $96cefe9acc8d79bc$var$EMPTY_OBJ;
    if ($96cefe9acc8d79bc$var$isEffect(fn)) fn = fn.raw;
    var effect3 = $96cefe9acc8d79bc$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $96cefe9acc8d79bc$var$stop(effect3) {
    if (effect3.active) {
        $96cefe9acc8d79bc$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $96cefe9acc8d79bc$var$uid = 0;
function $96cefe9acc8d79bc$var$createReactiveEffect(fn, options) {
    var effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$96cefe9acc8d79bc$var$effectStack.includes(effect3)) {
            $96cefe9acc8d79bc$var$cleanup(effect3);
            try {
                $96cefe9acc8d79bc$var$enableTracking();
                $96cefe9acc8d79bc$var$effectStack.push(effect3);
                $96cefe9acc8d79bc$var$activeEffect = effect3;
                return fn();
            } finally{
                $96cefe9acc8d79bc$var$effectStack.pop();
                $96cefe9acc8d79bc$var$resetTracking();
                $96cefe9acc8d79bc$var$activeEffect = $96cefe9acc8d79bc$var$effectStack[$96cefe9acc8d79bc$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $96cefe9acc8d79bc$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $96cefe9acc8d79bc$var$cleanup(effect3) {
    var deps = effect3.deps;
    if (deps.length) {
        for(var i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $96cefe9acc8d79bc$var$shouldTrack = true;
var $96cefe9acc8d79bc$var$trackStack = [];
function $96cefe9acc8d79bc$var$pauseTracking() {
    $96cefe9acc8d79bc$var$trackStack.push($96cefe9acc8d79bc$var$shouldTrack);
    $96cefe9acc8d79bc$var$shouldTrack = false;
}
function $96cefe9acc8d79bc$var$enableTracking() {
    $96cefe9acc8d79bc$var$trackStack.push($96cefe9acc8d79bc$var$shouldTrack);
    $96cefe9acc8d79bc$var$shouldTrack = true;
}
function $96cefe9acc8d79bc$var$resetTracking() {
    var last = $96cefe9acc8d79bc$var$trackStack.pop();
    $96cefe9acc8d79bc$var$shouldTrack = last === void 0 ? true : last;
}
function $96cefe9acc8d79bc$var$track(target, type, key) {
    if (!$96cefe9acc8d79bc$var$shouldTrack || $96cefe9acc8d79bc$var$activeEffect === void 0) return;
    var depsMap = $96cefe9acc8d79bc$var$targetMap.get(target);
    if (!depsMap) $96cefe9acc8d79bc$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    var dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($96cefe9acc8d79bc$var$activeEffect)) {
        dep.add($96cefe9acc8d79bc$var$activeEffect);
        $96cefe9acc8d79bc$var$activeEffect.deps.push(dep);
        if ($96cefe9acc8d79bc$var$activeEffect.options.onTrack) $96cefe9acc8d79bc$var$activeEffect.options.onTrack({
            effect: $96cefe9acc8d79bc$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $96cefe9acc8d79bc$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = $96cefe9acc8d79bc$var$targetMap.get(target);
    if (!depsMap) return;
    var effects = /* @__PURE__ */ new Set();
    var add2 = function(effectsToAdd) {
        if (effectsToAdd) effectsToAdd.forEach(function(effect3) {
            if (effect3 !== $96cefe9acc8d79bc$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $96cefe9acc8d79bc$var$isArray(target)) depsMap.forEach(function(dep, key2) {
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$96cefe9acc8d79bc$var$isArray(target)) {
                    add2(depsMap.get($96cefe9acc8d79bc$var$ITERATE_KEY));
                    if ($96cefe9acc8d79bc$var$isMap(target)) add2(depsMap.get($96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY));
                } else if ($96cefe9acc8d79bc$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$96cefe9acc8d79bc$var$isArray(target)) {
                    add2(depsMap.get($96cefe9acc8d79bc$var$ITERATE_KEY));
                    if ($96cefe9acc8d79bc$var$isMap(target)) add2(depsMap.get($96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($96cefe9acc8d79bc$var$isMap(target)) add2(depsMap.get($96cefe9acc8d79bc$var$ITERATE_KEY));
                break;
        }
    }
    var run = function(effect3) {
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $96cefe9acc8d79bc$var$isNonTrackableKeys = /* @__PURE__ */ $96cefe9acc8d79bc$var$makeMap("__proto__,__v_isRef,__isVue");
var $96cefe9acc8d79bc$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map(function(key) {
    return Symbol[key];
}).filter($96cefe9acc8d79bc$var$isSymbol));
var $96cefe9acc8d79bc$var$get2 = /* @__PURE__ */ $96cefe9acc8d79bc$var$createGetter();
var $96cefe9acc8d79bc$var$readonlyGet = /* @__PURE__ */ $96cefe9acc8d79bc$var$createGetter(true);
var $96cefe9acc8d79bc$var$arrayInstrumentations = /* @__PURE__ */ $96cefe9acc8d79bc$var$createArrayInstrumentations();
function $96cefe9acc8d79bc$var$createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = $96cefe9acc8d79bc$var$toRaw(this);
            for(var i = 0, l = this.length; i < l; i++)$96cefe9acc8d79bc$var$track(arr, "get", i + "");
            var res = (_arr = arr)[key].apply(_arr, (0, $cfh0a._)(args));
            if (res === -1 || res === false) return (_arr1 = arr)[key].apply(_arr1, (0, $cfh0a._)(args.map($96cefe9acc8d79bc$var$toRaw)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            $96cefe9acc8d79bc$var$pauseTracking();
            var res = $96cefe9acc8d79bc$var$toRaw(this)[key].apply(this, args);
            $96cefe9acc8d79bc$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $96cefe9acc8d79bc$var$createGetter() {
    var isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $96cefe9acc8d79bc$var$shallowReadonlyMap : $96cefe9acc8d79bc$var$readonlyMap : shallow ? $96cefe9acc8d79bc$var$shallowReactiveMap : $96cefe9acc8d79bc$var$reactiveMap).get(target)) return target;
        var targetIsArray = $96cefe9acc8d79bc$var$isArray(target);
        if (!isReadonly && targetIsArray && $96cefe9acc8d79bc$var$hasOwn($96cefe9acc8d79bc$var$arrayInstrumentations, key)) return Reflect.get($96cefe9acc8d79bc$var$arrayInstrumentations, key, receiver);
        var res = Reflect.get(target, key, receiver);
        if ($96cefe9acc8d79bc$var$isSymbol(key) ? $96cefe9acc8d79bc$var$builtInSymbols.has(key) : $96cefe9acc8d79bc$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $96cefe9acc8d79bc$var$track(target, "get", key);
        if (shallow) return res;
        if ($96cefe9acc8d79bc$var$isRef(res)) {
            var shouldUnwrap = !targetIsArray || !$96cefe9acc8d79bc$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($96cefe9acc8d79bc$var$isObject(res)) return isReadonly ? $96cefe9acc8d79bc$var$readonly(res) : $96cefe9acc8d79bc$var$reactive2(res);
        return res;
    };
}
var $96cefe9acc8d79bc$var$set2 = /* @__PURE__ */ $96cefe9acc8d79bc$var$createSetter();
function $96cefe9acc8d79bc$var$createSetter() {
    var shallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function set3(target, key, value, receiver) {
        var oldValue = target[key];
        if (!shallow) {
            value = $96cefe9acc8d79bc$var$toRaw(value);
            oldValue = $96cefe9acc8d79bc$var$toRaw(oldValue);
            if (!$96cefe9acc8d79bc$var$isArray(target) && $96cefe9acc8d79bc$var$isRef(oldValue) && !$96cefe9acc8d79bc$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        var hadKey = $96cefe9acc8d79bc$var$isArray(target) && $96cefe9acc8d79bc$var$isIntegerKey(key) ? Number(key) < target.length : $96cefe9acc8d79bc$var$hasOwn(target, key);
        var result = Reflect.set(target, key, value, receiver);
        if (target === $96cefe9acc8d79bc$var$toRaw(receiver)) {
            if (!hadKey) $96cefe9acc8d79bc$var$trigger(target, "add", key, value);
            else if ($96cefe9acc8d79bc$var$hasChanged(value, oldValue)) $96cefe9acc8d79bc$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $96cefe9acc8d79bc$var$deleteProperty(target, key) {
    var hadKey = $96cefe9acc8d79bc$var$hasOwn(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $96cefe9acc8d79bc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $96cefe9acc8d79bc$var$has(target, key) {
    var result = Reflect.has(target, key);
    if (!$96cefe9acc8d79bc$var$isSymbol(key) || !$96cefe9acc8d79bc$var$builtInSymbols.has(key)) $96cefe9acc8d79bc$var$track(target, "has", key);
    return result;
}
function $96cefe9acc8d79bc$var$ownKeys(target) {
    $96cefe9acc8d79bc$var$track(target, "iterate", $96cefe9acc8d79bc$var$isArray(target) ? "length" : $96cefe9acc8d79bc$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $96cefe9acc8d79bc$var$mutableHandlers = {
    get: $96cefe9acc8d79bc$var$get2,
    set: $96cefe9acc8d79bc$var$set2,
    deleteProperty: $96cefe9acc8d79bc$var$deleteProperty,
    has: $96cefe9acc8d79bc$var$has,
    ownKeys: $96cefe9acc8d79bc$var$ownKeys
};
var $96cefe9acc8d79bc$var$readonlyHandlers = {
    get: $96cefe9acc8d79bc$var$readonlyGet,
    set: function(target, key) {
        console.warn('Set operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    },
    deleteProperty: function(target, key) {
        console.warn('Delete operation on key "'.concat(String(key), '" failed: target is readonly.'), target);
        return true;
    }
};
var $96cefe9acc8d79bc$var$toReactive = function(value) {
    return $96cefe9acc8d79bc$var$isObject(value) ? $96cefe9acc8d79bc$var$reactive2(value) : value;
};
var $96cefe9acc8d79bc$var$toReadonly = function(value) {
    return $96cefe9acc8d79bc$var$isObject(value) ? $96cefe9acc8d79bc$var$readonly(value) : value;
};
var $96cefe9acc8d79bc$var$toShallow = function(value) {
    return value;
};
var $96cefe9acc8d79bc$var$getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function $96cefe9acc8d79bc$var$get$1(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    target = target["__v_raw"];
    var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
    var rawKey = $96cefe9acc8d79bc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "get", key);
    !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "get", rawKey);
    var _getProto = $96cefe9acc8d79bc$var$getProto(rawTarget), has2 = _getProto.has;
    var wrap = isShallow ? $96cefe9acc8d79bc$var$toShallow : isReadonly ? $96cefe9acc8d79bc$var$toReadonly : $96cefe9acc8d79bc$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $96cefe9acc8d79bc$var$has$1(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw"];
    var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
    var rawKey = $96cefe9acc8d79bc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "has", key);
    !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $96cefe9acc8d79bc$var$size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw"];
    !isReadonly && $96cefe9acc8d79bc$var$track($96cefe9acc8d79bc$var$toRaw(target), "iterate", $96cefe9acc8d79bc$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $96cefe9acc8d79bc$var$add(value) {
    value = $96cefe9acc8d79bc$var$toRaw(value);
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var proto = $96cefe9acc8d79bc$var$getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $96cefe9acc8d79bc$var$trigger(target, "add", value, value);
    }
    return this;
}
function $96cefe9acc8d79bc$var$set$1(key, value) {
    value = $96cefe9acc8d79bc$var$toRaw(value);
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var _getProto = $96cefe9acc8d79bc$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $96cefe9acc8d79bc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $96cefe9acc8d79bc$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $96cefe9acc8d79bc$var$trigger(target, "add", key, value);
    else if ($96cefe9acc8d79bc$var$hasChanged(value, oldValue)) $96cefe9acc8d79bc$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $96cefe9acc8d79bc$var$deleteEntry(key) {
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var _getProto = $96cefe9acc8d79bc$var$getProto(target), has2 = _getProto.has, get3 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $96cefe9acc8d79bc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $96cefe9acc8d79bc$var$checkIdentityKeys(target, has2, key);
    var oldValue = get3 ? get3.call(target, key) : void 0;
    var result = target.delete(key);
    if (hadKey) $96cefe9acc8d79bc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $96cefe9acc8d79bc$var$clear() {
    var target = $96cefe9acc8d79bc$var$toRaw(this);
    var hadItems = target.size !== 0;
    var oldTarget = $96cefe9acc8d79bc$var$isMap(target) ? new Map(target) : new Set(target);
    var result = target.clear();
    if (hadItems) $96cefe9acc8d79bc$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $96cefe9acc8d79bc$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw"];
        var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
        var wrap = isShallow ? $96cefe9acc8d79bc$var$toShallow : isReadonly ? $96cefe9acc8d79bc$var$toReadonly : $96cefe9acc8d79bc$var$toReactive;
        !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "iterate", $96cefe9acc8d79bc$var$ITERATE_KEY);
        return target.forEach(function(value, key) {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $96cefe9acc8d79bc$var$createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = $96cefe9acc8d79bc$var$toRaw(target);
        var targetIsMap = $96cefe9acc8d79bc$var$isMap(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $cfh0a._)(args));
        var wrap = isShallow ? $96cefe9acc8d79bc$var$toShallow : isReadonly ? $96cefe9acc8d79bc$var$toReadonly : $96cefe9acc8d79bc$var$toReactive;
        !isReadonly && $96cefe9acc8d79bc$var$track(rawTarget, "iterate", isKeyOnly ? $96cefe9acc8d79bc$var$MAP_KEY_ITERATE_KEY : $96cefe9acc8d79bc$var$ITERATE_KEY);
        return(// iterable protocol
        (0, $37e80ca29cd951d6$export$71511d61b312f219)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function $96cefe9acc8d79bc$var$createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        {
            var key = args[0] ? 'on key "'.concat(args[0], '" ') : "";
            console.warn("".concat($96cefe9acc8d79bc$var$capitalize(type), " operation ").concat(key, "failed: target is readonly."), $96cefe9acc8d79bc$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $96cefe9acc8d79bc$var$createInstrumentations() {
    var mutableInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this);
        },
        has: $96cefe9acc8d79bc$var$has$1,
        add: $96cefe9acc8d79bc$var$add,
        set: $96cefe9acc8d79bc$var$set$1,
        delete: $96cefe9acc8d79bc$var$deleteEntry,
        clear: $96cefe9acc8d79bc$var$clear,
        forEach: $96cefe9acc8d79bc$var$createForEach(false, false)
    };
    var shallowInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key, false, true);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this);
        },
        has: $96cefe9acc8d79bc$var$has$1,
        add: $96cefe9acc8d79bc$var$add,
        set: $96cefe9acc8d79bc$var$set$1,
        delete: $96cefe9acc8d79bc$var$deleteEntry,
        clear: $96cefe9acc8d79bc$var$clear,
        forEach: $96cefe9acc8d79bc$var$createForEach(false, true)
    };
    var readonlyInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key, true);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this, true);
        },
        has: function(key) {
            return $96cefe9acc8d79bc$var$has$1.call(this, key, true);
        },
        add: $96cefe9acc8d79bc$var$createReadonlyMethod("add"),
        set: $96cefe9acc8d79bc$var$createReadonlyMethod("set"),
        delete: $96cefe9acc8d79bc$var$createReadonlyMethod("delete"),
        clear: $96cefe9acc8d79bc$var$createReadonlyMethod("clear"),
        forEach: $96cefe9acc8d79bc$var$createForEach(true, false)
    };
    var shallowReadonlyInstrumentations2 = {
        get: function(key) {
            return $96cefe9acc8d79bc$var$get$1(this, key, true, true);
        },
        get size () {
            return $96cefe9acc8d79bc$var$size(this, true);
        },
        has: function(key) {
            return $96cefe9acc8d79bc$var$has$1.call(this, key, true);
        },
        add: $96cefe9acc8d79bc$var$createReadonlyMethod("add"),
        set: $96cefe9acc8d79bc$var$createReadonlyMethod("set"),
        delete: $96cefe9acc8d79bc$var$createReadonlyMethod("delete"),
        clear: $96cefe9acc8d79bc$var$createReadonlyMethod("clear"),
        forEach: $96cefe9acc8d79bc$var$createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $96cefe9acc8d79bc$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var /* @__PURE__ */ $96cefe9acc8d79bc$var$_createInstrumentations = (0, $40EBy._)($96cefe9acc8d79bc$var$createInstrumentations(), 4), $96cefe9acc8d79bc$var$mutableInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[0], $96cefe9acc8d79bc$var$readonlyInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[1], $96cefe9acc8d79bc$var$shallowInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[2], $96cefe9acc8d79bc$var$shallowReadonlyInstrumentations = $96cefe9acc8d79bc$var$_createInstrumentations[3];
function $96cefe9acc8d79bc$var$createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? $96cefe9acc8d79bc$var$shallowReadonlyInstrumentations : $96cefe9acc8d79bc$var$shallowInstrumentations : isReadonly ? $96cefe9acc8d79bc$var$readonlyInstrumentations : $96cefe9acc8d79bc$var$mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($96cefe9acc8d79bc$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $96cefe9acc8d79bc$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $96cefe9acc8d79bc$var$createInstrumentationGetter(false, false)
};
var $96cefe9acc8d79bc$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $96cefe9acc8d79bc$var$createInstrumentationGetter(true, false)
};
function $96cefe9acc8d79bc$var$checkIdentityKeys(target, has2, key) {
    var rawKey = $96cefe9acc8d79bc$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        var type = $96cefe9acc8d79bc$var$toRawType(target);
        console.warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var $96cefe9acc8d79bc$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $96cefe9acc8d79bc$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $96cefe9acc8d79bc$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $96cefe9acc8d79bc$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $96cefe9acc8d79bc$var$targetTypeMap($96cefe9acc8d79bc$var$toRawType(value));
}
function $96cefe9acc8d79bc$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $96cefe9acc8d79bc$var$createReactiveObject(target, false, $96cefe9acc8d79bc$var$mutableHandlers, $96cefe9acc8d79bc$var$mutableCollectionHandlers, $96cefe9acc8d79bc$var$reactiveMap);
}
function $96cefe9acc8d79bc$var$readonly(target) {
    return $96cefe9acc8d79bc$var$createReactiveObject(target, true, $96cefe9acc8d79bc$var$readonlyHandlers, $96cefe9acc8d79bc$var$readonlyCollectionHandlers, $96cefe9acc8d79bc$var$readonlyMap);
}
function $96cefe9acc8d79bc$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$96cefe9acc8d79bc$var$isObject(target)) {
        console.warn("value cannot be made reactive: ".concat(String(target)));
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = $96cefe9acc8d79bc$var$getTargetType(target);
    if (targetType === 0) return target;
    var proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $96cefe9acc8d79bc$var$toRaw(observed) {
    return observed && $96cefe9acc8d79bc$var$toRaw(observed["__v_raw"]) || observed;
}
function $96cefe9acc8d79bc$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$96cefe9acc8d79bc$var$magic("nextTick", function() {
    return $96cefe9acc8d79bc$var$nextTick;
});
// packages/alpinejs/src/magics/$dispatch.js
$96cefe9acc8d79bc$var$magic("dispatch", function(el) {
    return $96cefe9acc8d79bc$var$dispatch.bind($96cefe9acc8d79bc$var$dispatch, el);
});
// packages/alpinejs/src/magics/$watch.js
$96cefe9acc8d79bc$var$magic("watch", function(el, param) {
    var evaluateLater2 = param.evaluateLater, cleanup2 = param.cleanup;
    return function(key, callback) {
        var evaluate2 = evaluateLater2(key);
        var getter = function() {
            var value;
            evaluate2(function(i) {
                return value = i;
            });
            return value;
        };
        var unwatch = $96cefe9acc8d79bc$var$watch(getter, callback);
        cleanup2(unwatch);
    };
});
// packages/alpinejs/src/magics/$store.js
$96cefe9acc8d79bc$var$magic("store", $96cefe9acc8d79bc$var$getStores);
// packages/alpinejs/src/magics/$data.js
$96cefe9acc8d79bc$var$magic("data", function(el) {
    return $96cefe9acc8d79bc$var$scope(el);
});
// packages/alpinejs/src/magics/$root.js
$96cefe9acc8d79bc$var$magic("root", function(el) {
    return $96cefe9acc8d79bc$var$closestRoot(el);
});
// packages/alpinejs/src/magics/$refs.js
$96cefe9acc8d79bc$var$magic("refs", function(el) {
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $96cefe9acc8d79bc$var$mergeProxies($96cefe9acc8d79bc$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $96cefe9acc8d79bc$var$getArrayOfRefObject(el) {
    var refObjects = [];
    $96cefe9acc8d79bc$var$findClosest(el, function(i) {
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $96cefe9acc8d79bc$var$globalIdMemo = {};
function $96cefe9acc8d79bc$var$findAndIncrementId(name) {
    if (!$96cefe9acc8d79bc$var$globalIdMemo[name]) $96cefe9acc8d79bc$var$globalIdMemo[name] = 0;
    return ++$96cefe9acc8d79bc$var$globalIdMemo[name];
}
function $96cefe9acc8d79bc$var$closestIdRoot(el, name) {
    return $96cefe9acc8d79bc$var$findClosest(el, function(element) {
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $96cefe9acc8d79bc$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $96cefe9acc8d79bc$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$96cefe9acc8d79bc$var$magic("id", function(el, param) {
    var cleanup2 = param.cleanup;
    return function(name) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        var cacheKey = "".concat(name).concat(key ? "-".concat(key) : "");
        return $96cefe9acc8d79bc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, function() {
            var root = $96cefe9acc8d79bc$var$closestIdRoot(el, name);
            var id = root ? root._x_ids[name] : $96cefe9acc8d79bc$var$findAndIncrementId(name);
            return key ? "".concat(name, "-").concat(id, "-").concat(key) : "".concat(name, "-").concat(id);
        });
    };
});
$96cefe9acc8d79bc$var$interceptClone(function(from, to) {
    if (from._x_id) to._x_id = from._x_id;
});
function $96cefe9acc8d79bc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    var output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(function() {
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$96cefe9acc8d79bc$var$magic("el", function(el) {
    return el;
});
// packages/alpinejs/src/magics/index.js
$96cefe9acc8d79bc$var$warnMissingPluginMagic("Focus", "focus", "focus");
$96cefe9acc8d79bc$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $96cefe9acc8d79bc$var$warnMissingPluginMagic(name, magicName, slug) {
    $96cefe9acc8d79bc$var$magic(magicName, function(el) {
        return $96cefe9acc8d79bc$var$warn("You can't use [$".concat(magicName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/directives/x-modelable.js
$96cefe9acc8d79bc$var$directive("modelable", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater, cleanup2 = param1.cleanup;
    var func = evaluateLater2(expression);
    var innerGet = function() {
        var result;
        func(function(i) {
            return result = i;
        });
        return result;
    };
    var evaluateInnerSet = evaluateLater2("".concat(expression, " = __placeholder"));
    var innerSet = function(val) {
        return evaluateInnerSet(function() {}, {
            scope: {
                "__placeholder": val
            }
        });
    };
    var initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(function() {
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        var outerGet = el._x_model.get;
        var outerSet = el._x_model.set;
        var releaseEntanglement = $96cefe9acc8d79bc$var$entangle({
            get: function() {
                return outerGet();
            },
            set: function(value) {
                outerSet(value);
            }
        }, {
            get: function() {
                return innerGet();
            },
            set: function(value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$96cefe9acc8d79bc$var$directive("teleport", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $96cefe9acc8d79bc$var$warn("x-teleport can only be used on a <template> tag", el);
    var target = $96cefe9acc8d79bc$var$getTarget(expression);
    var clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach(function(eventName) {
        clone2.addEventListener(eventName, function(e) {
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $96cefe9acc8d79bc$var$addScopeToNode(clone2, {}, el);
    var placeInDom = function(clone3, target2, modifiers2) {
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $96cefe9acc8d79bc$var$mutateDom(function() {
        placeInDom(clone2, target, modifiers);
        $96cefe9acc8d79bc$var$skipDuringClone(function() {
            $96cefe9acc8d79bc$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = function() {
        var target2 = $96cefe9acc8d79bc$var$getTarget(expression);
        $96cefe9acc8d79bc$var$mutateDom(function() {
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(function() {
        return $96cefe9acc8d79bc$var$mutateDom(function() {
            clone2.remove();
            $96cefe9acc8d79bc$var$destroyTree(clone2);
        });
    });
});
var $96cefe9acc8d79bc$var$teleportContainerDuringClone = document.createElement("div");
function $96cefe9acc8d79bc$var$getTarget(expression) {
    var target = $96cefe9acc8d79bc$var$skipDuringClone(function() {
        return document.querySelector(expression);
    }, function() {
        return $96cefe9acc8d79bc$var$teleportContainerDuringClone;
    })();
    if (!target) $96cefe9acc8d79bc$var$warn('Cannot find x-teleport element for selector: "'.concat(expression, '"'));
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $96cefe9acc8d79bc$var$handler = function() {};
$96cefe9acc8d79bc$var$handler.inline = function(el, param, param1) {
    var modifiers = param.modifiers, cleanup2 = param1.cleanup;
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(function() {
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$96cefe9acc8d79bc$var$directive("ignore", $96cefe9acc8d79bc$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$96cefe9acc8d79bc$var$directive("effect", $96cefe9acc8d79bc$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect;
    effect3($96cefe9acc8d79bc$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $96cefe9acc8d79bc$var$on(el, event, modifiers, callback) {
    var listenerTarget = el;
    var handler4 = function(e) {
        return callback(e);
    };
    var options = {};
    var wrapHandler = function(callback2, wrapper) {
        return function(e) {
            return wrapper(callback2, e);
        };
    };
    if (modifiers.includes("dot")) event = $96cefe9acc8d79bc$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $96cefe9acc8d79bc$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        var nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        var wait = $96cefe9acc8d79bc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $96cefe9acc8d79bc$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        var nextModifier1 = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        var wait1 = $96cefe9acc8d79bc$var$isNumeric(nextModifier1.split("ms")[0]) ? Number(nextModifier1.split("ms")[0]) : 250;
        handler4 = $96cefe9acc8d79bc$var$throttle(handler4, wait1);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, function(next, e) {
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, function(next, e) {
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, function(next, e) {
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, function(next, e) {
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, function(next, e) {
        e.target === el && next(e);
    });
    if ($96cefe9acc8d79bc$var$isKeyEvent(event) || $96cefe9acc8d79bc$var$isClickEvent(event)) handler4 = wrapHandler(handler4, function(next, e) {
        if ($96cefe9acc8d79bc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return function() {
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $96cefe9acc8d79bc$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $96cefe9acc8d79bc$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, function(match, char) {
        return char.toUpperCase();
    });
}
function $96cefe9acc8d79bc$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $96cefe9acc8d79bc$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $96cefe9acc8d79bc$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $96cefe9acc8d79bc$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some(function(i) {
        return event.includes(i);
    });
}
function $96cefe9acc8d79bc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    var keyModifiers = modifiers.filter(function(i) {
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        var debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $96cefe9acc8d79bc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        var debounceIndex1 = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex1, $96cefe9acc8d79bc$var$isNumeric((keyModifiers[debounceIndex1 + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $96cefe9acc8d79bc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    var systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    var selectedSystemKeyModifiers = systemKeyModifiers.filter(function(modifier) {
        return keyModifiers.includes(modifier);
    });
    keyModifiers = keyModifiers.filter(function(i) {
        return !selectedSystemKeyModifiers.includes(i);
    });
    if (selectedSystemKeyModifiers.length > 0) {
        var activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter(function(modifier) {
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e["".concat(modifier, "Key")];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($96cefe9acc8d79bc$var$isClickEvent(e.type)) return false;
            if ($96cefe9acc8d79bc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $96cefe9acc8d79bc$var$keyToModifiers(key) {
    if (!key) return [];
    key = $96cefe9acc8d79bc$var$kebabCase2(key);
    var modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map(function(modifier) {
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter(function(modifier) {
        return modifier;
    });
}
// packages/alpinejs/src/directives/x-model.js
$96cefe9acc8d79bc$var$directive("model", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    var evaluateGet = $96cefe9acc8d79bc$var$evaluateLater(scopeTarget, expression);
    var evaluateSet;
    if (typeof expression === "string") evaluateSet = $96cefe9acc8d79bc$var$evaluateLater(scopeTarget, "".concat(expression, " = __placeholder"));
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $96cefe9acc8d79bc$var$evaluateLater(scopeTarget, "".concat(expression(), " = __placeholder"));
    else evaluateSet = function() {};
    var getValue = function() {
        var result;
        evaluateGet(function(value) {
            return result = value;
        });
        return $96cefe9acc8d79bc$var$isGetterSetter(result) ? result.get() : result;
    };
    var setValue = function(value) {
        var result;
        evaluateGet(function(value2) {
            return result = value2;
        });
        if ($96cefe9acc8d79bc$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(function() {}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $96cefe9acc8d79bc$var$mutateDom(function() {
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    var removeListener = $96cefe9acc8d79bc$var$isCloning ? function() {} : $96cefe9acc8d79bc$var$on(el, event, modifiers, function(e) {
        setValue($96cefe9acc8d79bc$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $96cefe9acc8d79bc$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($96cefe9acc8d79bc$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(function() {
        return el._x_removeModelListeners["default"]();
    });
    if (el.form) {
        var removeResetListener = $96cefe9acc8d79bc$var$on(el.form, "reset", [], function(e) {
            $96cefe9acc8d79bc$var$nextTick(function() {
                return el._x_model && el._x_model.set($96cefe9acc8d79bc$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue()));
            });
        });
        cleanup2(function() {
            return removeResetListener();
        });
    }
    el._x_model = {
        get: function() {
            return getValue();
        },
        set: function(value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = function(value) {
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $96cefe9acc8d79bc$var$mutateDom(function() {
            return $96cefe9acc8d79bc$var$bind(el, "value", value);
        });
        delete window.fromModel;
    };
    effect3(function() {
        var value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $96cefe9acc8d79bc$var$getInputValue(el, modifiers, event, currentValue) {
    return $96cefe9acc8d79bc$var$mutateDom(function() {
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($96cefe9acc8d79bc$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                var newValue = null;
                if (modifiers.includes("number")) newValue = $96cefe9acc8d79bc$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $96cefe9acc8d79bc$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter(function(el2) {
                    return !$96cefe9acc8d79bc$var$checkedAttrLooseCompare2(el2, newValue);
                });
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $96cefe9acc8d79bc$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map(function(option) {
                var rawValue = option.value || option.text;
                return $96cefe9acc8d79bc$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map(function(option) {
                return option.value || option.text;
            });
        } else {
            var newValue1;
            if ($96cefe9acc8d79bc$var$isRadio(el)) {
                if (event.target.checked) newValue1 = event.target.value;
                else newValue1 = currentValue;
            } else newValue1 = event.target.value;
            if (modifiers.includes("number")) return $96cefe9acc8d79bc$var$safeParseNumber(newValue1);
            else if (modifiers.includes("boolean")) return $96cefe9acc8d79bc$var$safeParseBoolean(newValue1);
            else if (modifiers.includes("trim")) return newValue1.trim();
            else return newValue1;
        }
    });
}
function $96cefe9acc8d79bc$var$safeParseNumber(rawValue) {
    var number = rawValue ? parseFloat(rawValue) : null;
    return $96cefe9acc8d79bc$var$isNumeric2(number) ? number : rawValue;
}
function $96cefe9acc8d79bc$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $96cefe9acc8d79bc$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $96cefe9acc8d79bc$var$isGetterSetter(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $j2WbH._)(value)) === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$96cefe9acc8d79bc$var$directive("cloak", function(el) {
    return queueMicrotask(function() {
        return $96cefe9acc8d79bc$var$mutateDom(function() {
            return el.removeAttribute($96cefe9acc8d79bc$var$prefix("cloak"));
        });
    });
});
// packages/alpinejs/src/directives/x-init.js
$96cefe9acc8d79bc$var$addInitSelector(function() {
    return "[".concat($96cefe9acc8d79bc$var$prefix("init"), "]");
});
$96cefe9acc8d79bc$var$directive("init", $96cefe9acc8d79bc$var$skipDuringClone(function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$96cefe9acc8d79bc$var$directive("text", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $96cefe9acc8d79bc$var$mutateDom(function() {
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$96cefe9acc8d79bc$var$directive("html", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, evaluateLater2 = param1.evaluateLater;
    var evaluate2 = evaluateLater2(expression);
    effect3(function() {
        evaluate2(function(value) {
            $96cefe9acc8d79bc$var$mutateDom(function() {
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $96cefe9acc8d79bc$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$96cefe9acc8d79bc$var$mapAttributes($96cefe9acc8d79bc$var$startingWith(":", $96cefe9acc8d79bc$var$into($96cefe9acc8d79bc$var$prefix("bind:"))));
var $96cefe9acc8d79bc$var$handler2 = function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, original = param.original, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (!value) {
        var bindingProviders = {};
        $96cefe9acc8d79bc$var$injectBindingProviders(bindingProviders);
        var getBindings = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
        getBindings(function(bindings) {
            $96cefe9acc8d79bc$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $96cefe9acc8d79bc$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    var evaluate2 = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
    effect3(function() {
        return evaluate2(function(result) {
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $96cefe9acc8d79bc$var$mutateDom(function() {
                return $96cefe9acc8d79bc$var$bind(el, value, result, modifiers);
            });
        });
    });
    cleanup2(function() {
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$96cefe9acc8d79bc$var$handler2.inline = function(el, param) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression;
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$96cefe9acc8d79bc$var$directive("bind", $96cefe9acc8d79bc$var$handler2);
function $96cefe9acc8d79bc$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$96cefe9acc8d79bc$var$addRootSelector(function() {
    return "[".concat($96cefe9acc8d79bc$var$prefix("data"), "]");
});
$96cefe9acc8d79bc$var$directive("data", function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    if ($96cefe9acc8d79bc$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    var magicContext = {};
    $96cefe9acc8d79bc$var$injectMagics(magicContext, el);
    var dataProviderContext = {};
    $96cefe9acc8d79bc$var$injectDataProviders(dataProviderContext, magicContext);
    var data2 = $96cefe9acc8d79bc$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $96cefe9acc8d79bc$var$injectMagics(data2, el);
    var reactiveData = $96cefe9acc8d79bc$var$reactive(data2);
    $96cefe9acc8d79bc$var$initInterceptors(reactiveData);
    var undo = $96cefe9acc8d79bc$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $96cefe9acc8d79bc$var$evaluate(el, reactiveData["init"]);
    cleanup2(function() {
        reactiveData["destroy"] && $96cefe9acc8d79bc$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$96cefe9acc8d79bc$var$interceptClone(function(from, to) {
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $96cefe9acc8d79bc$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$96cefe9acc8d79bc$var$isCloning) return false;
    if ($96cefe9acc8d79bc$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$96cefe9acc8d79bc$var$directive("show", function(el, param, param1) {
    var modifiers = param.modifiers, expression = param.expression, effect3 = param1.effect;
    var evaluate2 = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = function() {
        $96cefe9acc8d79bc$var$mutateDom(function() {
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = function() {
        $96cefe9acc8d79bc$var$mutateDom(function() {
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    var hide = function() {
        el._x_doHide();
        el._x_isShown = false;
    };
    var show = function() {
        el._x_doShow();
        el._x_isShown = true;
    };
    var clickAwayCompatibleShow = function() {
        return setTimeout(show);
    };
    var toggle = $96cefe9acc8d79bc$var$once(function(value) {
        return value ? show() : hide();
    }, function(value) {
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    var oldValue;
    var firstTime = true;
    effect3(function() {
        return evaluate2(function(value) {
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        });
    });
});
// packages/alpinejs/src/directives/x-for.js
$96cefe9acc8d79bc$var$directive("for", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    var iteratorNames = $96cefe9acc8d79bc$var$parseForExpression(expression);
    var evaluateItems = $96cefe9acc8d79bc$var$evaluateLater(el, iteratorNames.items);
    var evaluateKey = $96cefe9acc8d79bc$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(function() {
        return $96cefe9acc8d79bc$var$loop(el, iteratorNames, evaluateItems, evaluateKey);
    });
    cleanup2(function() {
        Object.values(el._x_lookup).forEach(function(el2) {
            return $96cefe9acc8d79bc$var$mutateDom(function() {
                $96cefe9acc8d79bc$var$destroyTree(el2);
                el2.remove();
            });
        });
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $96cefe9acc8d79bc$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    var isObject2 = function(i) {
        return (typeof i === "undefined" ? "undefined" : (0, $j2WbH._)(i)) === "object" && !Array.isArray(i);
    };
    var templateEl = el;
    evaluateItems(function(items) {
        var _loop = function(i3) {
            var key = removes[i3];
            if (!(key in lookup)) return "continue";
            $96cefe9acc8d79bc$var$mutateDom(function() {
                $96cefe9acc8d79bc$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }, _loop1 = function(i4) {
            var _moves_i = (0, $40EBy._)(moves[i4], 2), keyInSpot = _moves_i[0], keyForSpot = _moves_i[1];
            var elInSpot = lookup[keyInSpot];
            var elForSpot = lookup[keyForSpot];
            var marker = document.createElement("div");
            $96cefe9acc8d79bc$var$mutateDom(function() {
                if (!elForSpot) $96cefe9acc8d79bc$var$warn('x-for ":key" is undefined or invalid', templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }, _loop2 = function(i5) {
            var _adds_i = (0, $40EBy._)(adds[i5], 2), lastKey2 = _adds_i[0], index = _adds_i[1];
            var lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            var scope2 = scopes[index];
            var key = keys[index];
            var clone2 = document.importNode(templateEl.content, true).firstElementChild;
            var reactiveScope = $96cefe9acc8d79bc$var$reactive(scope2);
            $96cefe9acc8d79bc$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = function(newScope) {
                Object.entries(newScope).forEach(function(param) {
                    var _param = (0, $40EBy._)(param, 2), key2 = _param[0], value = _param[1];
                    reactiveScope[key2] = value;
                });
            };
            $96cefe9acc8d79bc$var$mutateDom(function() {
                lastEl.after(clone2);
                $96cefe9acc8d79bc$var$skipDuringClone(function() {
                    return $96cefe9acc8d79bc$var$initTree(clone2);
                })();
            });
            if ((typeof key === "undefined" ? "undefined" : (0, $j2WbH._)(key)) === "object") $96cefe9acc8d79bc$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        };
        if ($96cefe9acc8d79bc$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), function(i) {
            return i + 1;
        });
        if (items === void 0) items = [];
        var lookup = el._x_lookup;
        var prevKeys = el._x_prevKeys;
        var scopes = [];
        var keys = [];
        if (isObject2(items)) items = Object.entries(items).map(function(param) {
            var _param = (0, $40EBy._)(param, 2), key = _param[0], value = _param[1];
            var scope2 = $96cefe9acc8d79bc$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey(function(value2) {
                if (keys.includes(value2)) $96cefe9acc8d79bc$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: (0, $a9846c98c872cb75$export$71511d61b312f219)({
                    index: key
                }, scope2)
            });
            scopes.push(scope2);
        });
        else for(var i = 0; i < items.length; i++){
            var scope2 = $96cefe9acc8d79bc$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey(function(value) {
                if (keys.includes(value)) $96cefe9acc8d79bc$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: (0, $a9846c98c872cb75$export$71511d61b312f219)({
                    index: i
                }, scope2)
            });
            scopes.push(scope2);
        }
        var adds = [];
        var moves = [];
        var removes = [];
        var sames = [];
        for(var i1 = 0; i1 < prevKeys.length; i1++){
            var key = prevKeys[i1];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter(function(key) {
            return !removes.includes(key);
        });
        var lastKey = "template";
        for(var i2 = 0; i2 < keys.length; i2++){
            var key1 = keys[i2];
            var prevIndex = prevKeys.indexOf(key1);
            if (prevIndex === -1) {
                prevKeys.splice(i2, 0, key1);
                adds.push([
                    lastKey,
                    i2
                ]);
            } else if (prevIndex !== i2) {
                var keyInSpot = prevKeys.splice(i2, 1)[0];
                var keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i2, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key1);
            lastKey = key1;
        }
        for(var i3 = 0; i3 < removes.length; i3++)_loop(i3);
        for(var i4 = 0; i4 < moves.length; i4++)_loop1(i4);
        for(var i5 = 0; i5 < adds.length; i5++)_loop2(i5);
        for(var i6 = 0; i6 < sames.length; i6++)lookup[sames[i6]]._x_refreshXForScope(scopes[keys.indexOf(sames[i6])]);
        templateEl._x_prevKeys = keys;
    });
}
function $96cefe9acc8d79bc$var$parseForExpression(expression) {
    var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    var stripParensRE = /^\s*\(|\)\s*$/g;
    var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    var inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    var res = {};
    res.items = inMatch[2].trim();
    var item = inMatch[1].replace(stripParensRE, "").trim();
    var iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $96cefe9acc8d79bc$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    var scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        var names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map(function(i) {
            return i.trim();
        });
        names.forEach(function(name, i) {
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && (typeof item === "undefined" ? "undefined" : (0, $j2WbH._)(item)) === "object") {
        var names1 = iteratorNames.item.replace("{", "").replace("}", "").split(",").map(function(i) {
            return i.trim();
        });
        names1.forEach(function(name) {
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $96cefe9acc8d79bc$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $96cefe9acc8d79bc$var$handler3() {}
$96cefe9acc8d79bc$var$handler3.inline = function(el, param, param1) {
    var expression = param.expression, cleanup2 = param1.cleanup;
    var root = $96cefe9acc8d79bc$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(function() {
        return delete root._x_refs[expression];
    });
};
$96cefe9acc8d79bc$var$directive("ref", $96cefe9acc8d79bc$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$96cefe9acc8d79bc$var$directive("if", function(el, param, param1) {
    var expression = param.expression, effect3 = param1.effect, cleanup2 = param1.cleanup;
    if (el.tagName.toLowerCase() !== "template") $96cefe9acc8d79bc$var$warn("x-if can only be used on a <template> tag", el);
    var evaluate2 = $96cefe9acc8d79bc$var$evaluateLater(el, expression);
    var show = function() {
        if (el._x_currentIfEl) return el._x_currentIfEl;
        var clone2 = el.content.cloneNode(true).firstElementChild;
        $96cefe9acc8d79bc$var$addScopeToNode(clone2, {}, el);
        $96cefe9acc8d79bc$var$mutateDom(function() {
            el.after(clone2);
            $96cefe9acc8d79bc$var$skipDuringClone(function() {
                return $96cefe9acc8d79bc$var$initTree(clone2);
            })();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = function() {
            $96cefe9acc8d79bc$var$mutateDom(function() {
                $96cefe9acc8d79bc$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    var hide = function() {
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(function() {
        return evaluate2(function(value) {
            value ? show() : hide();
        });
    });
    cleanup2(function() {
        return el._x_undoIf && el._x_undoIf();
    });
});
// packages/alpinejs/src/directives/x-id.js
$96cefe9acc8d79bc$var$directive("id", function(el, param, param1) {
    var expression = param.expression, evaluate2 = param1.evaluate;
    var names = evaluate2(expression);
    names.forEach(function(name) {
        return $96cefe9acc8d79bc$var$setIdRoot(el, name);
    });
});
$96cefe9acc8d79bc$var$interceptClone(function(from, to) {
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$96cefe9acc8d79bc$var$mapAttributes($96cefe9acc8d79bc$var$startingWith("@", $96cefe9acc8d79bc$var$into($96cefe9acc8d79bc$var$prefix("on:"))));
$96cefe9acc8d79bc$var$directive("on", $96cefe9acc8d79bc$var$skipDuringClone(function(el, param, param1) {
    var value = param.value, modifiers = param.modifiers, expression = param.expression, cleanup2 = param1.cleanup;
    var evaluate2 = expression ? $96cefe9acc8d79bc$var$evaluateLater(el, expression) : function() {};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    var removeListener = $96cefe9acc8d79bc$var$on(el, value, modifiers, function(e) {
        evaluate2(function() {}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(function() {
        return removeListener();
    });
}));
// packages/alpinejs/src/directives/index.js
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Focus", "trap", "focus");
$96cefe9acc8d79bc$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $96cefe9acc8d79bc$var$warnMissingPluginDirective(name, directiveName, slug) {
    $96cefe9acc8d79bc$var$directive(directiveName, function(el) {
        return $96cefe9acc8d79bc$var$warn("You can't use [x-".concat(directiveName, '] without first installing the "').concat(name, '" plugin here: https://alpinejs.dev/plugins/').concat(slug), el);
    });
}
// packages/alpinejs/src/index.js
$96cefe9acc8d79bc$var$alpine_default.setEvaluator($96cefe9acc8d79bc$var$normalEvaluator);
$96cefe9acc8d79bc$var$alpine_default.setReactivityEngine({
    reactive: $96cefe9acc8d79bc$var$reactive2,
    effect: $96cefe9acc8d79bc$var$effect2,
    release: $96cefe9acc8d79bc$var$stop,
    raw: $96cefe9acc8d79bc$var$toRaw
});
var $96cefe9acc8d79bc$export$b7ee041e4ad2afec = $96cefe9acc8d79bc$var$alpine_default;
// packages/alpinejs/builds/module.js
var $96cefe9acc8d79bc$export$2e2bcd8739ae039 = $96cefe9acc8d79bc$export$b7ee041e4ad2afec;


// packages/persist/src/index.js
function $7b893ccb2c005aae$export$9a6132153fba2e0(Alpine) {
    var persist = function() {
        var alias;
        var storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            var dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor(function(initialValue, getter, setter, path, key) {
            var lookup = alias || "_x_".concat(path);
            var initial = $7b893ccb2c005aae$var$storageHas(lookup, storage) ? $7b893ccb2c005aae$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(function() {
                var value = getter();
                $7b893ccb2c005aae$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, function(func) {
            func.as = function(key) {
                alias = key;
                return func;
            }, func.using = function(target) {
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: function() {
            return persist();
        }
    });
    Alpine.magic("persist", persist);
    Alpine.persist = function(key, param) {
        var get = param.get, set = param.set, storage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : localStorage;
        var initial = $7b893ccb2c005aae$var$storageHas(key, storage) ? $7b893ccb2c005aae$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(function() {
            var value = get();
            $7b893ccb2c005aae$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $7b893ccb2c005aae$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $7b893ccb2c005aae$var$storageGet(key, storage) {
    var value = storage.getItem(key, storage);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $7b893ccb2c005aae$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $7b893ccb2c005aae$export$2e2bcd8739ae039 = $7b893ccb2c005aae$export$9a6132153fba2e0;



var $j2WbH = parcelRequire("j2WbH");

var $j2WbH = parcelRequire("j2WbH");
var $556dc400cba9ff95$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $556dc400cba9ff95$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: (typeof window === "undefined" ? "undefined" : (0, $j2WbH._)(window)) === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function errorHandler(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function getWeek(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $a3ebfaafc1e66230$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function ordinal(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $a3ebfaafc1e66230$export$2e2bcd8739ae039 = $a3ebfaafc1e66230$export$33e6c23ebe2ee669;


var $e90282772c5bfe3f$export$5d04458e2a6c373e = function pad(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $e90282772c5bfe3f$export$7d260a2a5f8bc19e = function int(bool) {
    return bool === true ? 1 : 0;
};
function $e90282772c5bfe3f$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $e90282772c5bfe3f$export$3131421a7d01b4fb = function arrayify(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $6862e0bfc6888d9a$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $6862e0bfc6888d9a$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $6862e0bfc6888d9a$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $6862e0bfc6888d9a$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $6862e0bfc6888d9a$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $6862e0bfc6888d9a$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $6862e0bfc6888d9a$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $6862e0bfc6888d9a$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $3a7a04b4bfac8db7$var$doNothing = function doNothing() {
    return undefined;
};
var $3a7a04b4bfac8db7$export$27a2dd9af757e89c = function monthToStr(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $3a7a04b4bfac8db7$export$9490b78b888a863f = {
    D: $3a7a04b4bfac8db7$var$doNothing,
    F: function F(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function G(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function H(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function J(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function K(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function M(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function S(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function U(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function W(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function Y(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function Z(_, ISODate) {
        return new Date(ISODate);
    },
    d: function d(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function h(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function i(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function j(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $3a7a04b4bfac8db7$var$doNothing,
    m: function m(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function n(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function s(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function u(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $3a7a04b4bfac8db7$var$doNothing,
    y: function y(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $3a7a04b4bfac8db7$export$55069460464ca7a9 = {
    Z: function Z(date) {
        return date.toISOString();
    },
    D: function D(date, locale, options) {
        return locale.weekdays.shorthand[$3a7a04b4bfac8db7$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function F(date, locale, options) {
        return $3a7a04b4bfac8db7$export$27a2dd9af757e89c($3a7a04b4bfac8db7$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function G(date, locale, options) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)($3a7a04b4bfac8db7$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function H(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function J(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function K(date, locale) {
        return locale.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function M(date, locale) {
        return $3a7a04b4bfac8db7$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function S(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function U(date) {
        return date.getTime() / 1000;
    },
    W: function W(date, _, options) {
        return options.getWeek(date);
    },
    Y: function Y(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function d(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function h(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function i(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function j(date) {
        return date.getDate();
    },
    l: function l(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function m(date) {
        return (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function n(date) {
        return date.getMonth() + 1;
    },
    s: function s(date) {
        return date.getSeconds();
    },
    u: function u(date) {
        return date.getTime();
    },
    w: function w(date) {
        return date.getDay();
    },
    y: function y(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $1790eb92a3243d88$export$ff1a0b75284ac636 = function createDateFormatter(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $556dc400cba9ff95$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $a3ebfaafc1e66230$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $3a7a04b4bfac8db7$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $3a7a04b4bfac8db7$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $1790eb92a3243d88$export$cfa2ef2687faeda2 = function createDateParser(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $556dc400cba9ff95$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $a3ebfaafc1e66230$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $556dc400cba9ff95$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $3a7a04b4bfac8db7$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $1790eb92a3243d88$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $1790eb92a3243d88$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $1790eb92a3243d88$export$a4d69fb5f2026c35 = function isBetween(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $1790eb92a3243d88$export$9fafc166baa96839 = function calculateSecondsSinceMidnight(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $1790eb92a3243d88$export$a4ce0def660bfe9e = function parseSeconds(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $1790eb92a3243d88$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $1790eb92a3243d88$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function _loop_1(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $d57b7be5ef1ae277$var$__assign = undefined && undefined.__assign || function() {
    $d57b7be5ef1ae277$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d57b7be5ef1ae277$var$__assign.apply(this, arguments);
};
var $d57b7be5ef1ae277$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $d57b7be5ef1ae277$var$DEBOUNCED_CHANGE_MS = 300;
function $d57b7be5ef1ae277$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, (0, $556dc400cba9ff95$export$ebe90cb607ad99e)), $d57b7be5ef1ae277$var$flatpickr.defaultConfig),
        l10n: (0, $a3ebfaafc1e66230$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $1790eb92a3243d88$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function getDaysInMonth(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $1790eb92a3243d88$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $1790eb92a3243d88$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $1790eb92a3243d88$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $1790eb92a3243d88$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $1790eb92a3243d88$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $1790eb92a3243d88$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $1790eb92a3243d88$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $1790eb92a3243d88$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function remove() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $e90282772c5bfe3f$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $e90282772c5bfe3f$export$61fc7d43ac8f84b0)(triggerChange, $d57b7be5ef1ae277$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function selText(e) {
                return (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function shouldBuildMonth(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $3a7a04b4bfac8db7$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function get() {
                return self.__hidePrevMonthArrow;
            },
            set: function set(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function get() {
                return self.__hideNextMonthArrow;
            },
            set: function set(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $1790eb92a3243d88$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $6862e0bfc6888d9a$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $6862e0bfc6888d9a$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $d57b7be5ef1ae277$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $d57b7be5ef1ae277$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $1790eb92a3243d88$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $1790eb92a3243d88$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $1790eb92a3243d88$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if ((typeof d === "undefined" ? "undefined" : (0, $j2WbH._)(d)) === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $1790eb92a3243d88$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $1790eb92a3243d88$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function get() {
                return self.config._enable;
            },
            set: function set(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function get() {
                return self.config._disable;
            },
            set: function set(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $d57b7be5ef1ae277$var$flatpickr.defaultConfig.dateFormat || (0, $556dc400cba9ff95$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $d57b7be5ef1ae277$var$flatpickr.defaultConfig.altFormat || (0, $556dc400cba9ff95$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function get() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function get() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function minMaxTimeSetter(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function get() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function get() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $556dc400cba9ff95$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $e90282772c5bfe3f$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $556dc400cba9ff95$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $e90282772c5bfe3f$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if ((0, $j2WbH._)(self.config.locale) !== "object" && typeof $d57b7be5ef1ae277$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, $d57b7be5ef1ae277$var$flatpickr.l10ns.default), (0, $j2WbH._)(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? $d57b7be5ef1ae277$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $3a7a04b4bfac8db7$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $d57b7be5ef1ae277$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $1790eb92a3243d88$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $1790eb92a3243d88$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $6862e0bfc6888d9a$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function isSelectable(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $6862e0bfc6888d9a$export$25245567f53f158f)((0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $1790eb92a3243d88$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && (typeof option === "undefined" ? "undefined" : (0, $j2WbH._)(option)) === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $556dc400cba9ff95$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $e90282772c5bfe3f$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && (typeof rule === "undefined" ? "undefined" : (0, $j2WbH._)(rule)) === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $6862e0bfc6888d9a$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $1790eb92a3243d88$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $1790eb92a3243d88$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $3a7a04b4bfac8db7$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $6862e0bfc6888d9a$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(isHourElem) && (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $e90282772c5bfe3f$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $e90282772c5bfe3f$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $d57b7be5ef1ae277$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $d57b7be5ef1ae277$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $d57b7be5ef1ae277$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $d57b7be5ef1ae277$var$_flatpickr([
            this
        ], config);
    };
}
var $d57b7be5ef1ae277$var$flatpickr = function flatpickr(selector, config) {
    if (typeof selector === "string") return $d57b7be5ef1ae277$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $d57b7be5ef1ae277$var$_flatpickr([
        selector
    ], config);
    else return $d57b7be5ef1ae277$var$_flatpickr(selector, config);
};
$d57b7be5ef1ae277$var$flatpickr.defaultConfig = {};
$d57b7be5ef1ae277$var$flatpickr.l10ns = {
    en: $d57b7be5ef1ae277$var$__assign({}, (0, $a3ebfaafc1e66230$export$2e2bcd8739ae039)),
    default: $d57b7be5ef1ae277$var$__assign({}, (0, $a3ebfaafc1e66230$export$2e2bcd8739ae039))
};
$d57b7be5ef1ae277$var$flatpickr.localize = function(l10n) {
    $d57b7be5ef1ae277$var$flatpickr.l10ns.default = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, $d57b7be5ef1ae277$var$flatpickr.l10ns.default), l10n);
};
$d57b7be5ef1ae277$var$flatpickr.setDefaults = function(config) {
    $d57b7be5ef1ae277$var$flatpickr.defaultConfig = $d57b7be5ef1ae277$var$__assign($d57b7be5ef1ae277$var$__assign({}, $d57b7be5ef1ae277$var$flatpickr.defaultConfig), config);
};
$d57b7be5ef1ae277$var$flatpickr.parseDate = (0, $1790eb92a3243d88$export$cfa2ef2687faeda2)({});
$d57b7be5ef1ae277$var$flatpickr.formatDate = (0, $1790eb92a3243d88$export$ff1a0b75284ac636)({});
$d57b7be5ef1ae277$var$flatpickr.compareDates = (0, $1790eb92a3243d88$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $d57b7be5ef1ae277$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $d57b7be5ef1ae277$var$flatpickr;
var $d57b7be5ef1ae277$export$2e2bcd8739ae039 = $d57b7be5ef1ae277$var$flatpickr;


var $c788bd62cabaec58$exports = {};
(function(global, factory) {
    factory($c788bd62cabaec58$exports);
})($c788bd62cabaec58$exports, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var German = {
        weekdays: {
            shorthand: [
                "So",
                "Mo",
                "Di",
                "Mi",
                "Do",
                "Fr",
                "Sa"
            ],
            longhand: [
                "Sonntag",
                "Montag",
                "Dienstag",
                "Mittwoch",
                "Donnerstag",
                "Freitag",
                "Samstag"
            ]
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "M\xe4r",
                "Apr",
                "Mai",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Okt",
                "Nov",
                "Dez"
            ],
            longhand: [
                "Januar",
                "Februar",
                "M\xe4rz",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ]
        },
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum \xc4ndern scrollen",
        toggleTitle: "Zum Umschalten klicken",
        time_24hr: true
    };
    fp.l10ns.de = German;
    var de = fp.l10ns;
    exports1.German = German;
    exports1.default = de;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


(0, $96cefe9acc8d79bc$export$2e2bcd8739ae039).plugin((0, $7b893ccb2c005aae$export$2e2bcd8739ae039));
var $276b24eba12f13fb$var$banner = new (0, (/*@__PURE__*/$parcel$interopDefault($2e218e1f75469fbf$exports)))(function() {
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */ _paq.push([
        'trackPageView'
    ]);
    _paq.push([
        'enableLinkTracking'
    ]);
    (function() {
        var u = "//stats.371stadtmagazin.de/";
        _paq.push([
            'setTrackerUrl',
            u + 'matomo.php'
        ]);
        _paq.push([
            'setSiteId',
            '3'
        ]);
        var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
        g.type = 'text/javascript';
        g.async = true;
        g.src = u + 'matomo.js';
        s.parentNode.insertBefore(g, s);
    })();
});
function $276b24eba12f13fb$var$initMap(zoom, center) {
    map = new google.maps.Map(document.getElementById('map'), {
        zoom: zoom || 11,
        center: center | {
            lat: 25.684411,
            lng: -100.317283
        }
    });
    var mapReadyEvent = new CustomEvent('map-ready');
    window.dispatchEvent(mapReadyEvent);
}
window.addEventListener('load', function() {
    var HomeCarousel = new (0, $b7fc613ae4207215$export$2e2bcd8739ae039)('.home-carousel', {
        spaceBetween: 0,
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: true
        },
        //effect: 'fade',
        speed: 900
    });
    (0, $d57b7be5ef1ae277$export$2e2bcd8739ae039)(".datetimeinput", {
        enableTime: true,
        dateFormat: "d.m.Y H:i:s",
        locale: (0, $c788bd62cabaec58$exports.German)
    });
    if (document.getElementsByClassName('gallery-main').length) {
        var galleryThumbs = {};
        if (document.getElementsByClassName('gallery-thumbs-1x').length) galleryThumbs = {
            swiper: new (0, $b7fc613ae4207215$export$2e2bcd8739ae039)('.gallery-thumbs-1x', {
                modules: [
                    (0, $9969adb5ca25ad64$export$2e2bcd8739ae039)
                ],
                spaceBetween: 10,
                slidesPerView: 2,
                freeMode: true,
                navigation: {
                    nextEl: '.gallery-thumbs-next',
                    prevEl: '.gallery-thumbs-prev'
                },
                loop: true,
                centeredSlides: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                preloadImages: false,
                freeModeSticky: true,
                // Enable lazy loading
                lazy: true,
                breakpoints: {
                    // others are 640px, 768px, 1024px, 1280px see tailwind.config.js
                    // TODO: import from tailwind
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        direction: 'vertical'
                    }
                }
            })
        };
        else if (document.getElementsByClassName('gallery-thumbs-3x').length) galleryThumbs = {
            swiper: new (0, $b7fc613ae4207215$export$2e2bcd8739ae039)('.gallery-thumbs-3x', {
                modules: [
                    (0, $9969adb5ca25ad64$export$2e2bcd8739ae039)
                ],
                spaceBetween: 10,
                slidesPerView: 2,
                freeMode: true,
                navigation: {
                    nextEl: '.gallery-thumbs-next',
                    prevEl: '.gallery-thumbs-prev'
                },
                loop: true,
                centeredSlides: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                preloadImages: false,
                freeModeSticky: true,
                // Enable lazy loading
                lazy: true,
                breakpoints: {
                    // others are 640px, 768px, 1024px, 1280px see tailwind.config.js
                    // TODO: import from tailwind
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        direction: 'vertical',
                        centeredSlides: true
                    }
                }
            })
        };
        var galleryTop = new (0, $b7fc613ae4207215$export$2e2bcd8739ae039)('.gallery-main', {
            modules: [
                (0, $9969adb5ca25ad64$export$2e2bcd8739ae039),
                (0, $4a20353ab7c9b248$export$2e2bcd8739ae039),
                (0, $03a2af08df22ddfa$export$2e2bcd8739ae039)
            ],
            spaceBetween: 0,
            preloadImages: false,
            pagination: {
                el: '.gallery-main-indicator',
                type: 'fraction'
            },
            // Enable lazy loading
            lazy: true,
            thumbs: galleryThumbs
        });
        var gallerylightbox = new (0, $d5cf025f85a9e906$export$2e2bcd8739ae039)({
            gallerySelector: '.gallery-main',
            childSelector: '.gallery-item',
            pswpModule: (0, $f38b189616c72948$export$2e2bcd8739ae039),
            // Optional padding for images,
            // note that this is an option of PhotoSwipe, not a plugin
            paddingFn: function(viewportSize) {
                return {
                    top: 30,
                    bottom: 30,
                    left: 70,
                    right: 70
                };
            }
        });
        var gallerycaptionPlugin = new (0, $cbc1a6e6e1eedade$export$2e2bcd8739ae039)(gallerylightbox, {
            // Plugins options, for example:
            type: 'auto'
        });
        // make sure you init photoswipe core after plugins are added
        gallerylightbox.init();
    }
});
var $276b24eba12f13fb$var$lightbox = new (0, $d5cf025f85a9e906$export$2e2bcd8739ae039)({
    gallerySelector: '.gallery-line',
    childSelector: '.gallery-item',
    showHideAnimationType: 'zoom',
    pswpModule: (0, $f38b189616c72948$export$2e2bcd8739ae039),
    // Optional padding for images,
    // note that this is an option of PhotoSwipe, not a plugin
    paddingFn: function(viewportSize) {
        return {
            top: 30,
            bottom: 30,
            left: 70,
            right: 70
        };
    }
});
var $276b24eba12f13fb$var$captionPlugin = new (0, $cbc1a6e6e1eedade$export$2e2bcd8739ae039)($276b24eba12f13fb$var$lightbox, {
    // Plugins options, for example:
    type: 'auto',
    captionContent: function(slide) {
        var currentSlide = slide.data.element;
        if (currentSlide) {
            var caption = currentSlide.querySelector('.caption');
            if (caption) return caption.innerHTML;
            else {
                // look for neighboring elements with .extra-caption class
                var next = currentSlide.parentNode.querySelector('.extra-caption');
                if (next) return next.innerHTML;
            }
        }
    }
});
// make sure you init photoswipe core after plugins are added
$276b24eba12f13fb$var$lightbox.init();
(0, $96cefe9acc8d79bc$export$2e2bcd8739ae039).data('InitGoogleMaps', function(apiKey) {
    var callbackName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'init';
    return {
        show_once: false,
        allowed: this.$persist(false).as('external-content-allowed'),
        loaded: false,
        showExternal: function() {
            return this.show_once || this.allowed;
        },
        loadGoogleMaps: function() {
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.async = true;
            g.defer = true;
            g.src = "https://maps.googleapis.com/maps/api/js?key=".concat(apiKey, "&v=beta&callback=").concat(callbackName);
            s.parentNode.insertBefore(g, s);
        },
        checkAndLoad: function() {
            if (this.showExternal() && !this.loaded) {
                this.loadGoogleMaps();
                this.loaded = true;
            }
        },
        init: function() {
            var _this = this;
            this.checkAndLoad();
            this.$watch('showExternal', function() {
                return _this.checkAndLoad();
            });
        }
    };
});
(0, $96cefe9acc8d79bc$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=assets.84b1ffe3.js.map
